import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MetadataTable } from 'src/app/interfaces/metada-table.interface';
import { StorageService } from 'src/app/services/storage.service';
import { ConfirmDeleteRowEvent } from '../../../../interfaces/datatable.interface';
import {
  ConsultarContratoAyudaPivotOVoResponse, ConsultarTarifaResponse, InsertarServiciosLocalesResponse, ItemsListarOrdenesVentaResponse,
  ItemsServiciosCalculadosTarifaResponse,
  ItemsTarifaDetalleResponse,
  ConsultarEntidadServicioResponse,
  GetCotizacionOVArchivoResponse,
  itemsTarifaFleteResponse,
  itemsAuditoriaOvCotResponse
} from '../../domain/response/comercial-orden-venta-response';
import { DetalleServiciosLocalesRequest, ServiciosLocalesRequest, ConsultarContratoAyudaPivotOVRequest, ConsultarTarifaRequest, ConsultarTariffDetailByIdRequest, CrudOrdenesVentaRequest, GetServiceCalculatedByTariffRequest, ListaDetCotizacionOVArchivoRequest, ListaDetCotizacionOVServicioActualizarRequest, listNaveViajePorPuertoRequest, EvenSiRequest, ConsultarEntidadServicio_Request, GetCotizacionOVArchivoRequest, validacionMapeoDatosOVRequest, getDocumentosServiciosRequest, D_getSeriePorDocumentoRequest, D_validarTipoCambioRequest, D_getAuditServChangeCtrlRequest, D_getListadoUsuariosChngCtrlRequest, enviarFinanzasChangeControlRequest, listAllOVRequest, ListarTarifaCotizacionRequest, ItemsAgrupador, TransaccionAgrupadorRequest, ListarAgrupacionRequest, GenerarOrdenServicioRequest, ListaDetCotizacionOVItinerarioRequest, AutorizacionSliRequest, getAuditoriaCotOvRequest, GetPlantillaCorreoGeneracionOvRequest } from '../../domain/request/comercial-orden-venta-request';
import { dropdownItems, UtilService } from 'src/app/services/util.service';
import { inputType, newmetadate, style } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { MatSelectChange } from '@angular/material/select';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { Parametros } from 'src/app/services/domain/services-domain';
import { Title } from '@angular/platform-browser';
import { SelectItem, ConfirmationService, MessageService } from 'primeng/api';
import { MantenimientoOrdenVentaValidacion } from './mantenimiento-orden-venta-validacion';
import { BehaviorSubject, catchError, concatMap, firstValueFrom, forkJoin, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { DatosCompartidosService } from 'src/app/services/datos-compartidos.service';
import { BuscarContratoComponent } from '../buscar-contrato/buscar-contrato.component';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BuscarNavesRequest, BuscarNaveViajeRequest } from 'src/app/mantenimiento/nave-viaje/domain/nave-viaje.request';
import { MantenimientoRespository } from 'src/app/mantenimiento/servicio/mantenimiento.repository';
import { MantenimientoNaveViajeComponent } from 'src/app/mantenimiento/nave-viaje/presentacion/mantenimiento-nave-viaje/mantenimiento-nave-viaje.component';
import { DialogTableComponent } from 'src/app/dialog-table/dialog-table.component';
import { consultarServiciosRequest, ListarEntidadesRequest } from 'src/app/comercial/mantenimiento/domain/request/mantenimiento-request';
import { itemsConsultarServiciosResponse, ListarEntidades } from 'src/app/comercial/mantenimiento/domain/response/mantenimiento-response';
import { DatatableComponent } from 'src/app/shared/components/datatable/datatable.component';
import { parametrosRepository } from 'src/app/parametros/servicio/parametros.repository';
import { listarEntidadesRequest, listarPuertosRequest, ObtenerParametrosRequest } from 'src/app/parametros/domain/parametros.request';
import { COD_ROLES, FUNC_ENTIDAD, CONST_VARIABLES } from 'src/app/shared/constantes/constantes';
import { ConsultarProfitTCambioRequest, ConsultarVigenciaTokenRequest, EliminarOPTransportistaRequest, GenerarTokenAutorizacionRequest, ListarDatosLoginRequest, TransaccionAuthCambioVtaRequest } from 'src/app/comercial/cotizacion/domain/request/cotizacion-request';
import { br } from '@fullcalendar/core/internal-common';
import { ProformaAgenciamientoAduanaComponent } from 'src/app/features/logistica/gestion-agenciamiento-aduana/componente/proforma-agenciamiento-aduana/proforma-agenciamiento-aduana.component';
import { readonlyMetadataTable } from 'src/app/shared/components/readonly-data-table/domain/readonly-data-table.domain';
import { getRutaByPlaceRequest, getZoneByProviderRequest } from 'src/app/features/logistica/gestion-transporte/domain/gestion-transporte.request';
import { LogisticaRepository } from 'src/app/features/logistica/services/logistica.repository';
import { LogisticaService } from 'src/app/features/logistica/services/logistica.service';
import { set } from 'date-fns';
import { BandejaTarifarioSliComponent } from 'src/app/features/pricing/tarifario-sli/presentacion/bandeja-tarifario-sli/bandeja-tarifario-sli.component';
import { ListarRolesUsuarioRequest, ListarUsuariosByRolRequest } from 'src/app/gestion-usuario/domain/request/gestion-usuario-request';
import { GestionUsuarioRepository } from 'src/app/gestion-usuario/domain/gestion-usuario-repository';
import { RolesSesionService } from 'src/app/services/roles-sesion.service';
import { GetRolesUsuarioLoginResponse } from 'src/app/usuario/domain/user-entity';
import { I_InitDatosEmision, I_ListadoContenedores } from '../../../orden-venta-operaciones/domain/interfaces/ov-datos-de-emision.interface';
import { OvDatosDeEmisionComponent } from 'src/app/comercial/orden-venta-operaciones/componentes/mant-ov-componentes/ov-datos-de-emision/ov-datos-de-emision.component';
import { I_InitBtnsSuperioresOv, I_InitDatosMantOv, I_InitMaestrosBtnsSuperiores } from 'src/app/comercial/orden-venta-operaciones/domain/interfaces/ov-mantenimiento.interface';
import { CorreoPreviewConfig, CorreoPreviewData, CorreoPreviewResult, itemsCorreoPreview } from 'src/app/shared/components/correo-preview/types/correo-preview.types';
import { CorreoPreviewComponent } from 'src/app/shared/components/correo-preview/correo-preview.component';

@Component({
  selector: 'app-mantenimiento-orden-venta',
  templateUrl: './mantenimiento-orden-venta.component.html',
  styleUrl: './mantenimiento-orden-venta.component.css',
  standalone: false,
  providers: [
    { provide: LogisticaRepository, useClass: LogisticaService },
  ]
})

export class MantenimientoOrdenVentaComponent {
  @Input() rowAgenciamiento: any;
  @Output() onDpValueChangeEvento: EventEmitter<any> = new EventEmitter();
  @Output() onDpValueChangeFleteEvento: EventEmitter<any> = new EventEmitter();
  @Output() onDpChangeTblServiciosChangeControl: EventEmitter<any> = new EventEmitter();
  @Output() onChangeTblViajeItinerario: EventEmitter<any> = new EventEmitter();
  @Output() onProcesado = new EventEmitter<any>();
  @Output() onDpChangeTbl: EventEmitter<any> = new EventEmitter();
  modifiedRow: any;
  soloLectura: boolean = false;
  date: Date = new Date();
  binary: boolean = true;
  uploadedFiles: any[] = [];
  datosRecibidos: any = [];
  esVisualizar: boolean = false;
  nombreUsuario: string = '';
  nombre_bl: string = 'BL Hijo';
  nombre_mbl: string = 'BL Master';
  solo_aereo: boolean = false;
  @Input() datos_ov: I_InitDatosMantOv;
  from_operaciones: boolean = false;
  evaluarEnvioCorreoOv: boolean = false;

  rol: string = '';
  estilos: style = {
    header: {
      align: 'left',
      justify: 'center',
      size: '10px'
    },
    body: {
      size: '9px'
    }
  }
  verBtnSave: boolean = false;
  leyendasTblSLI = [];
  leyendasRow = [
    { color: '#3f3f46', texto: 'INGRESADO' },
    { color: '#6363d3ff', texto: 'PREFACTURADO' },
    { color: '#ff0000ff', texto: 'CANCELADO' }
  ]
  leyendasAgrupacionRow = [
    { color: '#9CA3AF', texto: 'NO AGRUPADO' },
    { color: '#2563EB', texto: 'AGRUPADO' },
  ]
  // --EventosTareas
  ListaTodosEventoTarea: any[] = []
  ListTodosModulo: any[] = []

  isadmin: boolean = false;
  isLogisticaPlus: boolean = false;
  mostrarDetalleNaveViaje: boolean = false;
  ListaTodosPuertoOrigenyDestino: any[] = []

  listarServTariff: ItemsServiciosCalculadosTarifaResponse[] = [];
  listarTarifaDetalle: ItemsTarifaDetalleResponse[] = [];
  ListaTodosLineaNegocio: any[] = []
  ListaFiltradaTipoEntidadDP: any[] = [];
  ListaFiltradaNombreEntidadesDP: any[] = [];
  ListaNombreEntidadesDP: any[] = [];
  ListaTodosDescripcionServiciosLocales: any[] = []
  ListaTodosServiciosTable: any[] = []
  ListaFiltradaTodosServiciosTable: any[] = []
  ListaTodosMonedaItem: SelectItem[] = []
  datosViajePorPuerto2: any[] = []
  seguimiento_Embarque: any[] = []
  listRutas: any[] = []
  ListaEstadosDope: dropdownItems[] = []
  ListaSucursales: dropdownItems[] = []
  ListaBultos: dropdownItems[] = []
  ListaImo: dropdownItems[] = []
  ListaMods: dropdownItems[] = []

  //Cambiar Estado si es "NUEVO" o "EDITAR"
  //  --Datos Generales
  readOnlyNumeroDGDG: boolean;
  readOnlyNumeroCotizacionDG: boolean;
  readOnlyEstadoDG: boolean;
  readOnlyNoCRMDG: boolean;
  readonlyOrdenCompraDG: boolean;
  readonlyRegimenDG: boolean;
  readonlyViaDG: boolean;
  readonlyLineaNegocioDG: boolean;
  readonlyFEmisionDG: boolean;
  readonlyFVencimientoDG: boolean;
  readonlyFAprobacionDG: boolean;
  readonlyFEmbarqueDG: boolean;
  readOnlyClienteDG: boolean;  //PENDIENTE
  readOnlyCustomerDG: boolean;
  readOnlyAgenteDG: boolean;
  readOnlyEjecutivoDG: boolean;
  readonlyIncotermDG: boolean;
  readonlyServLogisticoDG: boolean;
  readonlyServicioDG: boolean;
  readonlyCotPropiaDG: boolean;
  visibledCotPropiaDG: boolean; //Cambia segun otras funciones
  readonlyAvisoLl_zDG: boolean;


  //  --Servicios y Tarifa
  readonlyTransportisaSTST: boolean;
  readonlyPuertoTransbordoST: boolean;
  readonlydTraficoST: boolean;
  readonlyPuertoOrigenST: boolean;
  readonlyPuertoDestinoST: boolean;
  readonlyMonedaST: boolean;
  readonlyTipoFechaTarifaST: boolean;
  readonlyFechaTarifaST: boolean;
  readonlyCondicionST: boolean;
  readonlyNumeroContratoST: boolean;
  readonlyAdicionalST: boolean;
  readonlyPCMblST: boolean;
  readonlyPCHblST: boolean;
  readOnlyFleteTotalST: boolean;
  readonlyDiasLibresSobreeestadiaST: boolean;


  // --Datos Embarque
  readonlyCargaRefrigeradaDE: boolean;
  readOnlyTemperaturaDE: boolean;
  readonlyCargaPeligrosaDE: boolean;
  readonlyImoClassDE: boolean;
  readonlyRoundTripDE: boolean;
  readOnlyImoUnDE: boolean;
  readonlyShipperDE: boolean;
  readonlyReferenciaDE: boolean;
  readonlyConsigneeDE: boolean;
  readonlyNotifyDE: boolean;

  // --Observaciones
  readonlyAlmacenajeObs: boolean;
  readonlySobreestadiaObs: boolean;
  readonlyTiempoViajeObs: boolean;
  readonlyValidezOfertaObs: boolean;
  readonlyInstruccionesEmbarqueObs: boolean;

  // --Novedades
  readonlyNroBookingNov: boolean;
  readonlyDepositoNov: boolean;
  readonlyBlNietoNov: boolean;
  readonlyBlHijoNov: boolean;
  readonlyBlMasterNov: boolean;
  readonlyContenedorNov: boolean;
  readOnlyViajeNov: boolean;
  readonlyFZarpeNov: boolean;
  readonlyFEtaEtdNov: boolean;
  readOnlyNaveNov: boolean;

  // --EventosTareas
  readonlyTipoEventoTareaET: boolean;
  readonlyFechaYHoraET: boolean;
  readonlyEstadoET: boolean;
  readonlyModuloET: boolean;
  readonlyUsuarioET: boolean;
  readonlyObservacionesET: boolean;

  // --Servicio Locales
  readOnlyCodigoOperacionDSL: boolean;
  readOnlyNumeroOpeacionDSL: boolean;
  readonlyFechaEmisionDSL: boolean;
  readOnlyClienteDSL: boolean;
  readOnlyTransportistaAMDSL: boolean;
  readOnlyAlmacenDSL: boolean;
  readOnlyAgenciaMaritimaDSL: boolean;
  readOnlyTerminalPortuarioDSL: boolean;
  readOnlyCondicionEmbarqueDSL: boolean;
  readonlyTransportistaDSL: boolean;
  readonlySADADSL: boolean;
  readonlyIMODSL: boolean;
  readonlyTarifaDSL: boolean;
  readonlyTipoDSL: boolean;
  readonlyVigenciaDesdeDSL: boolean;
  readonlyVigenciaHastaDSL: boolean;
  readonlyDescripcionDSL: boolean;//PENDIENTE
  readonlyObservacionesDSL: boolean;//PENDIENTE
  readOnlyVentaTotalDSL: boolean;
  bloqueoserviciolocal: boolean = false;
  bloqueoViajeItinerario: boolean = false;
  bloqueoDataDetalle: boolean = false;
  bloqueoTarifa: boolean = false;
  bloqueoObservaciones: boolean = false;
  bloqueoAdicionales: boolean = false;
  bloqueoFlete: boolean = false;
  bloqueoServiciosAdicionales: boolean = false;
  bloqueoChangeControl: boolean = false;
  bloqueoSegundoFlete: boolean = false;
  adicional: boolean = false;

  bloqueoCheckboxSLI: 'nolock' | 'lock' = 'nolock'

  //Variables que cambian segun otras acciones
  avisoLl_z: string = 'Aviso de llegada '; // Valor inicial del título
  fechaEm_z: string = 'F. Embarque';

  blockedColumnsArchivos: string[] = ['ovar_eliminar', 'ovar_fecemi', 'ovar_descrip', 'ovar_descargar'];
  blockedColumnsEventos: string[] = ['even_fecha', 'even_usuario'];
  blockedColumnsSL: string[] = ['resumen_eliminar'];
  // , 'even_observaciones_detalle'

  // isDrawerOpen = false;
  row: any;
  objPuertoOrigen: any = null;

  isColumnBlocked(field: string): boolean {
    return this.blockedColumnsArchivos.includes(field) || this.blockedColumnsEventos.includes(field) || this.blockedColumnsSL.includes(field);
  }

  CONS_ESTOVEINGRESADA: string = "001";
  CONS_ESTOVECOORDINADA: string = "002";
  CONS_ESTOVECONFIRMADA: string = "003";
  CONS_ESTOVECONCLUIDA: string = "004";
  CONS_ESTOVEANULADA: string = "005";
  CONS_ESTOVEDOCUMENTADA: string = "006";
  CONS_ESTOVEPREFACTURADA: string = "007";
  CONS_ESTOVECERRADA: string = "008";
  CONS_ESTOVEGESTIONADASLI: string = "009";
  @ViewChild('dtServiciosRef') dtServiciosRef!: any;
  @ViewChild('dtServiciosRefdt') dtServiciosRefdt!: DatatableComponent;
  @ViewChild('Flete') dataFlete!: DatatableComponent;
  @ViewChild('dtServiciosChangeControlRef') dtServiciosChangeControlRef!: any;
  coordLog: string = COD_ROLES.coord_log;
  gerentLog: string = COD_ROLES.ger_log;
  bloqueoAddAdicionales: boolean = true;
  accion: string = '';
  // listadoRoles: GetRolesUsuarioLoginResponse[] = []
  listadoRoles: GetRolesUsuarioLoginResponse[] = []

  constructor(//Daniel01-08
    private readonly router: Router,
    private readonly ordenventaService: ComercialRepository, // Daniel 26
    private readonly util: UtilService, // DANIEL 26
    private readonly title: Title,
    public storage: StorageService,
    private datosCompartidosService: DatosCompartidosService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    public dialogService: DialogService,
    private readonly mantenimientoservice: MantenimientoRespository,
    private readonly servParametros: parametrosRepository,
    private readonly messageService: MessageService,
    private readonly servLogistica: LogisticaRepository,
    private readonly usuariosService: GestionUsuarioRepository,
    private readonly rolesService: RolesSesionService,
  ) {
    this.title.setTitle('Nueva Orden Venta')
    const datosViajePorPuerto = JSON.parse(localStorage.getItem('datoViajePorPuerto'))
    this.datosViajePorPuerto2 = datosViajePorPuerto
    // console.log('LLEGA VACIO ESTO', this.datosViajePorPuerto2)
    this.accion = localStorage.getItem('Opcion')
    this.nombreUsuario = this.storage.get("usuario");
  }

  // codRegimen: string;
  onRegimenChange(event: any) { //Cambio de otros elementos
    // var nombre: string = this.group_datosgenerales.value["regimen"]
    // this.codRegimen = this.ListaTodosRegimen.find(item => item.nombre === nombre)?.codigo


    const selectedRegimen = event.value;
    if (selectedRegimen === '001') {
      // this.group_datosgenerales?.get('incoterm')?.clearValidators();
      // this.group_datosgenerales?.get('incoterm')?.updateValueAndValidity();
      this.group_datosgenerales.get('avisodellegada').setValue(true)
      this.group_datosgenerales.get('lineanegocio')?.setValue('004');
      this.avisoLl_z = 'Aviso de llegada';
      this.fechaEm_z = 'F. Embarque';
      this.visibledCotPropiaDG = true;
      //this.readonlyDepositoNov = this.adicional === true || this.adicional === null ? false : true
    } else if (selectedRegimen === '002') {
      // this.group_datosgenerales?.get('incoterm')?.setValidators([Validators.required]);
      // this.group_datosgenerales?.get('incoterm')?.updateValueAndValidity();
      this.group_datosgenerales.get('lineanegocio')?.setValue('002');  //Establece el valor del segundo cbx
      this.avisoLl_z = 'Aviso de Llegada';
      this.fechaEm_z = 'F. Llegada';
      this.group_datosgenerales.get('avisodellegada').setValue(true)
      this.visibledCotPropiaDG = true;
      // this.readonlyDepositoNov = false
    } else {
      this.group_datosgenerales.get('lineanegocio')?.setValue('');   //Limpia el valor si no se cumple la condición
      this.avisoLl_z = 'Aviso de llegada';
      this.fechaEm_z = 'F. Embarque';
      this.group_datosgenerales.get('avisodellegada').setValue(false)
      // this.group_datosgenerales?.get('incoterm')?.clearValidators();
      // this.group_datosgenerales?.get('incoterm')?.updateValueAndValidity();
      this.visibledCotPropiaDG = false;
    }

    this.actualizarValidacionSucursal();

    this.bloqueoBtnAddCoordinador('EDIT');
    this.cargarServiciosEnTablaSegunLineaNegocio();
    this.filtrarListaServicios();
    this.establecerLineaNegocio();
    this.cargarTarifasDefault();
  }

  // codVia: string;
  onViaChange(event: any) {
    this.cargarServiciosEnTablaSegunLineaNegocio();
    this.filtrarListaServicios();
    this.filtrarPuertosSegunVia()
    this.buscarPuertosByVia()
    this.establecerLineaNegocio();
    if (event.value === '003') {
      this.group_novedades?.get('blhijo')?.clearValidators();
      this.group_novedades?.get('blhijo')?.updateValueAndValidity();
    } else {
      this.group_novedades?.get('blhijo')?.setValidators([Validators.required]);
      this.group_novedades?.get('blhijo')?.updateValueAndValidity();
    }

    if (event.value === '002') { // aéreo
      this.nombre_bl = 'Guía Aérea Hijo';
      this.nombre_mbl = 'Guía Aérea Master';
      this.group_datosgenerales?.get('fechavencimiento')?.setValidators([Validators.required]);
      this.group_datosgenerales?.get('fechavencimiento')?.updateValueAndValidity();
    } else {
      this.nombre_bl = 'BL Hijo';
      this.nombre_mbl = 'BL Master';
      this.group_datosgenerales?.get('fechavencimiento')?.clearValidators();
      this.group_datosgenerales?.get('fechavencimiento')?.updateValueAndValidity();
    }
    // var nombre: string = this.group_datosgenerales.value["via"]
    // this.codVia = this.ListaTodosVia.find(item => item.nombre === nombre)?.codigo

  }

  codLineaNegocio: string;
  onLineaNegocioChange(event: any) {
    this.cargarServiciosEnTablaSegunLineaNegocio();
    this.filtrarListaServicios();
    // var nombreLinN: string = this.group_datosgenerales.value["lineanegocio"]
    // this.codLineaNegocio = this.ListaTodosLineaNegocio.find(item => item.nombre === nombreLinN)?.codigo

  }

  codCliente: number;
  onClienteChange(event: any) {
    var nombreCliente: string = this.group_datosgenerales.value["cliente"]
    this.codCliente = Number(this.ListaTodosCliente.find(item => item.nombre === nombreCliente)?.codigo)
    this.group_servicioslocales.get('clienteDSL')?.setValue(this.codCliente?.toString());

    if (this.group_datosgenerales.get('cliente')?.value != null) {
      this.buscarCustomerEjecutivoSegunCliente()
      this.cargarServiciosEnTablaSegunLineaNegocio()
    }

    this.group_datosembarque.get('consignee')?.setValue(event.value);
    this.group_datosembarque.get('notify')?.setValue(event.value);
  }

  desdebtn: boolean = false
  onClienteClear() {
    this.codCliente = null;
    this.group_datosgenerales.get('customer')?.setValue(null)
    this.group_datosgenerales.get('ejecutivo')?.setValue(null)
    this.group_datosembarque.get('consignee')?.setValue(null);
    this.group_datosembarque.get('notify')?.setValue(null);
  }

  codTransporte: number;
  transportistaSeleccionado: string;
  dopesEliminados: any[] = [];
  onTransporteChange(event: any) {
    this.group_serviciostarifa.get("transportista").setValue(this.transportistaSeleccionado)
    if (this.servicioslocales_datadetalle.length > 0) {
      this.confirmationService.confirm({
        message: "¿ESTÁ SEGURO QUE DESEA CONTINUAR? SE ELIMINARÁN LOS SERVICIOS ASOCIADOS A ESTE TRANSPORTISTA",
        icon: 'pi pi-exclamation-triangle',
        key: 'T',
        rejectButtonProps: {
          label: 'Cancelar',
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: 'Aceptar',
        },
        header: 'Confirmation',
        closable: false,
        closeOnEscape: false,
        accept: async () => {
          this.transportistaSeleccionado = event.value
          var nombreTransportista: string = event.value
          this.codTransporte = Number(this.ListaTodosTransportista.find(item => item.nombre === nombreTransportista)?.codigo)
          this.group_serviciostarifa.get("transportista").setValue(nombreTransportista)
          this.group_servicioslocales.get('transportistaam')?.setValue(nombreTransportista);
          this.dopesEliminados = [];
          const Request: EliminarOPTransportistaRequest = <EliminarOPTransportistaRequest>{}
          Request.COPE_Codigo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0;
          Request.ENTC_Codigo = this.codTransporte;
          try {
            const response = await firstValueFrom(this.ordenventaService.EliminarOPTransportista(Request));
            if (response.datos.status === 200) {
              console.log('Transportista eliminado correctamente');
              this.dopesEliminados = response.datos.result ?? [];
              console.log('Dopes eliminados:', this.dopesEliminados);
            }
          } catch (error) {
            console.error('Error eliminando transportista:', error);
          }

          this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.filter(item => {
            const servCodigo = Number(item.serv_codigo);
            const entcCodigo = Number(item.entc_codigo);
            const existeEnOriginal = this.listadoOriginal.some(orig => orig.dope_item === item.dope_item && orig.ctar_codigo === item.ctar_codigo && orig.entc_codigo === item.entc_codigo);
            const existeEnEliminados = this.dopesEliminados?.some(orig => orig.dopE_Item === item.dope_item);
            if ((servCodigo === 1107 || servCodigo === 1057) && entcCodigo !== this.codTransporte && item.ESTADO_OBJ !== 'D' && item.cons_codest === '001') {
              if (item.ESTADO_OBJ === 'A') {
                item.ESTADO_OBJ = existeEnOriginal ? 'U' : 'I';
              }
              if (item.ESTADO_OBJ === 'I') {
                return false;
              } else {
                if (!item.cons_codest) {
                  return false;
                } else {
                  if (existeEnEliminados) {
                    return false;
                  } else {
                    item.ESTADO_OBJ = 'D';
                  }
                }
              }
            }
            return true;
          });
          const agrupadosActivos = this.servicioslocales_detalleAgrupacion.filter(agrupado => agrupado.ESTADO_OBJ !== 'D' && agrupado.ESTADO_OBJ !== 'E');

          const promises = agrupadosActivos.map(async agrupado => {
            const hijosLocales = this.servicioslocales_datadetalle.filter(item => item.cod_padre === agrupado.dope_item && item.ESTADO_OBJ != 'D' && item.ESTADO_OBJ != 'E');
            let hijosRemotos: any[] = [];

            const Request: ListarAgrupacionRequest = {
              CODE_Agrupador: agrupado.dope_item,
              COPE_Codigo: agrupado.cope_codigo
            };

            try {
              const response = await firstValueFrom(this.ordenventaService.ListarAgrupacion(Request));
              if (response.datos.status === 200 && Array.isArray(response.datos.result)) {
                hijosRemotos = response.datos.result.filter(
                  item =>
                    (Number(item.serv_codigo) !== 1107) &&
                    (Number(item.serv_codigo) !== 1057) &&
                    Number(item.entc_codigo) !== this.codTransporte
                );
              }
            } catch (error) {
              console.error('Error al obtener agrupación remota:', error);
            }

            const todosLosHijos = [...hijosLocales, ...hijosRemotos];
            const total = todosLosHijos.reduce((acc, item) => acc + Number(item.dope_preciototvta || 0), 0);

            if (total === 0) {
              return { ...agrupado, ESTADO_OBJ: 'E' };
            } else {
              const existeEnOriginal = this.listadoOriginalAgrupados.some(
                orig => orig.dope_item === agrupado.dope_item && orig.cope_codigo === agrupado.cope_codigo
              );
              return {
                ...agrupado,
                dope_preciototvta: total.toFixed(2),
                dope_preciounitvta: total.toFixed(2),
                ESTADO_OBJ: existeEnOriginal ? 'U' : 'I'
              };
            }
          });

          const agrupadosActualizados = await Promise.all(promises);
          const agrupadosInactivos = this.servicioslocales_detalleAgrupacion.filter(agrupado => agrupado.ESTADO_OBJ === 'D' || agrupado.ESTADO_OBJ === 'E');
          this.buscarServicioLogistico()
          this.servicioslocales_detalleAgrupacion = [...agrupadosInactivos, ...agrupadosActualizados];
        },
        reject: () => {
          this.group_serviciostarifa.get("transportista").setValue(this.transportistaSeleccionado)
          this.group_servicioslocales.get('transportistaam')?.setValue(this.transportistaSeleccionado);
        }
      }
      );
    } else {
      this.transportistaSeleccionado = event.value
      var nombreTransportista: string = event.value
      this.codTransporte = Number(this.ListaTodosTransportista.find(item => item.nombre === nombreTransportista)?.codigo)
      this.group_serviciostarifa.get("transportista").setValue(nombreTransportista)
      this.group_servicioslocales.get('transportistaam')?.setValue(nombreTransportista);
    }

    this.cargarTarifasDefault();
  }

  codAgente: number = -1;
  onAgenteChange(event: any) {
    var nombreAgente: string = this.group_datosgenerales.value["agente"]
    this.codAgente = Number(this.ListaTodosAgentes.find(item => item.nombre === nombreAgente)?.codigo)
    if (this.serviciosytarifas_dataservicios.length > 0) {
      this.cargarServiciosEnTablaSegunAgente();
    } else {
      this.cargarServiciosEnTablaSegunLineaNegocio();
    }
    this.establecerLineaNegocio();

  }

  onNumeroContratoChange(event: any): void {
    const numeroContrato = this.group_serviciostarifa.get("numerocontrato")?.value;
    if (!numeroContrato || numeroContrato?.trim() === '') {
      this.group_serviciostarifa.get("cont_codigo")?.setValue(null);
    }
    this.cargarTarifasDefault();
  }

  codTransTerr: number;
  onTransTerrChange(event: any) {
    this.codTransTerr = this.group_servicioslocales.get('transportistaTerre')?.value;
  }

  onFechaEmiChange(event: any) {
    this.group_servicioslocales.get('fechaemision')?.setValue(this.group_datosgenerales.value["fechaemision"]);
  }

  onDepositoChange(event: any) {
    this.group_servicioslocales.get('almacen')?.setValue(this.group_novedades.value["deposito"]);
  }

  onShipperChange() {
    this.fnOnChangeEntidadesDatosEmision('shipper');
  }

  onConsigneeChange() {
    this.fnOnChangeEntidadesDatosEmision('consignee');
  }

  onNotifyChange() {
    this.fnOnChangeEntidadesDatosEmision('notify');
  }

  onCondicionChange(event: any) {
    const depositoEncontrado = this.ListaTodosCondicion.find(deposito => deposito.codigo === this.group_serviciostarifa.value["condicion"]);
    this.group_servicioslocales.get('condicion')?.setValue(depositoEncontrado.nombre);
    // PRUEBA
    if (this.group_serviciostarifa.value["condicion"] == '001') {
      this.inputtype = 'decimal';
    } else { this.inputtype = 'int'; }

    let paquetesFiltrados: any[] = []
    this.parametros.map(r => {
      if (r.tipo === 'PAQUETE') {
        paquetesFiltrados.push(r)
      }
    })

    if (event.value && event.value === '001') {
      this.ListaTipoPaquete = this.ListaPaqueteOriginal.filter(r => r.adicional2 !== "001")
      paquetesFiltrados = this.ListaPaqueteOriginal.filter(r => r.adicional2 !== "001")
    } else {
      this.ListaTipoPaquete = this.ListaPaqueteOriginal.filter(r => r.adicional2 === "001")
      paquetesFiltrados = this.ListaPaqueteOriginal.filter(r => r.adicional2 === "001")
    }

    paquetesFiltrados = paquetesFiltrados.map(e => ({ label: e.nombre, value: e.codigo }));

    this.logicaMetadataFlete(paquetesFiltrados);
    this.group_Transporte.get('condicion')?.setValue(depositoEncontrado.codigo);

    this.cargarTarifasDefault();
  }

  logicaMetadataFlete(paquetes?) {
    if (this.solosli === false) {
      if (this.group_serviciostarifa.value["condicion"] != null) this.metadatableFlete = Array.from([]);
      if (this.group_serviciostarifa.value["condicion"] == '001' || this.group_serviciostarifa.value["condicion"] == '002') {
        if (this.isadmin == true) {
          this.metadatableFlete = Array.from(this.metadatableFlete1ConCostos);
        } else {
          this.metadatableFlete = Array.from(this.metadatableFlete1);
        }
      }
      else if (this.group_serviciostarifa.value["condicion"] == '003' || this.group_serviciostarifa.value["condicion"] == '004') {
        if (this.isadmin == true) {
          this.metadatableFlete = Array.from(this.metadatableFlete2ConCostos);
        } else {
          this.metadatableFlete = Array.from(this.metadatableFlete2);
        }
      }
    } else {
      this.metadatableFlete = Array.from(this.metadatableFlete1);
    }

    setTimeout(() => {
      const metadataItem = this.dataFlete.metadata.find(m => m.field === "pack_desc");
      if (metadataItem) {
        metadataItem.dropdown = [...paquetes];
      }
    }, 1000);


  }

  onServiciosLocalesChange() {
    this.group_servicioslocales.get('fechaemision')?.setValue(this.group_datosgenerales.value["fechaemision"]);
    this.group_servicioslocales.get('clienteDSL')?.setValue(this.codCliente?.toString() ?? null);
    this.group_servicioslocales.get('transportistaam')?.setValue(this.group_serviciostarifa.value["transportista"]);
    const depositoEncontrado = this.ListaTodosCondicion.find(deposito => deposito.codigo === this.group_serviciostarifa.value["condicion"]);
    this.group_servicioslocales.get('condicion')?.setValue(depositoEncontrado?.nombre);
  }

  inicializarValoresSL() {
    const datos = this.datosRecibidos;
    // var nombreCliente = this.group_datosgenerales.get('cliente')?.value
    // this.codCliente = Number(this.ListaTodosCliente.find(item => item.nombre === nombreCliente)?.codigo)
    // var nombreTransportista: string = this.group_serviciostarifa.value["transportista"]
    // this.codTransporte = Number(this.ListaTodosTransportista.find(item => item.nombre === nombreTransportista)?.codigo)
    // var nombreAgente: string = this.group_datosgenerales.value["agente"]
    // this.codAgente = Number(this.ListaTodosAgentes.find(item => item.nombre === nombreAgente)?.codigo)
    // this.codTransTerr = this.group_servicioslocales.get('transportistaTerre')?.value
    // this.group_Transporte.get('condicion')?.disable();

    this.codCliente = datos.entc_codcliente;
    this.codTransporte = datos.entc_codtransportista;
    this.codAgente = datos.entc_codagente;
    this.codTransTerr = datos.entc_codtransterre;
    this.group_Transporte.get('condicion')?.disable();
  }

  transformData(data: any[]): any[] { //Para mapear los datos para que funcione en select
    return data.map(item => ({
      labely: item.nombre,
      valuey: item.nombre,
      codigoy: item.codigo,
    }));
  }

  onCargaRefrigeradaChange(event: any) {
    const isChecked = event.checked;
    if (isChecked) {
      this.readOnlyTemperaturaDE = false;
    } else {
      this.readOnlyTemperaturaDE = true;
    }
  }

  onCargaPeligrosaChange(event: any) {
    const isChecked = event.checked;
    if (isChecked) {
      this.readonlyImoClassDE = false;
      this.readOnlyImoUnDE = false;
    } else {
      this.readonlyImoClassDE = true;
      this.readOnlyImoUnDE = true;
    }
    const imoClassControl = this.group_datosembarque.get('imoclass');
    const imoUnControl = this.group_datosembarque.get('imoun');

    if (isChecked) {
      imoClassControl?.addValidators(Validators.required);
      imoUnControl?.addValidators(Validators.required);
    } else {
      imoClassControl?.removeValidators(Validators.required);
      imoUnControl?.removeValidators(Validators.required);
    }

    imoClassControl?.updateValueAndValidity();
    imoUnControl?.updateValueAndValidity();

  }

  pasarDataPuertosFavoritosByVia(list: any) {
    this.datosCompartidosService.setlistaDatos(list);
  }

  panelOpenState = false;
  parametros: Parametros[] = [] // any[] = []//Variable para guardar todos los datos de LTW

  group: FormGroup //No hace nada

  //Declaracion de los FormGroup
  group_datosgenerales: FormGroup
  group_serviciostarifa: FormGroup
  group_datosembarque: FormGroup
  group_observaciones: FormGroup
  group_viaje: FormGroup
  group_novedades: FormGroup
  group_archivos: FormGroup
  group_eventostareas: FormGroup
  group_servicioslocales: FormGroup
  group_flotantes: FormGroup
  group_tipodocumento: FormGroup
  group_Transporte: FormGroup

  inicializarFormularios(row) {
    this.group_datosgenerales = new FormGroup({//30
      numero: new FormControl(row.ccot_numdoc, null),
      numerocotizacion: new FormControl(row.ccot_numdoccot, null),
      estado: new FormControl(row.cons_codest, Validators.required),
      cotizacionpropia: new FormControl(row.ccot_propia, null),
      avisodellegada: new FormControl(row.ccot_enviaavisollegada, null),
      serviciologistico: new FormControl(row.ccot_serviciologistico, null),
      servicio: new FormControl(row.ccot_serviciotransmision, null),
      regimen: new FormControl(row.cons_codrgm, Validators.required),
      via: new FormControl(row.cons_codvia, Validators.required),
      lineanegocio: new FormControl(row.cons_codlng, Validators.required),
      //fechaemision: new FormControl(row.ccot_fecemi, null),
      fechaemision: new FormControl(row.ccot_fecemi ? new Date(row.ccot_fecemi) : null, Validators.required),
      fechavencimiento: new FormControl(row.ccot_fecvcto ? new Date(row.ccot_fecvcto) : null, row.cons_codvia !== '002' ? Validators.required : null),
      fechaaprobacion: new FormControl(row.ccoT_FecAprueba ? new Date(row.ccoT_FecAprueba) : null),
      fechaembarque: new FormControl(row.ddov_fecembarque ? new Date(row.ddov_fecembarque) : null),
      cliente: new FormControl(row.entc_nomcliente, Validators.required),
      customer: new FormControl(row.entC_NomCustomer, this.solosli === false ? Validators.required : null),
      agente: new FormControl(row.entc_nomagente, Validators.required),
      incoterm: new FormControl(row.tipo_codinc, null),
      ejecutivo: new FormControl(row.entc_nomejecutivo, Validators.required),
      numerocrm: new FormControl(row.ccot_numpresupuesto, null),
      broker: new FormControl(null, null),//Se eliminó
      ordencompra: new FormControl(row.ccot_ordencompra, null),
      fecsalida: new FormControl(row.doov_fecsalida ? new Date(row.doov_fecsalida) : null, null),
      feconexion: new FormControl(row.doov_fecconexion ? new Date(row.doov_fecconexion) : null, null),
      descshipper: new FormControl(row.ccot_descshipper, null),
      descconsignee: new FormControl(row.ccot_descconsignee, null),
    })

    this.group_serviciostarifa = new FormGroup({
      transportista: new FormControl(row.entc_nomtransportista !== '' ? row.entc_nomtransportista : null, null),
      aerolinea: new FormControl(row.entc_codlinaerea),
      puertotransbordo: new FormControl(row.puer_codtrasbordo, null),
      trafico: new FormControl(row.tipo_codtrf, null),
      puertoorigen: new FormControl(row.puer_codorigen, this.solosli === false ? Validators.required : null),
      puertodestino: new FormControl(row.puer_coddestino, this.solosli === false ? Validators.required : null),
      moneda: new FormControl(row.tipo_codmnd, Validators.required),
      tipofechatarifa: new FormControl(row.cons_codtft, null),
      fechatarifa: new FormControl(row.ccot_fectarifa ? new Date(row.ccot_fectarifa) : null, null),
      condicion: new FormControl(row.cons_codfle, Validators.required),
      numerocontrato: new FormControl(row.cont_numero, null),
      cont_codigo: new FormControl(row.cont_codigo, null),
      adicional: new FormControl(row.cont_descrip, null),
      pcmbl: new FormControl(row.ccot_pagombl, Validators.required),
      pchbl: new FormControl(row.ccot_pagohbl, Validators.required),
      fletetotal: new FormControl(row.dcot_totaluniventa, null),
      diaslibres: new FormControl(row.ccot_sobreestadia, null),
    })

    this.group_datosembarque = new FormGroup({
      cargarefrigerada: new FormControl(row.ccot_cargarefrigerada, null),
      cargapeligrosa: new FormControl(row.ccot_cargapeligrosa, null),
      roundtrip: new FormControl(row.ccot_roundtrip, null),
      temperatura: new FormControl(row.ccot_temperatura, null),
      imoclass: new FormControl(row.tipo_codimo),
      imoun: new FormControl(row.ccot_imoun, [Validators.maxLength(4)]),
      shipper: new FormControl(row.entc_nomshipper, null),
      consignee: new FormControl(row.entc_nomconsignee, null),
      notify: new FormControl(row.entc_nomnotify, null),
      referencia: new FormControl(row.doov_codreferencia?.trim(), null),
      desc_shipper: new FormControl(row.ccot_descshipper, null),
      desc_consignee: new FormControl(row.ccot_descconsignee, null),
    })

    this.group_observaciones = new FormGroup({
      almacenaje: new FormControl(row.ccot_almacenaje, null),
      sobreestadia: new FormControl(row.ccot_sobreestadia, null),
      tiempoviaje: new FormControl(row.ccot_tiempoviaje, null),
      validezoferta: new FormControl(row.ccot_validezoferta, null),
      instrucciones: new FormControl(row.ccot_observaciones, null),
    })

    this.group_novedades = new FormGroup({
      numerobooking: new FormControl(row.ddov_nrobooking, null),
      fecharecepcion: new FormControl(null, null),//Se eliminó
      deposito: new FormControl(row.entc_nomdeptemporal, null),
      blnieto: new FormControl(row.ddov_hblnieto, null),
      blhijo: new FormControl(row.doov_hbl, (this.solosli === true && this.group_datosgenerales.value?.via !== '003') || (this.group_datosgenerales.value?.via === '002') ? Validators.required : null),
      blmaster: new FormControl(row.doov_mbl, null),
      contenedor: new FormControl(row.doov_cntr, null),
      viaje: new FormControl(row.nvia_codigo, null),
      zarpe: new FormControl(row.ata_atd ? new Date(row.ata_atd) : null, null),
      etaetd: new FormControl(row.etd ? new Date(row.etd) : null, null),
      nave: new FormControl(row.nave_nombre, null),
      tiponotificacion: new FormControl(null, null),//Se eliminó
      descripcion: new FormControl(null, null),//Se eliminó
    })
    this.group_archivos = new FormGroup({
      archivo: new FormControl(null, null),
    })

    this.group_eventostareas = new FormGroup({
      tipoevento: new FormControl(null, null),
      observaciones: new FormControl(null, null),
      fechahora: new FormControl(null, null),
      estado: new FormControl(null, null),
      modulo: new FormControl(null, null),
      usuario: new FormControl(null, null),
    })

    this.group_servicioslocales = new FormGroup({
      codigooperacion: new FormControl(row.cope_codigo, null),
      numerooperacion: new FormControl(row.cope_numdoc, null),
      fechaemision: new FormControl(row.cope_fecemi ? new Date(row.cope_fecemi) : null, Validators.required),
      clienteDSL: new FormControl(row.entc_codcliente?.toString() ?? null, null),
      transportistaam: new FormControl(row.entc_nombretransportista, null),
      almacen: new FormControl(row.entc_nombrealmacen, null),
      agencia: new FormControl(row.entc_nombreagenciamaritima, null),
      terminal: new FormControl(row.terminal_portuario, null),
      condicion: new FormControl(row.descripcioncondicionembarque, null),
      transportista: new FormControl(null, null),
      sada: new FormControl(null, null),
      imo: new FormControl(null, null),
      tarifa: new FormControl(row.ctar_codigo, null),
      tipo: new FormControl(row.tarifftype, null),
      vigenciadesde: new FormControl(row.validfrom ? new Date(row.validfrom) : null, null),
      vigenciahasta: new FormControl(row.validto ? new Date(row.validto) : null, null),
      descripcion: new FormControl(row.remarks, null),
      observaciones: new FormControl(null, null),
      transportistaTerre: new FormControl(null, null),
      fechasl: new FormControl(row.cope_fechaSL ? new Date(row.cope_fechaSL) : null, null),
      isintegral: new FormControl(row.sintegral, null),
      promedio: new FormControl(true, null),
      rutas: new FormControl(row.codigo_ruta, null),
      montocif: new FormControl(null, null),
      montodam: new FormControl(row.cope_dam, null),
      cifLogistico: new FormControl(row.cope_cifLogistico, null),
      cifEjecVta: new FormControl(row.cope_cifEjecVta, null),
      peso: new FormControl(row.cope_peso_sli, null),
      volumen: new FormControl(row.cope_volumen_sli, null),
      unmd_peso: new FormControl(row.cope_unmd_peso, null),
      unmd_volumen: new FormControl(row.cope_unmd_volumen, null),
      sucursal: new FormControl(row.sucursal, (this.solosli === true && this.group_servicioslocales.value?.sucursal === null && ((this.group_datosgenerales.value?.regimen === '001' && this.group_serviciostarifa.value?.puertodestino === null) || (this.group_datosgenerales.value?.regimen === '002' && this.group_serviciostarifa.value?.puertoorigen === null))) ? Validators.required : null),
      // contenedorsli: new FormControl(this.datosRecibidos ? String(this.datosRecibidos?.['listadofletes']?.[0]?.pack_codigo) : null, null),
      // cantidadctnr: new FormControl(this.datosRecibidos?.['listadofletes']?.[0]?.dcot_cantidad, null)
    })
    this.group_flotantes = new FormGroup({
      ccotnumdoc_visualizacion: new FormControl(row.ccot_numdoc, null),
      doovhbl_visualizacion: new FormControl(row.doov_hbl, null),
    })
    //this.group_datosgenerales.get('estado')?.setValue('001');
    this.group_tipodocumento = new FormGroup({
      index: new FormControl(null, null),
      rowdata: new FormControl(null, null),
      origen: new FormControl(null, null),
    })
    this.group_Transporte = new FormGroup({
      condicion: new FormControl(row.cons_codfle, null),
    })
    this.groupAuth = new FormGroup({
      tipoauth: new FormControl(null, null),
      usuario: new FormControl(null, [Validators.required]),
      contrasenia: new FormControl(null, [Validators.required]),
      token: new FormControl(null, [Validators.required]),
    })
  }


  item2: ItemsListarOrdenesVentaResponse;
  exit: string = 'nuevo'
  datos: any[] = []

  LTWPAQUETEnombres: any[] = []//No hace nada
  enviarDatos(datos: string) { //No hace nada
    return this.parametros
      .filter(param => param.tipo === datos)
      .map(param => param.nombre);
  }

  //Listas para mandar al componente datatable, es para los select:
  ListaTipoPaquete: SelectItem[] = []
  ListaOriginalTipoPaquete: SelectItem[] = []
  ListaPuertosByVia: SelectItem[] = []
  ListaPuertosByViaItinerario: SelectItem[] = []
  ListaServicio: SelectItem[] = []
  //ListaIngreEgre: any[]=[]
  ListaTipoEntidad: SelectItem[] = []
  ListaProveedorG: SelectItem[] = []
  ListaBase: SelectItem[] = []
  ListaMoneda: SelectItem[] = []
  ListaComodity: SelectItem[] = []
  ListaUnidadMedida: SelectItem[] = []
  ListaTipoDocumento: SelectItem[] = []
  ListaTipoDocumentoDP: SelectItem[] = []
  ListaTipoMotivosDP: SelectItem[] = []
  ListaUsuariosDP: SelectItem[] = []
  ListaServiciosByViaRgmLngDP: SelectItem[] = []
  ListaTDO_DP: SelectItem[] = []
  ListaTodosTDO: Parametros[] = []
  ListaAgentePortuario: any[] = [];
  ListaTerminalPortuario: any[] = [];
  ListaTodosPuerto: any[] = [];
  ListaTodosEstadoNaveViaje: any[] = [];
  ListadoOperaciones: any[] = []
  ListadoGrupoPaquete: any[] = []
  ListadoServicioContenedores: any[] = []
  ListadoTarifaAsociada: any[] = []
  ListaTodosLNGTable: SelectItem[] = []
  ListaTodosMotivosSLI: SelectItem[] = []
  // ListadoDetalleAsociada:any[]=[]
  // ListadoServiciosAsociados:any[]=[]
  ListadoControlAsociados: any[] = []
  // ListadoEventosAsociados:any[]=[]

  //Declaraciones de metaDatas:
  serviciosytarifas_dataflete: any[] = []
  // metadatableFlete: newmetadate[]

  serviciosytarifas_dataservicios: any[] = []
  // metadatableServicio: newmetadate[]

  // dtServiciosChangeControl: any[] = []
  // metadatableSeguro: newmetadate[]

  datosembarque_dataflete: any[] = []
  metadatableFleteEmbarque: newmetadate[]

  viajeitinerario_dataitinerario: any[] = []
  // metadatableItinerario: newmetadate[]

  viajeitinerario_datanave: any[] = []
  metadatableDataNave: newmetadate[]

  archivos_dataarchivos: any[] = []
  metadatableDataArchivos: newmetadate[]

  eventostareas_dataeventos: any[] = []
  //metadatableDataEventos: newmetadate[]

  servicioslocales_dataservicios: any[] = []
  metadatableDataServicios: newmetadate[]

  servicioslocales_datadetalle: any[] = []
  metadatableDataDetalle: newmetadate[] = [
    { title: 'ITEM', field: 'dope_item', filterType: 'text', inputType: 'text', inputStatus: 'lock' },
    { title: 'NC', field: '', filterType: 'text', inputType: 'buttonPersonalizado', icon: 'pi pi-clone', function: (row) => this.CrearChangeControl(row), toolTip: 'Generar Nota de Crédito', condicion: 'puedechangecontrol' },
    { title: 'ADICIONAL', field: 'esadicional', filterType: 'boolean', inputType: 'checkboxEditInput', readonly: true },
    { title: 'LÍNEA DE NEGOCIO', field: 'cons_desclng', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosLNGTable, virtualScroll: true, inputStatus: 'lock', showClear: false },
    { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosServiciosTable, virtualScroll: true },
    { title: 'T', field: '', inputType: 'buttonPersonalizado', icon: 'pi pi-money-bill', toolTip: 'Cambiar a Proveedor Real', function: (row) => this.visualizarTarifarioCosto(row), condicion: 'verTarifario' },
    { title: 'UNIDAD BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaBase, virtualScroll: false },
    { title: 'TIPO ENTIDAD', field: 'tipoentidad', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoEntidad, required: true },
    // { title: 'RAZÓN SOCIAL', field: 'entc_razonsocial', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaNombreEntidadesDP, virtualScroll: true, modoOutput: 'puedemodRZ' },
    {
      field: 'entc_razonsocial', title: 'RAZÓN SOCIAL', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaNombreEntidadesDP,
      modoOutput: 'puedemodRZ', virtualScroll: true
    },
    { title: 'TIPO DE CAMBIO', field: 'tipocambioventa', filterType: 'numeric', inputType: 'decimal', verColumna: (row) => this.verColumnaMetadata(row, 'tipo_cambio'), },
    {
      title: 'MONEDA COSTO', field: 'nombremnd', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosMonedaItem, virtualScroll: true, showClear: false,
      disabledD: (row: any) => row.esadicional === true ? false : row.verTarifario && this.isLogisticaPlus ? false : true
    },
    { title: 'MONEDA VENTA', field: 'nombremndvta', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosMonedaItem, virtualScroll: true },
    { title: 'AFECTO IGV', field: 'afeigv', filterType: 'text', inputType: 'checkbox' },
    {
      title: 'COSTO REAL<br>(UNIDAD)', field: 'dope_preciounitcosto', filterType: 'text', operacion2: 'multiplicar2', inputType: 'inputNumberEdit',
      toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row), modoOutput: 'puedemodRZ',
      tipoValidar: 'costo', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
      coversion: true, relacionConversion: [
        { columna: 'dope_preciounit_prom', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremnd', tipovalor: null, comparartp: null },
        { columna: 'profit_fijo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndprofit', tipovalor: null, comparartp: null },
        { columna: 'profitminimo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipomonedam', tipovalor: 'tipoprofitm', comparartp: 'dope_preciounit_prom' },
        { columna: 'dope_preciounitvta', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremndvta', tipovalor: null, comparartp: null },
        { columna: 'dope_preciounitcosto', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremnd', tipovalor: null, comparartp: null }],
      rowFooter: 'sum_misma_moneda', onFocusfunction: (row) => this.ModOutputEdit(row), onBlurfunction: (row) => this.ModOutputBlur(row),
      relacionMultiplicacion: [{ columna: 'dope_preciounitcosto', multiplicador: 'dope_cantidad', resultado: 'dope_preciototcosto', operacion: 'multiplicar' }],
      disabledD: (row: any) => row.esadicional === true ? false : row.verTarifario && this.isLogisticaPlus ? false : true
      , actualizarEstado: true
    },
    {
      title: 'COSTO PROM<br>(UNIDAD)', field: 'dope_preciounit_prom', filterType: 'text', inputType: 'decimal', rowFooter: 'sum_misma_moneda',
      toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row),
      relacionMultiplicacion: [{ columna: 'dope_preciounit_prom', multiplicador: 'dope_cantidad', resultado: 'dope_preciotot_prom', operacion: 'multiplicar' }],
      textoAlerta: ["El costo real es menor al costo promedio, solicitar autorización para descuento.", "Es necesario definir una venta para este costo.",],
      coversion: true, relacionConversion: [
        { columna: 'dope_preciounit_prom', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null },
        { columna: 'profit_fijo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndprofit', tipovalor: null, comparartp: null },
        { columna: 'profitminimo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipomonedam', tipovalor: 'tipoprofitm', comparartp: 'dope_preciounit_prom' },
        { columna: 'dope_preciounitvta', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndventa', tipovalor: null, comparartp: null },
        { columna: 'dope_preciounitcosto', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null }],
    },
    {
      title: 'VENTA<br>(UNIDAD)', field: 'dope_preciounitvta', filterType: 'text', operacion: 'multiplicar', inputType: 'decimal', rowFooter: 'sum_misma_moneda',
      toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row),
      relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }],
      // tipoValidar: 'costo', textoAlerta: ["El costo real es menor al costo promedio, solicitar autorización para descuento.", "Es necesario definir una venta para este costo.", "Profit negativo, solicite autorización para descuento."],
      validar: 'dope_preciounitcosto', tipoValidar: 'venta', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
      coversion: true, relacionConversion: [
        { columna: 'dope_preciounit_prom', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremnd', tipovalor: null, comparartp: null },
        { columna: 'profit_fijo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndprofit', tipovalor: null, comparartp: null },
        { columna: 'profitminimo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipomonedam', tipovalor: 'tipoprofitm', comparartp: 'dope_preciounit_prom' },
        { columna: 'dope_preciounitvta', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremndvta', tipovalor: null, comparartp: null },
        { columna: 'dope_preciounitcosto', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremnd', tipovalor: null, comparartp: null }],
    },
    {
      title: 'CANTIDAD', field: 'dope_cantidad', filterType: 'text', inputType: 'int', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dope_preciounitcosto', multiplicador: 'dope_cantidad', resultado: 'dope_preciototcosto', operacion: 'multiplicar' },
      { columna: 'dope_preciounit_prom', multiplicador: 'dope_cantidad', resultado: 'dope_preciotot_prom', operacion: 'multiplicar' },
      { columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }
      ]
    },
    { title: 'COSTO REAL (TOTAL)', field: 'dope_preciototcosto', filterType: 'text', inputType: 'decimalResultado2', rowFooter: 'sum_misma_moneda', },
    { title: 'COSTO PROM (TOTAL)', field: 'dope_preciotot_prom', filterType: 'text', inputType: 'decimal', rowFooter: 'sum_misma_moneda' },
    { title: 'VENTA (TOTAL)', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimalResultado', inputStatus: 'lock', rowFooter: 'sum_misma_moneda', },
    { title: 'Descripción<br>Tarifa', field: 'desctarifa', filterType: 'text', inputType: 'textdisabled' },
    { title: 'Vigencias<br>Tarifa', field: 'vigencias', filterType: 'text', inputType: 'textdisabled' },
    { title: 'N° Orden Serv.', field: 'cose_nroordenservicio', filterType: 'text', inputType: 'text' },
    { title: 'CÓDIGO VENTA', field: 'docv_codigo', filterType: 'text', inputType: 'text' },
    { title: 'COMPROBANTE VENTA', field: 'docv_comprobante', filterType: 'text', inputType: 'text' },
    { title: 'ITEM<br>REFERENCIA', field: 'dope_itemchangecontrol', filterType: 'text', inputType: 'text' },
    { title: 'FECHA<br>OPERACIÓN', field: 'fechaoperacion', filterType: 'text', inputType: 'date' },
    { title: 'MOTIVO', field: 'tipo_codmsd', filterType: 'text', inputType: 'selectEdit', dropdown: this.ListaTodosMotivosSLI, modoOutput: 'msd_editable' },
    { title: 'Estado', field: 'cons_descest', filterType: 'text', inputType: 'textdisabled', disabledD: (row: any) => true },
  ]

  metadatableDataDetalleVta: newmetadate[] = [
    { title: 'ADICIONAL', field: 'esadicional', filterType: 'boolean', inputType: 'checkboxEditInput', readonly: true },
    { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', inputType: 'autocomplete', dropdown: this.ListaTodosServiciosTable, virtualScroll: true },
    { title: 'UNIDAD<br>BASE', field: 'cons_desc_spa', inputType: 'autocomplete', dropdown: this.ListaBase, virtualScroll: true },
    { title: 'TIPO<br>ENTIDAD', field: 'tipoentidad', inputType: 'autocomplete', dropdown: this.ListaTipoEntidad, virtualScroll: true, required: true },
    // { title: 'RAZÓN SOCIAL', field: 'entc_razonsocial', inputType: 'autocomplete', dropdown: this.ListaNombreEntidadesDP, virtualScroll: true, modoOutput: 'puedemodRZ' },
    {
      field: 'entc_razonsocial', title: 'RAZÓN SOCIAL', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaNombreEntidadesDP,
      modoOutput: 'puedemodRZ', virtualScroll: true
    },
    // { title: 'MONEDA COSTO', field: 'nombremnd', filterType: 'text', inputType: 'text', dropdown: this.ListaMoneda },
    { title: 'TIPO DE CAMBIO', field: 'tipocambioventa', filterType: 'numeric', inputType: 'decimal', verColumna: (row) => this.verColumnaMetadata(row, 'tipo_cambio'), },
    { title: 'MONEDA<br>VENTA', field: 'nombremndvta', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosMonedaItem, virtualScroll: true },
    {
      title: 'VENTA<br>(UNIDAD)', field: 'dope_preciounitvta', filterType: 'text', operacion: 'multiplicar', inputType: 'decimal', toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row),
      validar: 'dope_preciounitcosto', tipoValidar: 'venta', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
      coversion: true, relacionConversion: [
        { columna: 'dope_preciounit_prom', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null },
        { columna: 'profit_fijo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndprofit', tipovalor: null, comparartp: null },
        { columna: 'profitminimo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipomonedam', tipovalor: 'tipoprofitm', comparartp: 'dope_preciounit_prom' },
        { columna: 'dope_preciounitvta', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremndvta', tipovalor: null, comparartp: null },
        { columna: 'dope_preciounitcosto', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null }],
      rowFooter: 'sum_misma_moneda', relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }]
    },
    // { title: 'PROFIT', field: 'profit_fijo', filterType: 'text', inputType: 'decimal' },
    // { title: 'PROFIT<br>MINIMO', field: 'profitminimo', filterType: 'text', inputType: 'decimal' },
    {
      title: 'CANTIDAD', field: 'dope_cantidad', filterType: 'text', operacion: 'multiplicar', inputType: 'int',
      relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }]
    },
    { title: 'VENTA<br>(TOTAL)', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimalResultado', inputStatus: 'lock', rowFooter: 'sum_misma_moneda' },
    { title: 'Descripción<br>Tarifa', field: 'desctarifa', filterType: 'text', inputType: 'textdisabled' },
    { title: 'Vigencias<br>Tarifa', field: 'vigencias', filterType: 'text', inputType: 'textdisabled' },
    { title: 'Estado', field: 'cons_descest', filterType: 'text', inputType: 'textdisabled', disabledD: (row: any) => true },
  ]

  metadatableDataDetalleCosto: newmetadate[] = [
    { title: 'ITEM', field: 'dope_item', filterType: 'text', inputType: 'text', inputStatus: 'lock' },
    { title: 'NC', field: '', filterType: 'text', inputType: 'buttonPersonalizado', icon: 'pi pi-clone', function: (row) => this.CrearChangeControl(row), toolTip: 'Generar Nota de Crédito', condicion: 'puedechangecontrol' },
    { title: 'ADICIONAL', field: 'esadicional', filterType: 'boolean', inputType: 'checkboxEditInput', readonly: true },
    { title: 'LÍNEA DE NEGOCIO', field: 'cons_desclng', inputType: 'autocomplete', dropdown: this.ListaTodosLNGTable, virtualScroll: true, inputStatus: 'lock', showClear: false },
    { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', inputType: 'autocomplete', dropdown: this.ListaTodosServiciosTable, virtualScroll: true },
    { title: 'T', field: '', inputType: 'buttonPersonalizado', icon: 'pi pi-money-bill', toolTip: 'Cambiar a Proveedor Real', function: (row) => this.visualizarTarifarioCosto(row), condicion: 'verTarifario' },
    { title: 'UNIDAD BASE', field: 'cons_desc_spa', inputType: 'autocomplete', dropdown: this.ListaBase, virtualScroll: false },
    { title: 'TIPO ENTIDAD', field: 'tipoentidad', inputType: 'autocomplete', dropdown: this.ListaTipoEntidad, required: true },
    {
      field: 'entc_razonsocial', title: 'RAZÓN SOCIAL', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaNombreEntidadesDP,
      modoOutput: 'puedemodRZ', virtualScroll: true
    },
    // { title: 'RAZÓN SOCIAL', field: 'entc_razonsocial', inputType: 'autocomplete', dropdown: this.ListaNombreEntidadesDP, virtualScroll: true, modoOutput: 'puedemodRZ' },
    { title: 'AFECTO<br>IGV', field: 'afeigv', filterType: 'text', inputType: 'checkbox' },
    // { title: 'RAZÓN SOCIAL', field: 'entc_razonsocial', inputType: 'autocomplete', dropdown: this.ListaNombreEntidadesDP },
    { title: 'TIPO DE CAMBIO', field: 'tipocambioventa', filterType: 'numeric', inputType: 'decimal', verColumna: (row) => this.verColumnaMetadata(row, 'tipo_cambio'), },
    {
      title: 'MONEDA<br>COSTO', field: 'nombremnd', inputType: 'autocomplete', dropdown: this.ListaTodosMonedaItem, virtualScroll: true, showClear: false,
      disabledD: (row: any) => row.esadicional === true ? false : row.verTarifario && this.isLogisticaPlus ? false : true
    },
    {
      title: 'COSTO REAL<br>(UNIDAD)', field: 'dope_preciounitcosto', filterType: 'text', operacion2: 'multiplicar2', inputType: 'inputNumberEdit',
      toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row), modoOutput: 'puedemodRZ',
      tipoValidar: 'costo', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
      coversion: true, relacionConversion: [
        { columna: 'dope_preciounit_prom', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremnd', tipovalor: null, comparartp: null },
        { columna: 'profit_fijo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndprofit', tipovalor: null, comparartp: null },
        { columna: 'profitminimo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipomonedam', tipovalor: 'tipoprofitm', comparartp: 'dope_preciounit_prom' },
        { columna: 'dope_preciounitvta', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremndvta', tipovalor: null, comparartp: null },
        { columna: 'dope_preciounitcosto', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremnd', tipovalor: null, comparartp: null }],
      rowFooter: 'sum_misma_moneda', onFocusfunction: (row) => this.ModOutputEdit(row), onBlurfunction: (row) => this.ModOutputBlur(row),
      relacionMultiplicacion: [{ columna: 'dope_preciounitcosto', multiplicador: 'dope_cantidad', resultado: 'dope_preciototcosto', operacion: 'multiplicar' }],
      disabledD: (row: any) => row.esadicional === true ? false : row.verTarifario && this.isLogisticaPlus ? false : true
    },
    {
      title: 'COSTO PROM<br>(UNIDAD)', field: 'dope_preciounit_prom', filterType: 'text', inputType: 'decimal', rowFooter: 'sum_misma_moneda',
      toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row),
      relacionMultiplicacion: [{ columna: 'dope_preciounit_prom', multiplicador: 'dope_cantidad', resultado: 'dope_preciotot_prom', operacion: 'multiplicar' }],
      textoAlerta: ["El costo real es menor al profit promedio, solicitar autorización para descuento.", "Es necesario definir una venta para este costo."],
      coversion: true, relacionConversion: [
        { columna: 'dope_preciounit_prom', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null },
        { columna: 'profit_fijo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndprofit', tipovalor: null, comparartp: null },
        { columna: 'profitminimo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipomonedam', tipovalor: 'tipoprofitm', comparartp: 'dope_preciounit_prom' },
        { columna: 'dope_preciounitvta', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndventa', tipovalor: null, comparartp: null },
        { columna: 'dope_preciounitcosto', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmnd', tipovalor: null, comparartp: null }],
    },
    { title: 'MONEDA<br>VENTA', field: 'nombremndvta', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosMonedaItem, virtualScroll: true },
    {
      title: 'VENTA<br>(UNIDAD)', field: 'dope_preciounitvta', filterType: 'text', operacion: 'multiplicar', inputType: 'decimal', rowFooter: 'sum_misma_moneda',
      toolTip: 'Solicitar Autorizacón', icon: 'pi pi-bell', function: (row) => this.SolicitarAutorizacion(row),
      relacionMultiplicacion: [{ columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }],
      // tipoValidar: 'costo', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
      //   "Profit negativo, solicite autorización para descuento."
      // ],
      validar: 'dope_preciounitcosto', tipoValidar: 'venta', textoAlerta: ["Venta menor a la tarifa, solicite autorización para descuento.", "Profit negativo, solicite autorización para descuento."],
      coversion: true, relacionConversion: [
        { columna: 'dope_preciounit_prom', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremnd', tipovalor: null, comparartp: null },
        { columna: 'profit_fijo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipo_codmndprofit', tipovalor: null, comparartp: null },
        { columna: 'profitminimo', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'tipomonedam', tipovalor: 'tipoprofitm', comparartp: 'dope_preciounit_prom' },
        { columna: 'dope_preciounitvta', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremndvta', tipovalor: null, comparartp: null },
        { columna: 'dope_preciounitcosto', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'nombremnd', tipovalor: null, comparartp: null }],
    },
    {
      title: 'CANTIDAD', field: 'dope_cantidad', filterType: 'text', inputType: 'int', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dope_preciounitcosto', multiplicador: 'dope_cantidad', resultado: 'dope_preciototcosto', operacion: 'multiplicar' },
      { columna: 'dope_preciounit_prom', multiplicador: 'dope_cantidad', resultado: 'dope_preciotot_prom', operacion: 'multiplicar' },
      { columna: 'dope_preciounitvta', multiplicador: 'dope_cantidad', resultado: 'dope_preciototvta', operacion: 'multiplicar' }
      ]
    },
    { title: 'COSTO REAL<br>(TOTAL)', field: 'dope_preciototcosto', filterType: 'text', inputType: 'decimalResultado2', rowFooter: 'sum_misma_moneda' },
    { title: 'COSTO PROM<br>(TOTAL)', field: 'dope_preciotot_prom', filterType: 'text', inputType: 'decimal', rowFooter: 'sum_misma_moneda' },
    { title: 'VENTA<br>(TOTAL)', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimalResultado', inputStatus: 'lock', rowFooter: 'sum_misma_moneda' },
    { title: 'Descripción<br>Tarifa', field: 'desctarifa', filterType: 'text', inputType: 'textdisabled' },
    { title: 'Vigencias<br>Tarifa', field: 'vigencias', filterType: 'text', inputType: 'textdisabled' },
    { title: 'CÓDIGO<br>VENTA', field: 'docv_codigo', filterType: 'text', inputType: 'text' },
    { title: 'N° Orden<br>Serv.', field: 'cose_nroordenservicio', filterType: 'text', inputType: 'text' },
    { title: 'TIPO<br>COMPROBANTE', field: 'tipocomprobante', filterType: 'text', inputType: 'text' },
    { title: 'COMPROBANTE<br>VENTA', field: 'docv_comprobante', filterType: 'text', inputType: 'text' },
    { title: 'ITEM<br>REFERENCIA', field: 'dope_itemchangecontrol', filterType: 'text', inputType: 'text' },
    { title: 'FECHA<br>OPERACIÓN', field: 'fechaoperacion', filterType: 'text', inputType: 'date' },
    { title: 'MOTIVO', field: 'tipo_codmsd', filterType: 'text', inputType: 'selectEdit', dropdown: this.ListaTodosMotivosSLI, modoOutput: 'msd_editable' },
    { title: 'Estado', field: 'cons_descest', filterType: 'text', inputType: 'textdisabled', disabledD: (row: any) => true },
  ]

  servicioslocales_tarifa: any[] = []
  metadatableTarifa: newmetadate[] = [
    { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
    { title: 'TARIFA', field: 'idtariff', filterType: 'text', inputType: 'int' },
    { title: 'VIGENTE DESDE', field: 'vigente_desde', filterType: 'text', inputType: 'date' },
    { title: 'VIGENTE HASTA', field: 'vigente_hasta', filterType: 'text', inputType: 'date' },
    { title: 'DESCRIPCIÓN', field: 'descripcion', filterType: 'text', inputType: 'text' },
    { title: 'CONCEPTO', field: 'concepto', filterType: 'text', inputType: 'text' },
    { title: 'UNIDAD BASE', field: 'unidad_base', filterType: 'text', inputType: 'text' },
    { title: 'MONEDA', field: 'moneda', filterType: 'text', inputType: 'text' },
    { title: 'IMPORTE VENTA', field: 'importe_venta', filterType: 'text', inputType: 'decimal' },
    { title: 'UNIDAD NEGOCIO', field: 'unidad_negocio', filterType: 'text', inputType: 'text' },
    { title: 'PLANTILLA', field: 'plantilla', filterType: 'text', inputType: 'int' },
    { title: 'AGENTE PORTUARIO', field: 'agente_portuario', filterType: 'text', inputType: 'text' },
    { title: 'ALMACÉN', field: 'almacen', filterType: 'text', inputType: 'text' },
    { title: 'CLIENTE', field: 'cliente', filterType: 'text', inputType: 'text' },
    { title: 'RÉGIMEN', field: 'regimen', filterType: 'text', inputType: 'text' },
    { title: 'SEGMENTO DE CLIENTE', field: 'segmento_de_cliente', filterType: 'text', inputType: 'text' },
    { title: 'TERMINAL PORTUARIO', field: 'terminal_portuario', filterType: 'text', inputType: 'text' },
    { title: 'TRANSPORTISTA', field: 'transportista', filterType: 'text', inputType: 'text' },
    { title: 'VÍA', field: 'via', filterType: 'text', inputType: 'text' },
  ]

  setFilterData(table: any[], filtro: string) {
    let tabla = []
    tabla = table.filter(r => r['tipo'] === filtro)
    return tabla
  }

  metadatableFlete: newmetadate[] = [ // original
    { title: 'TIPO PAQUETE', field: 'pack_desc', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete, maxWidth: "40px", widthInput: "10px" },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: 'int', operacion: 'multiplicar', maxWidth: "20px",
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar', maxWidth: "20px",
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado', maxWidth: "20px" },
  ]

  metadatableFlete1ConCostos: newmetadate[] = [
    { title: 'TIPO PAQUETE', field: 'pack_desc', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete, style: { width: "40%" } },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: 'int', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' },
      { columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
      , style: { width: "12%" }
    },
    {
      title: 'P.U. COSTO', field: 'dcot_preciounicosto', filterType: 'numeric', inputType: 'decimal', inputStatus: 'lock', operacion2: 'multiplicar2', style: { width: "12%" },
      relacionMultiplicacion: [{ columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
      , style: { width: "12%" }
    },
    { title: 'TOTAL COSTO', field: 'dcot_totalunicosto', filterType: 'numeric', inputType: 'decimalResultado2', rowFooter: 'sum', inputStatus: 'lock', style: { width: "12%" } },
    { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado', style: { width: "12%" } },
  ]

  inputtype: inputType = 'decimal';
  metadatableFlete1: newmetadate[] = [
    { title: 'TIPO PAQUETE', field: 'pack_desc', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: this.inputtype, operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' },
      { columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. COSTO', field: 'dcot_preciounicosto', filterType: 'numeric', inputType: 'decimal', inputStatus: 'lock', operacion2: 'multiplicar2',
      relacionMultiplicacion: [{ columna: 'dcot_preciounicosto', multiplicador: 'dcot_cantidad', resultado: 'dcot_totalunicosto', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    { title: 'TOTAL COSTO', field: 'dcot_totalunicosto', filterType: 'numeric', inputType: 'decimal', rowFooter: 'sum', inputStatus: 'lock' },
    { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado' },
  ]

  metadatableFlete2: newmetadate[] = [
    { title: 'TIPO PAQUETE', field: 'pack_desc', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: this.inputtype, operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado' },
  ]

  // VEO QUE ESTO NO SE USA EN EL HTML
  metadatableFlete2ConCostos: newmetadate[] = [
    { title: 'TIPO PAQUETE', field: 'pack_desc', inputType: 'autocomplete', dropdown: this.ListaTipoPaquete },
    {
      title: 'CANTIDAD', field: 'dcot_cantidad', filterType: 'numeric', inputType: this.inputtype, operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    {
      title: 'P.U. VENTA', field: 'dcot_preciouniventa', filterType: 'numeric', inputType: 'decimal', operacion: 'multiplicar',
      relacionMultiplicacion: [{ columna: 'dcot_preciouniventa', multiplicador: 'dcot_cantidad', resultado: 'dcot_totaluniventa', operacion: 'multiplicar' }]
    },
    { title: 'TOTAL VENTA', field: 'dcot_totaluniventa', filterType: 'numeric', rowFooter: 'sum', inputType: 'decimalResultado' },
  ]

  metadatableServicio: newmetadate[] = [
    { title: 'ITEMS', field: 'scot_item', filterType: 'text', inputType: 'int', inputStatus: 'lock', widthInput: "10px", maxWidth: '60px' },
    { title: 'EXONERADO', field: 'scot_exonerado', filterType: 'boolean', inputType: 'checkboxEdit', inputStatus: 'lock', style: { width: '10px', align: 'center', justify: 'left' } },
    { title: 'SERVICIO', field: 'serv_nombre', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServiciosByViaRgmLngDP, style: { width: '20%', align: 'center', justify: 'left' }, widthInput: '200px', required: true },
    { title: 'I/E', field: 'ccot_ingresogasto', filterType: 'text', inputType: 'autocomplete', toolTip: "Ingreso/Egreso", dropdown: this.ListaServicio, required: true },//?
    { title: 'T. ENTIDAD', field: 'tipedescripcion', filterType: 'text', toolTip: "Tipo Entidad", inputType: 'autocomplete', dropdown: this.ListaTipoEntidad, buscar: 'tipe_codigo', children: 'entc_nomcom', required: true },
    { title: 'PROVEEDOR', field: 'entc_nomcom', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaProveedorG, virtualScroll: true, style: { width: '5%', align: 'center', justify: 'left' }, widthInput: '200px', required: true },
    { title: 'BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaBase, required: true },
    { title: 'CANTIDAD', field: 'scot_cantidad', filterType: 'text', inputType: 'int', widthInput: '60px !important', required: true },
    { title: 'MONEDA', field: 'tipo_descmnd', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaMoneda, style: { width: '5px', align: 'center', justify: 'left' }, required: true },
    { title: 'P. UNITARIO', field: 'scot_preciouni', filterType: 'text', toolTip: "Precio Unitario", inputType: 'decimal', widthInput: '80px !important', required: true },
    { title: 'I. INGRESO', field: 'scot_importe_ingreso', filterType: 'text', toolTip: "Importe Ingreso", inputType: 'decimal', widthInput: '80px !important' },
    { title: 'I. EGRESO', field: 'scot_importe_egreso', filterType: 'text', toolTip: "Importe Egreso", inputType: 'decimal', widthInput: '80px !important' },
    { title: 'A. IGV', field: 'serv_afeigv', filterType: 'boolean', toolTip: "Afecto a IGV", inputType: 'checkboxEdit' },
    { title: 'A. DETRACCIÓN', field: 'serv_afedet', filterType: 'boolean', toolTip: "Afecto a Detraccion", inputType: 'checkboxEdit' },
    //{ title: 'TIPO DOCUMENTO', field: null, filterType: 'text', inputType:'text' },//boton
    { title: 'TIPO DOC.', field: 'tipo_desctdo', filterType: 'text', toolTip: "Tipo Documento", inputType: 'autocomplete', dropdown: this.ListaTipoDocumentoDP, widthInput: '300px' },//Lo seleccionado, llega como null desde la BD
    { title: 'SERIE DOC.', field: 'scot_serietdo', filterType: 'text', toolTip: "Serie Documento", inputType: 'text' },
    { title: 'NRO. DOC', field: 'scot_numerotdo', filterType: 'text', toolTip: "Nro Documento", inputType: 'text' },
    { title: 'FEC. EMISIÓN', field: 'audi_feccrea', filterType: 'text', inputType: 'date' },//Cambiar luego por "scot_fechaemision, usando: audi_feccrea; this.formatDate('audi_feccrea', 'MM/DD/YYYY HH:mm:ss')"
  ]

  metadatableDataObservaciones: newmetadate[] = []

  // datosViajePorPuerto2:any[]=[]

  metadatableSeguro: newmetadate[] = [
    { title: 'EXONERADO', field: null, filterType: 'text', inputType: 'text' },
    { title: 'SERVICIO', field: null, filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServiciosByViaRgmLngDP },
    { title: 'INGRESO/EGRESO', field: null, filterType: 'text', inputType: 'text' },
    { title: 'ENTIDAD', field: null, filterType: 'text', inputType: 'text' },
    { title: 'TIPO ENTIDAD', field: null, filterType: 'text', inputType: 'text' },
    { title: 'PROVEEDOR', field: null, filterType: 'text', inputType: 'text' },
    { title: 'BASE', field: null, filterType: 'text', inputType: 'text' },
    { title: 'CANTIDAD', field: null, filterType: 'text', inputType: 'text' },
    { title: 'MONEDA', field: null, filterType: 'text', inputType: 'text' },
    { title: 'PRECIO UNITARIO', field: null, filterType: 'text', inputType: 'text' },
    { title: 'IMPORTE EGRESO', field: null, filterType: 'text', inputType: 'text' },
    { title: 'AFECTO IGV', field: null, filterType: 'text', inputType: 'text' },
    { title: 'AFECTO DETRACCIÓN', field: null, filterType: 'text', inputType: 'text' },
    { title: 'TIPO DOCUMENTO', field: null, filterType: 'text', inputType: 'text' },//
    { title: 'SERIE DOCUMENTO', field: null, filterType: 'text', inputType: 'text' },
    { title: 'NRO. DOCUMENTO', field: null, filterType: 'text', inputType: 'text' },
    { title: 'FEC. EMISIÓNNEW', field: null, filterType: 'text', inputType: 'text' },
  ]

  data: any = {
    puertoOrigen: this.objPuertoOrigen,
    data: this.datosViajePorPuerto2
  }

  inputbloqueado: 'lock' | "nolock" = 'nolock'

  metadatableItinerario: newmetadate[] = [
    { title: 'TRAMO', field: 'ovnv_item', filterType: 'numeric', inputType: 'textdisabled', maxWidth: '40px' },
    { title: 'FEEDER', field: 'nvia_esfeeder', filterType: 'boolean', inputType: 'checkboxEditInput', readonly: true },
    { title: 'FINAL', field: 'ovnv_final', filterType: 'boolean', inputType: 'checkboxEditInput', readonly: true },
    { title: 'CÓDIGO VIAJE', field: 'nvia_codigo', filterType: 'text', inputType: 'text', popup: 'y', maxWidth: '70%', function: (params: any) => this.popupViajeItinerario(params), },
    { title: 'NAVE', field: 'nave_nombre', filterType: 'text', inputType: 'text' },
    { title: this.solo_aereo == false ? 'VIAJE' : 'VUELO', field: 'nvia_nroviaje', filterType: 'text', inputType: 'text', inputStatus: this.inputbloqueado, },
    { title: 'ETD', field: 'etd', filterType: 'text', inputType: 'date' },
    { title: 'FECHA EMBARQUE', field: 'fechaembarque', filterType: 'text', inputType: 'date' },
    { title: 'ETA', field: 'eta', filterType: 'text', inputType: 'date' },
    { title: 'POL', field: 'nameportloading', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaPuertosByVia },
    { title: 'POD', field: 'nameportdischarge', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaPuertosByVia },
  ]

  metadatableDataEventos: newmetadate[] = [
    { title: 'EVENTO/TAREA', field: 'tipo_desc1', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosEventoTarea, widthInput: '400px' },
    // { title: 'MODULO', field: 'cons_desc_spa', filterType: 'text', inputType: 'text' },
    { title: 'FECHA', field: 'even_fecha', filterType: 'text', inputType: 'date', inputStatus: 'lock' },
    // { title: 'CUMPLIDA', field: 'even_cumplida', filterType: 'boolean', inputType: 'checkboxEdit' },
    { title: 'USUARIO', field: 'even_usuario', filterType: 'text', inputType: 'text' },
    { title: 'OBSERVACIONES', field: 'even_observaciones', filterType: 'text', inputType: 'viewobservaciones', maxWidth: '800px' },
    // { title: 'DETALLE OBS.', field: 'even_observaciones_detalle', maxWidth: '20px', popup: 'verDetalle', popupTitle: 'OBSERVACIONES DEL EVENTO' }
  ]

  ListaPaqueteOriginal: any[] = []
  dtServiciosChangeControl: any[] = []
  mtServiciosChangeControl: newmetadate[] = [
    // { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
    {
      field: 'btn_referencia', title: '', inputType: "buttonPersonalizado", icon: 'pi pi-copy', function: (row: any) => this.btnChangeControl2(row),
      style: { align: "center" }, toolTip: 'Crear Change Control con Referencia'
    },
    {
      field: 'btn_finanzas', title: 'SAP', inputType: "buttonPersonalizado", icon: 'pi pi-send', function: (row: any) => this.EnviarFinanzasServicioChangeControl(row),
      style: { align: "center" }, toolTip: 'Enviar Servicio a Finanzas (SAP)'
    },
    { title: 'ITEMS', field: 'scot_item', filterType: 'text', inputType: 'int', inputStatus: 'lock' },
    { title: 'EXONERADO', field: 'scot_exonerado', filterType: 'boolean', inputType: 'checkboxEdit', inputStatus: 'lock' },
    { title: 'SERVICIO', field: 'serv_nombre', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServiciosByViaRgmLngDP, style: { width: '20%', align: 'center', justify: 'left' }, widthInput: '350px' },
    { title: 'INGRESO/EGRESO', field: 'ccot_ingresogasto', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServicio },
    { title: 'TIPO ENTIDAD', field: 'tipedescripcion', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoEntidad },
    { title: 'ENTIDAD', field: 'entc_nomcom', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaProveedorG, virtualScroll: true, style: { width: '15%', align: 'center', justify: 'left' }, widthInput: '350px' },
    { title: 'BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaBase },
    { title: 'CANTIDAD', field: 'scot_cantidad', filterType: 'text', inputType: 'int' },
    { title: 'MONEDA', field: 'tipo_descmnd', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaMoneda },
    { title: 'PRECIO UNITARIO', field: 'scot_preciouni', filterType: 'text', inputType: 'decimal' },
    { title: 'IMPORTE INGRESO', field: 'scot_importe_ingreso', filterType: 'text', inputType: 'decimal' },
    { title: 'IMPORTE EGRESO', field: 'scot_importe_egreso', filterType: 'text', inputType: 'decimal' },
    { title: 'AFECTO IGV', field: 'serv_afeigv', filterType: 'boolean', inputType: 'checkboxEdit' },
    { title: 'AFECTO DETRACCIÓN', field: 'serv_afedet', filterType: 'boolean', inputType: 'checkboxEdit' },
    { title: 'TIPO DOCUMENTO', field: 'tipo_desctdo', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoDocumentoDP, widthInput: '300px' },
    { title: 'SERIE DOCUMENTO', field: 'scot_serietdo', filterType: 'text', inputType: 'text' },
    { title: 'NRO. DOCUMENTO', field: 'scot_numerotdo', filterType: 'text', inputType: 'text' },
    { title: 'FEC. EMISIÓNNEW', field: 'audi_feccrea', filterType: 'date', inputType: 'date' },
    { title: 'FECHA. OPERACIÓN', field: 'scot_fecha_operacion', filterType: 'date', inputType: 'date' },
    { title: 'CÓDIGO CTACTE', field: 'ccct_codigo', filterType: 'text', inputType: 'text' },
    { title: 'DOCUMENTO SAP', field: 'documentosap', filterType: 'text', inputType: 'text' },
    { title: 'ITEM REFERENCIA', field: 'scot_itemchangecontrol', filterType: 'text', inputType: 'int' },
    { title: 'DESCRIPCIÓN MOTIVO', field: 'nombremotivo', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoMotivosDP, widthInput: '350px' },
    { title: 'RESPONSABLE', field: 'scot_solicitante', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaUsuariosDP, widthInput: '300px' },
    { title: 'USUARIO AUTORIZA', field: 'scot_autoriza', filterType: 'text', inputType: 'text', dropdown: this.ListaUsuariosDP, widthInput: '300px' },
  ]

  solosli: boolean = false;
  async ngOnInit(): Promise<void> {
    const loadingScreen = this.util.showLoadingScreen({ message: "Cargando datos..." });
    try {
      this.nombreUsuario = this.storage.get("usuario");
      this.listadoRoles = this.rolesService.getRoles();
      // await this.listarRolesUsr();
      this.rol = this.storage.get('rol');
      const rol = this.rol;
      const roladd = this.rol;

      if (roladd != '4') {
        this.isadmin = true
      } else {
        this.isadmin = false
      }
      if (roladd === '1') {
        this.adicional = null;
      } else if (
        this.listadoRoles.some((r: any) =>
          ['1', '10', '11', '14', this.coordLog, this.gerentLog].includes(String(r.role_codigo))
        )) {
        // } else if (['1', '10', '11', '14', this.coordLog, this.gerentLog].includes(this.listadoRoles.role_codigo)) {
        this.adicional = true;
      } else {
        this.adicional = false;
      }

      // try {
      //   const res = await firstValueFrom(this.ordenventaService.ValidacionMapeoDatos(request));
      //    res.datos.status === 200 && res.datos.result === true;
      // } catch (error) {
      //   console.error(error);
      // }

      this.inicializarFormularios([])
      this.parametros = await this.util.getParametros()
      this.listarDatosParam()
      this.ListarParametros()
      this.parametros.map(r => {
        if (r.tipo === 'PAQUETE') {
          const item: SelectItem = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaOriginalTipoPaquete.push(item)
        }
        if (r.tipo === 'PAQUETE') {
          const item: SelectItem = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaTipoPaquete.push(item)
          this.ListaPaqueteOriginal.push(r)
        }
        if (r.tipo === 'TMC') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaServicio.push(item)
        }
        if (r.tipo === 'BAS') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaBase.push(item)
        }
        if (r.tipo === 'MND') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaMoneda.push(item)
        }
        if (r.tipo === 'TDO') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaTipoDocumento.push(item)
        }

        if (r.tipo === 'CDT') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaComodity.push(item)
        }
        if (r.tipo === 'UNM') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaUnidadMedida.push(item)
        }

        if (r.tipo === 'TIPE') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaTipoEntidad.push(item)
        }
        if (r.tipo === 'CLIENTE' || r.tipo === 'SHIPPER' || r.tipo === 'TRANSPORTISTA' || r.tipo === 'AGE' || r.tipo === 'PROVEEDOR') { //chiwa
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaProveedorG.push(item)
        }
        if (r.tipo === 'PROVEEDOR' || r.tipo === 'AGE' || r.tipo === 'DepositoVacio' || r.tipo === 'TERMINALPORTUARIO'
          || r.tipo === 'DepositoTemp' || r.tipo === 'TRANSPORTISTA' || r.tipo === 'SHIPPER' || r.tipo === 'CLIENTE') {
          const item = { label: r.nombre, value: r.codigo, tipo: r.tipo }
          this.ListaNombreEntidadesDP.push(item)
        }
        // if (r.tipo === 'EVE') {
        //   const item = {
        //     label: r.nombre,
        //     value: r.codigo
        //   }
        //   this.ListaTodosEventoTarea.push(item)
        // }
        if (r.tipo === 'DESCSERVL') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaTodosDescripcionServiciosLocales.push(item)
        }
        // if (r.tipo === 'CODBASE') {
        //   const item = {
        //     label: r.nombre,
        //     value: r.codigo
        //   }
        //   this.ListaTodosCodBase.push(item)
        // }
        // if (r.tipo === 'TRANSPORTISTA') {
        //   const item = {
        //     label: r.nombre,
        //     value: r.codigo
        //   }
        //   this.ListaTodosTransportista.push(item)
        // }
        if (r.tipo === 'EVE') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaTodosEventoTarea.push(item)


        }
        if (r.tipo === 'TDO') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaTipoDocumentoDP.push(item)
        }
        if (r.tipo === 'MCC') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaTipoMotivosDP.push(item)
        }
        if (r.tipo === 'LNG') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaTodosLNGTable.push(item)
        }
        if (r.tipo === 'SERVICIOSLI') {
          const item = {
            label: r.nombre.trim(),
            value: r.codigo,
            lng: r.lineaNegocio,
            rgm: r.regimen,
            via: r.via
          }
          this.ListaTodosServiciosTable.push(item)
        }
        if (r.tipo === 'MONEDA') {
          const item = {
            label: r.adicional1,
            value: r.codigo
          }
          this.ListaTodosMonedaItem.push(item)
        }
        if (r.tipo === 'MSD') {
          const item = {
            label: r.nombre,
            value: r.codigo
          }
          this.ListaTodosMotivosSLI.push(item)
        }
      })

      this.ListaOriginalTipoPaquete.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaTipoPaquete.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaServicio.sort((a, b) => a.label.localeCompare(b.label));
      // this.ListaBase.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaMoneda.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaTipoDocumento.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaComodity.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaUnidadMedida.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaProveedorG.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaTodosDescripcionServiciosLocales.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaTodosEventoTarea.sort((a, b) => a.label.localeCompare(b.label));
      this.ListaFiltradaNombreEntidadesDP = this.ListaNombreEntidadesDP
      this.ListaFiltradaTodosServiciosTable = this.ListaTodosServiciosTable
      this.eventostareas_dataeventos = []

      this.metadatableFleteEmbarque = [
        { title: 'COMODITY', field: 'cdt_desc', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaComodity },//?
        { title: 'PRODUCTO', field: 'dcot_producto', filterType: 'text', inputType: 'text' },
        { title: 'BULTOS', field: 'dcot_bultos', filterType: 'numeric', inputType: 'decimal' },
        { title: 'UNIDAD MEDIDA', field: 'unm_desc', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaUnidadMedida },
        { title: 'PESO (Kg)', field: 'dcot_peso', filterType: 'numeric', inputType: 'decimal' },
        { title: 'VOLUMEN (m3)', field: 'dcot_volumen', filterType: 'numeric', inputType: 'decimal' },
        { title: 'LARGO (cm)', field: 'dcot_largo', filterType: 'numeric', inputType: 'decimal' },
        { title: 'ANCHO (cm)', field: 'dcot_ancho', filterType: 'numeric', inputType: 'decimal' },
        { title: 'ALTO (cm)', field: 'dcot_alto', filterType: 'numeric', inputType: 'decimal' },
      ]

      this.metadatableDataNave = [
        {
          field: 'btn_editar', title: '', inputType: "buttonPersonalizado", icon: 'pi pi-file-edit', function: (row: any) => this.editarNaveViaje(row),
          style: { align: "center" }, toolTip: "Editar Nave Viaje", disabled: false
        },
        { title: 'TRAMO', field: 'ovnv_item', filterType: 'text', inputType: 'text', maxWidth: '40px' },
        { title: 'ETA CONTABLE', field: 'eta_contable', filterType: 'text', inputType: 'date' },
        { title: 'ETA OPERATIVA', field: 'eta_operativo', filterType: 'text', inputType: 'date' },
        { title: 'FECHA CUTOFF', field: 'nvia_feccutoff_expo', filterType: 'text', inputType: 'date' },
        { title: 'FECHA LLEGADA', field: 'fechallegada', filterType: 'text', inputType: 'date' },
        { title: 'FECHA ZARPE', field: 'fechazarpe', filterType: 'text', inputType: 'date' },
        { title: 'FECHA ARRIBO', field: 'fechaarribo', filterType: 'text', inputType: 'date' },
        { title: 'FECHA CIERRE DIRECC / TERMINO DE E.', field: 'nvia_feccierredire_impo_termemba_expo', filterType: 'text', inputType: 'date' },
        { title: 'FECHA DESCARGA', field: 'nvia_fecdescarga_impo', filterType: 'text', inputType: 'date' },
        { title: 'FECHA PLAZO VOBO', field: 'nvia_fecplazovistobueno', filterType: 'text', inputType: 'date' },
        { title: 'NRO. MANIFIESTO', field: 'nvia_nromanifiesto', filterType: 'text', inputType: 'text' },
        { title: 'NRO. MANIFIESTO DESCON', field: 'nvia_normanifiestodescon', filterType: 'text', inputType: 'text' },
        { title: 'FECHA RECOGER DOCS', field: 'entc_fecrecogerdocs', filterType: 'text', inputType: 'date' },
        { title: 'TERMINAL PORTUARIO', field: 'terminalportuario', filterType: 'text', inputType: 'text' },
        { title: 'AGENTE PORTUARIO VOBO', field: 'agenteportuariovobo', filterType: 'text', inputType: 'text' },
      ]

      this.metadatableDataArchivos = [
        { title: 'FECHA', field: 'ovar_fecemi', filterType: 'text', inputType: 'date' },
        { title: 'DESCRIPCIÓN', field: 'ovar_descrip', filterType: 'text', inputType: 'text' },
        { title: 'OBSERVACIÓN', field: 'ovar_observacion', filterType: 'text', inputType: 'text' },
        { title: 'DESCARGAR', field: 'ovar_descargar', filterType: 'text', inputType: 'text', showDowndloadButton: true },
      ]

      //     this.metadatableDataEventos : newmetadate[] =[
      //    //   { title: 'EVENTO/TAREA', field: 'tipo_desc1', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosEventoTarea, widthInput: '400px' },
      //    //   // { title: 'MODULO', field: 'cons_desc_spa', filterType: 'text', inputType: 'text' },
      //      { title: 'FECHA', field: 'even_fecha', filterType: 'text', inputType: 'date', inputStatus: 'lock' },
      //    //   // { title: 'CUMPLIDA', field: 'even_cumplida', filterType: 'boolean', inputType: 'checkboxEdit' },
      //    //   { title: 'USUARIO', field: 'even_usuario', filterType: 'text', inputType: 'text' },
      //    //   { title: 'OBSERVACIONES', field: 'even_observaciones', filterType: 'text', inputType: 'textResumidoOutput', maxWidth: '300px' },
      //  //     { title: 'DETALLE OBS.', field: 'even_observaciones_detalle', maxWidth: '20px', popup: 'verDetalle', popupTitle: 'OBSERVACIONES DEL EVENTO' }
      //     ]

      this.metadatableDataServicios = [
        { title: 'SERVICIO', field: 'conceptdescription', filterType: 'text', inputType: 'text' },
        { title: 'UNIDAD', field: 'unitdescription', filterType: 'text', inputType: 'text' },
        { title: 'MONEDA', field: 'currency', filterType: 'text', inputType: 'text' },//???????
        { title: 'IMPORTE VENTA', field: 'salesamount', filterType: 'text', inputType: 'text' },
      ]

      this.metadatableDataObservaciones = [
        { title: 'FECHA', field: 'even_fecha', filterType: 'text', inputType: 'text' },
        { title: 'USUARIO', field: 'even_usuario', filterType: 'text', inputType: 'text' },
        { title: 'OBSERVACIONES', field: 'even_observaciones', filterType: 'text', inputType: 'text' },//??????
        { title: 'ARCHIVO', field: 'even_filename', filterType: 'text', inputType: 'text' },

      ]

      this.metadatableTarifa = [
        { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
        { title: 'TARIFA', field: 'idtariff', filterType: 'text', inputType: 'int' },
        { title: 'VIGENTE DESDE', field: 'vigente_desde', filterType: 'text', inputType: 'date' },
        { title: 'VIGENTE HASTA', field: 'vigente_hasta', filterType: 'text', inputType: 'date' },
        { title: 'DESCRIPCIÓN', field: 'descripcion', filterType: 'text', inputType: 'text' },
        { title: 'CONCEPTO', field: 'concepto', filterType: 'text', inputType: 'text' },
        { title: 'UNIDAD BASE', field: 'unidad_base', filterType: 'text', inputType: 'text' },
        { title: 'MONEDA', field: 'moneda', filterType: 'text', inputType: 'text' },
        { title: 'IMPORTE VENTA', field: 'importe_venta', filterType: 'text', inputType: 'decimal' },
        { title: 'UNIDAD NEGOCIO', field: 'unidad_negocio', filterType: 'text', inputType: 'text' },
        { title: 'PLANTILLA', field: 'plantilla', filterType: 'text', inputType: 'int' },
        { title: 'AGENTE PORTUARIO', field: 'agente_portuario', filterType: 'text', inputType: 'text' },
        { title: 'ALMACÉN', field: 'almacen', filterType: 'text', inputType: 'text' },
        { title: 'CLIENTE', field: 'cliente', filterType: 'text', inputType: 'text' },
        { title: 'RÉGIMEN', field: 'regimen', filterType: 'text', inputType: 'text' },
        { title: 'SEGMENTO DE CLIENTE', field: 'segmento_de_cliente', filterType: 'text', inputType: 'text' },
        { title: 'TERMINAL PORTUARIO', field: 'terminal_portuario', filterType: 'text', inputType: 'text' },
        { title: 'TRANSPORTISTA', field: 'transportista', filterType: 'text', inputType: 'text' },
        { title: 'VÍA', field: 'via', filterType: 'text', inputType: 'text' },
      ]

      switch (this.adicional) {
        case true:
          this.metadatableDataDetalle = [...this.metadatableDataDetalleCosto]
          // this.bloqueoColumnas = [...this.bloqueoColumnasCosto]
          this.reset = [...this.resetCosto]
          break;
        case false:
          this.metadatableDataDetalle = [...this.metadatableDataDetalleVta]
          // this.bloqueoColumnas = [...this.bloqueoColumnasVta]
          this.reset = [...this.resetVta]
          break;
        default:
          this.metadatableDataDetalle = [...this.metadatableDataDetalle]
          // this.bloqueoColumnas = [...this.bloqueoColumnas]
          this.reset = [...this.resetCosto]
          break;
      }

      await this.validacionBloqueoRoles();

      this.metadataTableDetalleAgrupacion = [
        { title: 'DESCRIPCIÓN', field: 'serv_nombre_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTodosDescripcionServiciosLocales },
        { title: 'VENTA', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimal', operacion: 'multiplicar' },
        // { title: 'CANTIDAD', field: 'dope_cantidad', filterType: 'text', inputType: 'int', operacion: 'multiplicar' },
        // { title: 'VENTA (TOTAL)', field: 'dope_preciototvta', filterType: 'text', inputType: 'decimalResultado' },
        { title: '', field: '', inputType: 'buttonPersonalizado', icon: "pi pi-eye", toolTip: "Ver Tarifa", function: (row) => this.viewTarifas(row), condicion: 'agrupado' }
      ]

      this.datosRecibidos = JSON.parse(localStorage.getItem('datoov'))
      this.datos = this.datosRecibidos
      const opcion = this.accion

      if (opcion == 'EDITAR' || opcion === 'VISUALIZAR') {
        this.solosli = this.datosRecibidos.sli
        console.log("Solo SLI: ", this.solosli);
        console.log("Solo serv: ", this.datos['listadoservicio']);
        console.log("Solo leng: ", this.datos['listadoservicio'].length);


        if (this.datos && this.datos['listadoservicio']) {
          this.serviciosytarifas_dataservicios = this.datos['listadoservicio'];
        }


        if (this.datos && this.datos['listadoseguro']) {
          this.dtServiciosChangeControl = this.datos['listadoseguro'];
        }

        if (this.datos && this.datos['listadoviajeitinerario']) {
          this.viajeitinerario_dataitinerario = structuredClone(this.datos['listadoviajeitinerario']);
          this.viajeitinerario_dataitinerario.forEach(item => {
            item.ESTADO_OBJ = "NA";
          });
        }

        if (this.datos && this.datos['listadodetallenaveviaje']) {
          this.viajeitinerario_datanave = structuredClone(this.datos['listadoviajeitinerario']);
        }

        if (this.datos && this.datos['listadoarchivo']) {
          this.archivos_dataarchivos = this.datos['listadoarchivo'];
        }

        if (this.datos && this.datos['listadoeventostareas']) {
          this.eventostareas_dataeventos = this.datos['listadoeventostareas'];
        }

        if (this.datos && this.datos['listadoseguimientoembarque']) {
          this.seguimiento_Embarque = this.datos['listadoseguimientoembarque'];
        }

        if (this.datosViajePorPuerto2) {
        }

        if (this.datos && this.datos['listadooperaciones']) {
          this.ListadoOperaciones = this.datos['listadooperaciones'];
        }

        if (this.datos && this.datos['listadogrupopaquete']) {
          this.ListadoGrupoPaquete = this.datos['listadogrupopaquete'];
        }

        if (this.datos && this.datos['listadoserviciocontenedores']) {
          this.ListadoServicioContenedores = this.datos['listadoserviciocontenedores'];
        }

        if (this.datos && this.datos['listadotarifaasociada']) {
          this.ListadoTarifaAsociada = this.datos['listadotarifaasociada'];
        }

        if (this.datos && this.datos['listadodetalleasociada']) {//Es una tabla
          this.servicioslocales_dataservicios = this.datos['listadodetalleasociada'];
        }

        if (this.datos && this.datos['listadoserviciosasociados']) {//Es una tabla
          this.listadoOriginal = structuredClone(this.datos['listadoserviciosasociados']);
          this.servicioslocales_datadetalle = structuredClone(this.datos['listadoserviciosasociados']);
          this.servicioslocales_datadetalle.forEach(row => {
            row['ESTADO_OBJ'] = 'NA',
              // row['colorletra'] = row.cons_codest === '002' ? 'rgb(4, 0, 255)' : (row.cons_codest === '005' ? '#ff0000ff' : '#3f3f46'),
              // row['color'] = row.cons_codest === '002' ? 'rgba(4, 0, 255, 0.05)' : '#ffffffff',
              // row['fontbold'] = row.cons_codest === '002' ? true : false,
              row['disabled'] = (row.cons_codest !== '001' && row.cons_codest !== '006') || (row.fact_proveedor != null) ? true : false,
              row['tipoentidad'] = row['tipoentidad']?.toUpperCase(),
              row['puedechangecontrol'] = this.datos?.['listadooperaciones']?.cons_codestado === '002' ? true : (row['cons_codest'] === '002' ? true : false),
              row['verTarifario'] = row.esadicional != true && row.cons_codest !== '005' && (row.fact_proveedor == null || row.fact_proveedor == '') ? true : false,
              row['puedemodRZ'] = row['disabled'] == true && (row.fact_proveedor == null || row.fact_proveedor == '') ? this.isLogisticaPlus : false,
              row['msd_editable'] = true,
              row['tipo_codmsd'] = row.tipo_codmsd != null ? { value: row.tipo_codmsd, label: row.tipo_descmsd } : null,
              // row['entc_codigo'] = row.entc_codigo !== null ? String(row.entc_codigo) : null// testt
              // row['entc_razonsocial'] = row['puedemodRZ'] == true && row.entc_codigo !== null ? String(row.entc_codigo) : row['entc_razonsocial'];
              // row['entc_razonsocial'] = row.entc_codigo != null ? row['puedemodRZ'] == true ? String(row.entc_codigo) : this.adicional == true ?
              //   { label: row.entc_razonsocial?.toUpperCase().trim(), value: String(row.entc_codigo), tipo: row.subtipoproveedor } : null : null
              //row['entc_razonsocial'] = row.entc_codigo != null ? { label: row.entc_razonsocial?.toUpperCase().trim(), value: String(row.entc_codigo), tipo: row.subtipoproveedor } : null// testt
              row['entc_razonsocial'] = row.entc_codigo === null ? null : this.ListaNombreEntidadesDP.find(x => x.value === String(row.entc_codigo) && x.tipo?.toUpperCase() === row.subtipoproveedor?.toUpperCase()) ?? null,
              row['cons_codest_orig'] = row['cons_codest'],
              row['cons_descest_orig'] = row['cons_descest']
          });

          switch (this.adicional) {
            case true:
              // if (this.isLogisticaPlus != true) {
              //   this.servicioslocales_datadetalle.map(fila => {
              //     fila.entc_razonsocial = fila.entc_codigo !== null ? { label: fila.entc_razonsocial?.toUpperCase().trim(), value: String(fila.entc_codigo), tipo: fila.subtipoproveedor } : '';
              //   });
              // }
              break;
            case false:
              this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.filter(item =>
                (item.agrupado === null || item.agrupado === false) && item.dope_changecontrol === false
              );
              this.listadoOriginal = this.listadoOriginal.filter(item =>
                item.agrupado === null || item.agrupado === false && item.dope_changecontrol === false
              );
              break;
            default:
              this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.filter(item =>
                item.agrupado === null || item.agrupado === false && item.dope_changecontrol === false
              );
              this.listadoOriginal = this.listadoOriginal.filter(item =>
                item.agrupado === null || item.agrupado === false && item.dope_changecontrol === false
              );
              break;
          }
          const existeAutorizado = this.servicioslocales_datadetalle.some(row => row.desc_autorizado != null);
          if (existeAutorizado) {
            this.metadatableDataDetalle.push({ field: 'desc_autorizado', title: 'Estado<br>Autorizado', inputType: 'textdisabled', filterType: 'text', maxWidth: '80px' });
          }
        }

        if (this.datos && this.datos['listadocontrolasociados']) {
          this.ListadoControlAsociados = this.datos['listadocontrolasociados'];
        }

        if (this.datos && this.datos['listadoeventosasociados']) {//Es un tabla
          this.servicioslocales_dataObservaciones = this.datos['listadoeventosasociados'];
        }

        if (this.datos && this.datos['listadofletes']) {
          this.serviciosytarifas_dataflete = structuredClone(this.datos['listadofletes']);
          this.datosembarque_dataflete = structuredClone(this.datos['listadofletes']);
        }

        if (this.datos && this.datos['listadoAgrupadores']) {
          this.servicioslocales_detalleAgrupacion = this.datos['listadoAgrupadores'].map((asc) => ({
            ctar_codigo: asc.ctaR_Codigo,
            dtar_codigo: asc.dtaR_Codigo,
            cope_codigo: asc.cope_codigo,
            dope_item: asc.dope_item,
            dope_cantidad: asc.dopE_Cantidad,
            dope_preciototvta: asc.dopE_PrecioTotVta,
            dope_preciounitvta: asc.dopE_PrecioUnitVta,
            serv_nombre_spa: asc.serV_Descripcion,
            agrupado: true,
            cod_padre: null,
            ESTADO_OBJ: 'U'
          }))
          this.listadoOriginalAgrupados = this.datos['listadoAgrupadores'];
        } else {
        }

        this.item2 = {

          // para mostar datos traidos
          //=====DATOS GENERALES============
          ccot_numdoc: this.datosRecibidos.ccot_numdoc,
          ccot_numdoccot: this.datosRecibidos.ccot_numdoccot,
          cons_codest: this.datosRecibidos.cons_codest,
          cons_descest: this.datosRecibidos.cons_descest,
          cons_codrgm: this.datosRecibidos.cons_codrgm,
          cons_descrgm: this.datosRecibidos.cons_descrgm,
          cons_codvia: this.datosRecibidos.cons_codvia,
          cons_descvia: this.datosRecibidos.cons_descvia,
          cons_codlng: this.datosRecibidos.cons_codlng,
          cons_descfle: this.datosRecibidos.cons_descfle,
          ccot_propia: this.datosRecibidos.ccot_propia,
          ccot_enviaavisollegada: this.datosRecibidos.ccot_enviaavisollegada,
          ccot_serviciologistico: this.datosRecibidos.ccot_serviciologistico,
          ccot_serviciotransmision: this.datosRecibidos.ccot_serviciotransmision,
          ccot_fecemi: this.datosRecibidos.ccot_fecemi,
          ccot_fecemiformat: this.datosRecibidos.ccot_fecemiformat,
          ccot_fecvcto: this.datosRecibidos.ccot_fecvcto,
          ccot_fecaprueba: this.datosRecibidos.ccot_fecaprueba,
          ddov_fecembarque: this.datosRecibidos.ddov_fecembarque,
          entc_nomcliente: this.datosRecibidos.entc_nomcliente,
          entC_NomCustomer: this.datosRecibidos.entc_nomcustomer,
          entc_nomagente: this.datosRecibidos.entc_nomagente,
          tipo_codinc: this.datosRecibidos.tipo_codinc,
          ccot_ordencompra: this.datosRecibidos.ccot_ordencompra,
          entc_nomejecutivo: this.datosRecibidos.entc_nomejecutivo?.toString()?.toUpperCase(),
          ccot_numpresupuesto: this.datosRecibidos.ccot_numpresupuesto,

          //=====SERVICIOS Y TARIFA============================
          ///---datos de contrato
          entc_nomtransportista: this.datosRecibidos.entc_nomtransportista,
          puer_nombretrasbordo: this.datosRecibidos.puer_codtrasbordo,

          tipo_codtrf: this.datosRecibidos.tipo_codtrf,
          puer_nombreorigen: this.datosRecibidos.puer_codorigen,
          puer_nombredestino: this.datosRecibidos.puer_coddestino,
          tipo_codmnd: this.datosRecibidos.tipo_codmnd,
          cons_codtft: this.datosRecibidos.cons_codtft,
          ccot_fectarifa: this.datosRecibidos.ccot_fectarifa,
          cons_codfle: this.datosRecibidos.cons_codfle,//Es la condicion?
          cont_numero: this.datosRecibidos.cont_numero,
          cont_descrip: this.datosRecibidos.cont_descrip,
          cont_codigo: this.datosRecibidos.cont_codigo,
          ///--flete
          ccot_pagombl: this.tranformarDa(this.datosRecibidos.ccot_pagombl),
          ccot_pagohbl: this.tranformarDa(this.datosRecibidos.ccot_pagohbl),
          dcot_totaluniventa: this.datosRecibidos["listadofletes"].length > 0 ? this.datosRecibidos["listadofletes"][0].dcot_totaluniventa : null,
          //Dias Libres sobre Estadia es lo mimso que está en Observaciones
          //--servicios
          dcot_preciounicosto: this.datosRecibidos.dcot_preciounicosto,
          //--seguro
          //DATOS EMBARQUE=============================
          ccot_cargarefrigerada: this.datosRecibidos.ccot_cargarefrigerada,
          ccot_cargapeligrosa: this.datosRecibidos.ccot_cargapeligrosa,
          ccot_roundtrip: this.datosRecibidos.ccot_roundtrip,
          ccot_temperatura: this.datosRecibidos.ccot_temperatura,
          tipo_codimo: this.datosRecibidos.tipo_codimo,
          ccot_imoun: this.datosRecibidos.ccot_imoun,
          entc_nomshipper: this.datosRecibidos.entc_nomshipper,
          entc_nomconsignee: this.datosRecibidos.entc_nomconsignee,
          entc_nomnotify: this.datosRecibidos.entc_nomnotify,
          doov_codreferencia: this.datosRecibidos.doov_codreferencia?.trim() || null,
          //OBSERVACIONES-----------
          ccot_almacenaje: this.datosRecibidos.ccot_almacenaje,
          ccot_sobreestadia: this.datosRecibidos.ccot_sobreestadia,
          ccot_tiempoviaje: this.datosRecibidos.ccot_tiempoviaje,
          ccot_validezoferta: this.datosRecibidos.ccot_validezoferta,
          ccot_observaciones: this.datosRecibidos.ccot_observaciones,
          //VIAJE ITENERARIO------------------
          //NOVEDADES--------------------
          ddov_nrobooking: this.datosRecibidos.ddov_nrobooking,
          //fechaRecepcion
          entc_nomdeptemporal: this.datosRecibidos.entc_nomdeptemporal,
          ddov_hblnieto: this.datosRecibidos.ddov_hblnieto,
          doov_hbl: this.datosRecibidos.doov_hbl,
          doov_mbl: this.datosRecibidos.doov_mbl,
          doov_cntr: this.datosRecibidos.doov_cntr,
          nvia_codigo: this.datosRecibidos.nvia_codigo,
          //zARPE
          //ETA
          nave_nombre: this.datosRecibidos.nave_nombre,
          etd: this.datosRecibidos.nvia_feceta,
          ata_atd: this.datosRecibidos.ata_atd,
          //ARCHIVO------------------
          //EVENTOS/TAREAS-------------

          //SERVICIOS LOCALES-----------
          cope_codigo: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_codigo : 0,
          cope_numdoc: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_numdoc : null,
          cope_fecemi: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_fecemi : null,
          entc_nombrecliente: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombrecliente : null,
          entc_nombretransportista: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombretransportista : null,
          entc_nombrealmacen: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombrealmacen : null,
          entc_nombreagenciamaritima: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombreagenciamaritima : null,
          entc_nombreterminalportuario: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombreterminalportuario : null,
          descripcioncondicionembarque: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].descripcioncondicionembarque : null,
          // descripcioncondicionembarque: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].terr : null,
          //Transportista (Jalado de arriba)?????
          //SADA???
          //IMO?????
          ctar_codigo: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].ctar_codigo : null,
          tarifftype: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].tarifftype : null,
          validfrom: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].validfrom : null,
          validto: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].validto : null,
          remarks: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].remarks : null,
          //observaciones
          sintegral: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].sintegral : null,
          cope_fechaSL: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_fechaSL : null,
          codigo_ruta: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].codigo_ruta : null,
          cope_dam: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_dam : null,
          cope_cifLogistico: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_cifLogistico : null,
          cope_cifEjecVta: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_cifEjecVta : null,
          cope_peso_sli: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_peso_sli : null,
          cope_volumen_sli: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_volumen_sli : null,
          cope_unmd_peso: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_unmd_peso : null,
          cope_unmd_volumen: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_unmd_volumen : null,
          terminal_portuario: this.datosRecibidos.terminal_portuario,
          sucursal: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].sucursal : null,
          entc_codcliente: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_codcliente?.toString() : null,
          entc_codlinaerea: this.datosRecibidos.entc_codlinaerea,
          doov_fecsalida: this.datosRecibidos.doov_fecsalida,
          doov_fecconexion: this.datosRecibidos.doov_fecconexion,
          ccot_descshipper: this.datosRecibidos.ccot_descshipper,
          ccot_descconsignee: this.datosRecibidos.ccot_descconsignee
        };
        this.filtrarPuertosSegunVia()
        this.inicializarFormularios(this.item2)

        this.group_serviciostarifa.get('puertoorigen').setValue(this.datosRecibidos.puer_codorigen);
        this.group_serviciostarifa.get('puertodestino').setValue(this.datosRecibidos.puer_coddestino);
        this.group_serviciostarifa.get('puertotransbordo').setValue(this.datosRecibidos.puer_codtrasbordo);

        if (this.datosRecibidos.cons_codvia === '002') { // aéreo
          this.nombre_bl = 'Guía Aérea Hijo';
          this.nombre_mbl = 'Guía Aérea Master';
        } else {
          this.nombre_bl = 'BL Hijo';
          this.nombre_mbl = 'BL Master';
        }

        this.obtenerArchivos()

        this.date = this.group_datosgenerales.get('fechaemision')?.value;

        this.readOnlyCodigoOperacionDSL = true
        this.readOnlyNumeroOpeacionDSL = true
        this.readonlyFechaEmisionDSL = true
        this.readOnlyClienteDSL = true
        this.readOnlyTransportistaAMDSL = true
        this.readOnlyAlmacenDSL = true
        this.readOnlyAgenciaMaritimaDSL = true
        this.readOnlyTerminalPortuarioDSL = true
        this.readOnlyCondicionEmbarqueDSL = true
        this.readonlySADADSL = true
        this.readonlyIMODSL = true
        this.readOnlyVentaTotalDSL = true

        if (this.datosRecibidos.cons_codfle == '001') {
          this.inputtype = 'decimal';
        } else { this.inputtype = 'int'; }

        if (this.datosRecibidos.cons_codfle == '001' || this.datosRecibidos.cons_codfle == '002') {
          if (this.isadmin == true) {
            this.metadatableFlete = this.metadatableFlete1ConCostos
          } else {
            this.metadatableFlete = this.metadatableFlete1
          }
        }
        else if (this.datosRecibidos.cons_codfle == '003' || this.datosRecibidos.cons_codfle == '004') {
          if (this.isadmin == true) {
            this.metadatableFlete = this.metadatableFlete2ConCostos
          } else {
            this.metadatableFlete = this.metadatableFlete2
          }
        }

        this.onChangeCif('INI', '');

        //Cambiando el acceso a cada dato
        switch (opcion) {
          case 'EDITAR':
            if (this.datos_ov) {
              this.solo_aereo = (this.datosRecibidos && this.datosRecibidos.aereo != null) ? this.datosRecibidos.aereo : false;
              this.from_operaciones = this.datos_ov.from_operaciones;
            }
            this.soloLectura = false
            this.transportistaSeleccionado = this.datosRecibidos.entc_nomtransportista;
            this.dope_items = []
            this.cope_codigos = []

            if ((this.adicional == true || this.adicional == null)) {
              this.btns_archivos = [...this.btns_archivos_sli]
            }

            if (
              Array.isArray(this.datosRecibidos["listadooperaciones"]) &&
              this.datosRecibidos["listadooperaciones"].some(op => op.cons_codestado == "002" || op.cons_codestado == "004")
            ) {
              this.bloqueoserviciolocal = true;
              this.bloqueoCheckboxSLI = 'lock';
              this.servicioslocales_tarifa = [];
              this.bloqueoTarifa = true;
            }

            // if (this.datosRecibidos.cons_codrgm === '001') {
            //   this.readonlyDepositoNov = this.adicional === true || this.adicional === null ? false : true
            // } else {
            //   this.readonlyDepositoNov = true
            // }

            if (
              this.listadoRoles?.some(r =>
                ['1', '10', '11', '14', this.coordLog, this.gerentLog]
                  .filter(Boolean)
                  .map(x => String(x))
                  .includes(String(r.role_codigo))
              )
            ) {
              // if (['1', '10', '11', '14', this.coordLog, this.gerentLog].filter(Boolean).includes(this.rol)) {
              this.bloqueoAdicionales = false;
              // [disableDeleteRow]="bloqueoAdicionales" [disableEditRow]="bloqueoAdicionales"
              if (this.rol === '1' || this.datosRecibidos.audi_usrcrea?.toLowerCase() == this.nombreUsuario?.toLowerCase()) {
                this.verBtnSave = true;
              } else {
                this.verBtnSave = false;
              }
              this.bloqueoBtnAddCoordinador('INI');
            } else {
              // this.bloqueoAdicionales = true;
              this.bloqueoAddAdicionales = true;
              this.verBtnSave = true;
            }

            if (this.datosRecibidos.cons_codest == "001") {
              this.readOnlyNumeroDGDG = true;
              this.readOnlyNumeroCotizacionDG = true;
              this.readOnlyEstadoDG = true;
              this.readonlyFEmisionDG = true
              this.readonlyFEmbarqueDG = true;
            } else if (this.datosRecibidos.cons_codest == "007") { // PRE-FACTURADA
              this.readOnlyNumeroDGDG = true;
              this.readOnlyNumeroCotizacionDG = true;
              this.readOnlyEstadoDG = true;
              this.readonlyOrdenCompraDG = true;
              this.readonlyRegimenDG = true;
              this.readOnlyAgenteDG = true;
              this.readonlyViaDG = true;
              this.readonlyFEmisionDG = true;
              if (rol == '17' || rol == '1') {
                this.readOnlyClienteDG = false;
                this.readOnlyCustomerDG = false;
                this.readonlyIncotermDG = false;
                this.readOnlyEjecutivoDG = false;
                this.readonlyShipperDE = false;
                this.readonlyConsigneeDE = false;
                this.readonlyNotifyDE = false;
              } else {
                this.readOnlyClienteDG = true;
                this.readOnlyCustomerDG = true;
                this.readonlyIncotermDG = true;
                this.readOnlyEjecutivoDG = true;
                this.readonlyShipperDE = true;
                this.readonlyConsigneeDE = true;
                this.readonlyNotifyDE = true;
              }

              this.readonlyFVencimientoDG = true;
              this.readonlyFAprobacionDG = true;
              this.readonlyFEmbarqueDG = true;
              // this.readOnlyCustomerDG = true;

              // this.readOnlyEjecutivoDG = true;
              this.readonlyAvisoLl_zDG = true;
              this.readonlyCotPropiaDG = true;
              this.readonlydTraficoST = true;
              this.readOnlyCodigoOperacionDSL = true;
              this.readOnlyNumeroOpeacionDSL = true;
              this.readonlyFechaEmisionDSL = true;
              this.readOnlyClienteDSL = true;
              this.readOnlyTransportistaAMDSL = true;
              this.readOnlyAlmacenDSL = true;
              this.readOnlyAgenciaMaritimaDSL = true;
              this.readOnlyTerminalPortuarioDSL = true;
              this.readOnlyCondicionEmbarqueDSL = true;
              this.readonlyTransportistaDSL = true;
              this.readonlySADADSL = true;
              this.readonlyIMODSL = true;
              this.readonlyTipoDSL = true;
              this.readonlyVigenciaDesdeDSL = true;
              this.readonlyVigenciaHastaDSL = true;
              this.readonlyDescripcionDSL = true;

              this.bloqueoViajeItinerario = true;
              this.bloqueoDataDetalle = true;
              this.bloqueoObservaciones = true;
              /////////////////////////////////////////
              this.readonlyTransportisaSTST = true;
              this.readonlyPuertoOrigenST = true;
              this.readonlydTraficoST = true;
              this.readonlyPuertoDestinoST = true;
              this.readonlyTipoFechaTarifaST = true;
              this.readonlyFechaTarifaST = true;
              this.readonlyMonedaST = true;
              this.readonlyCondicionST = true;
              this.readonlyNumeroContratoST = true;
              this.readonlyAdicionalST = true;
              this.bloqueoFlete = true;
              this.readonlyPCMblST = true;
              this.readonlyPCHblST = true;
              this.readOnlyFleteTotalST = true;
              this.readonlyDiasLibresSobreeestadiaST = true;
              this.bloqueoServiciosAdicionales = true;
              this.bloqueoChangeControl = false;
              this.readonlyCargaRefrigeradaDE = true;
              this.readOnlyTemperaturaDE = true;
              this.readonlyCargaPeligrosaDE = true;
              this.readonlyImoClassDE = true;
              this.readOnlyImoUnDE = true;
              this.readonlyRoundTripDE = true;
              // this.readonlyShipperDE = true;
              // this.readonlyConsigneeDE = true;
              // this.readonlyNotifyDE = true;
              this.readonlyReferenciaDE = true;
              // this.bloqueoSegundoFlete= true;
              // this.readonlyTiempoViajeObs = true;
              // this.readonlySobreestadiaObs = true;
              // this.readonlyInstruccionesEmbarqueObs = true;

            } else if (this.datosRecibidos.cons_codest == "004") { // CONCLUIDO
              this.readOnlyNumeroDGDG = true;
              this.readOnlyNumeroCotizacionDG = true;
              this.readOnlyEstadoDG = true;

              this.readonlyViaDG = true;
              this.readonlyFEmisionDG = true;

              this.readonlyFAprobacionDG = true;
              this.readonlyFEmbarqueDG = true;
              this.readonlyRegimenDG = true;

              this.readonlyAvisoLl_zDG = true;
              this.readonlyCotPropiaDG = true;
              this.readonlyLineaNegocioDG = true;

              if (rol == '17' || rol == '1') {
                this.readonlyOrdenCompraDG = false;

                this.readOnlyAgenteDG = false;
                this.readOnlyClienteDG = false;
                this.readOnlyCustomerDG = false;
                this.readonlyFVencimientoDG = false;
                this.readonlyIncotermDG = false;
                this.readOnlyEjecutivoDG = false;
                this.readOnlyCustomerDG = false;
                this.readonlyPCMblST = false;
                this.readonlyPCHblST = false;

                this.readonlyShipperDE = false;
                this.readonlyConsigneeDE = false;
                this.readonlyNotifyDE = false;
                this.readonlyReferenciaDE = false;

                this.readonlyTransportisaSTST = false;
                this.readonlyPuertoOrigenST = false;
                this.readonlydTraficoST = false;
                this.readonlyPuertoDestinoST = false;
                this.readonlyTipoFechaTarifaST = false;
                this.readonlyFechaTarifaST = false;
                this.readonlyMonedaST = false;
                this.readonlyCondicionST = false;

                this.bloqueoServiciosAdicionales = false

                this.bloqueoFlete = false;


              } else {
                this.readonlyOrdenCompraDG = true;

                this.readOnlyAgenteDG = true;
                this.readOnlyClienteDG = true;
                this.readonlyFVencimientoDG = true;
                this.readonlyIncotermDG = true;
                this.readOnlyEjecutivoDG = true;
                this.readOnlyCustomerDG = true;
                this.readonlyShipperDE = true;
                this.readonlyConsigneeDE = true;
                this.readonlyNotifyDE = true;
                this.readonlyReferenciaDE = true;
                this.readonlyTransportisaSTST = true;
                this.readonlyPuertoOrigenST = true;
                this.readonlydTraficoST = true;
                this.readonlyPuertoDestinoST = true;
                this.readonlyTipoFechaTarifaST = true;
                this.readonlyFechaTarifaST = true;
                this.readonlyMonedaST = true;
                this.readonlyCondicionST = true;
                this.bloqueoServiciosAdicionales = true;
                this.bloqueoFlete = true;
              }

              ////////////////////////////////////
              this.readonlyNumeroContratoST = true;
              this.readonlyAdicionalST = true;


              this.readOnlyFleteTotalST = true;
              this.readonlyDiasLibresSobreeestadiaST = true;
              // this.bloqueoServiciosAdicionales = true;
              this.bloqueoChangeControl = true;
              this.readonlyCargaRefrigeradaDE = true;
              this.readOnlyTemperaturaDE = true;
              this.readonlyCargaPeligrosaDE = true;
              this.readonlyImoClassDE = true;
              this.readOnlyImoUnDE = true;
              this.readonlyRoundTripDE = true;

            } else if (this.datosRecibidos.cons_codest == "005" || this.datosRecibidos.cons_codest == "009") { // ANULADA & GESTIONADA SLI
              this.deshabilitarBtnGuardar = true;
              this.esVisualizar = true;
              this.mostrarDetalleNaveViaje = true;
              this.readOnlyNumeroDGDG = true;
              this.readOnlyNumeroCotizacionDG = true;
              this.readOnlyEstadoDG = true;
              this.readOnlyNoCRMDG = true;
              this.readonlyOrdenCompraDG = true;
              this.readonlyRegimenDG = true;
              this.readonlyViaDG = true;
              this.readonlyLineaNegocioDG = true;
              this.readonlyFEmisionDG = true;
              this.readonlyFVencimientoDG = true;
              this.readonlyFAprobacionDG = true;

              this.readOnlyClienteDG = true;
              this.readOnlyCustomerDG = true;
              this.readOnlyAgenteDG = true;
              this.readOnlyEjecutivoDG = true;
              if (rol == '17' || rol == '1') {
                this.readonlyIncotermDG = true;
              } else {
                this.readonlyIncotermDG = false;
              }
              this.readonlyServLogisticoDG = true;
              this.readonlyServicioDG = true;
              this.readonlyCotPropiaDG = true;
              this.visibledCotPropiaDG = true;
              this.readonlyAvisoLl_zDG = true;

              this.readonlyTransportisaSTST = true;
              this.readonlyPuertoTransbordoST = true;
              this.readonlydTraficoST = true;
              this.readonlyPuertoOrigenST = true;
              this.readonlyPuertoDestinoST = true;
              this.readonlyMonedaST = true;
              this.readonlyTipoFechaTarifaST = true;
              this.readonlydTraficoST = true;
              this.readonlyCondicionST = true;
              this.readonlyNumeroContratoST = true;
              this.readonlyAdicionalST = true;
              this.readonlyPCMblST = true;
              this.readonlyPCHblST = true;
              this.readOnlyFleteTotalST = true;
              this.readonlyDiasLibresSobreeestadiaST = true;

              this.readonlyCargaRefrigeradaDE = true;
              this.readOnlyTemperaturaDE = true;
              this.readonlyCargaPeligrosaDE = true;
              this.readonlyImoClassDE = true;
              this.readonlyRoundTripDE = true;
              this.readOnlyImoUnDE = true;
              this.readonlyShipperDE = true;
              this.readonlyReferenciaDE = true;
              this.readonlyConsigneeDE = true;
              this.readonlyNotifyDE = true;

              this.readonlyAlmacenajeObs = true;
              this.readonlySobreestadiaObs = true;
              this.readonlyTiempoViajeObs = true;
              this.readonlyValidezOfertaObs = true;
              this.readonlyInstruccionesEmbarqueObs = true;

              this.readonlyNroBookingNov = true;
              this.readonlyDepositoNov = true;
              this.readonlyBlNietoNov = true;
              this.readonlyBlHijoNov = true;
              this.readonlyBlMasterNov = true;
              this.readonlyContenedorNov = true;
              this.readOnlyViajeNov = true;
              this.readonlyFZarpeNov = true;
              this.readonlyFEtaEtdNov = true;
              this.readOnlyNaveNov = true;

              this.readonlyTipoEventoTareaET = true;
              this.readonlyFechaYHoraET = true;
              this.readonlyEstadoET = true;
              this.readonlyModuloET = true;
              this.readonlyUsuarioET = true;
              this.readonlyObservacionesET = true;

              this.readOnlyCodigoOperacionDSL = true;
              this.readOnlyNumeroOpeacionDSL = true;
              this.readonlyFechaEmisionDSL = true;
              this.readOnlyClienteDSL = true;
              this.readOnlyTransportistaAMDSL = true;
              this.readOnlyAlmacenDSL = true;
              this.readOnlyAgenciaMaritimaDSL = true;
              this.readOnlyTerminalPortuarioDSL = true;
              this.readOnlyCondicionEmbarqueDSL = true;
              this.readonlyTransportistaDSL = true;
              this.readonlySADADSL = true;
              this.readonlyIMODSL = true;
              this.readonlyTarifaDSL = true;
              this.readonlyTipoDSL = true;
              this.readonlyVigenciaDesdeDSL = true;
              this.readonlyVigenciaHastaDSL = true;
              this.readonlyDescripcionDSL = true;
              this.readonlyObservacionesDSL = true;
            } else if (this.datosRecibidos.cons_codest == "006") { // DOCUMENTADA

              if (rol == '17' || rol == '1') {

                this.readOnlyAgenteDG = false;
                this.readOnlyClienteDG = false;
                this.readonlyFVencimientoDG = false;
                this.readonlyFAprobacionDG = false;
                this.readOnlyCustomerDG = false;
                this.readonlyIncotermDG = false;
                this.readOnlyEjecutivoDG = false;
                this.readonlyAvisoLl_zDG = false;
                this.readonlyCotPropiaDG = false;
                this.readOnlyTransportistaAMDSL = false;
                this.readOnlyAlmacenDSL = false;
                this.readonlyPCMblST = false;
                this.readonlyPCHblST = false;
                this.readonlyShipperDE = false;
                this.readonlyConsigneeDE = false;
                this.readonlyNotifyDE = false;
                this.readonlyReferenciaDE = false;

                this.readonlyTransportisaSTST = false;
                this.readonlyPuertoOrigenST = false;
                this.readonlydTraficoST = false;
                this.readonlyPuertoDestinoST = false;
                this.readonlyTipoFechaTarifaST = false;
                this.readonlyFechaTarifaST = false;
                this.readonlyMonedaST = false;
                this.readonlyCondicionST = false;
                this.bloqueoServiciosAdicionales = false
                this.bloqueoFlete = false;

              } else {

                this.readOnlyAgenteDG = true;
                this.readOnlyClienteDG = true;
                this.readonlyFVencimientoDG = true;
                this.readonlyFAprobacionDG = true;
                this.readOnlyCustomerDG = true;
                this.readonlyIncotermDG = true;
                this.readOnlyEjecutivoDG = true;
                this.readonlyAvisoLl_zDG = true;
                this.readonlyCotPropiaDG = true;
                this.readOnlyTransportistaAMDSL = true;
                this.readOnlyAlmacenDSL = true;
                this.readonlyPCMblST = true;
                this.readonlyPCHblST = true;
                this.readonlyShipperDE = true;
                this.readonlyConsigneeDE = true;
                this.readonlyNotifyDE = true;
                this.readonlyReferenciaDE = true;

                this.readonlyTransportisaSTST = true;
                this.readonlyPuertoOrigenST = true;
                this.readonlydTraficoST = true;
                this.readonlyPuertoDestinoST = true;
                this.readonlyTipoFechaTarifaST = true;
                this.readonlyFechaTarifaST = true;
                this.readonlyMonedaST = true;
                this.readonlyCondicionST = true;
                this.bloqueoServiciosAdicionales = true
                this.bloqueoFlete = true;

              }

              this.readOnlyNumeroDGDG = true;
              this.readOnlyNumeroCotizacionDG = true;
              this.readOnlyEstadoDG = true;
              this.readonlyOrdenCompraDG = true;
              this.readonlyRegimenDG = true;

              this.readonlyViaDG = true;
              this.readonlyFEmisionDG = true;

              this.readonlyFEmbarqueDG = true;

              this.readonlydTraficoST = true;
              this.readOnlyCodigoOperacionDSL = true;
              this.readOnlyNumeroOpeacionDSL = true;
              this.readonlyFechaEmisionDSL = true;
              this.readOnlyClienteDSL = true;

              this.readOnlyAgenciaMaritimaDSL = true;
              this.readOnlyTerminalPortuarioDSL = true;
              this.readOnlyCondicionEmbarqueDSL = true;
              this.readonlyTransportistaDSL = true;
              this.readonlySADADSL = true;
              this.readonlyIMODSL = true;
              this.readonlyTipoDSL = true;
              this.readonlyVigenciaDesdeDSL = true;
              this.readonlyVigenciaHastaDSL = true;
              this.readonlyDescripcionDSL = true;

              ///////////////////////////////////////////

              this.readonlyNumeroContratoST = true;
              this.readonlyAdicionalST = true;

              this.readOnlyFleteTotalST = true;
              this.readonlyDiasLibresSobreeestadiaST = true;
              //this.bloqueoServiciosAdicionales = true;
              this.bloqueoChangeControl = true;
              this.readonlyCargaRefrigeradaDE = true;
              this.readOnlyTemperaturaDE = true;
              this.readonlyCargaPeligrosaDE = true;
              this.readonlyImoClassDE = true;
              this.readOnlyImoUnDE = true;
              this.readonlyRoundTripDE = true;


            }

            // this.filtrarPuertosSegunVia()
            // this.group_datosgenerales.get('estado')?.disable();
            // this.buscarTarifas()
            if (
              Array.isArray(this.datosRecibidos["listadooperaciones"]) &&
              this.datosRecibidos["listadooperaciones"].some(op => op.cons_codestado == "002" || op.cons_codestado == "004")
            ) {
              this.servicioslocales_tarifa = [];
            }
            this.buscarPuertosByVia()
            this.onPuertoChange(" ");
            // this.filtrarPuertosSegunVia()

            //en caso no tenga servicios que busque los que tiene el cliente
            if (this.datos && this.datos['listadoservicio']?.length == 0) {
              this.cargarServiciosEnTablaSegunLineaNegocioInicial(this.datosRecibidos.entc_codcliente, this.datosRecibidos.cons_codvia, this.datosRecibidos.cons_codrgm, this.datosRecibidos.cons_codlng)
            }
            this.filtrarListaServicios();

            break;
          case 'VISUALIZAR':
            this.esVisualizar = true;
            this.mostrarDetalleNaveViaje = true;
            this.readOnlyNumeroDGDG = true;
            this.readOnlyNumeroCotizacionDG = true;
            this.readOnlyEstadoDG = true;
            this.readOnlyNoCRMDG = true;
            this.readonlyOrdenCompraDG = true;
            this.readonlyRegimenDG = true;
            this.readonlyViaDG = true;
            this.readonlyLineaNegocioDG = true;
            this.readonlyFEmisionDG = true;
            this.readonlyFVencimientoDG = true;
            this.readonlyFAprobacionDG = true;

            this.readOnlyClienteDG = true;
            this.readOnlyCustomerDG = true;
            this.readOnlyAgenteDG = true;
            this.readOnlyEjecutivoDG = true;
            this.readonlyIncotermDG = true;
            this.readonlyServLogisticoDG = true;
            this.readonlyServicioDG = true;
            this.readonlyCotPropiaDG = true;
            this.visibledCotPropiaDG = true;
            this.readonlyAvisoLl_zDG = true;

            // --Servicios y Tarifa
            this.readonlyTransportisaSTST = true;
            this.readonlyPuertoTransbordoST = true;
            this.readonlydTraficoST = true;
            this.readonlyPuertoOrigenST = true;
            this.readonlyPuertoDestinoST = true;
            this.readonlyMonedaST = true;
            this.readonlyTipoFechaTarifaST = true;
            this.readonlyFechaTarifaST = true;
            this.readonlyCondicionST = true;
            this.readonlyNumeroContratoST = true;
            this.readonlyAdicionalST = true;
            this.readonlyPCMblST = true;
            this.readonlyPCHblST = true;
            this.readOnlyFleteTotalST = true;
            this.readonlyDiasLibresSobreeestadiaST = true;

            // --Datos Embarque
            this.readonlyCargaRefrigeradaDE = true;
            this.readOnlyTemperaturaDE = true;
            this.readonlyCargaPeligrosaDE = true;
            this.readonlyImoClassDE = true;
            this.readonlyRoundTripDE = true;
            this.readOnlyImoUnDE = true;
            this.readonlyShipperDE = true;
            this.readonlyReferenciaDE = true;
            this.readonlyConsigneeDE = true;
            this.readonlyNotifyDE = true;

            // --Observaciones
            this.readonlyAlmacenajeObs = true;
            this.readonlySobreestadiaObs = true;
            this.readonlyTiempoViajeObs = true;
            this.readonlyValidezOfertaObs = true;
            this.readonlyInstruccionesEmbarqueObs = true;

            // --Novedades
            this.readonlyNroBookingNov = true;
            this.readonlyDepositoNov = true;
            this.readonlyBlNietoNov = true;
            this.readonlyBlHijoNov = true;
            this.readonlyBlMasterNov = true;
            this.readonlyContenedorNov = true;
            this.readOnlyViajeNov = true;
            this.readonlyFZarpeNov = true;
            this.readonlyFEtaEtdNov = true;
            this.readOnlyNaveNov = true;

            // --EventosTareas
            this.readonlyTipoEventoTareaET = true;
            this.readonlyFechaYHoraET = true;
            this.readonlyEstadoET = true;
            this.readonlyModuloET = true;
            this.readonlyUsuarioET = true;
            this.readonlyObservacionesET = true;

            // --Servicio Locales
            this.readOnlyCodigoOperacionDSL = true;
            this.readOnlyNumeroOpeacionDSL = true;
            this.readonlyFechaEmisionDSL = true;
            this.readOnlyClienteDSL = true;
            this.readOnlyTransportistaAMDSL = true;
            this.readOnlyAlmacenDSL = true;
            this.readOnlyAgenciaMaritimaDSL = true;
            this.readOnlyTerminalPortuarioDSL = true;
            this.readOnlyCondicionEmbarqueDSL = true;
            this.readonlyTransportistaDSL = true;
            this.readonlySADADSL = true;
            this.readonlyIMODSL = true;
            this.readonlyTarifaDSL = true;
            this.readonlyTipoDSL = true;
            this.readonlyVigenciaDesdeDSL = true;
            this.readonlyVigenciaHastaDSL = true;
            this.readonlyDescripcionDSL = true;
            this.readonlyObservacionesDSL = true;
            this.soloLectura = true
            break;
        }

        setTimeout(() => {
          this.inicializarValoresSL()
        }, 4500);

      } else if (opcion == 'NUEVO') {
        if (this.datos_ov) {
          this.solosli = this.datos_ov.solo_sli;
          this.solo_aereo = this.datos_ov.solo_aereo;
          this.from_operaciones = this.datos_ov.from_operaciones;
        }
        this.verBtnSave = true;
        localStorage.removeItem('datoov');
        localStorage.removeItem('listadoservicio');
        this.soloLectura = true
        this.reset = [...this.resetVta]

        const dato = JSON.parse(localStorage.getItem('essolosli'))
        this.solosli = dato
        console.log("Solo SLI: ", this.solosli);

        let ccot_pagombl = null; let ccot_pagohbl = null;
        if (this.solosli) {
          ccot_pagombl = 'C';
          ccot_pagohbl = 'C';
        }
        this.evaluarEnvioCorreoOv = true;

        this.item2 = {
          //=====DATOS GENERALES============
          ccot_numdoc: null,
          ccot_numdoccot: null,
          cons_codest: null,
          cons_descest: null,
          cons_codrgm: null,
          cons_descrgm: null,
          cons_codvia: null,
          cons_descvia: null,
          cons_codlng: null,
          cons_descfle: null,
          ccot_propia: false,
          ccot_enviaavisollegada: false,
          ccot_serviciologistico: false,
          ccot_serviciotransmision: false,
          ccot_fecemi: new Date(),
          ccot_fecemiformat: null,
          ccot_fecvcto: new Date(),
          ccot_fecaprueba: null,
          ddov_fecembarque: null,
          entc_nomcliente: null,
          entC_NomCustomer: null,
          entc_nomagente: null,
          tipo_codinc: null,
          ccot_ordencompra: null,
          entc_nomejecutivo: null,
          ccot_numpresupuesto: null,
          //=====SERVICIOS Y TARIFA============================
          ///---datos de contrato
          entc_nomtransportista: null,
          puer_nombretrasbordo: null,
          tipo_codtrf: null,
          puer_nombreorigen: null,
          puer_nombredestino: null,
          tipo_codmnd: null,
          cons_codtft: null,
          ccot_fectarifa: null,
          cons_codfle: null,//Es la condicion?
          cont_codigo: null,
          cont_numero: null,
          cont_descrip: null,
          ///--flete
          ccot_pagombl: ccot_pagombl,
          ccot_pagohbl: ccot_pagohbl,
          dcot_totaluniventa: 0.00,
          //Dias Libres sobre Estadia es lo mimso que está en Observaciones
          //--servicios
          dcot_preciounicosto: null,
          //--seguro
          //DATOS EMBARQUE=============================
          ccot_cargarefrigerada: false,
          ccot_cargapeligrosa: false,
          ccot_roundtrip: false,
          ccot_temperatura: 0.00,
          tipo_codimo: null,
          ccot_imoun: null,
          entc_nomshipper: null,
          entc_nomconsignee: null,
          entc_nomnotify: null,
          doov_codreferencia: null,
          //OBSERVACIONES-----------
          ccot_almacenaje: 0,
          ccot_sobreestadia: 0,
          ccot_tiempoviaje: 0,
          ccot_validezoferta: 0,
          ccot_observaciones: " ",
          //VIAJE ITENERARIO------------------
          //NOVEDADES--------------------
          ddov_nrobooking: null,
          //fechaRecepcion
          entc_nomdeptemporal: null,
          ddov_hblnieto: false,
          doov_hbl: null,
          doov_mbl: null,
          doov_cntr: null,
          nvia_codigo: null,
          //zARPE
          //ETA
          nave_nombre: null,
          //ARCHIVO------------------
          //EVENTOS/TAREAS-------------
          //SERVICIOS LOCALES-----------
          cope_codigo: null,
          cope_numdoc: null,
          cope_fecemi: null,
          entc_nombrecliente: null,
          entc_nombretransportista: null,
          entc_nombrealmacen: null,
          entc_nombreagenciamaritima: null,
          entc_nombreterminalportuario: null,
          descripcioncondicionembarque: null,
          ctar_codigo: null,
          tarifftype: null,
          validfrom: null,
          validto: null,
          remarks: null,
          cope_peso_sli: null,
          cope_volumen_sli: null,
          cope_unmd_peso: null,
          cope_unmd_volumen: null,
          terminal_portuario: null,
          sucursal: null,
          entc_codcliente: null,
          entc_codlinaerea: null,
          doov_fecsalida: null,
          doov_fecconexion: null,
          ccot_descshipper: null,
          ccot_descconsignee: null
        };

        this.group_serviciostarifa.get('diaslibres').setValue(0);
        this.inicializarFormularios(this.item2)
        this.readOnlyNumeroDGDG = true;
        this.readOnlyNumeroCotizacionDG = true;
        this.readOnlyEstadoDG = true;
        this.readOnlyNoCRMDG = true;
        this.readOnlyTemperaturaDE = true;
        this.readonlyImoClassDE = true;
        this.readonlyRoundTripDE = true;
        this.readOnlyImoUnDE = true;

        this.group_datosgenerales.get('estado')?.setValue('001');
        this.group_eventostareas.get('estado')?.setValue('1');
        this.group_servicioslocales.get('fechaemision')?.setValue(this.date);
        this.group_servicioslocales.get('condicion')?.setValue('001');
      }

      this.leyendasTblSLI = structuredClone(this.leyendasRow);

      if (this.solosli === true) {
        this.metadatableFlete = [...this.metadatableFlete1]
      }
      this.EnabledItem(this.item2.cons_codest, opcion);

      // --Servicio Locales
      this.readOnlyCodigoOperacionDSL = true;
      this.readOnlyNumeroOpeacionDSL = true;
      this.readonlyFechaEmisionDSL = true;
      this.readOnlyClienteDSL = true;
      this.readOnlyTransportistaAMDSL = true;
      this.readOnlyAlmacenDSL = true;
      this.readOnlyAgenciaMaritimaDSL = true;
      this.readOnlyTerminalPortuarioDSL = true;
      this.readOnlyCondicionEmbarqueDSL = true;
      this.readonlyTransportistaDSL = true;
      this.readonlySADADSL = true;
      this.readonlyIMODSL = true;
      this.readonlyTarifaDSL = true;
      this.readonlyTipoDSL = true;
      this.readonlyDescripcionDSL = true;
      this.readonlyObservacionesDSL = true;
      this.readOnlyViajeNov = true;
      this.readonlyFZarpeNov = true;
      this.readonlyFEtaEtdNov = true;
      this.readOnlyNaveNov = true;
      this.readonlyContenedorNov = true;
      this.inicializarDatosComponentes();

      loadingScreen.close();
    } catch (err) {
      console.error(err);
    } finally {
      loadingScreen.close();
    }
  }

  //servicio: ItemsServicio_ByViaRegimenResponse[] = [];

  filtrarListaServicios() {
    const via = this.group_datosgenerales.value["via"];
    const regimen = this.group_datosgenerales.value["regimen"];
    const lineaNegocio = this.group_datosgenerales.value["lineanegocio"];
    if (!via || !regimen || !lineaNegocio) return;

    this.ListaServiciosByViaRgmLngDP = [];
    const item = this.ListaTodosServicios.filter(servicio =>
      servicio.via === via &&
      servicio.regimen === regimen &&
      servicio.lineaNegocio === lineaNegocio
    ).map(item => ({
      label: item.nombre,
      value: item.codigo.toString()
    }));
    this.ListaServiciosByViaRgmLngDP = item;
    this.restablecerMetadataServicios();
    this.restablecerMetadataServiciosChangeControl();
  }

  buscarPuertosByVia() {
    this.ListaPuertosByVia = this.ListaTodosPuertoOrigenyDestino.map(item => {
      return {
        value: item.codigo,
        label: item.nombre,
        nombre: item.adicional2,
        codigo: item.adicional1
      };
    });
    this.ListaPuertosByViaItinerario = this.ListaTodosPuertoOrigenyDestino.map(item => {
      return {
        value: item.codigo,
        label: item.nombre,
      };
    });
    this.modificarNamePortLoadingyNamePortDischarge(this.ListaPuertosByVia);
    this.reconstruirItinerario();


  }

  reconstruirItinerario() {
    this.metadatableItinerario[9].dropdown = [...this.ListaPuertosByVia];
    this.metadatableItinerario[10].dropdown = [...this.ListaPuertosByVia];
    this.pasarDataPuertosFavoritosByVia(this.ListaPuertosByVia);
    this.data = {
      puertoOrigen: this.objPuertoOrigen,
      data: this.datosViajePorPuerto2
    }
    this.metadatableItinerario = [
      { title: 'TRAMO', field: 'ovnv_item', filterType: 'numeric', inputType: 'textdisabled', maxWidth: '40px' },
      { title: 'FEEDER', field: 'nvia_esfeeder', filterType: 'boolean', inputType: 'checkboxEditInput', readonly: true },
      { title: 'FINAL', field: 'ovnv_final', filterType: 'boolean', inputType: 'checkboxEditInput', readonly: true },
      { title: 'CÓDIGO VIAJE', field: 'nvia_codigo', filterType: 'text', inputType: 'text', popup: 'y', maxWidth: '70%', function: (params: any) => this.popupViajeItinerario(params), },
      { title: 'NAVE', field: 'nave_nombre', filterType: 'text', inputType: 'text' },
      { title: this.solo_aereo == false ? 'VIAJE' : 'VUELO', field: 'nvia_nroviaje', filterType: 'text', inputType: 'text', },
      { title: 'ETD', field: 'etd', filterType: 'text', inputType: 'date' },
      { title: 'FECHA EMBARQUE', field: 'fechaembarque', filterType: 'text', inputType: 'date' },
      { title: 'ETA', field: 'eta', filterType: 'text', inputType: 'date' },
      { title: 'POL', field: 'nameportloading', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaPuertosByViaItinerario, virtualScroll: true, maxWidth: '500px' },
      { title: 'POD', field: 'nameportdischarge', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaPuertosByViaItinerario, virtualScroll: true, maxWidth: '500px' },
    ];
  }

  contratoSeleccionado: any = [];
  buscarContratoAyudaPivot() {
    const requiredFieldsGeneral = [
      "fechaemision",
      "regimen",
      "via"
    ];

    const requiredFieldsService = [
      "transportista",
      "fechatarifa"
    ];

    const prolrequest: ConsultarContratoAyudaPivotOVRequest = {
      EMPR_Codigo: 1,
      ENTC_CodTransportista: Number(this.ListaTodosTransportista.find(item => item.nombre === this.group_serviciostarifa.value["transportista"])?.codigo),
      CONT_FecDesde: this.util.formatearfecha(this.group_datosgenerales.value["fechaemision"], "yyyy-MM-ddTHH:mm:ss"),
      CONT_FecHasta: this.util.formatearfecha(this.group_serviciostarifa.value["fechatarifa"], "yyyy-MM-ddTHH:mm:ss"),
      CONS_TabRGM: "RGM",
      CONS_CodRGM: this.group_datosgenerales.value["regimen"],
      CONS_TabVIA: "VIA",
      CONS_CodVIA: this.group_datosgenerales.value["via"],
      PUER_CodOrigen: this.group_serviciostarifa.value["puertoorigen"] || null,
      PUER_CodDestino: this.group_serviciostarifa.value["puertodestino"] || null,
      CONT_Codigo: this.group_serviciostarifa.value["cont_codigo"] || null
    };


    const missingFieldsGeneral = requiredFieldsGeneral.filter(field => !this.group_datosgenerales.value[field]);
    const missingFieldsService = requiredFieldsService.filter(field => !this.group_serviciostarifa.value[field]);

    const emptyFields = Object.entries(prolrequest)
      .filter(([key, value]) =>
        !["PUER_CodOrigen", "PUER_CodDestino", "CONT_Codigo"].includes(key) && !value
      )
      .map(([key]) => key);

    if (missingFieldsGeneral.length || missingFieldsService.length || emptyFields.length) {
      this.util.MessageDialog({
        titulo: "ERROR",
        mensaje: `Faltan los siguientes campos: ${[...missingFieldsGeneral, ...missingFieldsService].join(", ")}`,
        tipo: "warning"
      });
      return;
    }

    this.ordenventaService.BuscarContratoAyudaPivot(prolrequest).subscribe(
      (response: ConsultarContratoAyudaPivotOVoResponse) => {
        if (response.datos.result.length <= 0) {
          this.util.MessageDialog({
            titulo: "ERROR",
            mensaje: "No se encontraron coincidencias.",
            tipo: "warning"
          });
        } else {
          if (response.datos.status == "200") {

            this.datosCompartidosService.setlistaDatosContratos(response.datos.result);

            const options = {
              disableClose: true,
              panelClass: 'panel'
            };

            const reference = this.dialogService.open(BuscarContratoComponent, {
              header: '',
              data: options,
              width: '90%',
              contentStyle: { "overflow": "auto" },
              baseZIndex: 10000,
              maximizable: true,
              closable: true,
            });

            reference.onClose.subscribe((result) => {
              if (result) {

                this.contratoSeleccionado = result;
                this.group_serviciostarifa.get('numerocontrato').setValue(result.row?.contrato);
                this.group_serviciostarifa.get('cont_codigo').setValue(result.codigo);
                this.group_serviciostarifa.get('adicional').setValue(result.descripcion);
                const listacopia = structuredClone(this.ListaOriginalTipoPaquete);
                // this.ListaTipoPaquete = listacopia;
                // this.ListaTipoPaquete = listacopia.filter(itemOriginal =>
                //   result?.contenedorValue.some(itemContenedor => itemContenedor.value === itemOriginal.value)
                // );
                const fila_edicion_flete = this.dataFlete?.getFirstEditingRow();
                if (fila_edicion_flete) {
                  this.asignacionFletePorTipoPaquete(fila_edicion_flete, fila_edicion_flete.__editIndex);
                  this.dataFlete?.aceptarEdicionActiva();
                }
                this.logicaMetadataFlete();
                this.renderizarDom();

              }
            });
          }
        }
      },
      error => {

      }
    );

  }

  modificarNamePortLoadingyNamePortDischarge(listaPuertosByVia: SelectItem[]) {
    if (this.datos != undefined) { this.viajeitinerario_dataitinerario = structuredClone(this.datos['listadoviajeitinerario']); }

    function getUpdatedPortLabel(port, listaPuertos) {
      if (typeof port === 'string') {
        const puertoEncontrado = listaPuertos.find(puerto => puerto.codigo.trim() === port.trim());
        return puertoEncontrado ? puertoEncontrado.label : port;
      } else if (port && port.label) {
        const puertoEncontrado = listaPuertos.find(puerto => puerto.label === port.label);
        return puertoEncontrado ? puertoEncontrado.label : port.label;
      }
      return port;
    }

    if (this.viajeitinerario_dataitinerario && this.viajeitinerario_dataitinerario.length > 0) {
      this.viajeitinerario_dataitinerario.forEach(itinerario => {
        itinerario.nameportloading = getUpdatedPortLabel(
          itinerario.portloading, listaPuertosByVia
        );
        itinerario.nameportdischarge = getUpdatedPortLabel(
          itinerario.portdischarge, listaPuertosByVia
        );
      });
    }
  }

  updateMetadata() {
    this.metadatableItinerario = this.metadatableItinerario.map(item => {
      if (item.field === 'nameportloading') {
        item.title = 'Nombre del Puerto de Carga';
      }
      if (item.field === 'nameportdischarge') {
        item.title = 'Nombre del Puerto de Descarga';
      }
      return item;
    });
  }

  handleDataSelect(event: any) {
    this.viajeitinerario_dataitinerario.push({
      ovnv_item: event.codigoviaje,
      nvia_esfeeder: event.nvia_esfeeder,
      nave_nombre: event.nombrenave,
      nvia_nroviaje: event.viaje_vuelo,
      eta: event.eta_etd != null && event.eta_etd != '' ? new Date(event.eta_etd) : null,
      nameportdischarge: event.puerto
    });
  }

  buscarTarifas() {
    this.onServiciosLocalesChange();
    const transportistaCodigo = this.group_serviciostarifa.value["transportista"];

    if (!transportistaCodigo) {
      this.util.MessageDialog({
        titulo: "ERROR",
        mensaje: `Debe elegir a un transportista.`,
        tipo: "warning"
      });
      return;
    }

    const prolrequest: ConsultarTarifaRequest = {
      IdBusinessUnit: null,
      DateFrom: this.group_servicioslocales.value["vigenciadesde"] || null,
      DateTo: this.group_servicioslocales.value["vigenciahasta"] || null,
      TariffStatus: null,
      ENTC_CodTransportista: Number(this.ListaTodosTransportista.find(item => item.nombre === this.group_serviciostarifa.value["transportista"])?.codigo),
    };

    this.ordenventaService.BuscarTarifasServiciosLocales(prolrequest).subscribe(
      (response: ConsultarTarifaResponse) => {
        if (response.datos.result.length <= 0) {
          this.util.MessageDialog({
            titulo: "ERROR",
            mensaje: "No se encontraron coincidencias.",
            tipo: "warning"
          });
        } else {
          if (response.datos.status == "200") {
            if (response.datos.result.length > 0) { this.servicioslocales_tarifa = response.datos.result }
          }
        }
      },
      error => {

      }
    );

  }

  //Para listar en cada cbx:
  // --DatosGenerales:
  ListaTodosEstado: any[] = []
  ListaTodosRegimen: any[] = []
  ListaTodosVia: any[] = []
  ListaTodosCliente: any[] = []
  ListaTodosCustomer: any[] = []
  ListaTodosAgentes: any[] = []
  ListaTodosIncoterm: any[] = []
  ListaTodosEjecutivos: any[] = []
  // --ServicioYTarifa
  ListaTodosServicios: any[] = []
  ListaTodosTransportista: any[] = []//dANIEL 24
  ListaTodosPuertoTransbordo: any[] = []
  ListaTodosTrafico: any[] = []
  ListaTodosPuertoOrigen: any[] = []
  ListaTodosPuertoDestino: any[] = []
  ListaTodosMoneda: any[] = []
  ListaTodosTipoFechaTarifa: any[] = []
  ListaTodosCondicion: any[] = []
  ListaTodosPCMBL: any[] = []
  ListaTodosPCHBL: any[] = []
  // --DatosEmbarque
  ListaTodosImoClass: any[] = []
  ListaTodosShipper: any[] = []
  ListaTodosConsignee: any[] = []
  ListaTodosNotify: any[] = []

  // --Novedades
  ListaTodosDeposito: any[] = []


  // --ServicioLocales

  ListaTodosTarifa: any[] = []
  ListaTodosCodBase: any[] = []

  // servicioslocales_dataservicios: any[] = []

  // servicioslocales_datadetalle: any[] = []

  servicioslocales_dataObservaciones: any[] = []

  //ListaTodosDepositoTemp: any[] = []
  ListarParametros() {
    this.deshabilitarBtnGuardar = true;
    try {
      // --DatosGenerales

      const opcion = this.accion
      if (opcion != 'NUEVO') { this.cargarListadoUsuarios(); }

      this.ListaTodosPuertoOrigen = this.parametros.slice()
        .filter(r => r.tipo === 'PUERTO')
        .map(item => ({
          ...item,
          codigo: Number(item.codigo)
        })).sort((a, b) => a.nombre.localeCompare(b.nombre));


      this.ListaTodosEstado = this.parametros.slice().filter(r => r.tipo === 'OVE');
      this.ListaTodosRegimen = this.parametros.slice().filter(r => r.tipo === 'RGM');
      this.ListaTodosVia = this.parametros.slice().filter(r => r.tipo === 'VIA');
      this.ListaTodosLineaNegocio = this.parametros.slice().filter(r => r.tipo === 'LNG');
      // this.ListaTodosCliente = this.parametros.slice().filter(r => r.tipo === 'CLIENTE').sort((a, b) => a.nombre.localeCompare(b.nombre));
      // this.ListaTodosCustomer = this.parametros.slice().filter(r => r.tipo === 'CUS').sort((a, b) => a.nombre.localeCompare(b.nombre));
      // this.ListaTodosAgentes = this.parametros.slice().filter(r => r.tipo === 'AGE').sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.ListaTodosIncoterm = this.parametros.slice().filter(r => r.tipo === 'INC').sort((a, b) => a.nombre.localeCompare(b.nombre));
      // this.ListaTodosEjecutivos = this.parametros.slice().filter(r => r.tipo === 'EJECUTIVOS').sort((a, b) => a.nombre.localeCompare(b.nombre));


      // DATOS GENERALES CON EL METODO PARAMETROS
      const request = <listarEntidadesRequest>{}
      request.entc_codigo = null
      request.tipe_codigo = FUNC_ENTIDAD.customer
      this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosCustomer = response.datos.result })
      request.tipe_codigo = FUNC_ENTIDAD.cliente
      this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosCliente = response.datos.result })
      request.tipe_codigo = FUNC_ENTIDAD.agente
      this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosAgentes = response.datos.result })
      request.tipe_codigo = FUNC_ENTIDAD.ejecutivo
      //       this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosEjecutivos = response.datos.result.filter(e => e.codpais?.trim() === "1") })
      // console.log("lista ejecutivos",this.ListaTodosEjecutivos)

      this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosEjecutivos = response.datos.result })


      request.tipe_codigo = FUNC_ENTIDAD.transportista
      this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosTransportista = response.datos.result })

      // --ServiciosYTarifa
      this.ListaTodosServicios = this.parametros.slice().filter(r => r.tipo === 'SERVICIO').sort((a, b) => a.nombre.localeCompare(b.nombre));
      // this.ListaTodosTransportista = this.parametros.slice().filter(r => r.tipo === 'TRANSPORTISTA').sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.ListaTodosTrafico = this.parametros.slice().filter(r => r.tipo === 'TRF').sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.ListaTodosMoneda = this.parametros.slice().filter(r => r.tipo === 'MND').sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.ListaTodosTipoFechaTarifa = this.parametros.slice().filter(r => r.tipo === 'TFT').sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.ListaTodosCondicion = this.parametros.slice().filter(r => r.tipo === 'FLE').sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.ListaTodosPCMBL = this.parametros.slice().filter(r => r.tipo === 'CTP')
        .map(r => ({ ...r, nombre: r.nombre.trim() })).sort((a, b) => a.nombre.localeCompare(b.nombre));

      this.ListaTodosPCHBL = this.parametros.slice().filter(r => r.tipo === 'CTP')
        .map(r => ({ ...r, nombre: r.nombre.trim() })).sort((a, b) => a.nombre.localeCompare(b.nombre));






      // --Datos Embarque
      this.ListaTodosImoClass = this.parametros.slice().filter(r => r.tipo === 'IMO').sort((a, b) => a.nombre.localeCompare(b.nombre));
      // this.ListaTodosShipper = this.parametros.slice().filter(r => r.tipo === 'SHIPPER').sort((a, b) => a.nombre.localeCompare(b.nombre));
      // this.ListaTodosConsignee = this.parametros.slice().filter(r => r.tipo === 'CLIENTE').sort((a, b) => a.nombre.localeCompare(b.nombre));
      // this.ListaTodosNotify = this.parametros.slice().filter(r => r.tipo == 'CLIENTE').sort((a, b) => a.nombre.localeCompare(b.nombre));


      // request.tipe_codigo = FUNC_ENTIDAD.shipper
      // this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosShipper = response.datos.result })
      // request.tipe_codigo = FUNC_ENTIDAD.cliente
      // this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosConsignee = response.datos.result })
      // request.tipe_codigo = FUNC_ENTIDAD.cliente
      // this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosNotify = response.datos.result })

      const obsShipper = this.servParametros.listarEntidades({ ...request, tipe_codigo: FUNC_ENTIDAD.shipper });
      const obsConsignee = this.servParametros.listarEntidades({ ...request, tipe_codigo: FUNC_ENTIDAD.cliente });
      const obsNotify = this.servParametros.listarEntidades({ ...request, tipe_codigo: FUNC_ENTIDAD.cliente });
      forkJoin([obsShipper, obsConsignee, obsNotify]).subscribe({
        next: ([resShipper, resConsignee, resNotify]) => {
          this.ListaTodosShipper = resShipper.datos.result;
          this.ListaTodosConsignee = resConsignee.datos.result;
          this.ListaTodosNotify = resNotify.datos.result;
          this.actualizarMaestros();
        },
        error: (err) => {
          console.error("Error al cargar maestros de entidades", err);
        }
      });

      // --Novedades
      // this.ListaTodosDeposito = this.parametros.slice().filter(r => r.tipo === 'DepositoTemp').sort((a, b) => a.nombre.localeCompare(b.nombre));


      request.tipe_codigo = FUNC_ENTIDAD.deposito_temporal
      this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTodosDeposito = response.datos.result })


      // --EventoTarea
      this.ListTodosModulo = this.parametros.slice().filter(r => r.tipo === 'MOD').sort((a, b) => a.nombre.localeCompare(b.nombre));

      // -ServicioLocales
      this.ListaTodosTarifa = this.parametros.slice().filter(r => r.tipo === 'WEB').sort((a, b) => a.nombre.localeCompare(b.nombre));
      // this.ListaTodosDescripcionServiciosLocales = this.parametros.slice().filter(r => r.tipo === 'DESCSERVL') // MARIA
      this.ListaTodosCodBase = this.parametros.slice().filter(r => r.tipo === 'CODBASE').sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.ListaTodosTDO = this.parametros.slice().filter(r => r.tipo === 'TDO').sort((a, b) => a.nombre.localeCompare(b.nombre));
      // this.ListaAgentePortuario = this.parametros.slice().filter(r => r.tipo === 'AGENTEPORTUARIO')
      // this.ListaTerminalPortuario = this.parametros.slice().filter(r => r.tipo === 'DepositoTemp')
      // this.ListaTodosPuerto = this.parametros.slice().filter(r => r.tipo === 'PUERTO');
      this.ListaTodosEstadoNaveViaje = [{ codigo: "A", nombre: "ABIERTO" }, { codigo: "C", nombre: "CERRADO" }, { codigo: "P", nombre: "PRE-FACTURADO" },];

      const requestpuerto = <listarPuertosRequest>{}
      requestpuerto.puer_nombre = null
      requestpuerto.puer_codigo = null
      this.servParametros.listarPuertos(requestpuerto).subscribe(response => { this.ListaTodosPuerto = response.datos.result })

      request.tipe_codigo = FUNC_ENTIDAD.agente_portuario
      this.servParametros.listarEntidades(request).subscribe(response => { this.ListaAgentePortuario = response.datos.result })
      request.tipe_codigo = FUNC_ENTIDAD.terminal_portuario
      this.servParametros.listarEntidades(request).subscribe(response => { this.ListaTerminalPortuario = response.datos.result })

      this.deshabilitarBtnGuardar = false;
    } catch (err) {
      this.deshabilitarBtnGuardar = false;
    }
    finally {
      this.deshabilitarBtnGuardar = false;
    }
  }

  limpiar(value) {
    this.group_datosgenerales.get(value).reset();
    this.CodigosFiltrosAutocomplete[0][value] = 0
  }

  limpiarST(value) {
    this.group_serviciostarifa.get(value).reset();
    this.CodigosFiltrosAutocomplete[0][value] = 0
  }

  limpiarDE(value) {
    this.group_datosembarque.get(value).reset();
    this.CodigosFiltrosAutocomplete[0][value] = 0
  }

  limpiarNovedades(value) {
    this.group_novedades.get(value).reset();
    this.CodigosFiltrosAutocomplete[0][value] = 0
  }

  // CLIENTES - DATOS GENERALES

  CodigosFiltrosAutocomplete = [{
    ejecutivo: 0,
    customer: 0,
    agente: 0,
    broker: 0,
    cliente: 0,
    transportista: 0,
    group_novedades: 0,    /*Daniel23 */
    shipper: 0,
    puertoOrigen: 0,
    puertoDestino: 0,
    puertoTransbordo: 0,
    consignee: 0,
    notify: 0,
    depositoTemp: 0,
  }]

  textoFiltro: string = '';
  // SERVICIOS Y TARIFAS



  showMessage(row: any) {

  }

  deleteRow(row: any): void {
    this.confirmationService.confirm({
      target: event.target,
      message: '¿Está seguro de eliminar este item?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const index = this.serviciosytarifas_dataflete.indexOf(row);
        if (index > -1) {
          this.serviciosytarifas_dataflete.splice(index, 1);
        }
      },
      reject: () => {
      }
    });
  }


  //NOVEDADES
  novedades_datanovedades: any[] = [{ a1: '1' }]
  novedades_metadatanovedades: MetadataTable[] = [
    { field: 'a1', title: 'FECHA' },
    { field: '2', title: 'EMAIL' },
    { field: '3', title: 'DESCRIPCIÓN' },
  ]

  //ARCHIVOS
  formatObject(obj) {
    return {
      label: obj.nombre,
      value: obj.codigo
    };
  }

  //EVENTOS TAREAS
  tranformarDa(dato: string): string {
    if ((dato == null || dato == undefined)) return "";
    if (dato?.trim() === "P") {

      return "P  ";
    } else if (dato?.trim() === "C") {

      return "C  ";
    }
    return "";
  }

  handleDropdownChange(event: MatSelectChange) {
    const selectedValue = event.value; // Obtiene el valor seleccionado


    // Si quieres obtener el objeto completo seleccionado en lugar del valor,
    // tendrás que buscarlo en tu lista de parámetros
    const selectedItem = this.parametros.find(param => param.codigo === selectedValue);
    if (selectedItem) {


    } else {

    }
  }



  list_menu: any = [
    //{ icon: 'exit_to_app', text: 'Salir' },
    { icon: 'save', text: 'Guardar' }
  ]
  itemagrupador: ItemsAgrupador[] = []
  async operaciones_menu(tipo: string, event?: Event, mensajeExito: string = null) {

    switch (tipo) {
      case 'Salir':
        localStorage.removeItem('datoov');
        localStorage.removeItem('listadoservicio');
        localStorage.removeItem('datoov');
        this.setFiltrosBusqueda();
        const rutaComponente = '/comercialordenventa';
        this.router.navigate([rutaComponente]);
        break;
      case 'Guardar':
        //Daniel26
        // this.actualizarCodigosFiltros()
        this.deshabilitarBtnGuardar = true;
        if (event) { (event.currentTarget as HTMLButtonElement).disabled = true; }
        try {

          if (this.group_datosgenerales.get('estado').value == "005") {
            this.util.MessageDialog({
              titulo: "La Orden de Venta se encuentra en estado anulada y no se guardará ningun cambio realizado.", mensaje: "",
              tipo: "warning", icono: 'pi pi-exclamation-triangle'
            });
            this.deshabilitarBotones(event);
            return;
          }

          this.group_datosgenerales.markAllAsTouched();
          this.group_datosembarque.markAllAsTouched();
          this.group_serviciostarifa.markAllAsTouched();
          this.group_novedades.markAllAsTouched();

          let totalVenta = 0;
          let totalCosto = 0;
          let totalProfitMinimo = 0;
          let totalProfitFijo = 0;
          let totalNuevoProfit = 0;
          let MensajeError: string;
          // if (Number(totalNuevoProfit) < 0) {
          //   MensajeError = 'El profit total es negativo';
          // } else {
          //   if (Number(totalNuevoProfit) < Number(totalProfitFijo)) {
          //     if (Number(totalNuevoProfit) < totalProfitMinimo) {
          //       MensajeError = 'El profit total es menor al profit mínimo total';
          //     } else {
          //       MensajeError = 'El profit total es menor al profit local total';
          //     }
          //   }
          // }

          if (MensajeError != null || MensajeError != undefined) {
            const confirmado = await this.confirmarContinuar(`${MensajeError} ¿Está seguro que desea continuar?`);
            if (!confirmado) {
              this.deshabilitarBotones(event);
              return;
            }
          }
          // const errorMessage: string[] = [];
          // const validateFormGroup = (formGroup: FormGroup, groupName: string) => {
          //   Object.entries(formGroup.controls).forEach(([controlName, control]) => {
          //     if (control.invalid && control.errors?.['required']) {
          //       errorMessage.push(`El campo "${controlName}" en "${groupName}" es obligatorio.`);
          //     }
          //   });
          // };

          // validateFormGroup(this.group_datosgenerales, 'Datos Generales');
          // validateFormGroup(this.group_datosembarque, 'Datos Embarque');

          // if (errorMessage.length > 0) {
          //   if (errorMessage.length === 1) {
          //     this.util.MessageDialog({
          //       titulo: 'ERROR',
          //       mensaje: errorMessage[0],
          //       tipo: 'warning',
          //     });
          //   } else {
          //     this.util.MessageDialog({
          //       titulo: 'ERROR',
          //       mensaje: 'Se han encontrado los siguientes errores. Revisar los detalles.',
          //       tipo: 'warning',
          //       detalle: errorMessage.join('\n'),
          //     });
          //   }
          //   return;
          // }

          this.servicioslocales_datadetalle.forEach((rowdata: any) => {
            const valorCosto = Number(rowdata['dope_preciounitcosto']) || 0;
            const valorVenta = Number(rowdata['dope_preciounitvta']) || 0;
            const valorProfitFijo = Number(rowdata['profit_fijo']) || 0;
            const tipoprofitm = rowdata['tipoprofitm'];
            const profitMinimo = tipoprofitm === '002' ? (valorProfitFijo * Number(rowdata['profitminimo'])) / 100 : Number(rowdata['profitminimo']);
            const tipoCambio = Number(rowdata['tipocambioventa']) || 0;

            const costoDolares = rowdata['tipo_codmnd'] === '001'
              ? valorCosto / tipoCambio
              : valorCosto;

            const ventaDolares = rowdata['tipo_codmndventa'] === '001'
              ? valorVenta / tipoCambio
              : valorVenta;

            const pfminimoDolares = rowdata['tipomonedam'] === '001'
              ? profitMinimo / tipoCambio
              : profitMinimo;

            const pftfijoDolares = rowdata['tipo_codmndprofit'] === '001'
              ? valorProfitFijo / tipoCambio
              : valorProfitFijo;

            const nuevoProfit = Math.round((ventaDolares - Number(costoDolares.toFixed(2))) * 100) / 100;

            totalVenta += ventaDolares;
            totalCosto += costoDolares;
            totalProfitMinimo += pfminimoDolares;
            totalProfitFijo += pftfijoDolares;
            totalNuevoProfit += nuevoProfit;
          });

          // const itinerarioFinal = this.viajeitinerario_dataitinerario.find(it => it.ovnv_final === true);

          // if (itinerarioFinal) {
          //   const codDestino = this.ListaPuertosByVia.find(r => r.label === itinerarioFinal.nameportdischarge) ?? this.ListaPuertosByVia.find(r => r.label === itinerarioFinal.nameportdischarge?.label);
          //   const puertoDestino = this.group_serviciostarifa.value["puertodestino"];


          //   // if (Number(codDestino.value) !== Number(puertoDestino)) {
          //   //   this.util.MessageDialog({
          //   //     titulo: "El puerto de la nave final no corresponde a la OV.",
          //   //     mensaje: "",
          //   //     tipo: "warning",
          //   //     icono: 'pi pi-exclamation-triangle'
          //   //   });
          //   //   return;
          //   // }
          // }

          // ----------------------------------------------------------------------------------
          // PUNTO DE CORTE: Se comentó para pruebas, se eliminará cuando esté estable
          // ----------------------------------------------------------------------------------

          const dataMapeada = this.obtenerDataActual('TODO');
          const request = dataMapeada.request;

          // Preparamos objetos para el validador (necesita formato { items: [] })
          const insertActualizarOVFlete = { items: dataMapeada.itemsFlete };
          const insertActualizarOVServicio = { items: dataMapeada.itemsServicio };

          // 4. Validaciones finales y llamada al Servicio
          if (request.pintENTC_CodCliente == null || request.pintENTC_CodCliente == 0) {
            this.util.MessageDialog({ titulo: "ERROR", mensaje: "Razon social vacia", tipo: "warning" });
            this.deshabilitarBotones(event);
          } else {

            const validacion = new MantenimientoOrdenVentaValidacion(request, insertActualizarOVFlete, insertActualizarOVServicio, this.solosli);
            const { isValid, errorMessage, tieneValAdicional, adicionalMessage } = validacion.Guardar(false);

            if (isValid) {

              if (tieneValAdicional && adicionalMessage?.length > 0) {
                const esUnico = adicionalMessage.length === 1;
                this.messageService.add({
                  key: 'tl', severity: 'warn', summary: 'Aviso de Validación',
                  detail: esUnico ? adicionalMessage[0] : 'Se han identificado las siguientes alertas:\n - ' + adicionalMessage.join('\n - '), sticky: true, life: 5000
                });
              }

              const opcion = this.accion;

              // this.manejoCorreoPreview(request, opcion, mensajeExito);

              if (opcion == 'EDITAR') {
                this.ordenventaService.TnsEditarOvCot(request).subscribe(response => {
                  const numeroDocumento = response.datos.numeroDocumento ?? '';
                  this.enviarEventoBandejaOv({ output: 'numdoc', numdoc: numeroDocumento });

                  if (response.datos.status === 200) {
                    this.setFiltrosBusqueda();
                    const msj = mensajeExito != null ? mensajeExito : "Se actualizó correctamente";
                    this.util.MessageDialog({ titulo: "Mantenimiento Orden Venta", mensaje: msj, icono: "OK", tipo: "ok" });
                    this.actualizar_datos_ov(event);
                  } else {
                    this.util.MessageDialog({ titulo: 'ERROR', mensaje: response.meta.mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
                    this.deshabilitarBotones(event);
                  }
                }, (err) => {
                  this.deshabilitarBotones(event);
                  const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
                  this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
                });

              } else { // NUEVO

                this.ordenventaService.TnsInsertarOvCot(request).subscribe(response => {
                  const numeroDocumento = response.datos.numeroDocumento ?? '';
                  this.enviarEventoBandejaOv({ output: 'numdoc', numdoc: numeroDocumento });

                  if (response.datos.status === 200) {
                    this.group_datosgenerales.get('numero')?.setValue(numeroDocumento);
                    this.group_flotantes.get('ccotnumdoc_visualizacion')?.setValue(numeroDocumento);
                    this.util.MessageDialog({
                      titulo: "Mantenimiento Orden Venta", mensaje: "Se guardó correctamente la orden de venta: " + numeroDocumento, icono: "OK", tipo: "ok"
                    });
                    this.actualizar_datos_ov(event);
                  } else {
                    this.util.MessageDialog({ titulo: 'ERROR', mensaje: response.meta.mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
                    this.deshabilitarBotones(event);
                  }
                }, (err) => {
                  this.deshabilitarBotones(event);
                  const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
                  this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
                });
              }
            } else {
              if (errorMessage && errorMessage.length > 0) {
                const errorCount = errorMessage.length;
                if (errorCount === 1) {
                  this.util.MessageDialog({ titulo: "Validación", mensaje: errorMessage[0], tipo: "warning" });
                } else {
                  this.util.MessageDialog({
                    titulo: "Validación",
                    mensaje: "Se han encontrado los siguientes errores. Revisar los detalles.",
                    tipo: "warning",
                    detalle: errorMessage.join('\n')
                  });
                }
              }
              this.deshabilitarBotones(event);
            }
          }
        } catch (error) {
          console.error('Error al guardar orden de venta:', error);
          this.deshabilitarBotones(event);
        }
        finally {
          this.deshabilitarBotones(event);
        }
        break;

      default:
        break;

    }
  }


  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const base64Data = (e.target?.result as string).split(',')[1];

      const request: ListaDetCotizacionOVArchivoRequest = {
        items: [{
          CCOT_Numero: this.datosRecibidos?.ccot_numero ?? null,
          CCOT_Tipo: this.datosRecibidos?.ccot_tipo ?? 2,
          OVAR_Descrip: file.name,
          OVAR_FecEmi: this.util.formatearfecha(new Date(), "yyyy-MM-ddTHH:mm:ss") || null,
          OVAR_Archivo: base64Data,
          AUDI_UsrMod: this.storage.get("usuario") || null,
          AUDI_UsrCrea: this.storage.get("usuario") || null,
          OVAR_Observacion: null,
          ESTADO_OBJ: "U"
        }]
      };

      const maxOvarCodigo = this.archivos_dataarchivos.length > 0
        ? Math.max(...this.archivos_dataarchivos.map(item => item.ovar_codigo || 0))
        : 0;

      const newOvarCodigo = maxOvarCodigo + 1;

      this.archivos_dataarchivos.push({
        ccot_tipo: request.items[0].CCOT_Tipo,
        ccot_numero: request.items[0].CCOT_Numero,
        ovar_codigo: newOvarCodigo,
        ovar_descrip: request.items[0].OVAR_Descrip,
        ovar_fecemi: request.items[0].OVAR_FecEmi,
        ovar_archivo: base64Data,
        ovar_observacion: request.items[0].OVAR_Observacion,
        audi_usrmod: request.items[0].AUDI_UsrMod,
        audi_usrcrea: request.items[0].AUDI_UsrCrea,
        ESTADO_OBJ: "I"
      });

      this.archivos_dataarchivos = [...this.archivos_dataarchivos];
      input.value = '';
    };

    reader.readAsDataURL(file);
  }

  onRowSelect(event: any) {
    this.row = event.data;
    const dataToReturn = {
      idtarifa: this.row.idtariff
    };


  }

  isTabActive: boolean = false;
  isDrawerOpen: boolean = false;

  onTabClick(): void {
    this.buscarTarifas()
    this.isTabActive = !this.isTabActive;
    this.isDrawerOpen = this.isTabActive;
  }

  idTarifa: number;
  aplicarTarifa() {
    this.group_servicioslocales.get('descripcion')?.setValue(this.row.descripcion);
    this.group_servicioslocales.get('vigenciadesde')?.setValue(new Date(this.row.vigente_desde));
    this.group_servicioslocales.get('vigenciahasta')?.setValue(new Date(this.row.vigente_hasta));
    this.group_servicioslocales.get('terminal')?.setValue(this.row.terminal_portuario);
    this.group_servicioslocales.get('almacen')?.setValue(this.row.almacen);

    const tarDetRequest = <ConsultarTariffDetailByIdRequest>{};
    tarDetRequest.idTariff = this.row.idtariff;
    this.idTarifa = this.row.idtariff;
    const servTarfRequest = <GetServiceCalculatedByTariffRequest>{};
    servTarfRequest.idTariff = this.row.idtariff;
    servTarfRequest.pintCCOTNumero = this.datosRecibidos != null ? this.datosRecibidos.ccot_numero : null;
    servTarfRequest.psinCCOTTipo = 2;
    servTarfRequest.pvchDOOVHBL = this.datosRecibidos != null ? this.datosRecibidos.doov_hbl : null;
    this.listarTarifaDetalle = [];
    this.listarServTariff = [];

    forkJoin({
      tarifaDetalle: this.ordenventaService.BuscarTariffDetailById(tarDetRequest),
      servicioCalculado: this.ordenventaService.GetServiceCalculatedByTariff(servTarfRequest)
    }).subscribe({
      next: (response) => {
        this.servicioslocales_datadetalle.forEach(det => {
          if (det.ESTADO_OBJ === 'U' || !det.ESTADO_OBJ) {
            det.ESTADO_OBJ = 'D';
          }
        });
        for (let i = this.servicioslocales_datadetalle.length - 1; i >= 0; i--) {
          if (this.servicioslocales_datadetalle[i].ESTADO_OBJ === 'I') {
            this.servicioslocales_datadetalle.splice(i, 1);
          }
        }
        this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle]

        if (response.tarifaDetalle.datos.status === "200" && response.tarifaDetalle.datos.result.length > 0) {
          this.listarTarifaDetalle.push(...response.tarifaDetalle.datos.result.map((item: ItemsTarifaDetalleResponse) => ({
            idTariffDetail: item.idTariffDetail,
            idTariff: item.idTariff,
            unitDescription: item.unitDescription,
            idUnit: item.idUnit,
            conceptDescription: item.conceptDescription,
            idConcept: item.idConcept,
            salesAmount: item.salesAmount,
            costsAmount: item.costsAmount,
            currency: item.currency,
            validaForm: item.validFrom,
            validTo: item.validTo,
            remarks: item.remarks,
            tariffType: item.tariffType
          })));

        }

        if (response.servicioCalculado.datos.status === "200" && response.servicioCalculado.datos.result.length > 0) {
          this.listarServTariff.push(...response.servicioCalculado.datos.result.map((item: ItemsServiciosCalculadosTarifaResponse) => ({
            equivalentCode: item.equivalentCode,
            serv_codigo: item.serv_codigo,
            conceptDescription: item.conceptDescription,
            idUnit: item.idUnit,
            cons_codbas: item.cons_codbas,
            cons_desc_spa: item.cons_desc_spa,
            dope_preciounitvta: item.dope_preciounitvta,
            dope_preciounitcosto: item.dope_preciounitcosto,
            dope_cantidad: item.dope_cantidad,
            dope_preciototvta: item.dope_preciototvta,
            dope_preciototcosto: item.dope_preciounitcosto * (item.dope_cantidad || 1),
            tipe_codigo: item.tipe_codigo,
            idTariffDetail: item.idTariffDetail,
            entc_codigo: item.entc_codigo,
            dtar_item: item.dtar_item,
            currency: item.currency,
            tipo_codmnd: item.tipo_codmnd,
            idTariff: item.idTariff,
            totalProfit: item.totalProfit
          })));

        }
        let dopeItemCounter = this.servicioslocales_datadetalle.length > 0
          ? Math.max(...this.servicioslocales_datadetalle.map(d => d.dope_item || 0))
          : 0;
        const nuevosDetalles = this.listarTarifaDetalle.map(tarifa => {
          const matchingServicio = this.listarServTariff.find(servicio =>
            servicio.idTariffDetail === tarifa.idTariffDetail &&
            servicio.idTariff === tarifa.idTariff
          );
          const rowsConMismoId = this.servicioslocales_tarifa.find(fila => fila.idtariff === tarifa.idTariff);
          const codtransportista = this.ListaTodosTransportista.find(item => (item.nombre)?.toUpperCase() === (rowsConMismoId.transportista)?.toUpperCase())?.codigo
          const descBase = this.ListaBase.find(item => item.value === matchingServicio.cons_codbas)?.label;
          const monedaLabel = this.ListaMoneda.find(item => item.value === matchingServicio.currency)?.label;
          dopeItemCounter++;

          if (matchingServicio) {
            return {
              ...tarifa,
              ...matchingServicio,
              dope_item: dopeItemCounter,
              serv_nombre_spa: tarifa?.conceptDescription,
              cons_desc_spa: descBase,
              tipoentidad: "PROVEEDOR",
              entc_razonsocial: rowsConMismoId?.transportista,
              dope_preciounitvta: matchingServicio?.dope_preciounitvta,
              nombremnd: monedaLabel,
              dope_cantidad: 1,
              dope_preciototvta: matchingServicio?.dope_preciounitvta,
              cope_version: 1,
              // key: dopeItemCounter,
              entc_codigo: codtransportista,
              ESTADO_OBJ: 'I'
            };
          } else {
            return []
          }
        });

        this.servicioslocales_datadetalle.push(...nuevosDetalles);
        this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle];

      },
      error: () => {
        this.util.MessageDialog({
          titulo: "ERROR",
          mensaje: "Hubo un error al consultar los datos de tarifa. Intenta nuevamente.",
          tipo: "error",
        });
      }
    });
  }

  buscarCustomerEjecutivoSegunCliente() {

    if (!this.codCliente) return;
    const clientesFiltrados = this.ListaTodosCliente.filter(cliente => cliente.codigo === this.codCliente.toString());

    if (clientesFiltrados.length === 0) return;
    clientesFiltrados.forEach(cliente => {
      let tipoRelacion: string = '';
      if (cliente.adicional1 && cliente.adicional1.trim() !== '') {
        tipoRelacion = 'CUSTOMER SERVICE';
        this.group_datosgenerales.get('customer')?.setValue(cliente.adicional1);
      }
      if (cliente.adicional2 && cliente.adicional2.trim() !== '') {

        const match = this.ListaTodosEjecutivos.find(ejecutivo =>
          ejecutivo?.nombre === (cliente.adicional2)?.toUpperCase()
        )?.nombre;
        if (match) {
          tipoRelacion = 'EJECUTIVO';
          this.group_datosgenerales.get('ejecutivo')?.setValue(match);
        }
      }
      if (cliente.adicional3 && cliente.adicional3.trim() !== '') {
        tipoRelacion = 'DEPOSITO TEMPORAL';
        this.group_novedades.get('deposito')?.setValue(cliente.adicional3);
      }
    });
  }




  cargarServiciosEnTablaSegunLineaNegocioInicial(pcodcliente: number, pvia: string, pregimen: string, plineanegocio: string) {
    const via = pvia//this.group_datosgenerales.value["via"];
    const regimen = pregimen //this.group_datosgenerales.value["regimen"];
    const lineaNegocio = plineanegocio //this.group_datosgenerales.value["lineanegocio"];

    if (pcodcliente == null || !via || !regimen || !lineaNegocio) { this.serviciosytarifas_dataservicios = []; return; }

    const prolrequest: ConsultarEntidadServicio_Request = {
      pintENTC_Codigo: pcodcliente || null,//this.codCliente || null,
      cons_tabvia: 'VIA',
      cons_codvia: via,//this.group_datosgenerales.value["via"],
      cons_tabrgm: 'RGM',
      cons_codrgm: regimen,//this.group_datosgenerales.value["regimen"],
      cons_tablng: 'LNG',
      cons_codlng: lineaNegocio//this.group_datosgenerales.value["lineanegocio"],
    };

    this.ordenventaService.BuscarEntidadServicio(prolrequest).subscribe(
      (response: ConsultarEntidadServicioResponse) => {
        if (response.datos.status === 200) {


          const mappedData = response.datos.result.map((item, index) => {
            const proveedor = this.ListaProveedorG.find(r => r.value === item.entC_Codigo.toString());
            const proveedorNombre = proveedor ? proveedor.label : item.entC_Codigo;
            const moneda = this.ListaMoneda.find(r => r.value === item.tipO_CodMnd);
            const monedaDescripcion = moneda ? moneda.label : item.tipO_CodMnd;

            return {
              scot_item: index + 1,
              scot_exonerado: item.eseR_Exonerado,
              serv_nombre: item.serV_Nombre,
              ccot_ingresogasto: "INGRESO",
              tipedescripcion: "CLIENTE",
              entc_nomcom: proveedorNombre,
              cons_desc_spa: item.conS_DescBAS,
              scot_cantidad: 1,
              tipo_descmnd: monedaDescripcion,
              scot_preciouni: item.eseR_Valor || 0.00,
              scot_importe_ingreso: item.eseR_Valor || 0.00,
              scot_importe_egreso: 0.00,
              serv_afeigv: true,
              serv_afedet: true,
              tipo_desctdo: null,
              scot_serietdo: null,
              scot_numerotdo: null,
              audi_feccrea: new Date(),
              ESTADO_OBJ: 'I',
            };
          });
          this.serviciosytarifas_dataservicios = mappedData;
          this.cargarServiciosEnTablaSegunAgente();

        } else {
          this.serviciosytarifas_dataservicios = [];
        }
      }, err => {
        this.serviciosytarifas_dataservicios = [];
      })
  }


  cargarServiciosEnTablaSegunLineaNegocio() {
    const via = this.group_datosgenerales.value["via"];
    const regimen = this.group_datosgenerales.value["regimen"];
    const lineaNegocio = this.group_datosgenerales.value["lineanegocio"];
    if (this.codCliente == null || !via || !regimen || !lineaNegocio) { this.serviciosytarifas_dataservicios = []; return; }

    const prolrequest: ConsultarEntidadServicio_Request = {
      pintENTC_Codigo: this.codCliente || null,
      cons_tabvia: 'VIA',
      cons_codvia: this.group_datosgenerales.value["via"],
      cons_tabrgm: 'RGM',
      cons_codrgm: this.group_datosgenerales.value["regimen"],
      cons_tablng: 'LNG',
      cons_codlng: this.group_datosgenerales.value["lineanegocio"],
    };

    this.ordenventaService.BuscarEntidadServicio(prolrequest).subscribe(
      (response: ConsultarEntidadServicioResponse) => {
        if (response.datos.status === 200) {


          const mappedData = response.datos.result.map((item, index) => {
            const proveedor = this.ListaProveedorG.find(r => r.value === item.entC_Codigo.toString());
            const proveedorNombre = proveedor ? proveedor.label : item.entC_Codigo;
            const moneda = this.ListaMoneda.find(r => r.value === item.tipO_CodMnd);
            const monedaDescripcion = moneda ? moneda.label : item.tipO_CodMnd;

            return {
              scot_item: index + 1,
              scot_exonerado: item.eseR_Exonerado,
              serv_nombre: item.serV_Nombre,
              ccot_ingresogasto: "INGRESO",
              tipedescripcion: "CLIENTE",
              entc_nomcom: proveedorNombre,
              cons_desc_spa: item.conS_DescBAS,
              scot_cantidad: 1,
              tipo_descmnd: monedaDescripcion,
              scot_preciouni: item.eseR_Valor || 0.00,
              scot_importe_ingreso: item.eseR_Valor || 0.00,
              scot_importe_egreso: 0.00,
              serv_afeigv: item.serv_afeigv,
              serv_afedet: item.serv_afedet,
              tipo_desctdo: null,
              scot_serietdo: null,
              scot_numerotdo: null,
              audi_feccrea: new Date()
            };
          });
          this.serviciosytarifas_dataservicios = mappedData;
          this.cargarServiciosEnTablaSegunAgente();

        } else {
          this.serviciosytarifas_dataservicios = [];
        }
      }, err => {
        this.serviciosytarifas_dataservicios = [];
      })
  }

  cargarServiciosEnTablaSegunAgente() {
    const entidad = this.codAgente;
    if (entidad == null) { return; }

    const prolrequest: ConsultarEntidadServicio_Request = {
      pintENTC_Codigo: entidad,
      cons_tabvia: null,
      cons_codvia: null,
      cons_tabrgm: null,
      cons_codrgm: null,
      cons_tablng: null,
      cons_codlng: null,
    };

    this.ordenventaService.BuscarEntidadServicio(prolrequest).subscribe(
      (response: ConsultarEntidadServicioResponse) => {
        if (response.datos.status === 200) {


          const mappedData = response.datos.result.map((item, index) => {
            const proveedor = this.ListaProveedorG.find(r => r.value === item.entC_Codigo.toString());
            const proveedorNombre = proveedor ? proveedor.label : item.entC_Codigo;
            const moneda = this.ListaMoneda.find(r => r.value === item.tipO_CodMnd);
            const monedaDescripcion = moneda ? moneda.label : item.tipO_CodMnd;

            return {
              scot_item: index + 1,
              scot_exonerado: item.eseR_Exonerado,
              serv_nombre: item.serV_Nombre,
              ccot_ingresogasto: "EGRESO",
              tipedescripcion: "AGENTE",
              entc_nomcom: proveedorNombre,
              cons_desc_spa: item.conS_DescBAS,
              scot_cantidad: 1,
              tipo_descmnd: monedaDescripcion,
              scot_preciouni: item.eseR_Valor || 0.00,
              scot_importe_ingreso: item.eseR_Valor || 0.00,
              scot_importe_egreso: 0.00,
              serv_afeigv: true,
              serv_afedet: true,
              tipo_desctdo: null,
              scot_serietdo: null,
              scot_numerotdo: null,
              audi_feccrea: new Date()
            };
          });
          this.serviciosytarifas_dataservicios = [
            ...this.serviciosytarifas_dataservicios,
            ...mappedData
          ];
        }
      });
  }

  obtenerArchivos() {
    this.archivos_dataarchivos = [];
    this.dtArchivosRef?.resetDatatable();

    const prolrequest: GetCotizacionOVArchivoRequest = {
      pintCCOT_Numero: this.datosRecibidos.ccot_numero,
      psinCCOT_Tipo: 2
    };

    this.ordenventaService.OVGetArchivos(prolrequest).subscribe(
      (response: GetCotizacionOVArchivoResponse) => {
        if (response.datos?.status === 200 && response.datos.result) {
          const rawData = response.datos.result;
          this.archivos_dataarchivos = rawData.map(item => {
            return {
              ovar_codigo: item.ovaR_Codigo ?? null,
              ccot_numero: item.ccoT_Numero ?? null,
              ccot_tipo: item.ccoT_Tipo ?? null,
              ovar_descrip: item.ovaR_Descrip ?? null,
              ovar_fecemi: item.ovaR_FecEmi ? new Date(item.ovaR_FecEmi) : null,
              ovar_archivo: item.ovaR_Archivo,
              ovar_observacion: item.ovaR_Observacion ?? null,
              audi_usrcrea: item.audI_UsrCrea ?? null,
              audi_feccrea: item.audI_FecCrea ? new Date(item.audI_FecCrea) : null,
              audi_usrmod: item.audI_UsrMod ?? null,
              audi_fecmod: item.audI_FecMod ? new Date(item.audI_FecMod) : null,
              ESTADO_OBJ: 'NA',
            };
          });
        }
      }
    );
  }

  ListaFiltradaPuertoOrigen: any[] = [];
  ListaFiltradaPuertoDestino: any[] = [];
  filtrarPuertosSegunVia() {
    const viaSeleccionada = this.group_datosgenerales.value["via"] || (this.datosRecibidos != null ? this.datosRecibidos.cons_codvia : null);
    const puertosFiltrados = this.ListaTodosPuertoOrigen.filter(puerto => {
      if (!viaSeleccionada) return true;
      return puerto.via === viaSeleccionada;
    });
    this.ListaTodosPuertoOrigenyDestino = puertosFiltrados;
    this.ListaFiltradaPuertoOrigen = this.ListaTodosPuertoOrigenyDestino;
    this.ListaFiltradaPuertoDestino = this.ListaTodosPuertoOrigenyDestino;

    const prioridadOrigen = new Map([["NINGBO", 0], ["SHANGHAI", 1], ["SHEKOU", 2]]);
    const prioridadDestino = new Map([["CALLAO", 0], ["PAITA", 1], ["CHANCAY", 2], ["ARICA", 3]]);
    const obtenerPrioridad = (nombre: string, prioridades: Map<string, number>) => {
      const upperNombre = nombre?.toUpperCase();
      for (const [clave, valor] of prioridades.entries()) {
        if (upperNombre.includes(clave)) return valor;
      }
      return Infinity; // Si no está en la lista, va al final
    };
    this.ListaFiltradaPuertoOrigen = this.ListaTodosPuertoOrigenyDestino.slice().sort((a, b) => {
      return obtenerPrioridad(a.nombre, prioridadOrigen) - obtenerPrioridad(b.nombre, prioridadOrigen);
    });
    this.ListaFiltradaPuertoDestino = this.ListaTodosPuertoOrigenyDestino.slice().sort((a, b) => {
      return obtenerPrioridad(a.nombre, prioridadDestino) - obtenerPrioridad(b.nombre, prioridadDestino);
    });

    this.ListaPuertosByVia = puertosFiltrados;
  }

  custombTarifas = [
    { icon: 'pi pi-search', function: () => this.buscarTarifas(), disable: this.bloqueoCheckboxSLI }
  ];

  onCheckboxChangeTarifas(event: { rowIndex: number, isChecked: boolean, rowdata: any }) {
    const { rowIndex, isChecked } = event;
    this.row = event.rowdata;

    this.aplicarTarifa();
  }

  formatDateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, '');

    if (value.length > 2) {
      value = `${value.substring(0, 2)}/${value.substring(2)}`;
    }
    if (value.length > 5) {
      value = `${value.substring(0, 5)}/${value.substring(5)}`;
    }
    input.value = value.substring(0, 10);
  }

  onPuertoChange(event: any) {
    const codPuerto = this.group_serviciostarifa.value["puertoorigen"];
    const puertoSeleccionado = this.ListaTodosPuertoOrigenyDestino.find(
      (item) => item.codigo === codPuerto
    );
    if (puertoSeleccionado) {
      const valorAdicional3 = puertoSeleccionado.adicional3;
      const traficoSeleccionado = this.ListaTodosTrafico.find(
        (item) => item.nombre === valorAdicional3
      );
      this.group_serviciostarifa.get('trafico')?.setValue(traficoSeleccionado?.codigo || null);
    }
    const value = this.ListaTodosPuertoOrigenyDestino?.find(item => item.codigo === codPuerto)?.codigo
    this.objPuertoOrigen = value !== null || value !== undefined ? {
      label: this.ListaTodosPuertoOrigenyDestino?.find(item => item.codigo === codPuerto)?.nombre,
      value: value
    } : ''
    this.reconstruirItinerario();
    this.actualizarValidacionSucursal();
  }

  setFiltrosBusqueda() {
    const filtrosBusquedaOv = JSON.parse(localStorage.getItem("filtrosBusquedaOv"));

    if (typeof filtrosBusquedaOv === 'object' && filtrosBusquedaOv !== null) {
      filtrosBusquedaOv.origen = "mantenimiento-ov";
      localStorage.setItem("filtrosBusquedaOv", JSON.stringify(filtrosBusquedaOv));
    }
  }

  onTableItinerarioChange(Event: any) {

  }

  onChange(vent: any) {

  }

  syncRowToOtherTable(event: any, action: 'add' | 'delete') {
    const keyField = 'ovnv_item';
    if (action === 'add') {

      const newRow = { ...event };
      const existe = this.viajeitinerario_datanave.some(row => row[keyField] === newRow[keyField]);
      if (!existe) {
        this.viajeitinerario_datanave = [...this.viajeitinerario_datanave, newRow];
      }

      const maxItem = Math.max(...this.viajeitinerario_dataitinerario.map(row => row.ovnv_item));
      this.viajeitinerario_datanave = this.viajeitinerario_dataitinerario.map(row => ({
        ...row,
        ovnv_item: row.ovnv_item === maxItem
      }));

      this.bloqueoBtnAddCoordinador('EDIT');

    } else if (action === 'delete') {
      if (!event.hasOwnProperty(keyField)) return;

      this.viajeitinerario_datanave = this.viajeitinerario_datanave.filter(
        row => row[keyField] !== event[keyField],
      );

      const maxItem = Math.max(...this.viajeitinerario_dataitinerario.map(row => row.ovnv_item));
      this.viajeitinerario_datanave = this.viajeitinerario_dataitinerario.map(row => ({
        ...row,
        ovnv_item: row.ovnv_item === maxItem
      }));
    }
  }

  syncRowToOtherTableFlete(event: any, action: 'add' | 'delete') {
    const keyField = 'dcot_item';

    if (action === 'add') {
      const newRow = { ...event };
      const yaExiste = this.datosembarque_dataflete.some(row => row[keyField] === newRow[keyField]);

      if (!yaExiste) {
        this.datosembarque_dataflete = [...this.datosembarque_dataflete, newRow];
        const temp = [...this.serviciosytarifas_dataflete];
        const maxItem = Math.max(...this.serviciosytarifas_dataflete.map(row => row[keyField] || 0));
        this.cdr.detectChanges();

        console.log('Temp leído:', temp.length);
      }
    } else if (action === 'delete') {
      if (!event.hasOwnProperty(keyField)) return;

      this.datosembarque_dataflete = this.datosembarque_dataflete.filter(
        row => row[keyField] !== event[keyField],
      );

      const temp = [...this.serviciosytarifas_dataflete];
      this.cdr.detectChanges();
    }
  }

  detectarNuevaFilaTablaEventos(event: any, action: 'add') {
    const row = event.row;
    if (action === 'add') {
      this.modifiedRow = {
        ...row,
        even_usuario: this.storage.get("usuario"),
        even_fecha: new Date().toISOString().split('T')[0],
      };
    }
  }

  async onChangeServicios(event: { field: string; event: any; index: any; rowdata: any }, origen: string) {

    const index = event.index;
    let valorDP;
    if (event.event && event.event.value && typeof event.event.value === 'object' && 'value' in event.event.value) {
      valorDP = String(event?.event?.value?.value);
    } else {
      valorDP = String(event?.event?.value);
    }
    const fieldCambiado = event.field;
    let nuevoValor;
    const rowdata = event.rowdata;
    // const scot_importe_ingreso = rowdata.scot_importe_ingreso?.value;
    const scot_preciouni = rowdata.scot_preciouni;
    const scot_cantidad = rowdata.scot_cantidad ?? 1;
    const ccot_ingresogasto = rowdata.ccot_ingresogasto;

    if (fieldCambiado == "tipedescripcion") { // TIPO ENTIDAD
      if (valorDP == "1") {
        nuevoValor = this.group_datosgenerales.get('cliente')?.value;
      } else if (valorDP == "10") {
        nuevoValor = this.group_datosembarque.get('shipper')?.value;
      } else if (valorDP == "2") {
        // PROVEEDORES
      } else if (valorDP == "5") {
        nuevoValor = this.group_serviciostarifa.get('transportista')?.value;
      } else if (valorDP == "6") {
        nuevoValor = this.group_datosgenerales.get('agente')?.value;
      } else if (valorDP == "7") {
        // BROKER
      }
      const entSeleccionada = this.ListaProveedorG.find(e => e.label === nuevoValor);
      if (origen == 'servicios_adicionales') {
        this.enviarNuevoValorToDatatable(entSeleccionada, index, 'entc_nomcom');
      } else if (origen == 'servicios_change_control') {
        this.enviarValorDTServiciosChangeControl(entSeleccionada, index, 'entc_nomcom');
      }
    }
    if (fieldCambiado == "cons_desc_spa") { // BASE

      if (origen == 'servicios_adicionales') {
        await this.calcularCantidadBase(valorDP, index, origen);
      } else if (origen == 'servicios_change_control') {
        await this.calcularCantidadBase(valorDP, index, origen);
      }
    }
    if (fieldCambiado == "tipo_desctdo") { // TIPO DOCUMENTO
      if (origen == 'servicios_change_control') {
        if (!rowdata.ccot_ingresogasto || rowdata.ccot_ingresogasto == "") {
          this.enviarValorDTServiciosChangeControl(null, index, 'tipo_desctdo');
          this.util.MessageDialog({
            titulo: "Actualizar Tipos de Documento", mensaje: "Debe seleccionar el si es Ingreso o Egreso."
            , tipo: "warning", icono: "pi pi-exclamation-triangle"
          });
          return;
        }
        this.AsignarSerieDocumento(origen, index, rowdata);
      } else if (origen == 'servicios_adicionales') {
        this.SeleccionarTipoDocumento(false, this.index_serviciosChangeControl, rowdata, 'input');
        // //
        // if (!rowdata.ccot_ingresogasto || rowdata.ccot_ingresogasto == "") {
        //   this.enviarNuevoValorToDatatable(null, index, 'tipo_desctdo');
        //   this.util.MessageDialog({
        //     titulo: "Actualizar Tipos de Documento", mensaje: "Debe seleccionar el si es Ingreso o Egreso."
        //     , tipo: "warning", icono: "pi pi-exclamation-triangle"
        //   });
        //   return;
        // }
        // this.AsignarSerieDocumento(origen, index, rowdata);
      }
    }

    if (fieldCambiado == "ccot_ingresogasto") {
      this.SetTipoDocumentoServicio(origen, index, rowdata);
    }

    if (fieldCambiado == "serv_nombre") {
      this.SetDatosServicios(origen, index, rowdata);
    }

    scot_preciouni
    let nuevo_importe = 0;
    let nuevo_scot_importe_ingreso = 0;
    let nuevo_scot_importe_egreso = 0;
    if (fieldCambiado == 'scot_preciouni' || fieldCambiado == 'scot_cantidad' || fieldCambiado == 'ccot_ingresogasto') {
      if (ccot_ingresogasto != null) {
        nuevo_importe = scot_preciouni * scot_cantidad;
        if (ccot_ingresogasto.value == '002') {
          nuevo_scot_importe_egreso = nuevo_importe;
        } else if (ccot_ingresogasto.value == '001') {
          nuevo_scot_importe_ingreso = nuevo_importe;
        }
      }

      if (origen == 'servicios_adicionales') {
        this.enviarNuevoValorToDatatable(nuevo_scot_importe_ingreso, index, 'scot_importe_ingreso');
        this.enviarNuevoValorToDatatable(nuevo_scot_importe_egreso, index, 'scot_importe_egreso');
      } else if (origen == 'servicios_change_control') {
        this.enviarValorDTServiciosChangeControl(nuevo_scot_importe_ingreso, index, 'scot_importe_ingreso');
        this.enviarValorDTServiciosChangeControl(nuevo_scot_importe_egreso, index, 'scot_importe_egreso');
      }

    }
  }

  enviarNuevoValorToDatatable(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onDpValueChangeEvento.emit(eventToEmit);
  }

  async establecerLineaNegocio() {
    this.group_datosgenerales.get('lineanegocio').setValue(null);
    const agente = this.group_datosgenerales.get('agente').value;
    const valuelng = this.group_datosgenerales.get('lineanegocio').value;
    const valuergm = this.group_datosgenerales.get('regimen').value;
    if (valuergm != null) {
      if (valuergm == '002') { // expo
        this.group_datosgenerales.get('lineanegocio').setValue('002');
      } else if (valuergm == '001') {
        if (agente != null) {
          if (valuelng == null) {
            const request = <validacionMapeoDatosOVRequest>{};
            request.tabla = "PARAMETROS";
            request.clave = "EAGENTE_MANDATO";
            request.cod_entidad = this.codAgente;
            this.validarAgente(request).then(res => {
              if (res == true) {
                this.group_datosgenerales.get('lineanegocio').setValue('001');
              } else if (res == false) {
                this.group_datosgenerales.get('lineanegocio').setValue('004');
              }
            });
          }
        }
      }
    }
  }

  async validarAgente(request: validacionMapeoDatosOVRequest): Promise<boolean> {
    try {
      const res = await firstValueFrom(this.ordenventaService.ValidacionMapeoDatos(request));
      return res.datos.status === 200 && res.datos.result === true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async calcularCantidadBase(_CONS_CodBAS: string, index, origen: string, opts?: { soloRetornar?: boolean }
  ): Promise<number | void> {
    if (_CONS_CodBAS && _CONS_CodBAS !== null && _CONS_CodBAS !== undefined) {
      let _SCOT_Cantidad: number = 1.00;
      let _DCOT_Peso: number | null = 0.00;
      let _DCOT_Volumen: number | null = 0.00;
      const teus20 = 1;
      const teus40 = 2;
      switch (_CONS_CodBAS) {
        case "001":
          // No cambia _SCOT_Cantidad, se queda en 1
          break;
        case "002":
          _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + (dcot.dcot_cantidad || 0), 0);
          break;
        case "003":
          const paquete = this.serviciosytarifas_dataflete[0]?.pack_desc;
          if (paquete?.value == "1") {
            _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + ((dcot.dcot_cantidad * teus20) || 0), 0);
          } else if (paquete?.value == "3") {
            _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + ((dcot.dcot_cantidad * teus40) || 0), 0);
          } else if (paquete?.value == "4") {
            _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + ((dcot.dcot_cantidad * teus40) || 0), 0);
          } else if (paquete?.value == "2") {
            _SCOT_Cantidad = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + ((dcot.dcot_cantidad * teus40) || 0), 0);
          }
          break;
        case "004":
          _DCOT_Peso = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + (dcot.dcot_peso || 0), 0);
          _DCOT_Volumen = this.serviciosytarifas_dataflete.reduce((sum, dcot) => sum + (dcot.dcot_volumen || 0), 0);

          if (_DCOT_Peso !== 0 && _DCOT_Volumen !== 0) {
            if (_DCOT_Peso > _DCOT_Volumen) {
              _SCOT_Cantidad = _DCOT_Peso;
            } else {
              _SCOT_Cantidad = _DCOT_Volumen;
            }
          }
          break;
        default:
          break;
      }

      if (opts?.soloRetornar) {
        return _SCOT_Cantidad;
      }

      if (origen == 'servicios_adicionales') {
        this.enviarNuevoValorToDatatable(_SCOT_Cantidad, index, 'scot_cantidad');
      } else if (origen == 'servicios_change_control') {
        this.enviarValorDTServiciosChangeControl(_SCOT_Cantidad, index, 'scot_cantidad');
      } else if (origen == 'servicios_sli') {
        this.enviarValorDtSLI(_SCOT_Cantidad, index, 'dope_cantidad');
      }

      return;
    }

  }

  //Funcion para actualizar el monto

  // @ViewChild('Flete') Flete: DatatableComponent

  calculateFlete = (evento: any) => {

    const total = this.serviciosytarifas_dataflete?.reduce((sum, item) => {
      const value = parseFloat(item.dcot_totaluniventa);
      return sum + (isNaN(value) ? 0 : value);
    }, 0);

    this.group_serviciostarifa.get('fletetotal').setValue(total);

    // actualización de servicios SLI por cantidad de fletes

    const filaOriginal = this.dataFlete?.getFilaOriginal?.(evento);

    const filaEncontrada = this.serviciosytarifas_dataflete?.find?.(
      (fila) => fila?.key === filaOriginal?.key
    );

    if (filaOriginal?.dcot_cantidad !== filaEncontrada?.dcot_cantidad) {

      if (this.servicioslocales_datadetalle.some(item => item.ESTADO_OBJ !== 'D')) {

        if (
          this.servicioslocales_datadetalle?.filter(t => t.ESTADO_OBJ !== 'D').some(t => t.cons_codest !== '001')
        ) {
          this.messageService.add({
            severity: 'error', summary: 'Cambio de cantidad no permitido', key: 'tl',
            detail: 'No se puede cambiar la cantidad de fletes porque ya hay servicios prefacturados',
          });

          filaEncontrada.dope_cantidad = filaOriginal.dcot_cantidad;
          return;
        }

        const totalCantidad = this.serviciosytarifas_dataflete?.reduce((sum, item) => {
          const value = parseFloat(item.dcot_cantidad);
          return sum + (isNaN(value) ? 0 : value);
        }, 0);

        if (this.servicioslocales_datadetalle.length > 0) {

          this.servicioslocales_datadetalle
            ?.filter(item => item.ESTADO_OBJ !== 'D')
            .forEach(item => {
              const preciounitcosto = parseFloat(item.dope_preciounitcosto) || 0;
              const preciounit_prom = parseFloat(item.dope_preciounit_prom) || 0;
              const preciounitvta = parseFloat(item.dope_preciounitvta) || 0;

              const preciototcosto = preciounitcosto * totalCantidad;
              const preciotot_prom = preciounit_prom * totalCantidad;
              const preciototvta = preciounitvta * totalCantidad;

              item.dope_preciototcosto = Number(Math.round(preciototcosto * 100) / 100);
              item.dope_preciotot_prom = Number(Math.round(preciotot_prom * 100) / 100);
              item.dope_preciototvta = Number(Math.round(preciototvta * 100) / 100);
              item.dope_cantidad = totalCantidad;
              item.ESTADO_OBJ = item.ESTADO_OBJ == 'NA' ? 'U' : item.ESTADO_OBJ;
            });

        }

        this.messageService.add({ severity: 'warn', summary: 'Actualización Servicios SLI', detail: 'Se actualizó el Costo y Venta Total considerando la nueva cantidad.', life: 3000, key: "tl" });

      }
    }

    setTimeout(() => {
      this.cargarTarifasDefault();
    }, 1000);

  }

  async onChangeFletes(event: { field: string; event: any; index: any; rowdata }) {

    const index = event.index;
    let valorDP;
    if (event?.event && event?.event?.value && typeof event?.event?.value === 'object' && 'value' in event?.event?.value) {
      valorDP = String(event?.event?.value?.value);
    } else {
      valorDP = String(event?.event?.value);
    }
    const fieldCambiado = event.field;
    const rowdata = event.rowdata;
    const row = this.contratoSeleccionado?.row;
    let dcot_preciounicosto = 0.00;
    let dcot_preciouniventa = 0.00;
    let dcot_totalunicosto = 0.00;
    let dcot_totaluniventa = 0.00;

    if (fieldCambiado == "pack_desc") { // TIPO PAQUETE
      const val_flete = await this.asignacionFletePorTipoPaquete(rowdata, index);
      if (val_flete) {
        dcot_preciounicosto = val_flete.dcot_preciounicosto ?? 0;
        dcot_preciouniventa = val_flete.dcot_preciouniventa ?? 0;
        dcot_totalunicosto = val_flete.dcot_totalunicosto ?? 0;
        dcot_totaluniventa = val_flete.dcot_totaluniventa ?? 0;
      }
    }

    if (fieldCambiado == "dcot_cantidad") { // CANTIDAD
      if (rowdata.dcot_cantidad != null && rowdata.dcot_cantidad != 0) {
        dcot_preciouniventa = rowdata.dcot_preciounicosto;
        dcot_totaluniventa = rowdata.dcot_preciounicosto * rowdata.dcot_cantidad;
        // dcot_totalunicosto = rowdata.dcot_cantidad * dcot_preciounicosto;
        dcot_totalunicosto = rowdata.dcot_cantidad * rowdata.dcot_preciounicosto;
        this.enviarNuevoValorToDatatableFlete(dcot_totalunicosto, index, 'dcot_totalunicosto');
        // this.enviarNuevoValorToDatatableFlete(dcot_preciouniventa, index, 'dcot_preciouniventa');
        // this.enviarNuevoValorToDatatableFlete(dcot_totaluniventa, index, 'dcot_totaluniventa');
        // this.group_serviciostarifa.get('fletetotal').setValue(dcot_totaluniventa);
      }
    }

  }

  enviarNuevoValorToDatatableFlete(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onDpValueChangeFleteEvento.emit(eventToEmit);
  }

  onHblChange(evento: any) {
    this.group_flotantes.get('doovhbl_visualizacion')?.setValue(this.group_novedades.get('blhijo')?.value);
  }

  listaTarifas: itemsTarifaFleteResponse[] = []
  async ConsultarTarifario(rowdata: any, actualizarCosto: boolean, actualizarPrecioVenta: boolean): Promise<any> {
    try {
      let PACK_Codigo;

      if (typeof rowdata.pack_desc === 'object' && rowdata.pack_desc !== null) {
        PACK_Codigo = Number(rowdata.pack_desc.value);
      } else if (typeof rowdata.pack_desc === 'string') {
        const packCod = this.ListaOriginalTipoPaquete.find(r => r.label === rowdata.pack_desc);
        PACK_Codigo = Number(packCod ? packCod.value : rowdata.pack_desc);
      }

      if (!isNaN(PACK_Codigo) && PACK_Codigo > 0) {

        const contrato = this.contratoSeleccionado?.codigo;
        const puertoOrigen = this.group_serviciostarifa.get('puertoorigen')?.value;
        const puertoDestino = this.group_serviciostarifa.get('puertodestino')?.value;

        if (contrato && puertoOrigen && puertoDestino) {
          const tarifa = this.contratoSeleccionado?.listaTarifas.find((t: any) =>
            t.pack_codigo === PACK_Codigo &&
            t.puer_codorigen === puertoOrigen &&
            t.puer_coddestino === puertoDestino
          );

          if (!tarifa) {
            throw new Error("No se encontró una tarifa adecuada para el flete que está ingresando.");
          }

          rowdata.tari_codigo = tarifa.tari_codigo;

          if ((tarifa.tari_costo != null && tarifa.tari_costo > 0) || actualizarCosto) {
            rowdata.dcot_preciounicosto = tarifa.tari_costo;
          }

          if ((tarifa.tari_pventa1 != null && tarifa.tari_pventa1 > 0) || actualizarPrecioVenta) {
            rowdata.dcot_preciouniventa = tarifa.tari_pventa1;
          }
        }
      }
    } catch (error: any) {
      this.util.MessageDialog({
        titulo: "Tarifa no encontrada", mensaje: "Ha ocurrido un error al configurar flete: "
          + error.message, tipo: "error", icono: "pi pi-exclamation-triangle"
      });
    }

    return rowdata;
  }

  // #region SERVICIOS CHANGE CONTROL

  enviarValorDTServiciosChangeControl(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onDpChangeTblServiciosChangeControl.emit(eventToEmit);
  }

  async btnMasInit(responder: (continuar: boolean, filaPreCargada?: any) => void) {
    let filaCreada: any = null;
    const continuar = await this.util.MessageDialog({
      titulo: "Advertencia",
      mensaje: "Esta opción es sólo para incluir un nuevo servicio, si necesita modificar un servicio que ya existe debe usar el botón [Crear Change Control] que está en la pestaña Servicios Adicionales, ¿desea continuar?",
      icono: "pi pi-exclamation-triangle",
      tipo: "warning",
      textoBtn: { textoBtnOpcion1: "Sí", textoBtnOpcion2: "No" },
      pregunta: {
        onAccept: () => true,
        onReject: () => false
      }
    });
    if (continuar) {
      filaCreada = await this.AddServicioChangeControl();
    }
    responder(continuar, filaCreada);
  }

  AddServicioChangeControl(): any {
    let _SCOT_Item = 0;

    const dataChangeControl = this.dtServiciosChangeControl as { scot_item: number }[];
    const dataServicio = this.serviciosytarifas_dataservicios as { scot_item: number }[];

    if (dataChangeControl.length === 0) {
      _SCOT_Item = dataServicio.length === 0
        ? 0
        : Math.max(...dataServicio.map(s => s.scot_item));
    } else {
      _SCOT_Item = Math.max(...dataChangeControl.map(s => s.scot_item));
    }

    const filaPorDefecto = {
      scot_item: _SCOT_Item + 1,
      scot_chagecontrol: true,
      scot_origen: 'D',
      scot_fechaoperacion: new Date(),
      audi_usrcrea: this.nombreUsuario,
      audi_feccrea: new Date(),
      scot_preciouni: 0,
      scot_importe_ingreso: 0,
      scot_importe_egreso: 0,
      scot_eliminable: true,
      scot_editable: true,
      scot_itemchangecontrol: null,
      scot_autoriza: null,
    };

    return filaPorDefecto;
  }


  btnDeleteInit(evento: ConfirmDeleteRowEvent) {
    const row = evento.row;

    if (row.scot_eliminable) {
      this.util.MessageDialog({
        titulo: "Advertencia", mensaje: "¿Está seguro que desea eliminar el servicio?",
        icono: "pi pi-exclamation-triangle", tipo: "warning",
        textoBtn: { textoBtnOpcion1: "Sí", textoBtnOpcion2: "No" },
        pregunta: {
          onAccept: async () => {
            evento.row = row;
            evento.index = evento.index;
            evento.responder(true);
          },
          onReject: () => evento.responder(false)
        }
      });
    } else {
      evento.responder(false);
      this.util.MessageDialog({
        titulo: "Orden de Venta", mensaje: "El registro no puede ser eliminado porque ya fue procesado por Finanzas.",
        tipo: "warning", icono: "pi pi-exclamation-triangle"
      });
    }
  }

  EnabledDatosGenerales: boolean = false;
  EnabledDatosTarifa: boolean = false;
  EnabledDatosServicios: boolean = false;
  EnabledDatosServiciosChangeControl: boolean = false;
  EnabledDatosEmbarque: boolean = false;
  EnabledDatosObservaciones: boolean = false;
  EnabledDatosDocumento: boolean = false;
  EnabledDatosHBL: boolean = false;
  EnabledAyudaViaje: boolean = false;
  EnabledDatosViaje: boolean = false;
  EnabledDatosNovedades: boolean = false;
  EnabledDatosArchivos: boolean = false;
  EnabledDatosEventos: boolean = false;
  EnabledDatosAnexos: boolean = false;
  EnabledItem(CONS_CodEST: string, opcion: string) {
    const OVSOLOLECTURA = opcion === "VISUALIZAR";
    if (opcion == "VISUALIZAR") {
      this.EnabledDatosGenerales = false;
      this.EnabledDatosTarifa = false;
      this.EnabledDatosServicios = false;
      this.EnabledDatosServiciosChangeControl = false;
      this.EnabledDatosEmbarque = false;
      this.EnabledDatosObservaciones = false;
      this.EnabledDatosDocumento = false;
      this.EnabledDatosHBL = false;
      this.EnabledAyudaViaje = false;
      this.EnabledDatosViaje = false;
      this.EnabledDatosNovedades = false;
      this.EnabledDatosArchivos = false;
      this.EnabledDatosEventos = false;
      this.EnabledDatosAnexos = false;
    } else {
      const noEsAnulada = CONS_CodEST !== this.CONS_ESTOVEANULADA;
      const noEsCerrada = CONS_CodEST !== this.CONS_ESTOVECERRADA;
      const noEsGestionadaSLi = CONS_CodEST !== this.CONS_ESTOVEGESTIONADASLI;
      const noEsPrefacturada = CONS_CodEST !== this.CONS_ESTOVEPREFACTURADA;

      if (opcion === "VISUALIZAR") {
        this.EnabledDatosGenerales = false;
        this.EnabledDatosTarifa = false;
        this.EnabledDatosServicios = false;
        this.EnabledDatosServiciosChangeControl = false;
        this.EnabledDatosEmbarque = false;
        this.EnabledDatosObservaciones = false;
        this.EnabledDatosDocumento = false;
        this.EnabledDatosHBL = false;
        this.EnabledAyudaViaje = false;
        this.EnabledDatosViaje = false;
        this.EnabledDatosNovedades = false;
        this.EnabledDatosArchivos = false;
        this.EnabledDatosEventos = false;
        this.EnabledDatosAnexos = false;
      } else {
        const editable = noEsAnulada && noEsCerrada && noEsGestionadaSLi && !OVSOLOLECTURA;
        const editableTarifa = noEsAnulada && noEsPrefacturada && noEsCerrada && noEsGestionadaSLi && !OVSOLOLECTURA;
        const editableServicios = editableTarifa;
        const editableServiciosCC = noEsAnulada && noEsGestionadaSLi && (CONS_CodEST === this.CONS_ESTOVEPREFACTURADA || CONS_CodEST === this.CONS_ESTOVECERRADA) && !OVSOLOLECTURA;

        this.EnabledDatosGenerales = editable;
        this.EnabledDatosTarifa = editableTarifa;
        this.EnabledDatosServicios = !editableServicios;
        this.EnabledDatosServiciosChangeControl = !editableServiciosCC;
        this.EnabledDatosEmbarque = editable;
        this.EnabledDatosObservaciones = editable;
        this.EnabledDatosDocumento = editable;
        this.EnabledDatosHBL = editable;
        this.EnabledAyudaViaje = editable;
        this.EnabledDatosViaje = false;
        this.EnabledDatosNovedades = false;
        this.EnabledDatosArchivos = editable;
        this.EnabledDatosEventos = editable;
        this.EnabledDatosAnexos = editable;
      }
    }
  }

  custombServChangeControl = [
    { icon: 'pi pi-search', function: () => this.manejoPoupAuditoriaChangeControl('A'), toolTip: 'Auditoria Detalle Servicio - Change Control ' },
  ];

  itemSeleccionado_ServiciosChangeControl: any = [];
  onCheckboxChangeServChangeCtrl(event: { rowIndex: number, isChecked: boolean, rowdata: any }) {
    const { rowIndex, isChecked, rowdata } = event;
    if (isChecked) {
      this.itemSeleccionado_ServiciosChangeControl = rowdata;
      this.index_serviciosChangeControl = rowIndex;
    } else {
      this.itemSeleccionado_ServiciosChangeControl = [];
      this.index_serviciosChangeControl = -1;
    }
  }



  async btnChangeControl(row: any) {

    const rowdata = row.row;
    // if (this.itemSeleccionado_ServiciosChangeControl.length <= 0) { this.util.showMessage("Seleccione la fila de Referencia"); return; };

    let filaCreada = await this.AddServicioChangeControl();

    // const rowdata = this.itemSeleccionado_ServiciosChangeControl;
    const nuevosDatos = {
      scot_exonerado: rowdata?.scot_exonerado ?? null,
      serv_nombre: rowdata.serv_nombre,
      ccot_ingresogasto: this.extraerLabelSinObjeto(rowdata.ccot_ingresogasto) === 'EGRESO' ? { label: 'INGRESO', value: '001' } : { label: 'EGRESO', value: '002' }, // '002' = egreso, 001 = ingreso
      tipedescripcion: rowdata.tipedescripcion,
      entc_nomcom: rowdata.entc_nomcom,
      cons_desc_spa: rowdata.cons_desc_spa,
      scot_cantidad: rowdata?.scot_cantidad ?? null,
      tipo_descmnd: rowdata?.tipo_descmnd,
      scot_preciouni: rowdata?.scot_preciouni,
      scot_importe_ingreso: rowdata?.scot_importe_ingreso == 0 ? rowdata.scot_importe_egreso : 0,
      scot_importe_egreso: rowdata?.scot_importe_egreso == 0 ? rowdata.scot_importe_ingreso : 0,
      scot_itemchangecontrol: rowdata?.scot_item
    };

    filaCreada = { ...filaCreada, ...nuevosDatos };
    await this.dtServiciosChangeControlRef.addEmptyRow(filaCreada);
    this.SeleccionarTipoDocumento(true, this.index_serviciosChangeControl, filaCreada, 'input');
  }

  activeTabIndex: number = 0; // inicia en el primer tab
  async btnChangeControl2(row: any) {

    const rowdata = row.row;
    // if (this.itemSeleccionado_ServiciosChangeControl.length <= 0) { this.util.showMessage("Seleccione la fila de Referencia"); return; };

    let filaCreada = await this.AddServicioChangeControl();


    // const rowdata = this.itemSeleccionado_ServiciosChangeControl;

    const filtrados = this.ListaServiciosByViaRgmLngDP
      .filter(x =>
        x.value
          .includes(rowdata.serv_codigo)
      );

    const Tipcliente = this.ListaTipoEntidad
      .filter(x =>
        x.value
          .includes(rowdata.tipe_codigo)
      );


    const proveedorserv = this.ListaProveedorG
      .filter(x =>
        x.value
          .includes(rowdata.entc_codigo)
      );

    const base = this.ListaBase
      .filter(x =>
        x.value
          .includes(rowdata.cons_codbas)
      );

    const moneda = this.ListaMoneda
      .filter(x =>
        x.value
          .includes(rowdata.tipo_codmnd)
      );


    const tdolistado = this.ListaTipoDocumentoDP
      .filter(x =>
        x.value
          .includes(rowdata.tipo_codtdo)
      );


    const nuevosDatos = {
      scot_exonerado: rowdata?.scot_exonerado ?? null,
      serv_nombre: filtrados[0],//rowdata.serv_nombre,
      ccot_ingresogasto: this.extraerLabelSinObjeto(rowdata.ccot_ingresogasto) === 'EGRESO' ? { label: 'INGRESO', value: '001' } : { label: 'EGRESO', value: '002' }, // '002' = egreso, 001 = ingreso
      tipedescripcion: Tipcliente[0],//rowdata.tipedescripcion,
      entc_nomcom: proveedorserv[0],//rowdata.entc_nomcom,
      cons_desc_spa: base[0],//rowdata.cons_desc_spa,
      scot_cantidad: rowdata?.scot_cantidad ?? null,
      tipo_descmnd: moneda[0],//rowdata?.tipo_descmnd,
      scot_preciouni: rowdata?.scot_preciouni,
      scot_importe_ingreso: rowdata?.scot_importe_ingreso == 0 ? rowdata.scot_importe_egreso : 0,
      scot_importe_egreso: rowdata?.scot_importe_egreso == 0 ? rowdata.scot_importe_ingreso : 0,
      scot_itemchangecontrol: rowdata?.scot_item,
      tipo_desctdo: tdolistado[0]
    };

    filaCreada = { ...filaCreada, ...nuevosDatos };
    await this.dtServiciosChangeControlRef.addEmptyRow(filaCreada);
    this.SeleccionarTipoDocumento(true, this.index_serviciosChangeControl, filaCreada, 'input');

    this.activeTabIndex = 1;
  }

  popUpDocumentos: boolean = false;
  async SeleccionarTipoDocumento(IsChangeControl: boolean, index: number, rowdata: any, modo_fila: string) {


    let _serviciosDocumento = [];


    const serv_codigo = this.extraerValueSinObjeto(rowdata.serv_nombre);
    if (serv_codigo != null && !isNaN(parseInt(serv_codigo))) {

      const request_documentos = <getDocumentosServiciosRequest>{};
      request_documentos.serv_codigo = serv_codigo;
      try {
        const res = await firstValueFrom(
          this.ordenventaService.GetAllServiciosDocumentosByServCodigo(request_documentos)
        );
        if (res.datos.status === 200) { _serviciosDocumento = res.datos.result; }
      } catch (error) { _serviciosDocumento = []; }

      let movimiento = rowdata.ccot_ingresogasto ?? null;

      if (!movimiento || movimiento == "") {
        this.util.MessageDialog({
          titulo: "Ayuda Tipos de Documento", mensaje: "Debe seleccionar si es Ingreso o Egreso.",
          tipo: "warning", icono: "pi pi-exclamation-triangle"
        });
      } else {
        movimiento = this.extraerValueSinObjeto(movimiento);
        if (movimiento === '002') { movimiento = 'E'; } else if (movimiento === '001') { movimiento = 'I'; }
        if (movimiento === 'E') { movimiento = 'C'; }
        const tiposTDO = this.ListaTodosTDO
          .filter(tdo =>
            _serviciosDocumento.some(doc =>
              doc.tipo_codtdo === tdo.codigo && doc.sedo_tipo === movimiento
            )
          )
          .sort((a, b) => {
            const itemA = _serviciosDocumento.find(doc => doc.tipo_codtdo === a.codigo)?.sedo_item ?? 0;
            const itemB = _serviciosDocumento.find(doc => doc.tipo_codtdo === b.codigo)?.sedo_item ?? 0;
            return itemA - itemB;
          });


        if (tiposTDO.length === 0) {
          this.util.MessageDialog({
            titulo: "Ayuda Tipos de Documento", mensaje: "No se encontraron Tipos de Documentos Configurados para el servicio seleccionado.",
            tipo: "warning", icono: "pi pi-exclamation-triangle"
          });
          // rowdata.tipo_tabtdo = null;
          // rowdata.tipo_codtdo = null;
          // rowdata.tipo_desctdo = null;
          if (!IsChangeControl) {
            // this.dtServiciosRef.onRowEditSave(rowdata, index);
            this.actualizarDpMtServicios('tipo_desctdo', []);
          } else if (IsChangeControl) {
            // this.dtServiciosChangeControlRef.onRowEditSave(rowdata, index);
            this.actualizarDpMtChangeControl('tipo_desctdo', []);
            // this.restablecerMetadataServiciosChangeControl();
          }
          this.enviarValorDTServiciosChangeControl(null, index, 'tipo_tabtdo');
          this.enviarValorDTServiciosChangeControl(null, index, 'tipo_codtdo');
          this.enviarValorDTServiciosChangeControl(null, index, 'tipo_desctdo');
        } else if (tiposTDO.length === 1) {
          const tipo_desctdo = { value: tiposTDO[0].codigo, label: tiposTDO[0].nombre };
          const listaTemporal = tiposTDO.map((item: any) => ({
            value: item.codigo,
            label: item.nombre
          }));
          // rowdata.tipo_tabtdo = tiposTDO[0].tipo;
          // rowdata.tipo_codtdo = tiposTDO[0].codigo;
          // rowdata.tipo_desctdo = tipo_desctdo;
          let valorDoc = listaTemporal.find(item => item.value === tiposTDO[0].codigo);
          if (!IsChangeControl) {
            // this.dtServiciosRef.onRowEditSave(rowdata, index);
            this.actualizarDpMtServicios('tipo_desctdo', listaTemporal);
            this.enviarNuevoValorToDatatable(tiposTDO[0].tipo, index, 'tipo_tabtdo');
            this.enviarNuevoValorToDatatable(tiposTDO[0].codigo, index, 'tipo_codtdo');
            this.enviarNuevoValorToDatatable(tipo_desctdo, index, 'tipo_desctdo');
          } else if (IsChangeControl) {
            this.actualizarDpMtChangeControl('tipo_desctdo', listaTemporal);
            // this.dtServiciosChangeControlRef.onRowEditSave(rowdata, index);
            // this.restablecerMetadataServiciosChangeControl();
            rowdata.tipo_tabtdo = tiposTDO[0].tipo
            rowdata.tipo_codtdo = tiposTDO[0].codigo
            rowdata.tipo_desctdo = valorDoc ?? tipo_desctdo
            this.enviarValorDTServiciosChangeControl(tiposTDO[0].tipo, index, 'tipo_tabtdo');
            this.enviarValorDTServiciosChangeControl(tiposTDO[0].codigo, index, 'tipo_codtdo');
            // this.enviarValorDTServiciosChangeControl(rowdata.tipo_desctdo, index, 'tipo_desctdo');

            console.log('index recibido:', index);
            console.log("tipos", tiposTDO)
            console.log('fila actual:', this.dtServiciosChangeControlRef?.data[index]);
          }
        } else {
          if (!IsChangeControl) {
            this.enviarNuevoValorToDatatable(null, index, 'tipo_tabtdo');
            this.enviarNuevoValorToDatatable(null, index, 'tipo_codtdo');
            this.enviarNuevoValorToDatatable(null, index, 'tipo_desctdo');
          } else if (IsChangeControl) {
            this.enviarValorDTServiciosChangeControl(null, index, 'tipo_tabtdo');
            this.enviarValorDTServiciosChangeControl(null, index, 'tipo_codtdo');
            this.enviarValorDTServiciosChangeControl(null, index, 'tipo_desctdo');
          }

          // SE COMENTO ESTA INFORMACION
          // rowdata.tipo_tabtdo = null;
          // rowdata.tipo_codtdo = null;
          // rowdata.tipo_desctdo = null;

          const listaTemporal = tiposTDO.map((item: any) => ({
            value: item.codigo,
            label: item.nombre
          }));

          if (!IsChangeControl) {
            // this.dtServiciosRef.onRowEditSave(rowdata, index);
            this.actualizarDpMtServicios('tipo_desctdo', listaTemporal);
            this.group_tipodocumento.get('index').setValue(index);
            this.group_tipodocumento.get('rowdata').setValue(rowdata);
            this.group_tipodocumento.get('origen').setValue('servicios_adicionales');
            // this.manejoPopUpDocumentos("A", tiposTDO);
            // SE COMENTO ESTA INFORMACION
          } else if (IsChangeControl) {
            rowdata.tipo_desctdo = listaTemporal
            this.actualizarDpMtChangeControl('tipo_desctdo', listaTemporal);
            this.group_tipodocumento.get('index').setValue(index);
            this.group_tipodocumento.get('rowdata').setValue(rowdata);
            this.group_tipodocumento.get('origen').setValue('servicios_change_control');
            // this.manejoPopUpDocumentos("A", tiposTDO);
            // SE COMENTO ESTA INFORMACION
            // this.dtServiciosChangeControlRef.onRowEditSave(rowdata, index);
            // this.restablecerMetadataServiciosChangeControl();
          }
        }
      }
    }

    // if (!IsChangeControl) {
    //   this.AsignarSerieDocumento('servicios_adicionales', index, rowdata);
    // }
    if (IsChangeControl) {
      this.AsignarSerieDocumento('servicios_change_control', index, rowdata);
    }

  }

  async AsignarSerieDocumento(origen: string, index: number, rowdata: any,): Promise<void> {
    const currentRow = rowdata;
    if (this.extraerValueSinObjeto(currentRow.ccot_ingresogasto) !== '001') return;
    if (currentRow.scot_exonerado === true) return;

    try {
      let lista_series = [];
      const request_serie = <D_getSeriePorDocumentoRequest>{};
      request_serie.tipo_codtdo = this.extraerValueSinObjeto(currentRow.tipo_desctdo);
      request_serie.cons_codlng = this.group_datosgenerales.get('lineanegocio').value;
      request_serie.usua_codusr = this.storage.get('codusuario');
      this.ordenventaService.getSerieByDocumento(request_serie).subscribe(
        (res) => {
          if (res.datos.status === 200) {
            lista_series = res.datos.result;
            if (lista_series && lista_series.length > 0) {
              const scot_serietdo = lista_series[0].seri_serie;
              if (origen === 'servicios_change_control') {
                this.enviarValorDTServiciosChangeControl(scot_serietdo, index, 'scot_serietdo');
              } else if (origen === 'servicios_adicionales') {
                this.enviarNuevoValorToDatatable(scot_serietdo, index, 'scot_serietdo');
              }
            }
          }
        }, err => {
          lista_series = [];
          // this.util.MessageDialog({
          //   titulo: "Orden de Venta", mensaje: "no hay serie asignada para el tipo de documento",
          //   detalle: err?.error?.meta?.mensaje, tipo: "warning", icono: "pi pi-exclamation-triangle"
          // });
        })
    } catch (err) {
      this.util.MessageDialog({
        titulo: "Orden de Venta", mensaje: "Ha ocurrido un error al asignar la serie.",
        detalle: err?.error?.meta?.mensaje, tipo: "warning", icono: "pi pi-exclamation-triangle"
      });
    }
  }


  desabilitarbotonreferencia(row): string {

    if (row.exonerado == true) {
      return 'lock'
    } else {
      return 'nolock'
    }

  }
  index_serviciosChangeControl: number;
  detectarNuevaFilaServChngCtrl(event: any) {
    const index = event.index;
    this.index_serviciosChangeControl = index;
  }

  restablecerMetadataServicios() {
    this.metadatableServicio[1].dropdown = this.ListaServiciosByViaRgmLngDP;
    this.metadatableServicio = [
      {
        field: 'btn_referencia', title: '', inputType: "buttonPersonalizado", icon: 'pi pi-copy', function: (row: any) => this.btnChangeControl2(row),
        style: { align: "center" }, toolTip: 'Crear Change Control con Referencia'
      },
      { title: 'ITEMS', field: 'scot_item', filterType: 'text', inputType: 'int', inputStatus: 'lock', widthInput: "10px", maxWidth: '60px' },
      { title: 'EXONERADO', field: 'scot_exonerado', filterType: 'boolean', inputType: 'checkboxEdit', inputStatus: 'lock' },
      { title: 'SERVICIO', field: 'serv_nombre', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServiciosByViaRgmLngDP, style: { width: '20%', align: 'center', justify: 'left' }, widthInput: '150px', required: true },
      { title: 'I/E', field: 'ccot_ingresogasto', filterType: 'text', toolTip: "Precio Unitario", inputType: 'autocomplete', dropdown: this.ListaServicio, required: true },//?
      { title: 'T. ENTIDAD', field: 'tipedescripcion', filterType: 'text', toolTip: "Tipo de Entidad", inputType: 'autocomplete', dropdown: this.ListaTipoEntidad, buscar: 'tipe_codigo', children: 'entc_nomcom', required: true },
      { title: 'PROVEEDOR', field: 'entc_nomcom', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaProveedorG, virtualScroll: true, style: { width: '20px', align: 'left', justify: 'left' }, widthInput: '150px', required: true },
      { title: 'BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaBase, required: true },
      { title: 'CANT.', field: 'scot_cantidad', filterType: 'text', inputType: 'int', widthInput: '50px', maxWidth: "10px", required: true },
      { title: 'MONEDA', field: 'tipo_descmnd', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaMoneda, style: { width: '5px', align: 'left', justify: 'left' }, required: true },
      { title: 'P. UNIT.', field: 'scot_preciouni', filterType: 'text', toolTip: "Precio Unitario", inputType: 'decimal', widthInput: '80px', required: true },
      { title: 'I. INGRE', field: 'scot_importe_ingreso', filterType: 'text', toolTip: "Importe Ingreso", inputType: 'decimal', widthInput: '80px' },
      { title: 'I. EGRE', field: 'scot_importe_egreso', filterType: 'text', toolTip: "Importe Egreso", inputType: 'decimal', widthInput: '80px' },
      { title: 'A. IGV', field: 'serv_afeigv', filterType: 'boolean', toolTip: "Afecto a IGV", inputType: 'checkboxEdit', style: { width: '5px', align: 'center', justify: 'left' } },
      { title: 'A. DETRACCIÓN', field: 'serv_afedet', filterType: 'boolean', toolTip: "Afecto aDetraccion", inputType: 'checkboxEdit' },
      { title: 'TIPO DOC', field: 'tipo_desctdo', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoDocumentoDP, widthInput: '300px' },
      { title: 'SERIE DOC', field: 'scot_serietdo', filterType: 'text', inputType: 'text' },
      { title: 'NRO. DOC', field: 'scot_numerotdo', filterType: 'text', inputType: 'text' },
      { title: 'FEC. EMISIÓN', field: 'audi_feccrea', filterType: 'text', inputType: 'date' },
    ]


  }


  restablecerMetadataServiciosChangeControl() {
    this.mtServiciosChangeControl[3].dropdown = this.ListaServiciosByViaRgmLngDP;
    this.mtServiciosChangeControl[15].dropdown = this.ListaTipoDocumentoDP;
    this.mtServiciosChangeControl = [
      // { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
      {
        field: 'btn_referencia', title: '', inputType: "buttonPersonalizado", icon: 'pi pi-copy', function: (row: any) => this.btnChangeControl2(row),
        style: { align: "center" }, toolTip: 'Crear Change Control con Referencia'
      },
      {
        field: 'btn_finanzas', title: 'SAP', inputType: "buttonPersonalizado", icon: 'pi pi-send', function: (row: any) => this.EnviarFinanzasServicioChangeControl(row),
        style: { align: "center" }, toolTip: 'Enviar Servicio a Finanzas (SAP)'
      },
      { title: 'ITEMS', field: 'scot_item', filterType: 'text', inputType: 'int', inputStatus: 'lock', widthInput: "10px", maxWidth: '60px' },
      { title: 'EXONERADO', field: 'scot_exonerado', filterType: 'boolean', inputType: 'checkboxEdit', inputStatus: 'lock' },
      { title: 'SERVICIO', field: 'serv_nombre', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServiciosByViaRgmLngDP, style: { width: '20%', align: 'center', justify: 'left' }, widthInput: '150px' },
      { title: 'I/E', field: 'ccot_ingresogasto', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaServicio },
      { title: 'T. ENTIDAD', field: 'tipedescripcion', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoEntidad },
      { title: 'ENTIDAD', field: 'entc_nomcom', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaProveedorG, virtualScroll: true, style: { width: '15%', align: 'center', justify: 'left' }, widthInput: '150px' },
      { title: 'BASE', field: 'cons_desc_spa', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaBase },
      { title: 'CANTIDAD', field: 'scot_cantidad', filterType: 'text', inputType: 'int', widthInput: "70px" },
      { title: 'MONEDA', field: 'tipo_descmnd', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaMoneda, widthInput: "140px" },
      { title: 'PRECIO UNITARIO', field: 'scot_preciouni', filterType: 'text', inputType: 'decimal', widthInput: "70px", maxWidth: '70px' },
      { title: 'IMPORTE INGRESO', field: 'scot_importe_ingreso', filterType: 'text', inputType: 'decimal', widthInput: "70px", maxWidth: '70px' },
      { title: 'IMPORTE EGRESO', field: 'scot_importe_egreso', filterType: 'text', inputType: 'decimal', widthInput: "70px", maxWidth: '70px' },
      { title: 'AFECTO IGV', field: 'serv_afeigv', filterType: 'boolean', inputType: 'checkboxEdit' },
      { title: 'AFECTO DETRACCIÓN', field: 'serv_afedet', filterType: 'boolean', inputType: 'checkboxEdit' },
      { title: 'TIPO DOCUMENTO', field: 'tipo_desctdo', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoDocumentoDP, widthInput: '120px' },

      { title: 'SERIE DOCUMENTO', field: 'scot_serietdo', filterType: 'text', inputType: 'text' },
      { title: 'NRO. DOCUMENTO', field: 'scot_numerotdo', filterType: 'text', inputType: 'text' },
      { title: 'FEC. EMISIÓNNEW', field: 'audi_feccrea', filterType: 'date', inputType: 'date' },
      { title: 'FECHA. OPERACIÓN', field: 'scot_fecha_operacion', filterType: 'date', inputType: 'date' },
      { title: 'CÓDIGO CTACTE', field: 'ccct_codigo', filterType: 'text', inputType: 'text' },
      { title: 'DOCUMENTO SAP', field: 'documentosap', filterType: 'text', inputType: 'text' },
      { title: 'ITEM REFERENCIA', field: 'scot_itemchangecontrol', filterType: 'text', inputType: 'int' },
      { title: 'DESCRIPCIÓN MOTIVO', field: 'nombremotivo', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaTipoMotivosDP, widthInput: '350px' },
      { title: 'RESPONSABLE', field: 'scot_solicitante', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaUsuariosDP, widthInput: '300px' },
      { title: 'USUARIO AUTORIZA', field: 'scot_autoriza', filterType: 'text', inputType: 'autocomplete', dropdown: this.ListaUsuariosDP, widthInput: '300px' },
    ]
  }

  extraerValueSinObjeto(valor: any): any {
    if (valor === null || valor === undefined) return null;
    return typeof valor === 'object' ? valor.value : valor;
  }

  extraerLabelSinObjeto(valor: any): any {
    if (valor === null || valor === undefined) return null;
    return typeof valor === 'object' ? valor.label : valor;
  }

  EnviarFinanzasServicioChangeControl(row: any) {
    // if (this.itemSeleccionado_ServiciosChangeControl.length <= 0) { this.util.showMessage("Seleccione la fila que se enviará a Finanzas"); return; };
    // if (this.itemSeleccionado_ServiciosChangeControl.length > 1) { this.util.showMessage("Seleccione solo una fila para enviar a Finanzas"); return; };

    // const rowdata = this.itemSeleccionado_ServiciosChangeControl;
    const rowdata = row.row;

    const index = row.index;
    if (rowdata.scot_editable) {

      this.util.MessageDialog({
        titulo: "Orden de Venta", mensaje: "¿Desea enviar a finanzas el registro seleccionado?",
        tipo: 'warning', icono: "pi pi-exclamation-triangle",
        textoBtn: { textoBtnOpcion1: "SÍ", textoBtnOpcion2: "NO", },
        pregunta: {
          onAccept: () => {
            const request = <D_validarTipoCambioRequest>{}
            request.scot_fechaoperacion = rowdata.scot_fechaoperacion == null ? new Date() : rowdata.scot_fechaoperacion;
            this.ordenventaService.getTipoCambio(request).subscribe(
              (res) => {
                if (res.datos.status === 200) {
                  const parametros = [
                    { valor: false, field: 'scot_editable' },
                    { valor: false, field: 'scot_eliminable' },
                    { valor: false, field: 'scot_enviarfinanzas' },
                    { valor: 'NA', field: 'ESTADO_OBJ' }
                  ];
                  this.transaccionServiciosChangeControl(parametros, index, rowdata);
                  return;
                }
              }, err => {
                this.util.MessageDialog({
                  titulo: "Orden de Venta", mensaje: err.error.meta.mensaje, tipo: "warning", icono: "pi pi-exclamation-triangle"
                });
                return;
              })
          },
          onReject: () => { return; },
        }
      });
    } else {
      this.util.MessageDialog({
        titulo: "Orden de Venta", mensaje: "El registro no puede ser enviado nuevamente a Finanzas.",
        tipo: "warning", icono: "pi pi-exclamation-triangle"
      });

    }

  }

  transaccionServiciosChangeControl(parametros: { valor: any, field: string }[], index: number, row) {

    const requestov: any = {
      pchrCCOT_PagoHBL: this.group_serviciostarifa.get('pchbl').value,
      pchrCCOT_PagoMBL: this.group_serviciostarifa.get('pcmbl').value,
    };

    const fletevacio = { items: [] };
    const insertOVServicioChangeControl = <ListaDetCotizacionOVServicioActualizarRequest>{};
    insertOVServicioChangeControl.items = [];
    const item = row;
    const estadoObj = item.ESTADO_OBJ !== undefined ? item.ESTADO_OBJ : "NA";
    if (estadoObj === "I" || estadoObj === "U" || estadoObj === "D" || estadoObj === "NA") {
      const CCOT_IngresoGasto = this.extraerValueSinObjeto(item.ccot_ingresogasto);
      const itemTablaServicio = {
        CCOT_Tipo: 2,
        CCOT_Numero: this.datosRecibidos.ccot_numero,
        SCOT_Item: item.scot_item,
        CCOT_IngresoGasto: CCOT_IngresoGasto === "002" ? "E" : CCOT_IngresoGasto === "001" ? "I" : null,
        SERV_Codigo: this.extraerValueSinObjeto(item.serv_nombre) != null ? Number(this.extraerValueSinObjeto(item.serv_nombre)) : null,
        SCOT_Origen: item.scot_origen,
        SCOT_Cantidad: item.scot_cantidad || 0,
        SCOT_PrecioUni: item.scot_preciouni || 0.00,
        SCOT_Importe_Ingreso: item.scot_importe_ingreso || 0.00,
        SCOT_Importe_Egreso: item.scot_importe_egreso || 0.00,
        TIPO_TabMnd: "MND",
        TIPO_CodMnd: this.extraerValueSinObjeto(item.tipo_descmnd),
        SCOT_PreSugerido: item.scot_presugerido != "" && item.scot_presugerido != null ? item.scot_presugerido : 0.00,
        TIPE_Codigo: this.extraerValueSinObjeto(item.tipedescripcion) != null ? Number(this.extraerValueSinObjeto(item.tipedescripcion)) : null,
        ENTC_Codigo: this.extraerValueSinObjeto(item.entc_nomcom) != null ? Number(this.extraerValueSinObjeto(item.entc_nomcom)) : null,
        TARI_Codigo: item.tari_codigo ?? null,
        CONS_TabBas: "BAS",
        CONS_CodBas: this.extraerValueSinObjeto(item.cons_desc_spa),
        SCOT_Exonerado: (item.scot_exonerado == "" ? false : item.scot_exonerado) ?? false,
        SCOT_ChageControl: item.scot_chagecontrol,
        PFAC_Numero: null,
        TIPO_TabTDO: item.tipo_tabtdo == "" || item.tipo_tabtdo == null ? "TDO" : item.tipo_tabtdo,
        TIPO_CodTDO: this.extraerValueSinObjeto(item.tipo_desctdo),
        SCOT_NumeroTDO: item.scot_numerotdo ?? null,
        SCOT_SerieTDO: item.scot_serietdo ?? null,
        AUDI_UsrMod: this.nombreUsuario,
        AUDI_UsrCrea: this.nombreUsuario,
        SCOT_FechaOperacion: this.util.formatearfecha(item.scot_fechaoperacion, "yyyy-MM-ddTHH:mm:ss") || null,
        SCOT_FechaEmision: this.util.formatearfecha(item.audi_feccrea, "yyyy-MM-ddTHH:mm:ss") || null,
        EMPR_Codigo: 1,
        CCCT_Codigo: item.ccct_codigo ?? 0,
        SCOT_FechaPrefactura: item.scot_fechaprefactura ?? new Date(),
        SCOT_ItemChangeControl: item.scot_itemchangecontrol ?? null,
        SCOT_CodMotivo: this.extraerValueSinObjeto(item.nombremotivo),
        SCOT_Solicitante: this.extraerValueSinObjeto(item.scot_solicitante),
        SCOT_Autoriza: this.extraerValueSinObjeto(item.scot_autoriza),
        AUDI_FecCrea: this.util.formatearfecha(new Date(), "yyyy-MM-ddTHH:mm:ss") || null,
        ESTADO_OBJ: estadoObj,
        SCOT_EvniarFinanzas: item.scot_enviarfinanzas ?? true,
      };
      insertOVServicioChangeControl.items.push(itemTablaServicio);
    }

    const validacion = new MantenimientoOrdenVentaValidacion(requestov, fletevacio, insertOVServicioChangeControl, this.solosli);
    const { isValid, errorMessage } = validacion.validarServicio();

    if (!isValid) {
      if (errorMessage && errorMessage.length > 0) {
        const errorCount = errorMessage.length;
        if (errorCount === 1) {
          this.util.MessageDialog({ titulo: "ERROR", mensaje: errorMessage[0], tipo: "warning", icono: "pi pi-exclamation-triangle" });
        } else {
          this.util.MessageDialog({
            titulo: "ERROR", mensaje: "Se han encontrado los siguientes errores. Revisar los detalles.",
            tipo: "warning", icono: "pi pi-exclamation-triangle", detalle: errorMessage.join('\n')
          });
        }
      }
    } else {
      const request = <enviarFinanzasChangeControlRequest>{}
      request.items = insertOVServicioChangeControl.items;
      request.empr_codigo = 1;
      request.sucr_codigo = 1;
      this.ordenventaService.OVServicioChangeControlEnviarFinanzas(request).subscribe(
        (res) => {
          if (res.datos.status === 200) {
            this.util.MessageDialog({
              titulo: "Orden de Venta", mensaje: res.meta.mensaje, tipo: "ok", icono: 'pi pi-check-circle'
            });
            const row = res.datos.result[0];
            parametros.unshift({ valor: row.ccct_codigo, field: 'ccct_codigo' });
            parametros.unshift({ valor: row.scot_item, field: 'scot_item' });
            parametros.unshift({ valor: row.scot_fechaoperacion, field: 'scot_fechaoperacion' });
            for (const param of parametros) {
              this.enviarValorDTServiciosChangeControl(param.valor, index, param.field);
            }
          }
        }, err => {
          this.util.MessageDialog({
            titulo: "Orden de Venta", mensaje: err.error.meta.mensaje, tipo: "warning", icono: "pi pi-exclamation-triangle"
          });
          return;
        })
    }
  }



  async cargarListadoUsuarios() {

    try {
      const request = <D_getListadoUsuariosChngCtrlRequest>{}
      request.descripcion = "%";
      const res = await firstValueFrom(
        this.ordenventaService.listarUsuariosChangeControl(request)
      );
      if (res.datos.status === 200) {
        this.ListaUsuariosDP = res.datos.result.map((item: any) => ({
          value: item.tipo_codtipo,
          label: item.tipo_desc1
        }));
      }
      this.restablecerMetadataServiciosChangeControl();
    } catch (error) { this.ListaUsuariosDP = []; }
  }

  @ViewChild('dtServiciosChangeControlRef') dtServiciosChangeC!: DatatableComponent;
  actualizarDpMtChangeControl = (field: string, lista: any[]) => {
    const fieldToUpdate = this.mtServiciosChangeControl.find(m => m.field === field);
    if (fieldToUpdate) { fieldToUpdate.dropdown = [...lista]; }

    const metadataItem = this.dtServiciosChangeC.metadata.find(m => m.field === field);
    if (metadataItem) {
      metadataItem.dropdown = [...lista];
    }




  };

  @ViewChild('dtServiciosRef') dtServicios!: DatatableComponent;

  actualizarDpMtServicios = (field: string, lista: any[]) => {

    const fieldToUpdate = this.metadatableServicio.find(m => m.field === field);

    if (fieldToUpdate) { fieldToUpdate.dropdown = lista; }

    const metadataItem = this.dtServicios.metadata.find(m => m.field === field);
    if (metadataItem) {
      metadataItem.dropdown = [...lista];
    }



    // this.metadatableServicio = this.metadatableServicio.map(m => {
    //   if (m.field === field) {
    //     return {
    //       ...m,
    //       dropdown: [...lista] // aseguras nueva referencia
    //     };
    //   }
    //   return m;
    // });


    this.renderizarDom();
  };

  dt_documentos: any[] = []
  mt_documentos: newmetadate[] = [
    { field: 'select', title: 'Seleccione', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
    { title: 'Tipo de Documento', field: 'nombre', filterType: 'text', inputType: 'text' },
    { title: 'Código Tipo de Documento', field: 'codigo', filterType: 'text', inputType: 'text' },
  ]

  manejoPopUpDocumentos(opcion: string, listado_database: any) {
    if (opcion === "A") {
      this.group_tipodocumento.reset();
      this.dt_documentos = listado_database;
      this.popUpDocumentos = true;
    } else if (opcion === "C") {
      this.popUpDocumentos = false;
      this.dt_documentos = [];
      this.group_tipodocumento.reset();
    }
  }

  aceptarPopUpDocumento() {
    const row = this.dt_documentos.filter(r => r.select === true)[0];
    if (row) {
      const index = this.group_tipodocumento.get('index').value;
      const rowdata = this.group_tipodocumento.get('rowdata').value;
      const origen = this.group_tipodocumento.get('origen').value;
      const tipo_desctdo = { label: row.nombre, value: row.codigo };
      this.enviarValorDTServiciosChangeControl(row.tipo, index, 'tipo_tabtdo');
      this.enviarValorDTServiciosChangeControl(row.codigo, index, 'tipo_codtdo');
      this.enviarValorDTServiciosChangeControl(tipo_desctdo, index, 'tipo_desctdo');
      this.AsignarSerieDocumento(origen, index, rowdata);
    } else {
      this.util.showMessage("Seleccione una fila");
    }
  }

  dt_auditoriaServChangeControl: any[] = [];
  mt_auditoriaServChangeControl: newmetadate[] = [
    { field: 'operacion', title: 'Operación', filterType: 'text', inputType: 'text' },
    { field: 'direccion_ip', title: 'Dirección IP', filterType: 'text', inputType: 'text' },
    { field: 'nombre_maquina', title: 'Nombre Máquina', filterType: 'text', inputType: 'text' },
    { field: 'nombre_aplicacion', title: 'Nombre Aplicación', filterType: 'text', inputType: 'text' },
    { field: 'usuario_sql', title: 'Usuario SQL', filterType: 'text', inputType: 'text' },
    { field: 'usuario_aplicacion', title: 'Usuario Aplicación', filterType: 'text', inputType: 'text' },
    { field: 'fecha_modificacion', title: 'Fecha Modificación', filterType: 'date', inputType: 'date' },
    { field: 'tipo_ov', title: 'Tipo OV', filterType: 'numeric', inputType: 'int' },
    { field: 'codigo_ov', title: 'Código OV', filterType: 'numeric', inputType: 'int' },
    { field: 'item', title: 'Item', filterType: 'numeric', inputType: 'int' },
    { field: 'tipo_servicio', title: 'Tipo Servicio', filterType: 'text', inputType: 'text' },
    { field: 'codigo_servicio', title: 'Código Servicio', filterType: 'numeric', inputType: 'int' },
    { field: 'origen_servicio', title: 'Origen Servicio', filterType: 'text', inputType: 'text' },
    { field: 'cantidad', title: 'Cantidad', filterType: 'numeric', inputType: 'int' },
    { field: 'precio_unitario', title: 'Precio Unitario', filterType: 'numeric', inputType: 'decimal' },
    { field: 'importe_ingreso', title: 'Importe Ingreso', filterType: 'numeric', inputType: 'decimal' },
    { field: 'importe_egreso', title: 'Importe Egreso', filterType: 'numeric', inputType: 'decimal' },
    { field: 'modeda', title: 'Moneda', filterType: 'text', inputType: 'text' },
    { field: 'codigo_moneda', title: 'Código Moneda', filterType: 'text', inputType: 'text' },
    { field: 'precio_sugerido', title: 'Precio Sugerido', filterType: 'numeric', inputType: 'decimal' },
    { field: 'tipo_entidad', title: 'Tipo Entidad', filterType: 'numeric', inputType: 'int' },
    { field: 'codigo_entidad', title: 'Código Entidad', filterType: 'numeric', inputType: 'int' },
    { field: 'codigo_tarifa', title: 'Código Tarifa', filterType: 'numeric', inputType: 'int' },
    { field: 'base_calculo', title: 'Base Cálculo', filterType: 'text', inputType: 'text' },
    { field: 'codigo_base_calculo', title: 'Código Base Cálculo', filterType: 'text', inputType: 'text' },
    { field: 'exonerado', title: 'Exonerado', filterType: 'boolean', inputType: 'checkbox' },
    { field: 'change_control', title: 'Change Control', filterType: 'boolean', inputType: 'checkbox' },
    { field: 'documento', title: 'Documento', filterType: 'text', inputType: 'text' },
    { field: 'codido_documento', title: 'Código Documento', filterType: 'text', inputType: 'text' },
    { field: 'serie_documento', title: 'Serie Documento', filterType: 'text', inputType: 'text' },
    { field: 'numero_documento', title: 'Número Documento', filterType: 'text', inputType: 'text' },
    { field: 'codigo_cuenta', title: 'Código Cuenta', filterType: 'numeric', inputType: 'int' },
    { field: 'fecha_operacion', title: 'Fecha Operación', filterType: 'date', inputType: 'date' },
    { field: 'codigo_empresa', title: 'Código Empresa', filterType: 'numeric', inputType: 'int' },
    { field: 'usuario_creo', title: 'Usuario Creo', filterType: 'text', inputType: 'text' },
    { field: 'fecha_crea', title: 'Fecha Crea', filterType: 'date', inputType: 'date' },
    { field: 'usuario_modifica', title: 'Usuario Modifica', filterType: 'text', inputType: 'text' },
    { field: 'fecha_modifica', title: 'Fecha Modifica', filterType: 'date', inputType: 'date' }
  ];

  custombAudiServChangeControl = [
    { icon: 'pi pi-file-export', function: () => this.exportarExcelAudiServChangeControl(), toolTip: 'Exportar Excel' },
  ];
  popUpAuditoriaChangeControl: boolean = false;
  manejoPoupAuditoriaChangeControl(opcion: string) {
    if (opcion === "A") {
      const request = <D_getAuditServChangeCtrlRequest>{};
      request.ccot_tipo = 2;
      request.ccot_numero = this.datosRecibidos.ccot_numero;
      request.scot_changecontrol = true;
      this.ordenventaService.auditoriaServiciosChangeControl(request).subscribe(res => {
        if (res.datos.status == 200) {
          this.dt_auditoriaServChangeControl = res.datos.result;
          this.popUpAuditoriaChangeControl = true;
        }
      }, err => { this.dt_auditoriaServChangeControl = []; this.popUpAuditoriaChangeControl = true; })

    } else if (opcion === "C") {
      this.popUpAuditoriaChangeControl = false;
      this.dt_auditoriaServChangeControl = [];
    }
  }

  exportarExcelAudiServChangeControl() {
    if (this.dt_auditoriaServChangeControl.length == 0) {
      this.util.MessageDialog({ titulo: "ERROR", mensaje: "No hay campos para exportar", icono: "pi pi-exclamation-triangle", tipo: "warning" });
      return;
    }
    let nuevadata = []
    this.dt_auditoriaServChangeControl.forEach(row => {
      const {
        operacion, direccion_ip, nombre_maquina, nombre_aplicacion,
        usuario_sql, usuario_aplicacion, fecha_modificacion,
        tipo_ov, codigo_ov, item, tipo_servicio, codigo_servicio,
        origen_servicio, cantidad, precio_unitario, importe_ingreso, importe_egreso,
        modeda, codigo_moneda, precio_sugerido,
        tipo_entidad, codigo_entidad, codigo_tarifa,
        base_calculo, codigo_base_calculo, exonerado, change_control,
        documento, codido_documento, serie_documento, numero_documento,
        codigo_cuenta, fecha_operacion, codigo_empresa,
        usuario_creo, fecha_crea, usuario_modifica, fecha_modifica
      } = row;

      const newItem = {
        "Operacion": operacion,
        "Direccion IP": direccion_ip,
        "Nombre Maquina": nombre_maquina,
        "Nombre Aplicacion": nombre_aplicacion,
        "Usuario SQL": usuario_sql,
        "Usuario Aplicacion": usuario_aplicacion,
        "Fecha Modificacion": this.util.formatearfecha(fecha_modificacion, 'dd/mm/yyyy'),
        "Tipo OV": tipo_ov,
        "Codigo OV": codigo_ov,
        "Item": item,
        "Tipo Servico": tipo_servicio,
        "Codigo Servicio": codigo_servicio,
        "Origen Servicio": origen_servicio,
        "Cantidad": cantidad,
        "Precio Unitario": precio_unitario,
        "Importe Ingreso": importe_ingreso,
        "Importe Egreso": importe_egreso,
        "Modeda": modeda,
        "Codigo Moneda": codigo_moneda,
        "Precio Sugerido": precio_sugerido,
        "Tipo Entidad": tipo_entidad,
        "Codigo Entidad": codigo_entidad,
        "Codigo Tarifa": codigo_tarifa,
        "Base Calculo": base_calculo,
        "Codigo Base Calculo": codigo_base_calculo,
        "Exonerado": exonerado,
        "Change Control": change_control,
        "Documento": documento,
        "Codido Documento": codido_documento,
        "Serie Documento": serie_documento,
        "Numero Documento": numero_documento,
        "Codigo Cuenta": codigo_cuenta,
        "Fecha Operacion": this.util.formatearfecha(fecha_operacion, 'dd/mm/yyyy'),
        "Codigo Empresa": codigo_empresa,
        "Usuario Creo": usuario_creo,
        "Fecha Crea": this.util.formatearfecha(fecha_crea, 'dd/mm/yyyy'),
        "Usuario Modifica": usuario_modifica,
        "Fecha Modifica": this.util.formatearfecha(fecha_modifica, 'dd/mm/yyyy'),
      };

      nuevadata.push(newItem);
    });

    const data = [{ data: nuevadata, cabeceras: [] }]
    this.util.ExportarExcel(data, 'AUDITORÍA SERVICIOS CHANGE CONTROL.xlsx')
  }

  //#endregion

  ListaTodosNave: any[] = [];
  ListaTodasNaves: any[] = [];
  popUpNaveViaje() {
    const request = <BuscarNavesRequest>{}
    request.entc_codtransportista = null;
    this.mantenimientoservice.BuscarNaves(request).subscribe(res => {
      this.ListaTodosNave = res.datos.result;
      this.ListaTodasNaves = this.ListaTodosNave;

      const fila_editable = this.dtItinerarioRef?.getFirstEditingRow();
      var puer_codorigen = this.extraerValueSinObjeto(fila_editable?.nameportloading) ?? null;
      var puer_coddestino = this.extraerValueSinObjeto(fila_editable?.nameportdischarge) ?? null;

      const datosOV = {
        entc_codtransportista: this.codTransporte, // this.group_serviciostarifa.value.transportista,
        cons_codvia: this.group_datosgenerales.value.via,
        cons_codrgm: this.group_datosgenerales.value.regimen,
        puer_codorigen: this.group_serviciostarifa.value.puertoorigen,
        puer_coddestino: this.group_serviciostarifa.value.puertodestino,
        puer_codigo: this.group_datosgenerales.value.regimen == '001' ? puer_coddestino ?? this.group_serviciostarifa.value.puertodestino : puer_codorigen ?? this.group_serviciostarifa.value.puertoorigen
      }

      let data = {
        tipo: 'I',
        row: datosOV,
        ListaTodasNaves: this.ListaTodasNaves,
        ListaAgentePortuario: this.ListaAgentePortuario,
        ListaTerminalPortuario: this.ListaTerminalPortuario,
        ListaTodosRegimen: this.ListaTodosRegimen,
        ListaTodosVia: this.ListaTodosVia,
        ListaTodosTransportista: this.ListaTodosTransportista,
        ListaTodosPuerto: this.ListaTodosPuerto,
        ListaTodosEstadoNaveViaje: this.ListaTodosEstadoNaveViaje,
        ListaTodosEstado: this.ListaTodosEstadoNaveViaje,
        nomUsuario: this.nombreUsuario,
        origen: 'orden_venta',
        datosordenventa: datosOV
      }

      const ref2 = this.dialogService.open(MantenimientoNaveViajeComponent, {
        header: 'Mantenimiento Nave Viaje',
        data: data,
        width: '90%',
        contentStyle: { "overflow": "auto" },
        baseZIndex: 10000,
        maximizable: true,
        closable: true,
        styleClass: "mantenimiento-nave"
      });

      ref2.onClose.subscribe((res) => {
        if (res.message == "OK") { this.actualizarListadoNaveViaje(0, res.code); }
        // if (res.data) {
        //   const product = res.data

        //   const index = this.viajeitinerario_dataitinerario.length
        //   this.enviarValorDTViajeItinerario(product["nvia_esfeeder"], index, 'nvia_esfeeder');
        //   this.enviarValorDTViajeItinerario(product["codigoviaje"], index, 'nvia_codigo');
        //   this.enviarValorDTViajeItinerario(product["nombrenave"], index, 'nave_nombre');
        //   this.enviarValorDTViajeItinerario(product["viaje_vuelo"], index, 'nvia_nroviaje');
        //   this.enviarValorDTViajeItinerario(product["eta_etd"] ?? null, index, 'eta');
        //   this.enviarValorDTViajeItinerario(product["puerto"], index, 'nameportdischarge');
        //   this.enviarValorDTViajeItinerario(product["puertoOrigen"], index, 'nameportloading');
        // }

      });
    })

  }

  actualizarListadoNaveViaje($event, code?) {
    // if (this.datosRecibidos != null) {
    let codPuerto;

    if (this.group_datosgenerales.value["regimen"] == "002") { // expo
      codPuerto = this.group_serviciostarifa.value["puertoorigen"];
    } else if (this.group_datosgenerales.value["regimen"] == "001") { // impo
      codPuerto = this.group_serviciostarifa.value["puertodestino"];
    }

    if (codPuerto != null) {
      const puertosSeleccionados = this.ListaTodosPuertoOrigenyDestino.filter(item => item.codigo === codPuerto);
      const numero = this.datosRecibidos == null ? 0 : this.datosRecibidos.ccot_numero;
      const transportista = this.codTransporte;
      const puerto = puertosSeleccionados[0].adicional1

      if (!numero || !transportista || !puerto) {
        console.warn('Faltan datos requeridos para la consulta de Nave Viaje.'); return;
      }

      const request: listNaveViajePorPuertoRequest = {
        ccot_numero: numero,
        codtransportista: transportista,
        formatport: 1,
        puer_codestandar: puerto
      };

      this.ordenventaService.listNaveViajePorPuerto(request).subscribe(response => {
        if (response.datos.status == '200') {
          this.datosViajePorPuerto2 = response.datos.result;

          setTimeout(async () => {

            if (code) {
              const product = this.datosViajePorPuerto2.find(r => r.codigoviaje === parseInt(code))

              var index: number
              if (this.dtItinerarioRef.data.length == 0) {
                index = 0//this.dtItinerarioRef.data.length
                this.dtItinerarioRef.addEmptyRow()
              }
              else if (this.dtItinerarioRef.data.length >= 1) {
                index = this.dtItinerarioRef.data.length - 1
              }
              else if (this.viajeitinerario_dataitinerario.length == 0) { index = this.viajeitinerario_dataitinerario.length }

              const puerto = this.ListaTodosPuertoOrigen.find(r => r.adicional1 === product["puerto"])

              this.enviarValorDTViajeItinerario(product["feeder"], index, 'nvia_esfeeder');
              //this.enviarValorDTViajeItinerario((product["nvia_esfeeder"] === true ? false : true), index, 'ovnv_final');
              this.enviarValorDTViajeItinerario((product["feeder"] === true ? false : true), index, 'ovnv_final');
              this.enviarValorDTViajeItinerario(product["codigoviaje"], index, 'nvia_codigo');
              this.enviarValorDTViajeItinerario(product["nombrenave"], index, 'nave_nombre');
              this.enviarValorDTViajeItinerario(product["viaje_vuelo"], index, 'nvia_nroviaje');
              this.enviarValorDTViajeItinerario(product["eta_etd"] != '' && product["eta_etd"] != null ? new Date(product["eta_etd"]) : null, index, 'eta');

              if (this.group_datosgenerales.value["regimen"] == "002") { // expo
                this.enviarValorDTViajeItinerario({ label: puerto.nombre, value: parseInt(puerto.codigo) }, index, 'nameportloading');
                if (product["feeder"] === false) {
                  const puertoDestino = this.ListaTodosPuertoOrigen.find(r => r.codigo === this.group_serviciostarifa.get('puertodestino').value)
                  this.enviarValorDTViajeItinerario({ label: puertoDestino.nombre, value: parseInt(puertoDestino.codigo) }, index, 'nameportdischarge')
                }

              }
              if (this.group_datosgenerales.value["regimen"] == "001") { // expo
                this.enviarValorDTViajeItinerario({ label: puerto.nombre, value: parseInt(puerto.codigo) }, index, 'nameportdischarge');
              }
              // this.enviarValorDTViajeItinerario({ label: puerto.nombre, value: parseInt(puerto.codigo) }, index, 'nameportdischarge');
              // this.enviarValorDTViajeItinerario(product["puertoOrigen"], index, 'nameportloading');
              const fila = this.dtItinerarioRef.data[index];
              this.dtItinerarioRef.onRowEditSave(fila, index);
              await this.reconstruirItinerario();
              this.dtItinerarioRef.table.initRowEdit(fila);
              this.dtItinerarioRef.onRowEditInit(fila);
            }

          }, 2000)


        }
      }, err => { this.datosViajePorPuerto2 = []; })
    }
    // }
  }

  async popupViajeItinerario(evento: any) {
    const row = evento.row;
    const data = {
      data: this.data,
      row: row,
    }

    const index = evento.index;
    const ref = this.dialogService.open(DialogTableComponent, {
      header: 'Nave Viaje',
      data: data,
      width: '90%',
      contentStyle: { "overflow": "auto" },
      baseZIndex: 10000,
      maximizable: true,
      closable: true,
    });

    ref.onClose.subscribe((product?: any) => {
      if (product) {
        this.enviarValorDTViajeItinerario(product["nvia_esfeeder"], index, 'nvia_esfeeder');
        this.enviarValorDTViajeItinerario((product["nvia_esfeeder"] === true ? false : true), index, 'ovnv_final');
        this.enviarValorDTViajeItinerario(product["codigoviaje"], index, 'nvia_codigo');
        this.enviarValorDTViajeItinerario(product["nombrenave"], index, 'nave_nombre');
        this.enviarValorDTViajeItinerario(product["viaje_vuelo"], index, 'nvia_nroviaje');
        this.enviarValorDTViajeItinerario(product["eta_etd"] != '' && product["eta_etd"] != null ? new Date(product["eta_etd"]) : null, index, 'eta');
        const noD = this.viajeitinerario_dataitinerario.filter(item => item?.ESTADO_OBJ !== 'D');

        if (noD.length == 0) {

          if (this.group_datosgenerales.value["regimen"] == "002") { // expo
            // const puerto = this.ListaTodosPuertoOrigen.find(r => r.adicional1 === product["puerto"])
            //this.enviarValorDTViajeItinerario( {label: puerto.nombre, value: parseInt(puerto.codigo) }, index, 'nameportloading');
            if (product["nvia_esfeeder"] === false) {
              this.enviarValorDTViajeItinerario(product["puertoOrigen"], index, 'nameportloading');
              const puertoDestino = this.ListaTodosPuertoOrigen.find(r => r.codigo === this.group_serviciostarifa.get('puertodestino').value)
              this.enviarValorDTViajeItinerario({ label: puertoDestino.nombre, value: parseInt(puertoDestino.codigo) }, index, 'nameportdischarge')
            }
          } else {//importaciones
            let vpuertoDestinoI: any
            if (product["nvia_esfeeder"] === true) {
              this.enviarValorDTViajeItinerario(null, index, 'nameportloading');
              vpuertoDestinoI = this.ListaTodosPuertoOrigen.find(r => r.codigo === product["puerto"])
              this.enviarValorDTViajeItinerario(null, index, 'nameportdischarge')
            } else {
              vpuertoDestinoI = this.ListaTodosPuertoOrigen.find(r => r.codigo === this.group_serviciostarifa.get('puertodestino').value)
              this.enviarValorDTViajeItinerario({ label: vpuertoDestinoI.nombre, value: parseInt(vpuertoDestinoI.codigo) }, index, 'nameportdischarge')
              // this.enviarValorDTViajeItinerario(product["puertoOrigen"], index, 'nameportloading'); lo comete por que jessica no quiere que se seleccione 
            }
            //   const puertoDestinoI = this.ListaTodosPuertoOrigen.find(r => r.codigo ===  this.group_serviciostarifa.get('puertodestino').value)
            //   this.enviarValorDTViajeItinerario({ label: vpuertoDestinoI.nombre, value: parseInt(vpuertoDestinoI.codigo) }, index, 'nameportdischarge')
            //this.enviarValorDTViajeItinerario(product["puerto"], index, 'nameportdischarge');

          }
        }

        if (this.group_datosgenerales.value["regimen"] == "002") { // expo
          // const puerto = this.ListaTodosPuertoOrigen.find(r => r.adicional1 === product["puerto"])
          //this.enviarValorDTViajeItinerario( {label: puerto.nombre, value: parseInt(puerto.codigo) }, index, 'nameportloading');
          if (product["nvia_esfeeder"] === false) {
            this.enviarValorDTViajeItinerario(product["puertoOrigen"], index, 'nameportloading');
            const puertoDestino = this.ListaTodosPuertoOrigen.find(r => r.codigo === this.group_serviciostarifa.get('puertodestino').value)
            this.enviarValorDTViajeItinerario({ label: puertoDestino.nombre, value: parseInt(puertoDestino.codigo) }, index, 'nameportdischarge')
          }
        } else { // importaciones
          let vpuertoDestinoI: any
          if (product["nvia_esfeeder"] === true) {
            this.enviarValorDTViajeItinerario(null, index, 'nameportloading');
            vpuertoDestinoI = this.ListaTodosPuertoOrigen.find(r => r.codigo === product["puerto"])
            this.enviarValorDTViajeItinerario(product["puerto"], index, 'nameportdischarge')
          } else {
            // this.enviarValorDTViajeItinerario(product["puertoOrigen"], index, 'nameportloading'); cometado por qeu jessica no quiere que aparesca cargado
            vpuertoDestinoI = this.ListaTodosPuertoOrigen.find(r => r.codigo === this.group_serviciostarifa.get('puertodestino').value)
            this.enviarValorDTViajeItinerario({ label: vpuertoDestinoI.nombre, value: parseInt(vpuertoDestinoI.codigo) }, index, 'nameportdischarge')
          }
          // const puertoDestinoI = this.ListaTodosPuertoOrigen.find(r => r.codigo ===  this.group_serviciostarifa.get('puertodestino').value)
          //this.enviarValorDTViajeItinerario(product["puerto"], index, 'nameportdischarge');

        }
      }
    });
  }

  enviarValorDTViajeItinerario(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onChangeTblViajeItinerario.emit(eventToEmit);
  }

  async SetTipoDocumentoServicio(origen: string, index: number, rowdata: any): Promise<void> {
    const currentRow = rowdata;
    let _SERV_Codigo: number;
    let _servicio: itemsConsultarServiciosResponse = null;
    let _serviciosDocumento = [];
    let _entidad: ListarEntidades = null;
    const ENTC_CodCliente = this.group_datosgenerales.get('cliente').value;
    const entc_nomcom = currentRow.entc_nomcom;

    if (currentRow.serv_nombre) {
      _SERV_Codigo = this.extraerValueSinObjeto(currentRow.serv_nombre);
      const request = <consultarServiciosRequest>{}
      request.serv_codigo = _SERV_Codigo;
      try {
        const res = await firstValueFrom(
          this.ordenventaService.obtenerServiciosDetallado(request)
        );
        if (res.datos.status === 200) { _servicio = res.datos.result[0]; }
      } catch (error) { _servicio = null; }

      const request_documentos = <getDocumentosServiciosRequest>{};
      request_documentos.serv_codigo = _SERV_Codigo;
      try {
        const res = await firstValueFrom(
          this.ordenventaService.GetAllServiciosDocumentosByServCodigo(request_documentos)
        );
        if (res.datos.status === 200) { _serviciosDocumento = res.datos.result; }
      } catch (error) { _serviciosDocumento = []; }

      let movimiento = rowdata.ccot_ingresogasto ?? null;

      if (movimiento) {
        movimiento = this.extraerValueSinObjeto(movimiento);
        if (movimiento === '002') { movimiento = 'E'; } else if (movimiento === '001') { movimiento = 'I'; }
        if (movimiento === 'E') { movimiento = 'C'; }
        if (movimiento === 'I' && ENTC_CodCliente && (entc_nomcom == null || entc_nomcom == "")) {
          const entidadCliente = this.ListaTipoEntidad.find(item => item.value === "1");
          let valorCliente = this.ListaTodosCliente.find(item => item.nombre === ENTC_CodCliente);
          valorCliente = valorCliente ? { label: valorCliente.nombre, value: valorCliente.codigo } : null;

          if (origen === 'servicios_change_control') {
            this.enviarValorDTServiciosChangeControl(entidadCliente, index, 'tipedescripcion');
            this.enviarValorDTServiciosChangeControl(valorCliente.value, index, 'entc_codigo');
            this.enviarValorDTServiciosChangeControl(valorCliente, index, 'entc_nomcom');
          } else if (origen === 'servicios_adicionales') {
            this.enviarNuevoValorToDatatable(entidadCliente, index, 'tipedescripcion');
            this.enviarNuevoValorToDatatable(valorCliente.value, index, 'entc_codigo');
            this.enviarNuevoValorToDatatable(valorCliente, index, 'entc_nomcom');
          }
        }

        const tiposTDO = this.ListaTodosTDO
          .filter(tdo =>
            _serviciosDocumento.some(doc =>
              doc.tipo_codtdo === tdo.codigo && doc.sedo_tipo === movimiento
            )
          )
          .sort((a, b) => {
            const itemA = _serviciosDocumento.find(doc => doc.tipo_codtdo === a.codigo)?.sedo_item ?? 0;
            const itemB = _serviciosDocumento.find(doc => doc.tipo_codtdo === b.codigo)?.sedo_item ?? 0;
            return itemA - itemB;
          });

        if (
          (movimiento === "I" && _servicio.serv_cueningreso?.startsWith("70")) ||
          (movimiento === "C" && _servicio.serv_cuencosto?.startsWith("70"))
        ) {
          let _tieneRUC: boolean = false;
          let _TIPE_Codigo: number = -1;
          let _ENTC_Codigo: number = -1;

          if (rowdata.tipedescripcion && rowdata.entc_nomcom) {
            _TIPE_Codigo = this.extraerValueSinObjeto(rowdata.tipedescripcion);
            _ENTC_Codigo = this.extraerValueSinObjeto(rowdata.entc_nomcom);

            const Request: ListarEntidadesRequest = <ListarEntidadesRequest>{}
            Request.pintENTC_Codigo = Number(_ENTC_Codigo);
            Request.pvchENTC_NomCompleto = null;
            Request.pvchTIPE_Codigo = Number(_TIPE_Codigo);
            Request.pvchENTC_DocIden = null;
            try {
              const res = await firstValueFrom(
                this.ordenventaService.ListarEntidades(Request)
              );
              if (res.datos.status === 200) { _entidad = res.datos.result[0]; }
            } catch (error) { _entidad = null; }

            _tieneRUC = _entidad?.tipO_CodTDI === '001';
          }
          const _tipoTDO = tiposTDO.find(item => item.codigo === this.extraerValueSinObjeto(rowdata.tipo_desctdo));

          const listaTemporal = tiposTDO.map((item: any) => ({
            value: item.codigo,
            label: item.nombre
          }));

          if (origen === 'servicios_change_control') {
            this.actualizarDpMtChangeControl('tipo_desctdo', listaTemporal);
          } else if (origen === 'servicios_adicionales') {
            this.actualizarDpMtServicios('tipo_desctdo', listaTemporal);
          }

          const codTipo = movimiento === "I" ? (_tieneRUC ? "001" : "003") : "007";
          let _movimientodesc: string = "";
          let _documentodesc: String = "";
          switch (codTipo) {
            case "001":
              _movimientodesc = "Ingreso";
              _documentodesc = "Factura";
              break;
            case "003":
              _movimientodesc = "Ingreso";
              _documentodesc = "Boleta";
              break;
            case "007":
              _movimientodesc = "Egreso";
              _documentodesc = "Nota Credito";
              break;
          }

          if (tiposTDO.length > 0) {

            if (origen === 'servicios_change_control') {
              this.enviarValorDTServiciosChangeControl(tiposTDO[0].tipo, index, 'tipo_tabtdo');
              this.enviarValorDTServiciosChangeControl(tiposTDO[0].codigo, index, 'tipo_codtdo');
              this.enviarValorDTServiciosChangeControl({ value: tiposTDO[0].codigo, label: tiposTDO[0].nombre }, index, 'tipo_desctdo');
              this.AsignarSerieDocumento(origen, index, rowdata);
            } else if (origen === 'servicios_adicionales') {
              this.enviarNuevoValorToDatatable(tiposTDO[0].tipo, index, 'tipo_tabtdo');
              this.enviarNuevoValorToDatatable(tiposTDO[0].codigo, index, 'tipo_codtdo');
              this.enviarNuevoValorToDatatable({ value: tiposTDO[0].codigo, label: tiposTDO[0].nombre }, index, 'tipo_desctdo');
            }
          }

          else if (_tipoTDO) {

            if (origen === 'servicios_change_control') {
              this.enviarValorDTServiciosChangeControl(_tipoTDO.tipo, index, 'tipo_tabtdo');
              this.enviarValorDTServiciosChangeControl(_tipoTDO.codigo, index, 'tipo_codtdo');
              this.enviarValorDTServiciosChangeControl({ value: _tipoTDO.codigo, label: _tipoTDO.nombre }, index, 'tipo_desctdo');
              this.AsignarSerieDocumento(origen, index, rowdata);

            } else if (origen === 'servicios_adicionales') {
              this.enviarNuevoValorToDatatable(_tipoTDO.tipo, index, 'tipo_tabtdo');
              this.enviarNuevoValorToDatatable(_tipoTDO.codigo, index, 'tipo_codtdo');
              this.enviarNuevoValorToDatatable({ value: _tipoTDO.codigo, label: _tipoTDO.nombre }, index, 'tipo_desctdo');
            }

          } else {
            const mensaje = `Debe ingresar al mantenimiento de Servicios, editar el servicio ${_servicio.serv_nombre_spa} y configurar el documento ${_documentodesc} para el tipo de movimiento ${_movimientodesc}.`;
            this.util.MessageDialog({ titulo: "Configuración de Servicios", mensaje, tipo: "warning", icono: "pi pi-exclamation-triangle" });
          }

        } else {
          if (tiposTDO.length > 0) {
            const listaTemporal = tiposTDO.map((item: any) => ({
              value: item.codigo,
              label: item.nombre
            }));
            if (origen === 'servicios_change_control') {
              this.actualizarDpMtServicios('tipo_desctdo', listaTemporal);
            } else if (origen === 'servicios_adicionales') {
              this.actualizarDpMtServicios('tipo_desctdo', listaTemporal);
            }
            if (origen === 'servicios_change_control') {
              this.enviarValorDTServiciosChangeControl(tiposTDO[0].tipo, index, 'tipo_tabtdo');
              this.enviarValorDTServiciosChangeControl(tiposTDO[0].codigo, index, 'tipo_codtdo');
              this.enviarValorDTServiciosChangeControl({ value: tiposTDO[0].codigo, label: tiposTDO[0].nombre }, index, 'tipo_desctdo');
              this.AsignarSerieDocumento(origen, index, rowdata);
            } else if (origen === 'servicios_adicionales') {
              this.enviarNuevoValorToDatatable(tiposTDO[0].tipo, index, 'tipo_tabtdo');
              this.enviarNuevoValorToDatatable(tiposTDO[0].codigo, index, 'tipo_codtdo');
              this.enviarNuevoValorToDatatable({ value: tiposTDO[0].codigo, label: tiposTDO[0].nombre }, index, 'tipo_desctdo');
            }
          }
        }

      }
    }
  }

  async SetDatosServicios(origen: string, index: number, rowdata: any) {
    const currentRow = rowdata;
    let _SERV_Codigo: number;
    let _itemServicio: itemsConsultarServiciosResponse = null;
    let _serviciosDocumento = [];
    const ENTC_CodCliente = this.group_datosgenerales.get('cliente').value;

    if (currentRow.serv_nombre && currentRow.serv_nombre != "") {
      _SERV_Codigo = this.extraerValueSinObjeto(currentRow.serv_nombre);
      const request = <consultarServiciosRequest>{}
      request.serv_codigo = _SERV_Codigo;
      try {
        const res = await firstValueFrom(
          this.ordenventaService.obtenerServiciosDetallado(request)
        );
        if (res.datos.status === 200) { _itemServicio = res.datos.result[0]; }
      } catch (error) { _itemServicio = null; }

      let ccot_ingresogasto = null;

      switch (_itemServicio.serv_tipomov) {
        case 'A':
          // asigna null
          break;
        case 'C':
          ccot_ingresogasto = this.ListaServicio.find(item => item.value === "002");
          break;

        case 'I':
          ccot_ingresogasto = this.ListaServicio.find(item => item.value === "001");

          if (ENTC_CodCliente) {
            const entidadCliente = this.ListaTipoEntidad.find(item => item.value === "1");
            let valorCliente = this.ListaTodosCliente.find(item => item.nombre === ENTC_CodCliente);
            valorCliente = valorCliente ? { label: valorCliente.nombre, value: valorCliente.codigo } : null;

            if (origen === 'servicios_change_control') {
              this.enviarValorDTServiciosChangeControl(entidadCliente, index, 'tipedescripcion');
              this.enviarValorDTServiciosChangeControl(valorCliente.value, index, 'entc_codigo');
              this.enviarValorDTServiciosChangeControl(valorCliente, index, 'entc_nomcom');
            } else if (origen === 'servicios_adicionales') {
              this.enviarNuevoValorToDatatable(entidadCliente, index, 'tipedescripcion');
              this.enviarNuevoValorToDatatable(valorCliente.value, index, 'entc_codigo');
              this.enviarNuevoValorToDatatable(valorCliente, index, 'entc_nomcom');
            }
          }
          break;
      }

      if (_itemServicio.serv_afeigv == true || _itemServicio.serv_afeigv == false) {
        if (origen === 'servicios_change_control') {
          this.enviarValorDTServiciosChangeControl(_itemServicio.serv_afeigv, index, 'serv_afeigv');
        } else if (origen === 'servicios_adicionales') {
          this.enviarNuevoValorToDatatable(_itemServicio.serv_afeigv, index, 'serv_afeigv');
        }
      }
      if (_itemServicio.serv_afedet == true || _itemServicio.serv_afedet == false) {
        if (origen === 'servicios_change_control') {
          this.enviarValorDTServiciosChangeControl(_itemServicio.serv_afedet, index, 'serv_afedet');
        } else if (origen === 'servicios_adicionales') {
          this.enviarNuevoValorToDatatable(_itemServicio.serv_afedet, index, 'serv_afedet');
        }
      }

      if (origen === 'servicios_change_control') {
        this.enviarValorDTServiciosChangeControl(_itemServicio.serv_valor, index, 'scot_presugerido');
        this.enviarValorDTServiciosChangeControl(_itemServicio.serv_valor, index, 'scot_preciouni');
        this.enviarValorDTServiciosChangeControl(_itemServicio.tipo_tabmnd, index, 'tipo_tabmnd');
        this.enviarValorDTServiciosChangeControl({ value: _itemServicio.tipo_codmnd, label: _itemServicio.tipo_descmnd }, index, 'tipo_descmnd');
        this.enviarValorDTServiciosChangeControl(_itemServicio.cons_tabbas, index, 'cons_tabbas');
        this.enviarValorDTServiciosChangeControl({ value: _itemServicio.cons_codbas, label: _itemServicio.cons_descbas }, index, 'cons_desc_spa');
      } else if (origen === 'servicios_adicionales') {
        this.enviarNuevoValorToDatatable(_itemServicio.serv_valor, index, 'scot_presugerido');
        this.enviarNuevoValorToDatatable(_itemServicio.serv_valor, index, 'scot_preciouni');
        this.enviarNuevoValorToDatatable(_itemServicio.tipo_tabmnd, index, 'tipo_tabmnd');
        this.enviarNuevoValorToDatatable({ value: _itemServicio.tipo_codmnd, label: _itemServicio.tipo_descmnd }, index, 'tipo_descmnd');
        this.enviarNuevoValorToDatatable(_itemServicio.cons_tabbas, index, 'cons_tabbas');
        this.enviarNuevoValorToDatatable({ value: _itemServicio.cons_codbas, label: _itemServicio.cons_descbas }, index, 'cons_desc_spa');
      }

      this.calcularCantidadBase(this.extraerValueSinObjeto(rowdata.cons_desc_spa), index, origen);

      const request_documentos = <getDocumentosServiciosRequest>{};
      request_documentos.serv_codigo = _SERV_Codigo;
      try {
        const res = await firstValueFrom(
          this.ordenventaService.GetAllServiciosDocumentosByServCodigo(request_documentos)
        );
        if (res.datos.status === 200) { _serviciosDocumento = res.datos.result; }
      } catch (error) { _serviciosDocumento = []; }

      let movimiento = rowdata.ccot_ingresogasto ?? null;

      if (movimiento || movimiento != "") {
        this.SetTipoDocumentoServicio(origen, index, rowdata);
      }
    }
  }

  async editarNaveViaje(row) {
    row = row.row;
    const request = <BuscarNavesRequest>{}
    request.entc_codtransportista = null;
    this.mantenimientoservice.BuscarNaves(request).subscribe(res => {
      this.ListaTodosNave = res.datos.result;
      this.ListaTodasNaves = this.ListaTodosNave;

      const request = <BuscarNaveViajeRequest>{}
      request.nvia_codigo = row.nvia_codigo;
      request.cons_tab_rgm = null;
      request.cons_cod_rgm = null;
      request.cons_tab_via = null;
      request.cons_cod_via = null;
      request.entc_cod_transportista = null;
      request.nvia_nro_viaje = null;
      request.nave_codigo = null;
      request.pdtm_nvia_fec_creacion = null;
      request.usuario = this.nombreUsuario;

      request.pchr_nvia_estado = null;
      this.mantenimientoservice.BuscarNaveViaje(request).subscribe(res => {
        if (res.datos.status === 200) {
          const datos_nvia_codigo = res.datos.result[0];


          const datosOV = {
            entc_codtransportista: Number(this.ListaTodosTransportista.find(item => item.nombre === this.group_serviciostarifa.value["transportista"])?.codigo), //this.codTransporte, // this.group_serviciostarifa.value.transportista,
            cons_codvia: this.group_datosgenerales.value.via,
            cons_codrgm: this.group_datosgenerales.value.regimen,
            puer_codorigen: this.group_serviciostarifa.value.puertoorigen,
            puer_coddestino: this.group_serviciostarifa.value.puertodestino,
          }

          let data = {
            tipo: 'U',
            row: datos_nvia_codigo,
            ListaTodasNaves: this.ListaTodasNaves,
            ListaAgentePortuario: this.ListaAgentePortuario,
            ListaTerminalPortuario: this.ListaTerminalPortuario,
            ListaTodosRegimen: this.ListaTodosRegimen,
            ListaTodosVia: this.ListaTodosVia,
            ListaTodosTransportista: this.ListaTodosTransportista,
            ListaTodosPuerto: this.ListaTodosPuerto,
            ListaTodosEstadoNaveViaje: this.ListaTodosEstadoNaveViaje,
            nomUsuario: this.nombreUsuario,
            origen: 'orden_venta',
            datosordenventa: datosOV,//this.datosRecibidos,
            ListaTodosEstado: this.ListaTodosEstadoNaveViaje// : this.ListaTodosEstadoNaveViaje
          }

          const ref = this.dialogService.open(MantenimientoNaveViajeComponent, {
            header: 'Mantenimiento Nave Viaje',
            data: data,
            width: '90%',
            contentStyle: { "overflow": "auto" },
            baseZIndex: 10000,
            maximizable: true,
            closable: true,
          });

          ref.onClose.subscribe((res) => {
            if (res.message == "OK") { }
          });
        } else {
          this.util.MessageDialog({ titulo: "warning", mensaje: res.meta.mensaje, icono: "pi pi-exclamation-triangle", tipo: "warning" });
        }
      })
    })

  }

  enviarEventoBandejaOv(objeto) {
    const resultado = { objeto };
    this.onProcesado.emit(resultado);
  }

  actualizarListaEntidad(tipo: number, lista: any[], field: string): void {

    lista.length = 0
    const request = <listarEntidadesRequest>{}
    request.entc_codigo = null
    request.tipe_codigo = tipo
    this.servParametros.listarEntidades(request).subscribe(response => {
      if (response.datos.status === 200) {
        lista.push(...response.datos.result)
        this.actualizarMaestros();
        this.messageService.add({ severity: 'info', summary: field, detail: 'Los datos se han refrescado correctamente.', life: 3000 });
      }
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: field, detail: 'Ocurrio un problema al refresacar la informacion.', life: 3000 });
    })
  }

  deshabilitarBtnGuardar: boolean = false;
  @ViewChild('dtItinerarioRef') dtItinerarioRef!: DatatableComponent;
  @ViewChild('dtArchivosRef') dtArchivosRef!: DatatableComponent;
  @ViewChild('dtDetItinerarioRef') dtDetItinerarioRef!: DatatableComponent;
  @ViewChild('dtEventosRef') dtEventosRef!: DatatableComponent;
  // @ViewChild('dtSliDetRef') dtSliDetRef!: DatatableComponent;
  @ViewChild('dtSliObsRef') dtSliObsRef!: DatatableComponent;
  @ViewChild('dtFleteDetRef') dtFleteDetRef!: DatatableComponent;

  async actualizar_datos_ov(event: any) {
    this.deshabilitarBtnGuardar = true;
    const loadingScreen = this.util.showLoadingScreen({ message: "Cargando datos..." });
    try {
      this.serviciosytarifas_dataservicios = [];
      this.dtServiciosRef?.resetDatatable();
      this.dtServiciosChangeControlRef?.resetDatatable();
      this.dtServiciosChangeControl = [];
      this.dtServiciosChangeControl = [];
      this.dtItinerarioRef?.resetDatatable();
      this.viajeitinerario_dataitinerario = [];
      this.dtDetItinerarioRef?.resetDatatable();
      this.viajeitinerario_datanave = [];
      this.dtArchivosRef?.resetDatatable();
      this.archivos_dataarchivos = [];
      this.dtEventosRef?.resetDatatable();
      this.eventostareas_dataeventos = [];
      this.seguimiento_Embarque = [];
      this.ListadoGrupoPaquete = [];
      this.ListadoOperaciones = [];
      this.ListadoServicioContenedores = [];
      this.ListadoTarifaAsociada = [];
      this.servicioslocales_dataservicios = [];
      // this.dtSliDetRef?.resetDatatable();
      this.servicioslocales_datadetalle = [];
      this.ListadoControlAsociados = [];
      this.dtSliObsRef?.resetDatatable();
      this.servicioslocales_dataObservaciones = [];
      this.dataFlete?.resetDatatable();
      this.serviciosytarifas_dataflete = [];
      this.dtFleteDetRef?.resetDatatable();
      this.datosembarque_dataflete = [];

      const request = <listAllOVRequest>{}
      request.empresa = 1
      request.sucursal = 1
      request.tipo = 2
      request.regimen = ""
      request.flete = ""
      request.via = []
      request.estado = []
      request.ejecutivo = []
      request.customer = []
      request.agente = ""
      request.cliente = ""
      request.numdoc = this.group_datosgenerales.get("numero").value;
      request.mbl = ""
      request.hbl = ""
      request.booking = ""
      request.desde = "";
      request.hasta = "";
      request.condetalle = "S"
      request.numero_cotizacion = "";
      try {
        const res: any = await firstValueFrom(this.ordenventaService.listAllOV(request));
        if (res.datos.status === 200) {

          this.datosRecibidos = res.datos.result?.[0] || {};
          this.datos = res.datos.result?.[0] || {};
          localStorage.setItem("datoov", JSON.stringify(this.datosRecibidos))

          if (this.datos && this.datos['listadoservicio']) { this.serviciosytarifas_dataservicios = structuredClone(this.datos['listadoservicio']); }
          if (this.datos && this.datos['listadoseguro']) { this.dtServiciosChangeControl = structuredClone(this.datos['listadoseguro']); }
          if (this.datos && this.datos['listadoviajeitinerario']) {
            this.viajeitinerario_dataitinerario = structuredClone(this.datos['listadoviajeitinerario']);
            this.viajeitinerario_dataitinerario.forEach(item => { item.ESTADO_OBJ = "NA"; });
          }
          if (this.datos && this.datos['listadodetallenaveviaje']) { this.viajeitinerario_datanave = structuredClone(this.datos['listadoviajeitinerario']); }
          if (this.datos && this.datos['listadoarchivo']) { this.archivos_dataarchivos = structuredClone(this.datos['listadoarchivo']); }
          if (this.datos && this.datos['listadoeventostareas']) { this.eventostareas_dataeventos = structuredClone(this.datos['listadoeventostareas']); }
          if (this.datos && this.datos['listadoseguimientoembarque']) { this.seguimiento_Embarque = structuredClone(this.datos['listadoseguimientoembarque']); }
          if (this.datos && this.datos['listadooperaciones']) { this.ListadoOperaciones = structuredClone(this.datos['listadooperaciones']); }
          if (this.datos && this.datos['listadogrupopaquete']) { this.ListadoGrupoPaquete = structuredClone(this.datos['listadogrupopaquete']); }
          if (this.datos && this.datos['listadoserviciocontenedores']) { this.ListadoServicioContenedores = structuredClone(this.datos['listadoserviciocontenedores']); }
          if (this.datos && this.datos['listadotarifaasociada']) { this.ListadoTarifaAsociada = structuredClone(this.datos['listadotarifaasociada']); }
          if (this.datos && this.datos['listadodetalleasociada']) { this.servicioslocales_dataservicios = structuredClone(this.datos['listadodetalleasociada']); }
          if (this.datos && this.datos['listadoserviciosasociados']) {
            this.servicioslocales_datadetalle = structuredClone(this.datos['listadoserviciosasociados']);
            this.servicioslocales_datadetalle.forEach(item => { item.ESTADO_OBJ = "NA"; });
            this.listadoOriginal = structuredClone(this.datos['listadoserviciosasociados']);
          }
          if (this.datos && this.datos['listadocontrolasociados']) { this.ListadoControlAsociados = structuredClone(this.datos['listadocontrolasociados']); }
          if (this.datos && this.datos['listadoeventosasociados']) { this.servicioslocales_dataObservaciones = structuredClone(this.datos['listadoeventosasociados']); }
          if (this.datos && this.datos['listadofletes']) {
            this.serviciosytarifas_dataflete = structuredClone(this.datos['listadofletes']);
            this.datosembarque_dataflete = structuredClone(this.datos['listadofletes']);
          }
          this.solo_aereo = (this.datosRecibidos && this.datosRecibidos.aereo != null) ? this.datosRecibidos.aereo : false,

            this.item2 = {
              ccot_numdoc: this.datosRecibidos.ccot_numdoc,
              ccot_numdoccot: this.datosRecibidos.ccot_numdoccot,
              cons_codest: this.datosRecibidos.cons_codest,
              cons_descest: this.datosRecibidos.cons_descest,
              cons_codrgm: this.datosRecibidos.cons_codrgm,
              cons_descrgm: this.datosRecibidos.cons_descrgm,
              cons_codvia: this.datosRecibidos.cons_codvia,
              cons_descvia: this.datosRecibidos.cons_descvia,
              cons_codlng: this.datosRecibidos.cons_codlng,
              cons_descfle: this.datosRecibidos.cons_descfle,
              ccot_propia: this.datosRecibidos.ccot_propia,
              ccot_enviaavisollegada: this.datosRecibidos.ccot_enviaavisollegada,
              ccot_serviciologistico: this.datosRecibidos.ccot_serviciologistico,
              ccot_serviciotransmision: this.datosRecibidos.ccot_serviciotransmision,
              ccot_fecemi: this.datosRecibidos.ccot_fecemi,
              ccot_fecemiformat: this.datosRecibidos.ccot_fecemiformat,
              ccot_fecvcto: this.datosRecibidos.ccot_fecvcto,
              ccot_fecaprueba: this.datosRecibidos.ccot_fecaprueba,
              ddov_fecembarque: this.datosRecibidos.ddov_fecembarque,
              entc_nomcliente: this.datosRecibidos.entc_nomcliente,
              entC_NomCustomer: this.datosRecibidos.entc_nomcustomer,
              entc_nomagente: this.datosRecibidos.entc_nomagente,
              tipo_codinc: this.datosRecibidos.tipo_codinc,
              ccot_ordencompra: this.datosRecibidos.ccot_ordencompra,
              entc_nomejecutivo: this.datosRecibidos.entc_nomejecutivo?.toString()?.toUpperCase(),
              ccot_numpresupuesto: this.datosRecibidos.ccot_numpresupuesto,
              entc_nomtransportista: this.datosRecibidos.entc_nomtransportista,
              puer_nombretrasbordo: this.datosRecibidos.puer_codtrasbordo,
              tipo_codtrf: this.datosRecibidos.tipo_codtrf,
              puer_nombreorigen: this.datosRecibidos.puer_codorigen,
              puer_nombredestino: this.datosRecibidos.puer_coddestino,
              tipo_codmnd: this.datosRecibidos.tipo_codmnd,
              cons_codtft: this.datosRecibidos.cons_codtft,
              ccot_fectarifa: this.datosRecibidos.ccot_fectarifa,
              cons_codfle: this.datosRecibidos.cons_codfle,
              cont_codigo: this.datosRecibidos.cont_codigo,
              cont_numero: this.datosRecibidos.cont_numero,
              cont_descrip: this.datosRecibidos.cont_descrip,
              ccot_pagombl: this.tranformarDa(this.datosRecibidos.ccot_pagombl),
              ccot_pagohbl: this.tranformarDa(this.datosRecibidos.ccot_pagohbl),
              dcot_totaluniventa: this.datosRecibidos["listadofletes"].length > 0 ? this.datosRecibidos["listadofletes"][0].dcot_totaluniventa : null,
              dcot_preciounicosto: this.datosRecibidos.dcot_preciounicosto,
              ccot_cargarefrigerada: this.datosRecibidos.ccot_cargarefrigerada,
              ccot_cargapeligrosa: this.datosRecibidos.ccot_cargapeligrosa,
              ccot_roundtrip: this.datosRecibidos.ccot_roundtrip,
              ccot_temperatura: this.datosRecibidos.ccot_temperatura,
              tipo_codimo: this.datosRecibidos.tipo_codimo,
              ccot_imoun: this.datosRecibidos.ccot_imoun,
              entc_nomshipper: this.datosRecibidos.entc_nomshipper,
              entc_nomconsignee: this.datosRecibidos.entc_nomconsignee,
              entc_nomnotify: this.datosRecibidos.entc_nomnotify,
              doov_codreferencia: this.datosRecibidos.doov_codreferencia?.trim() || null,
              ccot_almacenaje: this.datosRecibidos.ccot_almacenaje,
              ccot_sobreestadia: this.datosRecibidos.ccot_sobreestadia,
              ccot_tiempoviaje: this.datosRecibidos.ccot_tiempoviaje,
              ccot_validezoferta: this.datosRecibidos.ccot_validezoferta,
              ccot_observaciones: this.datosRecibidos.ccot_observaciones,
              ddov_nrobooking: this.datosRecibidos.ddov_nrobooking,
              entc_nomdeptemporal: this.datosRecibidos.entc_nomdeptemporal,
              ddov_hblnieto: this.datosRecibidos.ddov_hblnieto,
              doov_hbl: this.datosRecibidos.doov_hbl,
              doov_mbl: this.datosRecibidos.doov_mbl,
              doov_cntr: this.datosRecibidos.doov_cntr,
              nvia_codigo: this.datosRecibidos.nvia_codigo,
              nave_nombre: this.datosRecibidos.nave_nombre,
              etd: this.datosRecibidos.nvia_feceta,
              ata_atd: this.datosRecibidos.ata_atd,
              cope_codigo: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_codigo : 0,
              cope_numdoc: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_numdoc : null,
              cope_fecemi: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_fecemi : null,
              entc_nombrecliente: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombrecliente : null,
              entc_nombretransportista: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombretransportista : null,
              entc_nombrealmacen: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombrealmacen : null,
              entc_nombreagenciamaritima: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombreagenciamaritima : null,
              entc_nombreterminalportuario: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_nombreterminalportuario : null,
              descripcioncondicionembarque: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].descripcioncondicionembarque : null,
              ctar_codigo: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].ctar_codigo : null,
              tarifftype: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].tarifftype : null,
              validfrom: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].validfrom : null,
              validto: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].validto : null,
              remarks: this.datosRecibidos["listadotarifaasociada"].length > 0 ? this.datosRecibidos["listadotarifaasociada"][0].remarks : null,
              cope_fechaSL: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_fechaSL : null,
              codigo_ruta: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].codigo_ruta : null,
              cope_dam: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_dam : null,
              cope_cifLogistico: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_cifLogistico : null,
              cope_cifEjecVta: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_cifEjecVta : null,
              cope_peso_sli: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_peso_sli : null,
              cope_volumen_sli: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_volumen_sli : null,
              cope_unmd_peso: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_unmd_peso : null,
              cope_unmd_volumen: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_unmd_volumen : null,
              terminal_portuario: this.datosRecibidos.terminal_portuario,
              sucursal: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].sucursal : null,
              entc_codcliente: this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].entc_codcliente : null,
              entc_codlinaerea: this.datosRecibidos.entc_codlinaerea,
              doov_fecsalida: this.datosRecibidos.doov_fecsalida,
              doov_fecconexion: this.datosRecibidos.doov_fecconexion,
              ccot_descshipper: this.datosRecibidos.ccot_descshipper,
              ccot_descconsignee: this.datosRecibidos.ccot_descconsignee
            };
          await this.inicializarFormularios(this.item2)
          this.obtenerArchivos()
          this.date = this.group_datosgenerales.get('fechaemision')?.value;
          this.group_serviciostarifa.get('puertoorigen').setValue(this.datosRecibidos.puer_codorigen);
          this.group_serviciostarifa.get('puertodestino').setValue(this.datosRecibidos.puer_coddestino);
          this.group_serviciostarifa.get('puertotransbordo').setValue(this.datosRecibidos.puer_codtrasbordo);
          this.inicializarDatosComponentes();

          const opcion = this.accion
          if (opcion == 'NUEVO') {
            this.actualizarListadoNaveViaje(0, null);
          }
          this.accion = 'EDITAR';
          this.buscarPuertosByVia();

          this.deshabilitarBotones(event);
          loadingScreen.close();
        } else {
          this.deshabilitarBotones(event);
          loadingScreen.close();
        }
      } catch (err) {
        console.error(err);
        this.deshabilitarBotones(event);
        loadingScreen.close();

      } finally {
        this.deshabilitarBotones(event);
        loadingScreen.close();
      }
    } catch (err) {
      console.error(err);
      this.deshabilitarBotones(event);
      loadingScreen.close();
    } finally {
      this.deshabilitarBotones(event);
      loadingScreen.close();
    }

  }

  temp_servicioslocales_datadetalle: any[] = []
  modovisualizar: boolean = true
  dope_items: number[] = []
  cope_codigos: number[] = []
  datosAdesagrupar: any[] = []
  desagrupar: boolean = true
  agrupar: boolean = true
  visibleTarifa: boolean
  searchTarifa() {
    this.desdebtn = false
    this.cancelarFilasEdicion();
    if (this.group_servicioslocales.value.fechasl === null || this.group_servicioslocales.value.fechasl === undefined) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'Seleccione una fecha para filtrar Tarifas.', life: 3000, key: "tl" });
      return;
    }

    if (this.serviciosytarifas_dataflete.length === 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'No hay flete', detail: 'Debe agregar por lo menos un flete.', life: 3000, key: "tl" });
      return;
    }

    const value = this.group_Transporte.value["condicion"]
    if (value === null) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'No se ha seleccionado una Condición para esta OV.', life: 3000, key: "tl" });
      return;
    }

    const valuergm = this.group_datosgenerales?.value?.regimen
    if (valuergm === null) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'No se ha seleccionado Régimen.', life: 3000, key: "tl" });
      // return;
    } else {

      const valuetrans = this.group_serviciostarifa.value["transportista"]
      if (valuetrans === null) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Campo Requerido para el tarifario de VB / Gate In / Gate Out', detail: 'No se ha seleccionado transportista. Elegir uno si desea ver el tarifario.', life: 4000, key: "tl" });
        // return;
      } else {
        this.buscarServicioLogistico()
      }

      this.buscarAgenteAduana()
      const fakeEvent = { value: value };
      this.buscarTarifaAlmacen()

      const valueRuta = this.group_servicioslocales.value["rutas"]
      if (valueRuta === null) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Campo Requerido para el tarifario de Transporte', detail: 'No se ha seleccionado una ruta. Elegir uno si desea ver el tarifario.', life: 4000, key: "tl" });
        // return;
      } else {
        this.buscarTransporte(fakeEvent);
      }
      this.buscarTarifasExtra();
      this.buscarTarifasTacna();
    }

    this.onExpanded = this.onExpanded === false ? true : true;
  }

  AgruparPoppup() {
    if (this.tablaAgrupados.some(t => t.cons_codest !== '001')) {
      this.messageService.add({ severity: 'error', summary: 'Agrupación no permitida', detail: 'No se puede agrupar un servicio que ya ha sido prefacturado o cancelado.', key: 'tl' });
      this.PrefacturarServicios('C');
      return;
    }

    if (this.tablaAgrupados.length > 0) {
      const monedaReferencia = this.extraerValueSinObjeto(this.tablaAgrupados[0].nombremndvta);
      if (this.tablaAgrupados.some(t => this.extraerValueSinObjeto(t.nombremndvta) !== monedaReferencia)) {

        this.messageService.add({
          severity: 'error', summary: 'Agrupación no permitida',
          detail: 'No se pueden agrupar. Todas las operaciones deben tener la misma moneda de venta.', key: 'tl'
        });
        this.PrefacturarServicios('C');
        return;
      }
    }

    const elementosParaAgrupar = this.tablaAgrupados.filter(row => row.cod_padre === null);
    const existentes = [
      ...this.servicioslocales_datadetalle,
      ...(this.servicioslocales_detalleAgrupacion || [])
    ]
      .filter(i => i.dope_item != null)
      .map(i => Number(i.dope_item));

    const siguienteDope = existentes.length > 0 ? Math.max(...existentes) + 1 : 1;

    this.tablaAgrupados = []

    const elementosOriginales = this.servicioslocales_datadetalle.filter(i =>
      elementosParaAgrupar.some(row => i.dope_item === row.dope_item && i.ctar_codigo === row.ctar_codigo && i.cope_codigo === row.cope_codigo)
    );

    const sumaCantidad = elementosOriginales.reduce((acc, cur) => acc + (cur.dope_cantidad || 0), 0);
    const sumaPrecioUnit = elementosOriginales.reduce((acc, cur) => acc + (Number(cur.dope_preciounitvta) || 0), 0);
    const sumaPrecioTotal = elementosOriginales.reduce((acc, cur) => acc + (Number(cur.dope_preciototvta) || 0), 0);

    this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.map(item => {
      if (elementosOriginales.some(elim => elim.dope_item === item.dope_item && elim.ctar_codigo === item.ctar_codigo && elim.cope_codigo === item.cope_codigo)) {
        return { ...item, cod_padre: siguienteDope, ESTADO_OBJ: 'A', agrupado: true };
      }
      return item;
    });

    this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle];

    const itemAgrupado = {
      ctar_codigo: null,
      dtar_codigo: null,
      cope_codigo: elementosOriginales[0].cope_codigo,
      dope_item: siguienteDope,
      dope_cantidad: sumaCantidad,
      dope_preciototvta: sumaPrecioTotal,
      dope_preciounitvta: sumaPrecioUnit,
      serv_nombre_spa: "Servicio Local",
      agrupado: true,
      cod_padre: null,
      ESTADO_OBJ: 'I'
    };

    this.servicioslocales_detalleAgrupacion = [...this.servicioslocales_detalleAgrupacion, itemAgrupado];
    this.edicion = false
    this.agrupar = true;
    this.prefacturar = true;
    this.cancelar = true;
    this.generaros = true;
  }

  async desagruparServicio() {
    this.desagrupar = true;

    for (let index = 0; index < this.dope_items.length; index++) {
      const codigoAgrupado = this.dope_items[index];
      const copecodigo = this.cope_codigos[index];

      const Request: ListarAgrupacionRequest = {
        CODE_Agrupador: codigoAgrupado,
        COPE_Codigo: copecodigo
      };

      try {
        const response = await firstValueFrom(this.ordenventaService.ListarAgrupacion(Request));

        if (response.datos.status === 200) {
          const datosModificados = response.datos.result.map(item => ({
            ...item,
            ESTADO_OBJ: 'U',
            cod_padre: null,
            agrupado: false
          }));

          this.servicioslocales_datadetalle = [
            ...this.servicioslocales_datadetalle,
            ...datosModificados
          ];
        }
      } catch (errorServicio) {
        this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.map(item => {
          if (item.cod_padre === codigoAgrupado && item.ESTADO_OBJ !== 'D') {
            const enOriginal = this.listadoOriginal.some(orig =>
              orig.dope_item === item.dope_item &&
              orig.ctar_codigo === item.ctar_codigo &&
              orig.entc_codigo === item.entc_codigo
            );
            return {
              ...item,
              cod_padre: null,
              agrupado: false,
              ESTADO_OBJ: enOriginal ? 'U' : 'I'
            };
          }
          return item;
        });
      }

      // Eliminar de tablaAgrupados
      for (let i = this.tablaAgrupados.length - 1; i >= 0; i--) {
        const item = this.tablaAgrupados[i];
        if (item.dope_item === codigoAgrupado || item.cod_padre === codigoAgrupado) {
          this.tablaAgrupados.splice(i, 1);
        }
      }

      // Eliminar de servicioslocales_detalleAgrupacion
      for (let i = this.servicioslocales_detalleAgrupacion.length - 1; i >= 0; i--) {
        const item = this.servicioslocales_detalleAgrupacion[i];
        if (item.dope_item === codigoAgrupado) {
          const encontrado = this.listadoOriginalAgrupados.find(o =>
            o.dope_item === item.dope_item && o.cope_codigo === item.cope_codigo
          );
          if (encontrado) {
            item.ESTADO_OBJ = 'D';
          } else {
            this.servicioslocales_detalleAgrupacion.splice(i, 1);
          }
        }
      }

      // Refrescar tabla
      this.tablaAgrupados = [...this.tablaAgrupados];
      this.servicioslocales_detalleAgrupacion = [...this.servicioslocales_detalleAgrupacion];
      this.edicion = this.tablaAgrupados.length === 0 ? false : true;
    }

    // Limpiar listas al final
    this.dope_items = [];
    this.cope_codigos = [];
  }
  dataTableTarifaServicioLogistico: any[] = []
  metadataTableTarifaServicioLogistico: newmetadate[] = []
  data_busqueda: any[] = [];
  buscarServicioLogistico(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.dataTableTarifaServicioLogistico = []
      this.metadataTableTarifaServicioLogistico = []

      const hayReefer = this.serviciosytarifas_dataflete?.some(
        (item: any) => {
          const label = item?.paqueteObj?.label || item?.pack_desc?.label || item?.pack_desc;
          return label?.toLowerCase()?.includes('reefer');
        }
      );

      let entc_codtermport = null;
      if (this.viajeitinerario_dataitinerario.length > 0) {
        switch (this.group_datosgenerales?.value?.regimen) {
          case "001":
            entc_codtermport = this.viajeitinerario_dataitinerario?.find((item: any) => item?.ovnv_final === true)?.entc_codtermport;
            break;
          case "002":
            entc_codtermport = this.viajeitinerario_dataitinerario?.[0]?.entc_codtermport;
            break;
          default:
            break;
        }
      }

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_datosgenerales.get('cliente')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_serviciostarifa.get('transportista')?.value
      );

      const contenedores = this.serviciosytarifas_dataflete
        .filter(x => x.ESTADO_OBJ !== 'D')
        .map(x => ({
          label: String(x.pack_desc?.value ?? x.pack_codigo ?? x.pacK_Codigo ?? '')
        }));

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "001"
      request.fechaVig = this.group_servicioslocales.value.fechasl
      request.solopromedio = this.desdebtn === false ? (this.group_servicioslocales.value.promedio === null ? false : this.group_servicioslocales.value.promedio) : false
      request.regimen = this.group_datosgenerales?.value?.regimen
      request.puerto = request.regimen == '001' ? this.group_serviciostarifa.get('puertodestino').value : request.regimen == '002' ? this.group_serviciostarifa.get('puertoorigen').value : null
      request.cliente = cod_cliente ?? null;
      request.esReefer = hayReefer;
      request.entc_codtermport = entc_codtermport;
      request.transportista = cod_transportista ?? null;
      request.contrato = this.group_serviciostarifa.get("numerocontrato")?.value ?? null;
      request.contenedores = contenedores;
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            this.metadataTableTarifaServicioLogistico.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            this.data_busqueda = response.datos.result;
            const resultados = this.data_busqueda;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = null;
            const nuevasFilas: any[] = [];
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));

              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }

                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto') {
                    if (recargo.recO_Codigo === 15) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }
                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  // row['proft'] = recargo.profit;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['cons_codtds'] = this.adicional === true ? "002" : "001";
                  row['tipodeservicio'] = this.adicional === true ? "Adicional" : "Servicio";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['tipoequipo'] = r.tipO_CodCTR
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['tipo_tabtar'] = r.tipO_TabTAR
                  row['tipo_codtar'] = r.tipO_CodTAR
                  row['cliente_tariff'] = cli_tariff
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableTarifaServicioLogistico.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableTarifaServicioLogistico.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableTarifaServicioLogistico.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableTarifaServicioLogistico[index] = item;
                    } else {
                      this.metadataTableTarifaServicioLogistico.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });

            // if (!['14', '1', this.coordLog, this.gerentLog].filter(Boolean).includes(this.rol)) {
            if (
              !this.listadoRoles?.some(r =>
                ['14', '1', this.coordLog, this.gerentLog]
                  .filter(Boolean)
                  .map(x => String(x))
                  .includes(String(r.role_codigo))
              )
            ) {
              const tipo = this.adicional === false ? 'costo' : 'venta'
              this.metadataTableTarifaServicioLogistico = this.metadataTableTarifaServicioLogistico.filter(item =>
                !item.field.toLowerCase().includes(tipo) &&
                !item.field.toLowerCase().includes('profit')
              );
            } else {
              this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
                !item.field.toLowerCase().includes('profit')
              );
            }

            this.dataTableTarifaServicioLogistico.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableTarifaServicioLogistico.forEach(row => {
              this.metadataTableTarifaServicioLogistico.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });
            const transportistaSeleccionado = this.group_serviciostarifa?.value?.transportista;
            const promedioSeleccionado = this.group_servicioslocales?.value?.promedio;
            if (transportistaSeleccionado && (promedioSeleccionado === false || promedioSeleccionado === null)) {
              this.dataTableTarifaServicioLogistico = this.dataTableTarifaServicioLogistico.filter(row => {
                return row.linea?.label === transportistaSeleccionado;
              });
            }

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {//!existeProveedor
              this.dataTableTarifaServicioLogistico.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['linea'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'linea',
                title: 'Línea',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableTarifaServicioLogistico.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableTarifaServicioLogistico.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableTarifaServicioLogistico.push(itemProveedor);
              }
            }

            this.metadataTableTarifaServicioLogistico = this.metadataTableTarifaServicioLogistico.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            // logica filtro por contenedor

            // const packCodigos = this.serviciosytarifas_dataflete.map(item => Number(item.pack_desc?.value ?? Number(item.pack_codigo) ?? Number(item.pacK_Codigo)));

            // this.dataTableTarifaServicioLogistico = this.dataTableTarifaServicioLogistico.filter(row => {
            //   const contenedorVal = String(row.contenedor?.value ?? '');
            //   const almacenVal = String(row.almacen?.value ?? '');

            //   const coincide = packCodigos.includes(Number(contenedorVal));

            //   if (coincide || contenedorVal === '' || contenedorVal === null) {
            //     return true;
            //   }

            //   return false;
            // });

            // lógica lotes

            const sumasPorPack: Record<string, any> = {};
            this.serviciosytarifas_dataflete
              .filter(x => x.ESTADO_OBJ !== 'D')
              .forEach(x => {
                const key = x.pack_desc?.value ?? x.pack_codigo ?? x.pacK_Codigo ?? '';
                const cantidad = x.dcot_cantidad || 0;
                if (!sumasPorPack[key]) {
                  sumasPorPack[key] = { pack_codigo: key, cantidad: 0 };
                }
                sumasPorPack[key].cantidad += cantidad;
              });

            const sumaTotalGlobal = Object.values(sumasPorPack).reduce((acc, curr) => acc + curr.cantidad, 0);

            this.dataTableTarifaServicioLogistico = this.dataTableTarifaServicioLogistico.filter(elemento => {
              if ((elemento.lote_desde === undefined || Number(elemento.lote_desde) === 0) &&
                (elemento.lote_hasta === undefined || Number(elemento.lote_hasta) === 0)) {
                return true;
              }

              const contenedorValue = elemento.contenedor?.value ?? '';
              let cantidadAComparar = 0;

              if (contenedorValue !== '' && contenedorValue != null) {
                const packData = sumasPorPack[contenedorValue];
                cantidadAComparar = packData ? packData.cantidad : 0;
              } else {
                cantidadAComparar = sumaTotalGlobal;
              }

              return cantidadAComparar > 0 &&
                cantidadAComparar >= elemento.lote_desde &&
                cantidadAComparar <= elemento.lote_hasta;
            });

            // logica para tarifa con unidades combinadas (cont + fijo)

            let codigoGrupo = 1;

            for (let i = 0; i < this.dataTableTarifaServicioLogistico.length; i++) {

              const item = this.dataTableTarifaServicioLogistico[i];

              if (item.codigo_grupo) { continue; }

              const grupo = this.dataTableTarifaServicioLogistico.filter(x =>
                x.ctaR_Codigo === item.ctaR_Codigo &&
                x.servicio?.value === item.servicio?.value &&
                x.linea?.value === item.linea?.value &&
                x.proveedor?.value === item.proveedor?.value &&
                x.lote_desde === item.lote_desde &&
                x.lote_hasta === item.lote_hasta
              );

              if (grupo.length > 1) {

                grupo.forEach(x => {
                  x.tariff_accion = 'HIJO';
                  x.codigo_grupo = codigoGrupo;
                });
                const costoTotal = grupo.reduce((sum, x) => sum + Number(x.costo || 0), 0);
                const ventaTotal = grupo.reduce((sum, x) => sum + Number(x.venta || 0), 0);
                const montoVentaDolaresTotal = grupo.reduce((sum, x) => sum + Number(x.montoventadolares || 0), 0);
                const profitTotal = grupo.reduce((sum, x) => sum + Number(x.profit || 0), 0);
                const profitMinimoTotal = grupo.reduce((sum, x) => sum + Number(x.profitminimo || 0), 0);
                const rtaRValueCostoTotal = grupo.reduce((sum, x) => sum + Number(x.rtaR_ValueCosto || 0), 0);
                const rtaRValueVentaTotal = grupo.reduce((sum, x) => sum + Number(x.rtaR_ValueVenta || 0), 0);

                const principal = {
                  ...grupo[0],
                  tariff_accion: 'PRINCIPAL',
                  codigo_grupo: codigoGrupo,
                  costo: costoTotal,
                  venta: ventaTotal,
                  montoventadolares: montoVentaDolaresTotal,
                  profit: profitTotal,
                  profitminimo: profitMinimoTotal,
                  rtaR_ValueCosto: rtaRValueCostoTotal,
                  rtaR_ValueVenta: rtaRValueVentaTotal
                };

                this.dataTableTarifaServicioLogistico.push(principal);

                codigoGrupo++;
              }
            }

            this.metadataTableTarifaServicioLogistico.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableTarifaServicioLogistico.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableTarifaServicioLogistico = [...this.metadataTableTarifaServicioLogistico];
            this.dataTableTarifaServicioLogistico = [...this.dataTableTarifaServicioLogistico];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      // console.log("dataTableTarifaServicioLogistico", this.dataTableTarifaServicioLogistico);
      // console.log("metadataTableTarifaServicioLogistico", this.metadataTableTarifaServicioLogistico);
    })
  }

  dataTableTarifaAlmacen: any[] = []
  metadataTableTarifaAlmacen: newmetadate[] = []
  data_Almacen: any[] = [];
  buscarTarifaAlmacen(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.data_Almacen = []
      this.metadataTableTarifaAlmacen = []
      this.dataTableTarifaAlmacen = []

      let entc_codtermport = null;
      if (this.viajeitinerario_dataitinerario.length > 0) {
        switch (this.group_datosgenerales?.value?.regimen) {
          case "001":
            entc_codtermport = this.viajeitinerario_dataitinerario?.find((item: any) => item?.ovnv_final === true)?.entc_codtermport;
            break;
          case "002":
            entc_codtermport = this.viajeitinerario_dataitinerario?.[0]?.entc_codtermport;
            break;
          default:
            break;
        }
      }

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_datosgenerales.get('cliente')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_serviciostarifa.get('transportista')?.value
      );

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = this.codTransporte
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "003"
      request.fechaVig = this.group_servicioslocales.value.fechasl
      request.solopromedio = false// this.desdebtn === false ? (this.group_servicioslocales.value.promedio === null ? false : this.group_servicioslocales.value.promedio) : false
      request.regimen = this.group_datosgenerales?.value?.regimen
      request.puerto = request.regimen == '001' ? this.group_serviciostarifa.get('puertodestino').value : request.regimen == '002' ? this.group_serviciostarifa.get('puertoorigen').value : null
      request.cliente = cod_cliente ?? null;
      request.entc_codtermport = entc_codtermport;
      request.contenedores = this.serviciosytarifas_dataflete
        .filter(x => x.ESTADO_OBJ !== 'D')
        .map(x => ({
          label: String(x.pack_desc?.value ?? x.pack_codigo ?? x.pacK_Codigo ?? '')
        }));
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            this.metadataTableTarifaAlmacen.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            this.data_Almacen = response.datos.result;
            const resultados = this.data_Almacen;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = null;
            let cod_terminal_portuario: string = null;
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));

              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    } else if (recargo.recO_Codigo === 2 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cod_terminal_portuario = recargo.rtaR_CodigoInterno;
                    }
                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto') {
                    if (recargo.recO_Codigo === 15) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }
                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['color'] = detalle.eshijo === true ? '#9aef9e' : 'white'
                  row['cons_tabtds'] = "TDS";
                  row['cons_codtds'] = this.adicional === true ? "002" : "001";
                  row['tipodeservicio'] = this.adicional === true ? "Adicional" : "Servicio";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['tipo_tabtar'] = r.tipO_TabTAR
                  row['tipo_codtar'] = r.tipO_CodTAR
                  row['cliente_tariff'] = cli_tariff
                  row['cod_terminal_portuario'] = cod_terminal_portuario;
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableTarifaAlmacen.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableTarifaAlmacen.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableTarifaAlmacen.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableTarifaAlmacen[index] = item;
                    } else {
                      this.metadataTableTarifaAlmacen.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });
            if (
              !this.listadoRoles?.some(r =>
                ['14', '1', this.coordLog, this.gerentLog]
                  .filter(Boolean)
                  .map(x => String(x))
                  .includes(String(r.role_codigo))
              )
            ) {
              // if (!['14', '1', this.coordLog, this.gerentLog].filter(Boolean).includes(this.rol)) {
              const tipo = this.adicional === false ? 'costo' : 'venta'
              this.metadataTableTarifaAlmacen = this.metadataTableTarifaAlmacen.filter(item =>
                !item.field.toLowerCase().includes(tipo) &&
                !item.field.toLowerCase().includes('profit')
              );
            } else {
              this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
                !item.field.toLowerCase().includes('profit')
              );
            }


            this.dataTableTarifaAlmacen.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableTarifaAlmacen.forEach(row => {
              this.metadataTableTarifaAlmacen.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });
            // const packCodigos = this.serviciosytarifas_dataflete.map(item => Number(item.pack_desc?.value ?? Number(item.pack_codigo) ?? Number(item.pacK_Codigo)));

            // this.dataTableTarifaAlmacen = this.dataTableTarifaAlmacen.filter(row => {
            //   const contenedorVal = String(row.contenedor?.value ?? '');
            //   const almacenVal = String(row.almacen?.value ?? '');

            //   const coincide = packCodigos.includes(Number(contenedorVal));

            //   if (coincide || contenedorVal === '' || contenedorVal === null) {
            //     return true;
            //   }

            //   return false;
            // });

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableTarifaAlmacen.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['almacen'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'almacen',
                title: 'Almacén',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableTarifaAlmacen.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableTarifaAlmacen.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableTarifaAlmacen.push(itemProveedor);
              }
            }
            // if (this.viajeitinerario_dataitinerario.length > 0) {
            //   let entc_codtermport;
            //   switch (this.group_datosgenerales?.value?.regimen) {
            //     case "001":
            //       entc_codtermport = this.viajeitinerario_dataitinerario?.find((item: any) => item?.ovnv_final === true)?.entc_codtermport;
            //       break;
            //     case "002":
            //       entc_codtermport = this.viajeitinerario_dataitinerario?.[0]?.entc_codtermport;
            //       break;
            //     default:
            //       break;
            //   }
            //   if (entc_codtermport !== null && !isNaN(entc_codtermport)) {
            //     this.dataTableTarifaAlmacen = this.dataTableTarifaAlmacen.filter(
            //       (row: any) => Number(row.terminal?.value) === Number(entc_codtermport)
            //     );
            //   }
            // }

            this.metadataTableTarifaAlmacen = this.metadataTableTarifaAlmacen.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableTarifaAlmacen.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableTarifaAlmacen.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableTarifaAlmacen = [...this.metadataTableTarifaAlmacen];
            this.dataTableTarifaAlmacen = [...this.dataTableTarifaAlmacen];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      // console.log("dataTableTarifaAlmacen", this.dataTableTarifaAlmacen);
      // console.log("metadataTableTarifaAlmacen", this.metadataTableTarifaAlmacen);
    })
  }

  dataTableAgeAduana: any[] = []
  metadataTableAgeAduana: newmetadate[] = []
  dataAgeAduana: any[] = [];
  buscarAgenteAduana(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.dataTableAgeAduana = []
      this.metadataTableAgeAduana = []
      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_datosgenerales.get('cliente')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_serviciostarifa.get('transportista')?.value
      );
      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "004";
      request.fechaVig = this.group_servicioslocales.value.fechasl
      request.solopromedio = false//this.desdebtn === false ? (this.group_servicioslocales.value.promedio === null ? false : this.group_servicioslocales.value.promedio) : false
      request.regimen = this.group_datosgenerales?.value?.regimen
      request.puerto = request.regimen == '001' ? this.group_serviciostarifa.get('puertodestino').value : request.regimen == '002' ? this.group_serviciostarifa.get('puertoorigen').value : null
      request.cliente = cod_cliente ?? null;
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status == 200) {
            this.metadataTableAgeAduana.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            console.log(response.datos.result);
            this.dataAgeAduana = response.datos.result;
            const resultados = this.dataAgeAduana;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';
            const nuevasFilas: any[] = [];
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));

              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }
                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'unidad_valor') {
                    if (recargo.recO_Codigo === 15 || recargo.recO_Codigo === 35) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16 || recargo.recO_Codigo === 36) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }
                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  // row['proft'] = recargo.profit;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['cons_codtds'] = this.adicional === true ? "002" : "001";
                  row['tipodeservicio'] = this.adicional === true ? "Adicional" : "Servicio";
                  row['tipo_codrgm'] = r.conS_CodRGM
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['tipo_tabtar'] = r.tipO_TabTAR
                  row['tipo_codtar'] = r.tipO_CodTAR
                  row['cliente_tariff'] = cli_tariff
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableAgeAduana.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableAgeAduana.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableAgeAduana.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableAgeAduana[index] = item;
                    } else {
                      this.metadataTableAgeAduana.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });

            // this.dataTableAgeAduana = this.dataTableAgeAduana.filter(row => row.tipo_venta?.value === '001');
            // if (!['14', '1', this.coordLog, this.gerentLog].filter(Boolean).includes(this.rol)) {
            if (
              !this.listadoRoles?.some(r =>
                ['14', '1', this.coordLog, this.gerentLog]
                  .filter(Boolean)
                  .map(x => String(x))
                  .includes(String(r.role_codigo))
              )
            ) {
              const tipo = this.adicional === false ? 'costo' : 'venta'
              this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
                !item.field.toLowerCase().includes(tipo) &&
                !item.field.toLowerCase().includes('profit') &&
                !item.field.toLowerCase().includes('tipo') &&
                !item.field.toLowerCase().includes('cif')
              );
            } else {
              this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
                !item.field.toLowerCase().includes('profit') &&
                !item.field.toLowerCase().includes('tipo') &&
                !item.field.toLowerCase().includes('cif')
              );
            }

            this.dataTableAgeAduana.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableAgeAduana.forEach(row => {
              this.metadataTableAgeAduana.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });
            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableAgeAduana.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['agente'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'agente',
                title: 'Agente',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableAgeAduana.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableAgeAduana.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableAgeAduana.push(itemProveedor);
              }
            }

            const montocif = this.group_servicioslocales?.value?.montocif;

            if (montocif !== null && montocif !== undefined) {
              this.dataTableAgeAduana = this.dataTableAgeAduana.filter(row => {
                if (row.concepto?.value === '001') {
                  const min = parseFloat(row.rango_minimo);
                  const max = parseFloat(row.rango_maximo);
                  return !isNaN(min) && !isNaN(max) && montocif >= min && montocif <= max;
                }
                return true;
              });
            }

            const montodam = this.group_servicioslocales?.value?.montodam;

            if (montodam !== null && montodam !== undefined) {
              this.dataTableAgeAduana = this.dataTableAgeAduana.filter(row => {
                if (row.concepto?.value === '002') {
                  const min = parseFloat(row.rango_minimo);
                  const max = parseFloat(row.rango_maximo);
                  return !isNaN(min) && !isNaN(max) && montodam >= min && montodam <= max;
                }
                return true;
              });
            }
            this.metadataTableAgeAduana = this.metadataTableAgeAduana.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableAgeAduana.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableAgeAduana.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableAgeAduana = [...this.metadataTableAgeAduana];
            this.dataTableAgeAduana = [...this.dataTableAgeAduana];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      console.log("dataTableAgeAduana", this.dataTableAgeAduana);
      console.log("metadataTableAgeAduana", this.metadataTableAgeAduana);
    });
  }

  dataTableTransporte: any[] = []
  metadataTableTransporte: newmetadate[] = []
  dataTransporte: any[] = [];
  buscarTransporte(event): Promise<void> {
    return new Promise((resolve, reject) => {
      console.log(event)

      const hayReefer = this.serviciosytarifas_dataflete?.some(
        (item: any) => {
          const label = item?.paqueteObj?.label || item?.pack_desc?.label || item?.pack_desc;
          return label?.toLowerCase()?.includes('reefer');
        }
      );

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_datosgenerales.get('cliente')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_serviciostarifa.get('transportista')?.value
      );
      // aquiiiii

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = event.value === '004' ? "002" : "006"
      request.CONS_CodFLE = event.value
      request.fechaVig = this.group_servicioslocales.value.fechasl
      request.solopromedio = false//this.desdebtn === false ? (this.group_servicioslocales.value.promedio === null ? false : this.group_servicioslocales.value.promedio) : false
      request.regimen = this.group_datosgenerales?.value?.regimen
      request.puerto = request.regimen == '001' ? this.group_serviciostarifa.get('puertodestino').value : request.regimen == '002' ? this.group_serviciostarifa.get('puertoorigen').value : null
      request.peso_sli = this.group_servicioslocales.get('peso')?.value ?? null;
      request.unmd_peso = this.group_servicioslocales.get('unmd_peso')?.value ?? null;
      request.volumen_sli = this.group_servicioslocales.get('volumen')?.value ?? null;
      request.unmd_volumen = this.group_servicioslocales.get('unmd_volumen')?.value ?? null;
      request.cliente = cod_cliente ?? null;
      request.esReefer = hayReefer;
      request.ruta = this.group_servicioslocales.value.ruta;
      request.puerto2 = request.regimen == '002' ? this.group_serviciostarifa.get('puertodestino').value : request.regimen == '001' ? this.group_serviciostarifa.get('puertoorigen').value : null
      this.dataTransporte = []
      this.dataTableTransporte = []
      this.metadataTableTransporte = []
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            console.log(response.datos.result);
            this.metadataTableTransporte.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            this.dataTransporte = response.datos.result;
            const resultados = this.dataTransporte;
            const tipocambioventa = resultados[0].tipocambioventa;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));
              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    // row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                    //   value: recargo.rtaR_CodigoInterno,
                    //   label: recargo.rtaR_ValueDescripcion,
                    //   tipovalue: recargo.recO_Lista
                    // } : '';
                    row[columnName] = (recargo.rtaR_CodigoInterno && recargo.rtaR_ValueDescripcion)
                      ? { value: recargo.rtaR_CodigoInterno, label: recargo.rtaR_ValueDescripcion, tipovalue: recargo.recO_Lista }
                      : null;

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }

                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'valor_unm') {
                    if (recargo.recO_Codigo === 15) {
                      // if (recargo.recO_Codigo === 15 || recargo.recO_Codigo === 41 || recargo.recO_Codigo === 43) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      // } else if (recargo.recO_Codigo === 16 || recargo.recO_Codigo === 42 || recargo.recO_Codigo === 44) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }

                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['cons_codtds'] = this.adicional === true ? "002" : "001";
                  row['tipodeservicio'] = this.adicional === true ? "Adicional" : "Servicio";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['tipo_tabtar'] = r.tipO_TabTAR
                  row['tipo_codtar'] = r.tipO_CodTAR
                  row['cliente_tariff'] = cli_tariff
                  // row['tipoequipo'] = recargo.carga?.label
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableTransporte.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableTransporte.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
              if (totalColumn && !columnasSet.has(totalColumn)) {
                this.dataTableTransporte.push({ field: totalColumn, title: totalColumn, inputType: 'text', filterType: 'text', });
                columnasSet.add(totalColumn);
              }
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableTransporte.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableTransporte[index] = item;
                    } else {
                      this.metadataTableTransporte.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });
            // if (!['14', '1', this.coordLog, this.gerentLog].filter(Boolean).includes(this.rol)) {
            if (
              !this.listadoRoles?.some(r =>
                ['14', '1', this.coordLog, this.gerentLog]
                  .filter(Boolean)
                  .map(x => String(x))
                  .includes(String(r.role_codigo))
              )
            ) {
              const tipo = this.adicional === false ? 'costo' : 'venta'
              this.metadataTableTransporte = this.metadataTableTransporte.filter(item =>
                !item.field.toLowerCase().includes(tipo) &&
                !item.field.toLowerCase().includes('profit') && !item.field.toLowerCase().includes('distrito')
              );
            } else {
              this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
                !item.field.toLowerCase().includes('profit') &&
                !item.field.toLowerCase().includes('distrito')
              );
            }


            this.metadataTableTransporte.push(
              { field: 'tipocambioventa', title: 'Tipo Cambio Venta', inputType: 'decimal' },
              { field: 'montoventadolares', title: 'Monto Venta Dólares', inputType: 'decimal' }
            );

            this.dataTableTransporte.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableTransporte.forEach(row => {
              this.metadataTableTransporte.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });

            const rutaSeleccionada = this.group_servicioslocales?.value?.rutas;
            if (rutaSeleccionada !== null) {
              this.dataTableTransporte = this.dataTableTransporte.filter(row => {
                return Number(row.ruta?.value) === Number(rutaSeleccionada);
              });
            }

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableTransporte.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['proveedor'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'proveedor',
                title: 'Proveedor',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableTransporte.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableTransporte.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableTransporte.push(itemProveedor);
              }
            }

            // const hayReefer = this.serviciosytarifas_dataflete?.some(
            //   (item: any) => {
            //     const label = item?.paqueteObj?.label || item?.pack_desc?.label || item?.pack_desc;
            //     return label?.toLowerCase()?.includes('reefer');
            //   }
            // );
            // if (event.value === '004') {
            //   if (hayReefer === true) {
            //     this.dataTableTransporte = this.dataTableTransporte.filter(
            //       (row: any) => String(row.carga?.value) === '001'
            //     );
            //   } else {
            //     this.dataTableTransporte = this.dataTableTransporte.filter(
            //       (row: any) => String(row.carga?.value) === '002'
            //     );
            //   }
            // }
            this.metadataTableTransporte = this.metadataTableTransporte.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableTransporte.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableTransporte.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableTransporte = [...this.metadataTableTransporte];
            this.dataTableTransporte = [...this.dataTableTransporte];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      // console.log("dataTableTransporte", this.dataTableTransporte);
      // console.log("metadataTableTransporte", this.metadataTableTransporte);
    });
  }

  dataTableExtras: any[] = []
  metadataTableExtras: newmetadate[] = []
  dataExtras: any[] = [];
  buscarTarifasExtra(): Promise<void> {
    return new Promise((resolve, reject) => {

      const hayReefer = this.serviciosytarifas_dataflete?.some(
        (item: any) => {
          const label = item?.paqueteObj?.label || item?.pack_desc?.label || item?.pack_desc;
          return label?.toLowerCase()?.includes('reefer');
        }
      );

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_datosgenerales.get('cliente')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_serviciostarifa.get('transportista')?.value
      );

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "007"
      request.CONS_CodFLE = this.group_serviciostarifa.get('condicion')?.value;
      request.fechaVig = this.group_servicioslocales.value.fechasl
      request.solopromedio = false//this.desdebtn === false ? (this.group_servicioslocales.value.promedio === null ? false : this.group_servicioslocales.value.promedio) : false
      request.regimen = this.group_datosgenerales?.value?.regimen
      request.puerto = request.regimen == '001' ? this.group_serviciostarifa.get('puertodestino').value : request.regimen == '002' ? this.group_serviciostarifa.get('puertoorigen').value : null
      request.peso_sli = this.group_servicioslocales.get('peso')?.value ?? null;
      request.unmd_peso = this.group_servicioslocales.get('unmd_peso')?.value ?? null;
      request.volumen_sli = this.group_servicioslocales.get('volumen')?.value ?? null;
      request.unmd_volumen = this.group_servicioslocales.get('unmd_volumen')?.value ?? null;
      request.cliente = cod_cliente ?? null;
      request.esReefer = hayReefer;
      request.ruta = this.group_servicioslocales.value.ruta;
      request.transportista = cod_transportista ?? null;
      this.dataTableExtras = []
      this.dataExtras = []
      this.metadataTableExtras = []
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            const fakeEvent = { checked: [true] };
            this.metadataTableExtras.push({
              title: '', field: 'btn_duplicar', filterType: 'text', inputType: 'buttonPersonalizado', icon: 'pi pi-clone',
              function: (row) => this.addTarifa(fakeEvent, row.row, 'I', 'EXT'), toolTip: 'Agregar de nuevo', inputStatus: 'nolock'
            });
            this.metadataTableExtras.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            this.dataExtras = response.datos.result;
            const resultados = this.dataExtras;
            const tipocambioventa = resultados[0].tipocambioventa;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));
              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }
                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'valor_unm') {
                    if (recargo.recO_Codigo === 15) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }

                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['cons_codtds'] = this.adicional === true ? "002" : "001";
                  row['tipodeservicio'] = this.adicional === true ? "Adicional" : "Servicio";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['tipo_tabtar'] = r.tipO_TabTAR
                  row['tipo_codtar'] = r.tipO_CodTAR
                  row['btn_duplicar'] = true
                  row['cliente_tariff'] = cli_tariff
                  // row['tipoequipo'] = recargo.carga?.label
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableExtras.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableExtras.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
              if (totalColumn && !columnasSet.has(totalColumn)) {
                this.dataTableExtras.push({ field: totalColumn, title: totalColumn, inputType: 'text', filterType: 'text', });
                columnasSet.add(totalColumn);
              }
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableExtras.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableExtras[index] = item;
                    } else {
                      this.metadataTableExtras.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });
            // if (!['14', '1', this.coordLog, this.gerentLog].filter(Boolean).includes(this.rol)) {
            if (
              !this.listadoRoles?.some(r =>
                ['14', '1', this.coordLog, this.gerentLog]
                  .filter(Boolean)
                  .map(x => String(x))
                  .includes(String(r.role_codigo))
              )
            ) {
              const tipo = this.adicional === false ? 'costo' : 'venta'
              this.metadataTableExtras = this.metadataTableExtras.filter(item =>
                !item.field.toLowerCase().includes(tipo) &&
                !item.field.toLowerCase().includes('profit') && !item.field.toLowerCase().includes('distrito')
              );
            } else {
              this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
                !item.field.toLowerCase().includes('profit') &&
                !item.field.toLowerCase().includes('distrito')
              );
            }

            // this.metadataTableExtras.push(
            //   { field: 'tipocambioventa', title: 'Tipo Cambio Venta', inputType: 'decimal' },
            //   { field: 'montoventadolares', title: 'Monto Venta Dólares', inputType: 'decimal' }
            // );

            this.dataTableExtras.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableExtras.forEach(row => {
              this.metadataTableExtras.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableExtras.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['proveedor'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'proveedor',
                title: 'Proveedor',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableExtras.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableExtras.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableExtras.push(itemProveedor);
              }
            }
            this.metadataTableExtras = this.metadataTableExtras.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableExtras.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableExtras.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableExtras = [...this.metadataTableExtras];
            this.dataTableExtras = [...this.dataTableExtras];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      // console.log("dataTableExtras", this.dataTableExtras);
      // console.log("metadataTableExtras", this.metadataTableExtras);
    });
  }

  dataTableTc: any[] = []
  metadataTableTc: newmetadate[] = []
  dataTc: any[] = [];
  buscarTarifasTacna(): Promise<void> {
    return new Promise((resolve, reject) => {

      const hayReefer = this.serviciosytarifas_dataflete?.some(
        (item: any) => {
          const label = item?.paqueteObj?.label || item?.pack_desc?.label || item?.pack_desc;
          return label?.toLowerCase()?.includes('reefer');
        }
      );

      const cod_cliente = this.obtenerCodigoPorValor(
        this.ListaTodosCliente, this.group_datosgenerales.get('cliente')?.value
      );

      const cod_transportista = this.obtenerCodigoPorValor(
        this.ListaTodosTransportista, this.group_serviciostarifa.get('transportista')?.value
      );

      const request: ListarTarifaCotizacionRequest = <ListarTarifaCotizacionRequest>{}
      request.ENTC_CodAgente = null
      request.CTAR_Codigo = null
      request.TIPO_CodTAR = "008"
      request.CONS_CodFLE = this.group_serviciostarifa.get('condicion')?.value;
      request.fechaVig = this.group_servicioslocales.value.fechasl
      request.solopromedio = false//this.desdebtn === false ? (this.group_servicioslocales.value.promedio === null ? false : this.group_servicioslocales.value.promedio) : false
      request.regimen = this.group_datosgenerales?.value?.regimen
      request.puerto = request.regimen == '001' ? this.group_serviciostarifa.get('puertodestino').value : request.regimen == '002' ? this.group_serviciostarifa.get('puertoorigen').value : null
      request.cliente = cod_cliente ?? null;
      request.esReefer = hayReefer;
      request.ruta = this.group_servicioslocales.value.ruta;
      request.transportista = cod_transportista ?? null;
      request.contenedores = this.serviciosytarifas_dataflete
        .filter(x => x.ESTADO_OBJ !== 'D')
        .map(x => ({
          label: String(x.pack_desc?.value ?? x.pack_codigo ?? x.pacK_Codigo ?? '')
        }));
      this.dataTableTc = []
      this.dataTc = []
      this.metadataTableTc = []
      this.ordenventaService.ListarTarifaCotizacion(request).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            this.metadataTableTc.push({ field: 'desctarifa', title: 'Descripción Tarifa', inputType: 'text', filterType: 'text', });
            this.dataTc = response.datos.result;
            const resultados = this.dataTc;
            const tipocambioventa = resultados[0].tipocambioventa;
            const columnasRecargos = new Set<string>();
            const columnasDinamicas = new Map<number, { columns: Set<string>, totalColumn: string, totalValue: number }>();
            let recargosData: any[] = []
            const columnNameMap = new Map<string, string>();
            const tipos: any[] = [];
            let tipo_tabmndcosto: string = '';
            let tipo_codmndcosto: string = '';
            let nombremndcosto: string = '';
            let tipo_tabmndventa: string = '';
            let tipo_codmndventa: string = '';
            let tipo_tabmndprofit: string = '';
            let tipo_codmndprofit: string = '';
            let nombremndvta: string = '';
            let cli_tariff: string = '';
            resultados.forEach(r => {
              r.detallerecargos.forEach(det => tipos.push(det));
              r.listadodetalle.forEach(detalle => {
                let row: any = {};

                const recargosOrdenados = (detalle.listadorecargos || []).sort((a, b) => a.rtaR_Codigo - b.rtaR_Codigo);

                recargosOrdenados.forEach(recargo => {
                  const rawColumnName = recargo.recO_Descripcion;
                  const columnName = rawColumnName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '');
                  const tipoRecargo = tipos.find(t => String(t.recO_Codigo) === String(recargo.recO_Codigo));
                  if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'select' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'selectbytype') {
                    row[columnName] = recargo.rtaR_CodigoInterno !== null ? {
                      value: recargo.rtaR_CodigoInterno,
                      label: recargo.rtaR_ValueDescripcion,
                      tipovalue: recargo.recO_Lista
                    } : '';

                    if (recargo.recO_Codigo === 46 && recargo.rtaR_CodigoInterno !== null && recargo.rtaR_CodigoInterno !== '') {
                      cli_tariff = recargo.rtaR_CodigoInterno;
                    }
                  } else if (tipoRecargo?.tipO_DesINP?.toLowerCase() === 'int' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'decimal' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'moneda_monto' || tipoRecargo?.tipO_DesINP?.toLowerCase() === 'valor_unm') {
                    if (recargo.recO_Codigo === 15) {
                      row[columnName] = recargo.rtaR_ValueCosto;
                      tipo_tabmndcosto = recargo.tipO_TabMND;
                      tipo_codmndcosto = recargo.tipO_CodMND;
                      nombremndcosto = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 16) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndventa = recargo.tipO_TabMND;
                      tipo_codmndventa = recargo.tipO_CodMND;
                      nombremndvta = recargo.tipO_DesMND;
                    } else if (recargo.recO_Codigo === 23) {
                      row[columnName] = recargo.rtaR_ValueVenta;
                      tipo_tabmndprofit = recargo.tipO_TabMND;
                      tipo_codmndprofit = recargo.tipO_CodMND;
                    } else {
                      row[columnName] = recargo.rtaR_ValueVenta;
                    }
                  } else {
                    row[columnName] = recargo.rtaR_ValueDescripcion;
                  }
                  columnNameMap.set(columnName, rawColumnName);
                  const existe = recargosData.some(item =>
                    item.columnName === columnName && item.recO_Codigo === recargo.recO_Codigo);
                  if (!existe) {
                    recargosData.push({ columnName, recO_Codigo: recargo.recO_Codigo });
                  }

                  columnasRecargos.add(columnName);
                  row['tipo_tabmndcosto'] = tipo_tabmndcosto;
                  row['tipo_codmndcosto'] = tipo_codmndcosto;
                  row['tipo_tabmndventa'] = tipo_tabmndventa;
                  row['tipo_codmndventa'] = tipo_codmndventa;
                  row['tipo_tabmndprofit'] = tipo_tabmndprofit;
                  row['tipo_codmndprofit'] = tipo_codmndprofit;
                  row['descripcion_monedacosto'] = nombremndcosto;
                  row['descripcion_monedaventa'] = nombremndvta;
                  row['rtaR_ValueCosto'] = recargo.rtaR_ValueCosto;
                  row['rtaR_ValueVenta'] = recargo.rtaR_ValueVenta;
                  row['serV_Codigo'] = recargo.serV_Codigo;
                  row['dtar_Codigo'] = recargo.dtaR_Codigo;
                  row['rtar_Codigo'] = recargo.rtaR_Codigo;
                  row['profit_local'] = r.ctaR_ProfitLocal;
                  row['tipocambioventa'] = r.tipocambioventa;
                  row['tipocambiocompra'] = r.tipocambiocompra;
                  row['profitminimo'] = detalle.profitminimo;
                  row['tipoprofitm'] = detalle.tipoprofitm;
                  row['tipomonedam'] = detalle.tipomonedam;
                  row['cons_tabtds'] = "TDS";
                  row['cons_codtds'] = this.adicional === true ? "002" : "001";
                  row['tipodeservicio'] = this.adicional === true ? "Adicional" : "Servicio";
                  row['codigoproveedor'] = r.entC_Codigo
                  row['desctarifa'] = r.ctaR_Descripcion_SPA
                  row['vigencias'] = `${this.util.formatearfecha(r.ctaR_VigenteDesde, 'dd-mm-yyyy')} - ${this.util.formatearfecha(r.ctaR_VigenteHasta, 'dd-mm-yyyy')}`
                  row['ctar_observacion'] = r.ctaR_Observacion
                  row['tipo_tabtar'] = r.tipO_TabTAR
                  row['tipo_codtar'] = r.tipO_CodTAR
                  row['cliente_tariff'] = cli_tariff
                  // row['tipoequipo'] = recargo.carga?.label
                });
                row['ctaR_Codigo'] = detalle.ctaR_Codigo;
                this.dataTableTc.push(row);
              });
            });
            const columnasSet = new Set<string>();
            Array.from(columnasDinamicas.keys()).sort((a, b) => a - b).forEach(codigo => {
              const { columns, totalColumn } = columnasDinamicas.get(codigo)!;
              columns.forEach(columnName => {
                if (!columnasSet.has(columnName)) {
                  this.metadataTableTc.push({ field: columnName, title: columnName, inputType: 'text', filterType: 'text', });
                  columnasSet.add(columnName);
                }
              });
              if (totalColumn && !columnasSet.has(totalColumn)) {
                this.dataTableTc.push({ field: totalColumn, title: totalColumn, inputType: 'text', filterType: 'text', });
                columnasSet.add(totalColumn);
              }
            });

            columnasRecargos.forEach(columnName => {
              if (!columnasSet.has(columnName)) {
                const recargoEncontrado = recargosData.find(recargo =>
                  recargo.columnName.trim().toLowerCase() === columnName.trim().toLowerCase() &&
                  tipos.some(tipo => String(tipo.recO_Codigo) === String(recargo.recO_Codigo))
                );

                if (recargoEncontrado) {
                  const tipoCorrespondiente = tipos.find(tipo =>
                    String(tipo.recO_Codigo) === String(recargoEncontrado.recO_Codigo));
                  if (tipoCorrespondiente) {
                    let input_type = tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? 'autocomplete' : tipoCorrespondiente.tipO_DesINP?.toLowerCase();
                    const item: any = {
                      field: columnName,
                      title: columnNameMap.get(columnName) || columnName,
                      inputType: input_type,
                      style: tipoCorrespondiente.tipO_DesINP?.toLowerCase() === 'select' || tipoCorrespondiente?.tipO_DesINP?.toLowerCase() === 'selectbytype' ? { justify: 'left' } : { justify: 'center' }
                    };

                    const index = this.metadataTableTc.findIndex(meta => meta.field === columnName);
                    if (index !== -1) {
                      this.metadataTableTc[index] = item;
                    } else {
                      this.metadataTableTc.push(item);
                    }
                  }
                }
                columnasSet.add(columnName);
              }
            });
            // if (!['14', '1', this.coordLog, this.gerentLog].filter(Boolean).includes(this.rol)) {
            if (
              !this.listadoRoles?.some(r =>
                ['14', '1', this.coordLog, this.gerentLog]
                  .filter(Boolean)
                  .map(x => String(x))
                  .includes(String(r.role_codigo))
              )
            ) {
              const tipo = this.adicional === false ? 'costo' : 'venta'
              this.metadataTableTc = this.metadataTableTc.filter(item =>
                !item.field.toLowerCase().includes(tipo) &&
                !item.field.toLowerCase().includes('profit') && !item.field.toLowerCase().includes('distrito')
              );
            } else {
              this.metadataTableAgeAduana = this.metadataTableAgeAduana.filter(item =>
                !item.field.toLowerCase().includes('profit') &&
                !item.field.toLowerCase().includes('distrito')
              );
            }

            // this.metadataTableTc.push(
            //   { field: 'tipocambioventa', title: 'Tipo Cambio Venta', inputType: 'decimal' },
            //   { field: 'montoventadolares', title: 'Monto Venta Dólares', inputType: 'decimal' }
            // );

            this.dataTableTc.forEach(row => {
              const ventaStr = String(row.venta).replace(/,/g, '');
              const venta = parseFloat(ventaStr);
              const tipoCambio = parseFloat(row.tipocambioventa);
              row['montoventadolares'] = row.tipo_codmndventa === '001' ? parseFloat((venta / tipoCambio).toFixed(4)) : row.venta;
            });

            this.dataTableTc.forEach(row => {
              this.metadataTableTc.forEach(meta => {
                if (!(meta.field in row)) {
                  row[meta.field] = '';
                }
              });
            });

            // const packCodigos = this.serviciosytarifas_dataflete
            //   .filter(item => item.ESTADO_OBJ !== 'D')
            //   .map(item =>
            //     Number(item.pack_desc?.value ?? item.pack_codigo ?? item.pacK_Codigo)
            //   );

            // this.dataTableTc = this.dataTableTc.filter(row => {
            //   const contenedorVal = String(row.contenedor?.value ?? '');

            //   const coincide = packCodigos.includes(Number(contenedorVal));

            //   if (coincide || contenedorVal === '' || contenedorVal === null) {
            //     return true;
            //   }

            //   return false;
            // });

            const codigosProveedor = [1, 24, 17];
            const existeProveedor = recargosData.some(rec => codigosProveedor.includes(rec.recO_Codigo));

            if (!existeProveedor) {
              this.dataTableTc.forEach(row => {
                const value = row.codigoproveedor;
                const entidadEncontrada = this.ListaNombreEntidadesDP.find(
                  e => Number(e.value) === Number(value)
                );
                row['proveedor'] = {
                  value: value,
                  label: entidadEncontrada ? entidadEncontrada.label : null,
                  tipovalue: entidadEncontrada ? entidadEncontrada.tipo : null
                };
              });
              const itemProveedor: any = {
                field: 'proveedor',
                title: 'Proveedor',
                inputType: 'autocomplete',
                style: { justify: 'left' },
                dropdown: this.ListaNombreEntidadesDP
              };

              const idxServicio = this.metadataTableTc.findIndex(m =>
                m.field.toLowerCase().includes('servicio')
              );

              if (idxServicio !== -1) {
                this.metadataTableTc.splice(idxServicio + 1, 0, itemProveedor);
              } else {
                this.metadataTableTc.push(itemProveedor);
              }
            }
            this.metadataTableTc = this.metadataTableTc.map(meta => {
              const lowerField = meta.field.toLowerCase();

              if (lowerField.includes('costo')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndcosto
                };
              }

              if (lowerField.includes('venta')) {
                return {
                  ...meta,
                  getSimboloMnd: (row: any) => row.tipo_codmndventa
                };
              }

              return meta;
            });

            this.metadataTableTc.push({ field: 'ctar_observacion', title: 'Observaciones', inputType: 'viewobservaciones', filterType: 'text', maxWidth: '800px' });
            this.metadataTableTc.forEach(item => {
              if (!('filterType' in item)) {
                if (item.inputType === 'moneda_monto') {
                  item.filterType = 'numeric';
                }
                else {
                  item.filterType = 'text';
                }
              }
            });

            this.metadataTableTc = [...this.metadataTableTc];
            this.dataTableTc = [...this.dataTableTc];
          }
          resolve();
        },
        error: (err) => reject(err)
      });
      // console.log("dataTableTc", this.dataTableTc);
      // console.log("metadataTableTc", this.metadataTableTc);
    });
  }

  bloqueoColumnas: string[] = ["desctarifa", "vigencias", "cons_descest", "tipocambioventa"];
  bloqueoColumnasVta: string[] = ['dope_preciototvta', 'profit_fijo', "profitminimo", "dope_preciototcosto"
    , 'entc_razonsocial', 'cons_desc_spa', 'serv_nombre_spa', 'nombremnd', 'nombremndvta', "desctarifa", "vigencias", "cons_descest", "entc_codigo", "tipoentidad", "tipocambioventa"
  ];
  bloqueoColumnasCosto: string[] = ['dope_item', 'dope_preciototvta', 'dope_preciototcosto', 'tipodeservicio', 'dope_preciounit_prom', 'dope_preciotot_prom', 'tipocomprobante', "docv_codigo", "docv_comprobante", "dope_itemchangecontrol",
    "cose_nroordenservicio", "desctarifa", "vigencias", "cons_descest", "tipocambioventa"
  ];
  bloqueoColumnasCostoYVta: string[] = ['dope_item', 'dope_preciototvta', 'dope_preciototcosto', 'tipodeservicio', 'dope_preciounit_prom', 'dope_preciotot_prom', 'tipocomprobante', "docv_codigo", "docv_comprobante", "dope_itemchangecontrol",
    "cose_nroordenservicio", "desctarifa", "vigencias", "cons_descest", "tipocambioventa"
  ];
  bloqueoColumnasLogisticaPlus: string[] = ['dope_item', 'dope_preciototvta', 'dope_preciototcosto', 'tipodeservicio', 'dope_preciounit_prom', 'dope_preciotot_prom', 'tipocomprobante', "docv_codigo", "docv_comprobante", "dope_itemchangecontrol",
    "cose_nroordenservicio", "desctarifa", "vigencias", "cons_descest", "tipocambioventa"
  ];
  bloqueoadd: string[] = ['dope_item', "cose_nroordenservicio", 'tipocomprobante', "docv_codigo", "docv_comprobante", "dope_itemchangecontrol", "dope_preciounit_prom", "dope_preciotot_prom", "desctarifa", "vigencias", "tipocambioventa"]
  reset = [];
  resetVta = [
    { icon: 'pi pi-history', function: () => this.ResetTabla(), toolTip: "Refrezcar", loading: false },
  ];
  resetCosto = [
    { icon: 'pi pi-history', function: () => this.ResetTabla(), toolTip: "Refrezcar", loading: false },
    { icon: 'pi pi-file-edit', severity: "success", function: () => this.openComponent(), toolTip: "Abrir Proforma", loading: false, disabled: this.adicional || this.isadmin },
    { icon: 'pi pi-save', function: (event?: Event) => this.saveOperaciones(event), toolTip: "Guardar Cambios SLI", loading: false, disabled: this.soloLectura }
  ];
  btns_archivos = [];
  btns_archivos_sli = [
    { icon: 'pi pi-save', function: () => this.saveArchivos(), toolTip: "Guardar Cambios Archivos", loading: false, disable: this.esVisualizar }
  ];

  ResetTabla() {
    this.leyendasTblSLI = structuredClone(this.leyendasRow);
    this.servicioslocales_datadetalle = [];
    this.servicioslocales_datadetalle = this.temp_servicioslocales_datadetalle;
    this.temp_servicioslocales_datadetalle = [];
    this.modovisualizar = true
  }
  edicion: boolean = false
  monto_original: number;
  erroresValidacion: { [key: string]: string } = {};
  async onEditRowInit(product: any): Promise<void> {
    const key = product.key;
    this.dtServiciosRefdt.puedeValidar[key] = false;
    this.monto_original = null
    let lng = { label: product.cons_desclng?.label || product.cons_desclng, value: product.cons_desclng?.value || product.cons_codlng }
    let eventlng: {
      event: { originalEvent: PointerEvent; value: any; };
      field: string; index: number | null; rowdata: any | null;
    } =
    {
      event: { originalEvent: new PointerEvent("click"), value: lng },
      field: "cons_desclng", index: null, rowdata: null
    };
    this.onSelectChange(eventlng)
    let proveedor = { label: product.tipoentidad?.label || product.tipoentidad, value: product.tipoentidad?.value || product.tipe_codigo }
    let eventtipe: {
      event: { originalEvent: PointerEvent; value: any; };
      field: string; index: number | null; rowdata: any | null;
    } =
    {
      event: { originalEvent: new PointerEvent("click"), value: proveedor },
      field: "tipoentidad", index: null, rowdata: null
    };
    this.onSelectChange(eventtipe)
    // const codigoLng = product['cons_desclng']?.value ?? product['cons_codlng'];
    // const codrgm = this.datos['listadooperaciones']?.[0]?.cons_codrgm
    // const codvia = this.datos['listadooperaciones']?.[0]?.cons_codvia

    // const listaFiltrada = this.ListaTodosServiciosTable.filter(
    //   item => item.lng === codigoLng && item.rgm === codrgm && item.via === codvia
    // );
    // this.ListaFiltradaTodosServiciosTable = listaFiltrada;
    // this.actualizarDpMtRelacionados('serv_nombre_spa', this.ListaFiltradaTodosServiciosTable);
    // const tiposMap: Record<string, string> = {
    //     '15': 'DepositoVacio',
    //     '14': 'DepositoTemp',
    //     '3': 'EJEC',
    //     '4': 'CUS',
    //     '5': 'TRANSPORTISTA',
    //     '9': 'CONTACTO',
    //     '6': 'AGE',
    //     '7': 'AGE',
    //     '2': 'PROVEEDOR',
    //     '10': 'SHIPPER'
    //   };
    //   const tiposSeleccionados = valueArray.map(codigo => tiposMap[codigo]);

    //   this.ListaFiltradaTipoEntidadDP = this.ListaNombreEntidadesDP.filter(item =>
    //     tiposSeleccionados.includes(item.tipo)
    //   );

    //   this.ListaFiltradaNombreEntidadesDP =
    //     tiposSeleccionados.includes('AGE')
    //       ? this.ListaNombreEntidadesDP.filter(item => item.tipo === 'AGE')
    //       : this.ListaNombreEntidadesDP.filter(item =>
    //         tiposSeleccionados.includes(item.tipo)
    //       );
    //   this.actualizarDpMtRelacionados('entc_razonsocial', this.ListaFiltradaNombreEntidadesDP);
    // if (product['tipocambioventa'] === null || product['tipocambioventa'] === undefined || product['tipocambioventa'] === 0) {
    const Request: ConsultarProfitTCambioRequest = <ConsultarProfitTCambioRequest>{}
    Request.SERV_Codigo = product['serv_nombre_spa']?.value || product['serv_codigo']
    Request.tipo = "TC"
    try {
      const response = await firstValueFrom(this.ordenventaService.ConsultarTCambio(Request));
      if (response.datos.status === 200) {
        product['tipocambiocompra'] = response.datos.result[0].tipocambiocompra
        product['tipocambioventa'] = response.datos.result[0].tipocambioventa
        if (this.dtServiciosRefdt && this.dtServiciosRefdt.puedeValidar) {
          this.dtServiciosRefdt.puedeValidar[key] = true;
        }
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'OK', detail: 'El tipo de cambio de venta se ha actualizado correctamente.', life: 3000, key: "tl" });
      }
    } catch (error) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'El tipo de cambio de venta no está definido para el día de hoy. Por favor, verifique.', life: 3000, key: "tl" });
      this.dtServiciosRefdt.onRowEditCancel(product, product['key'] - 1);
      return;
    }
    // }
    // if (product['profitminimo'] === null || product['profitminimo'] === undefined || product['profitminimo'] === 0) {
    // }
    this.monto_original = this.adicional === true ? product['dope_preciounit_prom'] : product['dope_preciounitvta']
  }

  servicioslocales_detalleAgrupacion: any[] = []
  metadataTableDetalleAgrupacion: newmetadate[] = []
  tablaAgrupados: any[] = []
  tarifaActualizada: any[] = []
  selectedKey: string | null = null;
  async addTarifa(event, row, accion, tipo) {

    if (event.checked.length > 0) {
      const existentes = [
        ...this.servicioslocales_datadetalle,
        ...(this.servicioslocales_detalleAgrupacion || [])
      ].filter(i => i.dope_item != null).map(i => Number(i.dope_item));
      const siguienteDope = existentes.length > 0 ? Math.max(...existentes) + 1 : 1;
      let item
      const unidadCodigo = row.unidad?.value || row.cons_codbas;
      const packCodigo = row.contenedor?.value;
      let ventaUnit = row.tipo_codmndventa === '001' ? Number(row.montoventadolares) : Number(row.venta)
      let costo_tariff = Number(row.costo) ?? 0;
      row.select = true;

      const tiposValidos = ['ALM', 'TNS', 'SLI', 'AGE', 'EXT', 'TC'];

      const sinTipoEntidad = !row.tipo_entidad || row.tipo_entidad === "" || (typeof row.tipo_entidad === 'object' && !row.tipo_entidad.value);

      if (sinTipoEntidad && tiposValidos.includes(tipo) && accion === 'I' 
      && !['003', '004', '006', '007'].includes(row.tipo_codtar ?? '')) {
        row.select = false;

        if (event && Array.isArray(event.checked)) {
          const index = event.checked.indexOf(row.key ?? row);
          if (index !== -1) {
            event.checked.splice(index, 1);
          } else {
            event.checked = [];
          }
        }
        this.cdr.detectChanges();

        this.messageService.clear();
        this.messageService.add({
          severity: 'error', summary: 'Tarifa no disponible', life: 6000, key: 'tl',
          detail: 'No se puede seleccionar esta tarifa porque no tiene un tipo de proveedor registrado. Por favor, comunícate con el equipo de analistas de costos.',
        });

        return; 
      }

      // if (row.proveedor === null) {
      //   row.select = false;
      //   this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'No se puede agregar un servicio local sin proveedor asignado.', life: 5000, key: "tl" });
      //   return;
      // }
      // if (unidadCodigo === undefined || unidadCodigo === null || unidadCodigo === '') {
      //   row.select = false;
      //   this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'No se puede agregar un servicio local sin proveedor conntenedor asignado.', life: 5000, key: "tl" });
      //   return;
      // }

      if (tiposValidos.includes(tipo) && accion === 'I' && row.select == true) {
        this.cancelarFilasEdicion();
      }

      if (tipo === 'ALM') {

        const cantidad = unidadCodigo === '002'
          ? this.serviciosytarifas_dataflete
            .filter(item => {
              const noEliminado = item.ESTADO_OBJ !== 'D';
              const cumplePack = (!packCodigo || packCodigo === "") ? true : (Number(item.pack_desc?.value) || Number(item.pack_codigo)) === Number(packCodigo);

              return noEliminado && cumplePack;
            })
            .reduce((total, item) => total + (item.dcot_cantidad || 0), 0) || 1
          : 1;

        const tipecodigo = this.obtenerCodigoPorEntidad(row.almacen?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        const tipe = this.obtenerCodigoPorEntidad(row.almacen?.value ?? row.entc_codigo, 'tipe')

        item = {
          "cons_desc_spa": row.unidad?.label || row.cons_desc_spa,
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": ventaUnit * cantidad,
          "dope_preciounitvta": ventaUnit,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costo_tariff * cantidad,
          "entc_razonsocial": this.adicional === true ? { label: row.almacen?.label || row.entc_razonsocial, value: String(row.almacen?.value) || row.entc_codigo.toString(), tipo: 'PROVEEDOR' } : row.almacen?.label,
          "entc_codigo": row.almacen?.value || row.entc_codigo,
          "nombremnd": row.descripcion_monedacosto,
          "nombremndvta": row.descripcion_monedaventa,
          "serv_nombre_spa": row.servicio?.label || row.serv_nombre_spa,
          "serv_codigo": row.servicio?.value || row.serv_codigo,
          "tipo_codmnd": row.tipo_codmndcosto,
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "cons_codbas": row.unidad?.value || row.cons_codbas,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": row.tipo_codmndventa,
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_tabbas": "BAS",
          "tipoentidad": 'PROVEEDOR',
          "tipe_codigo": 2,
          "profit_local": row.profit,
          "profit_fijo": row.profit ?? 0,
          "profitminimo": row.profitminimo ?? 0,
          "tipoprofitm": row.tipoprofitm,
          "tipomonedam": row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": Number(row.costo) ?? 0,
          "dope_preciotot_prom": Number(row.costo) * cantidad,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "puedemodRZ": false,
          "verTarifario": true,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "msd_editable": true,
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": ventaUnit,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "tipo_codtar": row.tipo_codtar,
          "tipo_tabtar": row.tipo_tabtar,
          "cliente_tariff": row.cliente_tariff,
          "cod_terminal_portuario": row.cod_terminal_portuario,
        }
      } else if (tipo === 'TNS') {
        const cantidad =
          unidadCodigo === '002'
            ? this.serviciosytarifas_dataflete
              .filter(item => item.estado_obj !== 'D')
              .reduce((total, item) => total + (item.dcot_cantidad || 0), 0) || 1 : 1;
        const tipecodigo = this.obtenerCodigoPorEntidad(row.proveedor?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        const tipe = this.obtenerCodigoPorEntidad(row.proveedor?.value ?? row.entc_codigo, 'tipe')
        const condicion = this.group_serviciostarifa.get('condicion')?.value;
        const costo_tariff = Number(row.costo) ?? 0;
        item = {
          "cons_desc_spa": condicion != '001' ? row.unidad?.label ?? "CONTENEDOR" : "CARGA SUELTA",
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": ventaUnit * cantidad,
          "dope_preciounitvta": ventaUnit,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costo_tariff * cantidad,
          "entc_razonsocial": this.adicional === true ? { label: row.proveedor?.label || row.proveedor, value: String(row.proveedor?.value) || row.entc_codigo.toString(), tipo: 'PROVEEDOR' } : row.proveedor?.label,
          "entc_codigo": row.proveedor?.value ?? row.entc_codigo,
          "nombremnd": row.descripcion_monedacosto,
          "nombremndvta": row.descripcion_monedaventa,
          "serv_nombre_spa": row.servicio?.label || row.serv_nombre_spa || "SERVICIO DE TRANSPORTE LOCAL",
          "serv_codigo": row.servicio?.value ?? row.serv_codigo,
          "tipo_codmnd": row.tipo_codmndcosto,
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": row.tipo_codmndventa,
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_codbas": condicion != '001' ? row.unidad?.value === null ? "002" : row.unidad?.value : '004',
          "cons_tabbas": "BAS",
          "tipoentidad": 'PROVEEDOR',
          "tipe_codigo": 2,
          "profit_local": row.profit ?? 0,
          "profit_fijo": row.profit ?? 0,
          "profitminimo": row.profitminimo ?? 0,
          "tipoprofitm": row.tipoprofitm,
          "tipomonedam": row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": Number(row.costo) ?? 0,
          "dope_preciotot_prom": Number(row.costo) * cantidad,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "verTarifario": true,
          "puedemodRZ": false,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "msd_editable": true,
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": ventaUnit,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "tipo_codtar": row.tipo_codtar,
          "tipo_tabtar": row.tipo_tabtar,
          "cliente_tariff": row.cliente_tariff,
        }
      } else if (tipo === 'SLI') {

        const cant_cntr = this.serviciosytarifas_dataflete
          .filter(item => item.ESTADO_OBJ !== 'D')
          .reduce((total, item) => total + (item.dcot_cantidad || 0), 0) || 1;
        let cantidad = unidadCodigo === '002' ? cant_cntr : 1;
        const tipecodigo = this.obtenerCodigoPorEntidad(row.linea?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        const tipe = this.obtenerCodigoPorEntidad(row.linea?.value ?? row.entc_codigo, 'tipe')
        let ventaTotal = ventaUnit * cantidad;
        let costoTotal = costo_tariff * cantidad;

        if (row?.tariff_accion === 'PRINCIPAL') {
          const hijos = this.dataTableTarifaServicioLogistico.filter(item => item.tariff_accion === 'HIJO' && item.codigo_grupo === row.codigo_grupo);

          console.log("tarif_hijo", hijos)

          let totalCosto = 0;
          let totalVenta = 0;

          for (let i = 0; i < hijos.length; i++) {

            const hijo = hijos[i];
            const codBase = hijo.unidad?.value || hijo.cons_codbas;
            const canti = await this.calcularCantidadBase(codBase, i, 'servicios_sli', { soloRetornar: true }) || 0;
            cantidad = Math.min(cantidad, Number(canti)); // para almacenar la cantidad mayor
            const costoUnitario = Number(hijo.costo) || 0;

            const ventaUnitario = hijo.tipo_codmndventa === '001' ? Number(hijo.montoventadolares) : Number(hijo.venta) || 0;
            const costoTotalFila = canti * costoUnitario;
            const ventaTotalFila = canti * ventaUnitario;

            totalCosto += costoTotalFila;
            totalVenta += ventaTotalFila;
          }

          costoTotal = totalCosto;
          ventaTotal = totalVenta;

          // reescribir para que salga el total como unitario
          ventaUnit = ventaTotal;
          costo_tariff = costoTotal;
        }

        item = {
          "cons_desc_spa": row.unidad?.label ?? row.cons_desc_spa,
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": ventaTotal,
          "dope_preciounitvta": ventaUnit,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costoTotal,
          "entc_razonsocial": this.adicional === false || this.adicional === null ? row.proveedor?.label : (Number(row.servicio?.value) === 1107 ? row.proveedor?.label : { label: row.proveedor?.label || row.entc_razonsocial, value: row.proveedor?.value?.toString() || row.entc_codigo.toString(), tipo: 'PROVEEDOR' }),
          "entc_codigo": row.proveedor?.value ?? row.entc_codigo,
          "nombremnd": row.descripcion_monedacosto,
          "nombremndvta": row.descripcion_monedaventa,
          "serv_nombre_spa": row.servicio?.label ?? row.serv_nombre_spa,
          "serv_codigo": row.servicio?.value ?? row.serv_codigo,
          "tipo_codmnd": row.tipo_codmndcosto,
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": row.tipo_codmndventa,
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_codbas": row.unidad?.value ?? row.cons_codbas,
          "cons_tabbas": "BAS",
          "tipoentidad": row.tipo_entidad?.label ?? 'PROVEEDOR',
          "tipe_codigo": String(row.tipo_entidad?.value) ?? 2,
          "profit_local": row.profit ?? 0,
          "profit_fijo": row.profit ?? 0,
          "profitminimo": row.profitminimo ?? 0,
          "tipoprofitm": row.tipoprofitm,
          "tipomonedam": row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": costo_tariff,
          "dope_preciotot_prom": costoTotal,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "verTarifario": true,
          "puedemodRZ": false,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "msd_editable": true,
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": ventaUnit,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "tipo_codtar": row.tipo_codtar,
          "tipo_tabtar": row.tipo_tabtar,
          "cliente_tariff": row.cliente_tariff,
        }
      } else if (tipo === 'AGE') {
        if (this.group_servicioslocales?.value?.montocif === null && row.concepto?.value === '001' && this.group_datosgenerales.get('regimen')?.value === '001') {
          row.select = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'Para agregar agentes de aduana, primero debe ingresar el monto CIF en el servicio local.', life: 5000, key: "tl" });
          return;
        }
        if (this.group_servicioslocales?.value?.montodam === null && row.concepto?.value === '002') {
          row.select = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'Para agregar agentes de aduana, primero debe ingresar el monto DAM en el servicio local.', life: 5000, key: "tl" });
          return;
        }
        const cantidad = 1;
        const tipecodigo = this.obtenerCodigoPorEntidad(row.agente?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        let profit_minimo = 0; let tipo_profit = 0;
        const tipe = this.obtenerCodigoPorEntidad(row.agente?.value ?? row.entc_codigo, 'tipe')
        const montocif = this.group_servicioslocales?.value?.montocif;
        const montodam = this.group_servicioslocales?.value?.montocif;
        let valorfvta = 0
        let valorfcosto = 0
        if (montocif !== null && row.concepto?.value === '001') { //&& 
          const costo = this.calcularValor(row.tipo_codmndcosto, row.costo, row.tipocambioventa)
          const venta = this.calcularValor(row.tipo_codmndventa, row.venta, row.tipocambioventa)

          const costopm = row.tipo_codmndcosto === null ? 0 : row.tipo_codmndcosto !== '004' ? costo : montocif * costo
          const ventapm = row.tipo_codmndventa === null ? 0 : row.tipo_codmndventa !== '004' ? venta : montocif * venta

          let costominc: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '003')?.costo ?? 0;
          let profiminc: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '003')?.profitminimo ?? 0;
          let tipoprofitm: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '003')?.tipo_codmndprofit ?? 0;

          // let gastoopec: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '004')?.costo ?? 0;

          let costominv: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '003')?.venta ?? 0;
          // let gastoopev: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(row.agente?.value) && f.concepto?.value === '004')?.venta ?? 0;

          // valorfcosto = Number(costopm) > Number(costominc) ? Number(costopm) + Number(gastoopec) : Number(costominc) + Number(gastoopec)
          // valorfvta = Number(ventapm) > Number(costominv) ? Number(ventapm) + Number(gastoopev) : Number(costominv) + Number(gastoopev)

          // valorfcosto = Number(costopm) > Number(costominc) ? Number(costopm) : Number(costominc)
          // valorfvta = Number(ventapm) > Number(costominv) ? Number(ventapm) : Number(costominv)

          if (Number(costopm) > Number(costominc)) {
            valorfcosto = Number(costopm);
            // profit_minimo = row.profitminimo;
            profit_minimo = row.profit;
            //tipo_profit = row.tipoprofitm;
            tipo_profit = row.tipo_codmndprofit;
          } else {
            valorfcosto = Number(costominc);
            profit_minimo = profiminc;
            tipo_profit = tipoprofitm;
          }

          if (Number(ventapm) > Number(costominv)) {
            valorfvta = Number(ventapm);
          } else {
            valorfvta = Number(costominv);
          }
        }
        if (montodam !== null && row.concepto?.value === '002') {
          valorfcosto = this.calcularValor(row.tipo_codmndcosto, row.costo, row.tipocambioventa)
          valorfvta = this.calcularValor(row.tipo_codmndventa, row.venta, row.tipocambioventa)
        }
        if (row.concepto?.value !== '001' && row.concepto?.value !== '002') {
          valorfcosto = this.calcularValor(row.tipo_codmndcosto, row.costo, row.tipocambioventa)
          valorfvta = this.calcularValor(row.tipo_codmndventa, row.venta, row.tipocambioventa)
        }

        const costo_tariff = Number(Math.round(valorfcosto * 100) / 100);
        const venta_tariff = Math.round(valorfvta * 100) / 100;
        item = {
          "cons_desc_spa": { label: 'CONTENEDOR', tipovalue: "BAS", value: "002" },
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": (Math.round(valorfvta * 100) / 100) * cantidad,
          "dope_preciounitvta": Math.round(valorfvta * 100) / 100,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costo_tariff * cantidad,
          "entc_razonsocial": this.adicional === true ? { label: row.agente?.label || row.entc_razonsocial, value: String(row.agente?.value) || row.entc_codigo.toString(), tipo: 'PROVEEDOR' } : row.agente?.label,
          "entc_codigo": row.agente?.value ?? row.entc_codigo,
          "nombremnd": "USD",
          "nombremndvta": "USD",
          "serv_nombre_spa": row.servicio?.label ?? row.serv_nombre_spa,
          "serv_codigo": row.servicio?.value ?? row.serv_codigo,
          "tipo_codmnd": "002",
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": "002",
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_codbas": "002",
          "cons_tabbas": "BAS",
          "tipoentidad": 'PROVEEDOR',
          "tipe_codigo": 2,
          "profit_local": profit_minimo ?? 0,//row.profit ?? 0,
          "profit_fijo": profit_minimo ?? 0,//row.profit ?? 0,
          "profitminimo": profit_minimo ?? 0, //row.profitminimo ?? 0,
          "tipoprofitm": tipo_profit,//row.tipoprofitm,
          "tipomonedam": row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": Number(Math.round(valorfcosto * 100) / 100) ?? 0,
          "dope_preciotot_prom": Number(Math.round(valorfcosto * 100) / 100) * cantidad,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "verTarifario": true,
          "puedemodRZ": false,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "msd_editable": true,
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": venta_tariff,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "tipo_codtar": row.tipo_codtar,
          "tipo_tabtar": row.tipo_tabtar,
          "cliente_tariff": row.cliente_tariff,
        }
      } else if (tipo === 'EXT' || tipo === 'TC') {
        const cantidad =
          unidadCodigo === '002'
            ? this.serviciosytarifas_dataflete
              .filter(item => item.estado_obj !== 'D')
              .reduce((total, item) => total + (item.dcot_cantidad || 0), 0) || 1 : 1;

        const tipecodigo = this.obtenerCodigoPorEntidad(row.proveedor?.value ?? row.entc_codigo, 'codigo')
        const tipoentidadObj = this.ListaTipoEntidad.find(
          t => Number(t.value) === Number(tipecodigo)
        );
        const tipe = this.obtenerCodigoPorEntidad(row.proveedor?.value ?? row.entc_codigo, 'tipe')
        const condicion = this.group_serviciostarifa.get('condicion')?.value;
        item = {
          "cons_desc_spa": row.unidad?.label,
          "ctar_codigo": row.ctaR_Codigo,
          "dtar_codigo": row.dtar_Codigo,
          "rtar_codigo": row.rtar_Codigo,
          "cope_codigo": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          "cope_version": (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          "dope_item": siguienteDope,
          "dope_cantidad": cantidad,
          "dope_preciototvta": ventaUnit * cantidad,
          "dope_preciounitvta": ventaUnit,
          "dope_preciounitcosto": costo_tariff,
          "dope_preciototcosto": costo_tariff * cantidad,
          "entc_razonsocial": this.adicional === true ? { label: row.proveedor?.label || row.proveedor, value: String(row.proveedor?.value) || row.entc_codigo.toString(), tipo: 'PROVEEDOR' } : row.proveedor?.label,
          "entc_codigo": row.proveedor?.value ?? row.entc_codigo,
          "nombremnd": row.descripcion_monedacosto,
          "nombremndvta": row.descripcion_monedaventa,
          "serv_nombre_spa": row.servicio?.label ?? row.serv_nombre_spa,
          "serv_codigo": row.servicio?.value ?? row.serv_codigo,
          "tipo_codmnd": row.tipo_codmndcosto,
          "tipo_tabmnd": row.tipo_tabmndcosto,
          "tipo_tabmndventa": row.tipo_tabmndventa,
          "tipo_codmndventa": row.tipo_codmndventa,
          "tipocambioventa": row.tipocambioventa,
          "tipocambiocompra": row.tipocambiocompra,
          "cons_codbas": row.unidad?.value,
          "cons_tabbas": "BAS",
          "tipoentidad": 'PROVEEDOR',
          "tipe_codigo": 2,
          "profit_local": row.profit ?? 0,
          "profit_fijo": row.profit ?? 0,
          "profitminimo": row.profitminimo ?? 0,
          "tipoprofitm": row.tipoprofitm,
          "tipomonedam": row.tipomonedam,
          "tipo_tabmndprofit": row.tipo_tabmndprofit,
          "tipo_codmndprofit": row.tipo_codmndprofit,
          "agrupado": false,
          "cod_padre": null,
          "cons_codtds": row.cons_codtds,
          "cons_tabtds": row.cons_tabtds,
          "tipodeservicio": row.tipodeservicio,
          "cons_codlng": '003',
          "cons_tablng": 'LNG',
          "cons_desclng": 'SERVICIO INTEGRADO LOCAL',
          "fechaoperacion": new Date(),
          "cons_codest": '001',
          "dope_preciounit_prom": Number(row.costo) ?? 0,
          "dope_preciotot_prom": Number(row.costo) * cantidad,
          "dope_itemchangecontrol": null,
          "puedechangecontrol": false,
          "verTarifario": true,
          "puedemodRZ": false,
          "desctarifa": row.desctarifa,
          "vigencias": row.vigencias,
          "ESTADO_OBJ": 'I',
          "msd_editable": true,
          "costo_tarifa_original": costo_tariff,
          "venta_tarifa_original": ventaUnit,
          "cod_mnd_venta_tariff_original": row.tipo_codmndventa,
          "tab_mnd_venta_tariff_original": row.tipo_tabmndventa,
          "desc_mnd_venta_tariff_original": row.descripcion_monedaventa,
          "tipo_codtar": row.tipo_codtar,
          "tipo_tabtar": row.tipo_tabtar,
          "cliente_tariff": row.cliente_tariff,
        }
      }

      if (tiposValidos.includes(tipo) && accion === 'I' && row.select == true) {
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Se agregó un nuevo Servicio SLI.', life: 3000, key: "tl" });
      }

      if (accion === 'I') {
        this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle, item];
      } else if (accion === 'A') {
        this.edicion = true;
        this.tablaAgrupados = [...this.tablaAgrupados, row];
        this.agrupar = this.tablaAgrupados.length > 1 ? false : true;
        this.edicion = this.tablaAgrupados.length === 0 ? false : true;
        this.prefacturar = this.tablaAgrupados.length > 0 ? false : true;
        this.cancelar = this.tablaAgrupados.length > 0 ? false : true;
        this.generaros = this.tablaAgrupados.length > 0 ? this.tablaAgrupados.some(item => item.cons_codest === '005') : true;
      } else if (accion === 'D') {
        this.desagrupar = false;
        this.dope_items.push(row.dope_item);
        this.cope_codigos.push(row.cope_codigo);
      }
    } else {
      if (accion === 'I') {
        let idx2 = -1;
        for (let i = this.servicioslocales_datadetalle.length - 1; i >= 0; i--) {
          const item = this.servicioslocales_datadetalle[i];
          if (
            Number(item.ctar_codigo) === Number(row.ctaR_Codigo) &&
            Number(item.dtar_codigo) === Number(row.dtar_Codigo) &&
            Number(item.rtar_codigo) === Number(row.rtar_Codigo)
          ) {
            idx2 = i;
            break;
          }
        }

        // if (idx2 !== -1) {
        //   this.servicioslocales_datadetalle = [
        //     ...this.servicioslocales_datadetalle.slice(0, idx2),
        //     ...this.servicioslocales_datadetalle.slice(idx2 + 1)
        //   ];
        // }

        if (idx2 !== -1) {
          const item = this.servicioslocales_datadetalle[idx2];

          if (item.ESTADO_OBJ === 'I') {
            this.servicioslocales_datadetalle = [
              ...this.servicioslocales_datadetalle.slice(0, idx2),
              ...this.servicioslocales_datadetalle.slice(idx2 + 1)
            ];
          } else if (item.ESTADO_OBJ === 'D') {
            return;
          } else {
            // this.servicioslocales_datadetalle[idx2].ESTADO_OBJ = 'D'; no debería hacer nada
          }
        }

      } else if (accion === 'A') {
        let idx = this.tablaAgrupados.findIndex(i =>
          i.dope_item === row.dope_item
          && i.cope_codigo === row.cope_codigo && i.ctar_codigo === row.ctar_codigo
        );

        if (idx === -1) {
          idx = this.tablaAgrupados.findIndex(i => i.dope_item === row.dope_item && i.ctar_codigo === row.ctar_codigo);
        }

        if (idx !== -1) {
          this.tablaAgrupados = [
            ...this.tablaAgrupados.slice(0, idx),
            ...this.tablaAgrupados.slice(idx + 1)
          ];
        }
        if (this.tablaAgrupados.length < 2) {
          this.agrupar = true;
        }
        this.edicion = this.tablaAgrupados.length === 0 ? false : true;
        this.prefacturar = this.tablaAgrupados.length === 0 ? true : false;
        this.cancelar = this.tablaAgrupados.length === 0 ? true : false;
        this.generaros = this.tablaAgrupados.length === 0 ? true : this.tablaAgrupados.some(item => item.cons_codest === '005');
      } else if (accion === 'D') {
        this.desagrupar = true;
        const index = this.dope_items.findIndex((dope, i) =>
          dope === row.dope_item && this.cope_codigos[i] === row.cope_codigo
        );

        if (index !== -1) {
          this.dope_items.splice(index, 1);
          this.cope_codigos.splice(index, 1);
        }
      }
    }

  }

  listadoOriginal: any[] = []
  listadoOriginalAgrupados: any[] = []
  eliminarServicio(row, tipo) {
    this.confirmationService.confirm({
      target: event.target as HTMLElement,
      key: 'DT',
      message: "¿ESTÁ SEGURO QUE DESEA CONTINUAR?",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if (tipo === 'D') {
          for (let i = this.servicioslocales_datadetalle.length - 1; i >= 0; i--) {
            const item = this.servicioslocales_datadetalle[i];

            if (item?.dope_item === row.dope_item) {
              if (item.ESTADO_OBJ === 'I') {
                this.servicioslocales_datadetalle.splice(i, 1);
              } else if (item.ESTADO_OBJ === undefined || item.ESTADO_OBJ === 'U' || item.ESTADO_OBJ === 'NA') {
                item.ESTADO_OBJ = 'D';
              }
            }

            else if (row.agrupado && row.cod_padre === null && row.ESTADO_OBJ === 'I') {
              if (item.cod_padre === row.dope_item && item.ESTADO_OBJ === 'A') {
                const encontrado = this.listadoOriginal.find(o =>
                  o.dope_item === item.dope_item &&
                  o.cope_codigo === item.cope_codigo
                );

                if (encontrado) {
                  item.ESTADO_OBJ = 'D';
                } else {
                  this.servicioslocales_datadetalle.splice(i, 1);
                }
              }
            }
          }
        } else if (tipo === 'A') {
          for (let i = this.tablaAgrupados.length - 1; i >= 0; i--) {
            if (this.tablaAgrupados[i].cod_padre === row.dope_item) {
              this.tablaAgrupados.splice(i, 1);
            }
          }

          for (let i = this.servicioslocales_detalleAgrupacion.length - 1; i >= 0; i--) {
            const item = this.servicioslocales_detalleAgrupacion[i];
            if (item?.dope_item === row.dope_item) {
              const encontrado = this.listadoOriginalAgrupados.find(o =>
                o.dope_item === item.dope_item && o.cope_codigo === item.cope_codigo
              )?.dope_item;
              if (encontrado != null || encontrado !== undefined) {
                item.ESTADO_OBJ = 'E';
              } else {
                this.servicioslocales_detalleAgrupacion.splice(i, 1);
              }
            }
          }
          for (let i = this.servicioslocales_datadetalle.length - 1; i >= 0; i--) {
            const item = this.servicioslocales_datadetalle[i];
            if (item?.cod_padre === row.dope_item) {
              const existeEnOriginal = this.listadoOriginal.some(o =>
                o.dope_item === item.dope_item && o.serv_codigo === item.serv_codigo && o.entc_codigo === item.entc_codigo
              );
              if (existeEnOriginal) {
                item.ESTADO_OBJ = 'D';
              } else {
                if (!item.cons_codest) {
                  item.ESTADO_OBJ = 'D';
                } else {
                  this.servicioslocales_datadetalle.splice(i, 1);
                }
              }
            }
          }
        }

        this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle];
        this.tablaAgrupados = [...this.tablaAgrupados];
        this.servicioslocales_detalleAgrupacion = [...this.servicioslocales_detalleAgrupacion];
        this.confirmationService.close();
      },
      reject: () => { this.confirmationService.close(); }
    })
  }

  visibleAuth: boolean;
  groupAuth: FormGroup
  tipoAuth: any[] = [
    { key: 'U', name: 'Usuario' },
    { key: 'T', name: 'Token' }
  ]
  modoT: boolean = false;
  mensajeError: string;
  mensajeIntento: string;
  mostrarModAuth(event) {
    if (event === 'U') {
      this.modoT = false;
      this.groupAuth.get('usuario')?.setValidators([Validators.required]);
      this.groupAuth.get('contrasenia')?.setValidators([Validators.required]);
      this.groupAuth.get('token')?.clearValidators();
      this.groupAuth.get('token')?.updateValueAndValidity();
      this.groupAuth.get('token')?.reset();
      this.mensajeError = null
    } else {
      this.modoT = true;
      this.groupAuth.get('token')?.setValidators([Validators.required]);
      this.groupAuth.get('usuario')?.clearValidators();
      this.groupAuth.get('usuario')?.updateValueAndValidity();
      this.groupAuth.get('usuario')?.reset();
      this.groupAuth.get('contrasenia')?.clearValidators();
      this.groupAuth.get('contrasenia')?.updateValueAndValidity();
      this.groupAuth.get('contrasenia')?.reset();
      this.mensajeError = 'Este campo es obligatorio'
    }
  }

  rowAuth: any[] = [];
  btnToken: boolean = true;
  SolicitarAutorizacion(row) {
    this.rowAuth = [];
    this.groupAuth.reset();
    // if (['9', '2', '1', '15', '1030', '4', '14', '10', this.gerentLog, this.coordLog].filter(Boolean).includes(this.rol)) {
    if (
      this.listadoRoles?.some(r =>
        ['9', '2', '1', '15', '1030', '4', '14', '10', this.gerentLog, this.coordLog]
          .filter(Boolean)
          .map(x => String(x))
          .includes(String(r.role_codigo))
      )
    ) {
      this.visibleAuth = true
      this.groupAuth.get('tipoauth').setValue('U');
      if (row?.row) {
        this.rowAuth = row?.row;
        const Request: ConsultarVigenciaTokenRequest = <ConsultarVigenciaTokenRequest>{}
        Request.COPE_Codigo = this.rowAuth['cope_codigo'];
        Request.DOPE_Item = this.rowAuth['dope_item'];
        Request.SERV_Codigo = this.rowAuth['serv_nombre_spa']?.value ? this.rowAuth['serv_nombre_spa']?.value : this.rowAuth['serv_codigo'];
        Request.AUDI_Usuario = 'ext_ichumpitaz' //this.storage.get('usuario');
        Request.ENTC_CodCliente = this.group_datosgenerales.get('cliente')?.value ?
          Number(this.ListaTodosCliente.find(cliente => cliente.nombre === this.group_datosgenerales.get('cliente')?.value)?.codigo) || 0 :
          null;
        Request.monto_solicitado = this.adicional === true ? this.rowAuth['dope_preciounitcosto'] : this.rowAuth['dope_preciounitvta'];
        this.ordenventaService.ConsultarVigenciaToken(Request).subscribe(response => {
          if (response.datos.status === 200) {
            switch (response.datos.result[0].vigencia) {
              case 'NV':
                this.btnToken = true;
                break;
              default:
                this.btnToken = false;
                this.mensajeIntento = `Le quedan solo ${response.datos.result[0].vigencia} intentos para ingresar el token.`;
            }
          }
        })
      }
    } else {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Sin permisos', detail: 'No cuenta con permisos suficientes para realizar esta acción.', life: 3000, key: "tl" });
    }
  }

  intentoU: number = 0;
  async AutorizarCambioVenta(accion) {
    const Request: TransaccionAuthCambioVtaRequest = <TransaccionAuthCambioVtaRequest>{}
    Request.COPE_Codigo = this.rowAuth['cope_codigo'];
    Request.DOPE_Item = this.rowAuth['dope_item'];
    Request.SERV_Codigo = this.rowAuth['serv_nombre_spa']?.value ? this.rowAuth['serv_nombre_spa']?.value : this.rowAuth['serv_codigo'];
    Request.AUDI_Usuario = 'ext_ichumpitaz'//this.storage.get('usuario');
    Request.token = this.groupAuth.get('token').value;
    Request.usuario_autoriza = this.groupAuth.get('usuario').value;
    Request.monto_solicitado = this.adicional === true ? this.rowAuth['dope_preciounitcosto'] : this.rowAuth['dope_preciounitvta'];
    Request.ENTC_CodCliente = this.group_datosgenerales.get('cliente')?.value ?
      Number(this.ListaTodosCliente.find(cliente => cliente.nombre === this.group_datosgenerales.get('cliente')?.value)?.codigo) || 0 :
      null;
    Request.monto_original = this.adicional === true ? this.rowAuth['dope_preciounit_prom'] : this.monto_original;
    Request.tipoAuth = this.adicional === true ? 'C' : 'V'
    if (this.groupAuth.get('tipoauth').value === 'U') {
      const datosLogin = await this.login();
      const esTodoNull = Object.values(datosLogin).every(value => value === null);
      if (esTodoNull) {
        this.intentoU++;
        Request.tipo = accion === 'N' ? 'N' : null;
        if (this.intentoU >= 3) {
          this.visibleAuth = false;
          this.intentoU = 0;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Se acabaron los intentos, vuelva a intentarlo más tarde.', life: 3000, key: "tl" });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Credenciales incorrectas', life: 3000, key: "tl" });
        }
      } else {
        switch (datosLogin['codigoRol']) {
          case 1:
          case 10:
          case 11:
          case 14:
            Request.tipo = accion === 'A' ? this.groupAuth.get('tipoauth').value : accion;
            break;
          default:
            this.intentoU++;
            if (this.intentoU >= 3) {
              this.visibleAuth = false;
              this.intentoU = 0;
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Se acabaron los intentos, vuelva a intentarlo más tarde.', life: 3000, key: "tl" });
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No cuenta con permisos suficientes para realizar esta acción.', life: 3000, key: "tl" });
            }
            break;
        }
      }
    } else {
      Request.tipo = accion === 'A' ? this.groupAuth.get('tipoauth').value : accion;
    }

    this.ordenventaService.TransaccionAuthCVta(Request).subscribe(response => {
      if (response.datos.status === 200) {
        const mensaje = response.datos.result
        const cv = this.adicional === true ? "costo real" : "venta";
        switch (mensaje) {
          case 'OK':
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'OK', detail: `Se autorizó el cambio de ${cv} correctamente.`, life: 3000, key: "tl" });
            this.visibleAuth = false;
            this.btnToken = true;
            this.mensajeIntento = 'Token correcto.';
            this.groupAuth.reset();
            this.dtServiciosRefdt.onRowEditSave(this.rowAuth, this.rowAuth['key'] - 1);
            this.intentoU = 0;
            this.dtServiciosRefdt.erroresValidacion = {}
            break;
          case 'NV':
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'No vigente', detail: 'Se acabó el tiempo de vigencia de este token, genere uno nuevo.', life: 3000, key: "tl" });
            this.btnToken = true;
            this.groupAuth.get('token').setValue(null);
            break;
          case 'NA':
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Falta generar Token', detail: 'No se ha generado ningún Token para este servicio.', life: 3000, key: "tl" });
            this.btnToken = true;
            this.groupAuth.get('token').setValue(null);
            break;
          case 'DT':
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'No autorizado', detail: `No se autorizó el cambio de ${cv}.`, life: 3000, key: "tl" });
            this.visibleAuth = false;
            this.btnToken = true;
            this.groupAuth.reset();
            const index = this.servicioslocales_datadetalle.findIndex(d => d['key'] === this.rowAuth['key']);
            const key = this.dtServiciosRefdt.key
            if (this.dtServiciosRefdt.clonedProducts[key] === undefined || this.dtServiciosRefdt.clonedProducts[key] === null) {
              this.dtServiciosRefdt.erroresValidacion = {}
              // this.dtServiciosRefdt.clonedProducts[key] = JSON.parse(JSON.stringify(this.rowAuth));
              this.dtServiciosRefdt.onRowEditCancel(this.rowAuth, index);
            } else {
              this.dtServiciosRefdt.onRowEditCancel(this.dtServiciosRefdt.clonedProducts['key'], this.dtServiciosRefdt.clonedProducts['key'] - 1);
            }
            this.groupAuth.reset();
            this.intentoU = 0;
            break;
          case 'AU':
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'OK', detail: `Se autorizó el cambio de ${cv} correctamente.`, life: 3000, key: "tl" });
            this.visibleAuth = false;
            this.btnToken = true;
            this.groupAuth.reset();
            this.dtServiciosRefdt.onRowEditSave(this.rowAuth, this.rowAuth['key'] - 1);
            this.intentoU = 0;
            this.dtServiciosRefdt.erroresValidacion = {}
            break;
          case '0':
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Token incorrecto', detail: 'Se ha acabado el número de intentos para este token, genere uno nuevo.', life: 3000, key: "tl" });
            this.visibleAuth = false;
            this.groupAuth.get('token').setValue(null);
            break;
          default:
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Token incorrecto', detail: 'El token no coincide, vuelva a intentarlo.', life: 3000, key: "tl" });
            this.btnToken = false;
            this.mensajeIntento = `Le quedan solo ${mensaje} intentos para ingresar el token.`;
            this.groupAuth.get('token').setValue(null);
            break;
        }
      }
    })
  }

  async login() {
    const values = this.groupAuth.value;
    const Request: ListarDatosLoginRequest = {
      Usuario: values.usuario,
      Clave: values.contrasenia
    };
    const response = await firstValueFrom(this.ordenventaService.ListarDatosLogin(Request));
    if (response.datos.status === 200) {
      return response.datos.result[0];
    }
    return []
  }

  GenerarTokenAuth() {
    if (this.rowAuth != null || this.rowAuth != undefined) {
      const costoDolares = this.rowAuth['tipo_codmnd'] === '001'
        ? Number(this.rowAuth['dope_preciounitcosto']) / Number(this.rowAuth['tipocambioventa'])
        : Number(this.rowAuth['dope_preciounitcosto']);
      const ventaOrigin = Number(this.rowAuth['profit_fijo']) + Number(costoDolares.toFixed(2));
      const cv = this.adicional === true ? "costo" : "flete";
      const Request: GenerarTokenAutorizacionRequest = <GenerarTokenAutorizacionRequest>{}
      Request.COPE_Codigo = this.rowAuth['cope_codigo'];
      Request.DOPE_Item = this.rowAuth['dope_item'];
      Request.SERV_Codigo = this.rowAuth['serv_nombre_spa']?.value ? this.rowAuth['serv_nombre_spa']?.value : this.rowAuth['serv_codigo'];
      Request.AUDI_Usuario = 'ext_ichumpitaz'//this.storage.get('usuario');
      Request.CCOT_NumDoc = this.datosRecibidos?.ccot_numdoc || null
      Request.ventaTarifa = this.adicional === true ? Number(this.rowAuth['dope_preciounit_prom']) : ventaOrigin;
      Request.ventaSolicitada = this.adicional === true ? Number(this.rowAuth['dope_preciounitcosto']) : Number(this.rowAuth['dope_preciounitvta']);;
      Request.asunto = this.datosRecibidos?.ccot_numdoc != null || this.datosRecibidos?.ccot_numdoc != undefined ?
        `(PRUEBA)Solicito autorización para cambio de ${cv} - Orden Venta ${this.datosRecibidos?.ccot_numdoc}` :
        `(PRUEBA)Solicito autorización para cambio de ${cv} - Cliente ${this.group_servicioslocales.value.clienteDSL}`
      Request.servicio = this.rowAuth['serv_nombre_spa']?.label ? this.rowAuth['serv_nombre_spa']?.label : this.rowAuth['serv_nombre_spa'];
      Request.monedaVenta = this.adicional === true ? this.ListaTodosMoneda.find(m => m.codigo === this.rowAuth['nombremnd']?.value || this.rowAuth['tipo_codmnd'])?.adicional2 : this.ListaTodosMoneda.find(m => m.codigo === this.rowAuth['nombremndvta']?.value || this.rowAuth['tipo_codmndventa'])?.adicional2;
      Request.ENTC_CodCliente = this.group_datosgenerales.get('cliente')?.value ?
        Number(this.ListaTodosCliente.find(cliente => cliente.nombre === this.group_datosgenerales.get('cliente')?.value)?.codigo) || 0 :
        null;
      Request.monto_solicitado = this.adicional === true ? Number(this.rowAuth['dope_preciounitcosto']) : Number(this.rowAuth['dope_preciounitvta']);
      Request.nombreCliente = this.group_datosgenerales.value.cliente
      Request.tipoAuth = this.adicional === true ? 'C' : 'V';
      this.ordenventaService.GenerarTokenAutorizacion(Request).subscribe(response => {
        if (response.datos.status === 200) {
          this.messageService.clear();
          this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Se generó el token de autorización correctamente. Solicite a su supervisor.', life: 3000, key: "tl" });
          this.btnToken = false
          this.mensajeIntento = "Solo tiene 3 intentos para ingresar el token."
        }
      }, (errorServicio) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: errorServicio.error.meta.mensaje, life: 3000, key: "tl" });
      })
    }
  }

  confirmarContinuar(mensaje: string): Promise<boolean> {
    return new Promise(resolve => {
      this.confirmationService.confirm({
        message: mensaje,
        icon: 'pi pi-exclamation-triangle',
        key: 'C',
        rejectButtonProps: {
          label: 'Cancelar',
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: 'Continuar',
        },
        header: 'Confirmation',
        closable: false,
        closeOnEscape: false,
        accept: () => resolve(true),
        reject: () => resolve(false),
      })
    });
  }

  viewTarifas(row) {
    this.modovisualizar = false;
    this.agrupar = true;
    this.desagrupar = true;

    this.leyendasTblSLI = structuredClone(this.leyendasAgrupacionRow);

    this.temp_servicioslocales_datadetalle = [...this.servicioslocales_datadetalle];
    if (row.row.cope_codigo !== null) {
      // const datosFiltradosOriginal = this.temp_servicioslocales_datadetalle
      //   .filter(item => item.cod_padre === row.row.dope_item && item.cope_codigo === row.row.cope_codigo);
      // const datosFiltrados = datosFiltradosOriginal.map(item => ({ ...item, ESTADO_OBJ: item.ESTADO_OBJ === 'A' ? '' : item.ESTADO_OBJ }));

      const datosActualizar = this.temp_servicioslocales_datadetalle
        .filter(item => item.cod_padre === row.row.dope_item && item.cope_codigo === row.row.cope_codigo)
        .map(item => ({
          ...item,
          ESTADO_OBJ: item.ESTADO_OBJ === 'A' ? '' : item.ESTADO_OBJ
        }));

      const datosNormales = this.temp_servicioslocales_datadetalle
        .filter(item => !(item.cod_padre === row.row.dope_item && item.cope_codigo === row.row.cope_codigo));

      const datosUnificados = [...datosNormales, ...datosActualizar];

      if (datosActualizar.length > 0) {
        this.servicioslocales_datadetalle = [...datosUnificados];
      } else {
        const Request: ListarAgrupacionRequest = <ListarAgrupacionRequest>{};
        Request.CODE_Agrupador = row.row.dope_item;
        Request.COPE_Codigo = row.row.cope_codigo;

        this.ordenventaService.ListarAgrupacion(Request).subscribe(response => {
          if (response.datos.status === 200) {
            const datosActualizar = response.datos.result.map(item => {
              return {
                ...item,
                ESTADO_OBJ: '',
                tipoentidad: item.tipoentidad?.toUpperCase()
              }
            });

            const datosNormales = this.temp_servicioslocales_datadetalle.filter(tempItem =>
              !datosActualizar.some(actualizarItem =>
                tempItem.cope_codigo === actualizarItem.cope_codigo &&
                tempItem.dope_item === actualizarItem.dope_item
              )
            );

            const datosUnificados = [...datosNormales, ...datosActualizar];
            this.servicioslocales_datadetalle = [...datosUnificados];

            // this.servicioslocales_datadetalle = [...datosModificados];
          }
        }, (errorServicio) => {
          this.servicioslocales_datadetalle = [];
        });
      }

    } else {
      //cope_codigo es null → solo filtrar por cod_padre
      // const datosFiltradosOriginal = this.temp_servicioslocales_datadetalle
      //   .filter(item => item.cod_padre === row.row.dope_item)
      // const datosFiltrados = datosFiltradosOriginal.map(item => ({ ...item, ESTADO_OBJ: item.ESTADO_OBJ === 'A' ? '' : item.ESTADO_OBJ }));

      // this.servicioslocales_datadetalle = [...datosFiltrados];


      const datosActualizar = this.temp_servicioslocales_datadetalle
        .filter(item => item.cod_padre === row.row.dope_item)
        .map(item => ({
          ...item,
          ESTADO_OBJ: item.ESTADO_OBJ === 'A' ? '' : item.ESTADO_OBJ
        }));

      const datosNormales = this.temp_servicioslocales_datadetalle
        .filter(item => item.cod_padre !== row.row.dope_item);

      this.servicioslocales_datadetalle = [...datosNormales, ...datosActualizar];

    }
  }

  onExpanded: boolean = false;
  prefacturar: boolean = true;
  cancelar: boolean = true;
  generaros: boolean = true;
  viewPoppupPrefacturacion: boolean;
  verPoppup: boolean = false;
  data_pf: any;
  cargandoPrefactura: boolean = false;
  async PrefacturarServicios(accion) {
    if (accion === 'A') {
      if (this.validarCambios('PRF')) {
        return; // ⬅ Detenemos ejecución
      }
      if ((this.datosRecibidos?.doov_hbl === null || this.datosRecibidos?.doov_hbl === '' || this.datosRecibidos?.doov_hbl === undefined) && this.group_datosgenerales.get('via')?.value !== '003') {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'No se ha definido un HBL para esta orden de venta. Por favor, verifique.', life: 3000, key: "tl" });
        return;
      }

      const valores = this.tablaAgrupados.map(item => item.nombremndvta?.value !== undefined ? item.nombremndvta.value : item.tipo_codmndventa ?? null);
      const valorBase = valores[0];
      const existeDiferente = valores.some(v => v !== valorBase);

      // if (existeDiferente) {
      //   this.messageService.clear();
      //   this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'No se puede prefacturar en grupo servicios con distintas Monedas de Venta.', life: 3000, key: "tl" });
      //   return;
      // }

      this.data_pf = null;
      const Request: ConsultarProfitTCambioRequest = <ConsultarProfitTCambioRequest>{}
      Request.SERV_Codigo = this.tablaAgrupados[0].serv_codigo
      Request.tipo = "TC"
      this.cargandoPrefactura = true;
      try {
        const response = await firstValueFrom(this.ordenventaService.ConsultarTCambio(Request));
        if (response?.datos?.status === 200) {
          const copecodigo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0
          localStorage.setItem("copeCodigo", JSON.stringify(copecodigo));
          localStorage.setItem("dataservicio", JSON.stringify(this.tablaAgrupados));
          localStorage.setItem("dataov", JSON.stringify(this.datosRecibidos));
          this.data_pf = {
            operacion: this.datosRecibidos["listadooperaciones"][0],
            cod_lng: this.tablaAgrupados[0].cons_codlng,
          }
          // this.viewPoppupPrefacturacion = true;
          this.cdr.detectChanges();

          setTimeout(() => {
            this.viewPoppupPrefacturacion = true;
            this.cdr.detectChanges();
          }, 50);
        }
      } catch (error) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'El tipo de cambio de venta no está definido para el día de hoy. Por favor, verifique.', life: 3000, key: "tl" });
      } finally {
        this.cargandoPrefactura = false;
        this.cdr.detectChanges();
      }
    } else {
      // this.servicioslocales_datadetalle = JSON.parse(JSON.stringify(this.servicioslocales_datadetalle));
      this.tablaAgrupados = []
      this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle]
      this.viewPoppupPrefacturacion = false;
      this.edicion = false;
      this.prefacturar = true;
      this.cancelar = true;
      this.agrupar = true;
      this.generaros = true;
      this.toggleSeleccionarTodos({ target: { checked: false } } as unknown as Event);
    }
  }

  manejoEventoPrefacturacion(evento: any) {
    if (evento?.severity === 'success') {
      this.PrefacturarServicios('C');
      this.messageService.clear();
      this.messageService.add(evento);
      this.listarOPCambios();
    }
  }

  async saveOperaciones(event?: Event) {

    let botonElemento: HTMLButtonElement | null = null;
    if (event) {
      botonElemento = event.currentTarget as HTMLButtonElement;
      botonElemento.disabled = true;
      botonElemento.style.cursor = 'not-allowed';
    }

    this.resetCosto[2].loading = true;
    this.reset = [...this.resetCosto]

    try {
      const request_sli = <ServiciosLocalesRequest>{};
      const cope_codigo = this.group_servicioslocales.get('codigooperacion')?.value;
      request_sli.ESTADO_OBJ = this.accion === 'NUEVO' ? 'I' : cope_codigo == null || cope_codigo == '' || cope_codigo == 0 ? 'I' : 'U';
      request_sli.cope_codigo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
        this.datosRecibidos["listadooperaciones"].length > 0)
        ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
        : 0;
      request_sli.cope_fecemi = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
        this.datosRecibidos["listadooperaciones"].length > 0)
        ? this.datosRecibidos["listadooperaciones"][0].cope_fecemi
        : new Date();
      // request_sli.cope_numdoc = this.datosRecibidos != null || undefined ? this.datosRecibidos["listadooperaciones"] != null || undefined ? this.datosRecibidos["listadooperaciones"][0].cope_numdoc : null : null;
      // request_sli.cope_fecemi = this.datosRecibidos != null || undefined ? this.datosRecibidos["listadooperaciones"] != null || undefined ? this.datosRecibidos["listadooperaciones"][0].cope_fecemi : new Date() : new Date();
      request_sli.cope_observacion = null;
      request_sli.cope_hbl = this.datosRecibidos != null ? this.datosRecibidos.doov_hbl ?? ' ' : "  ";
      request_sli.ccot_codigo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
        this.datosRecibidos["listadooperaciones"].length > 0)
        ? this.datosRecibidos["listadooperaciones"][0].ccot_codigo
        : null;
      request_sli.ccot_numero = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
        this.datosRecibidos["listadooperaciones"].length > 0)
        ? this.datosRecibidos["listadooperaciones"][0].ccot_numero
        : this.datosRecibidos.ccot_numero ?? 0;
      // request_sli.ccot_codigo = this.datosRecibidos != null || undefined ? this.datosRecibidos.ccot_codigo : null;
      // request_sli.ccot_numero = this.datosRecibidos != null || undefined ? this.datosRecibidos.ccot_numero : null;
      request_sli.ccot_tipo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
        this.datosRecibidos["listadooperaciones"].length > 0)
        ? this.datosRecibidos["listadooperaciones"][0].ccot_tipo
        : this.datosRecibidos.ccot_tipo ?? 0;
      if (request_sli.ESTADO_OBJ == 'I' && this.datosRecibidos && this.datosRecibidos.ccot_numpadre != null) {
        request_sli.ccot_numero = this.datosRecibidos.ccot_numpadre;
        request_sli.ccot_tipo = String(this.datosRecibidos.ccot_tipopadre);
      }
      request_sli.entc_codcliente = this.group_servicioslocales.get('clienteDSL').value == null || this.group_servicioslocales.get('clienteDSL').value == "" ? this.codCliente : this.group_servicioslocales.get('clienteDSL').value;
      request_sli.entc_codtransporte = this.codTransporte;
      request_sli.entc_codagente = this.codAgente;
      request_sli.cons_codestado = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
        this.datosRecibidos["listadooperaciones"]?.length > 0)
        ? this.datosRecibidos["listadooperaciones"][0].cons_codestado
        : '001';
      // this.group_datosgenerales.value["estado"];
      request_sli.cons_tabestado = "OPE";
      request_sli.cope_excepcion = null;
      request_sli.cope_fob = 0.00;
      request_sli.cope_seguro = 0.00;
      request_sli.cope_flete = 0.00;
      request_sli.cope_cif = 0.00;
      request_sli.cope_partarancelaria = 0.00;
      request_sli.cope_ipm = 0.00;
      request_sli.cope_igv = 0.00;
      request_sli.cope_percepcion = 0.00;
      request_sli.cope_tasadespacho = 0.00;
      request_sli.cope_advalorem = 0.00;
      request_sli.cope_1erembarque = null;
      request_sli.audi_usrmod = this.nombreUsuario;
      request_sli.audi_usrcrea = this.nombreUsuario;
      request_sli.tipo_tabmnd = "MND";
      request_sli.tipo_codmnd = this.group_serviciostarifa.value["moneda"]
      request_sli.cons_codcrg = null;  // preguntar a miguel
      request_sli.cons_tabcrg = "CRG";
      request_sli.ccot_codaduana = null;
      request_sli.ccot_codlogistico = null;
      request_sli.ccot_codtransporte = null;
      request_sli.cope_nave = null;
      request_sli.cope_viaje = null;
      request_sli.cope_mbl = request_sli.cope_mbl = this.group_novedades.value["blmaster"] ?? ' ';// preguntar
      request_sli.cope_fechaarribo = null;
      request_sli.cope_cantidaddias = null;
      request_sli.cope_kilos = null;
      request_sli.cope_volumen = null;
      request_sli.cope_preciosada = null;
      request_sli.entc_codagenport = null;
      request_sli.entc_codtermport = null;
      request_sli.entc_coddeptemporal = null;
      request_sli.ctar_codigo = this.idTarifa !== undefined
        ? this.idTarifa
        : ((this.datosRecibidos != null && this.datosRecibidos["listadotarifaasociada"] &&
          this.datosRecibidos["listadotarifaasociada"].length > 0)
          ? this.datosRecibidos["listadotarifaasociada"][0].idtariff//.ctar_codigo
          : null);
      request_sli.ctar_version = 1;
      request_sli.entc_codtransterre = this.group_servicioslocales.get('transportistaTerre')?.value || null;
      request_sli.cope_version = 1;
      request_sli.cons_codlng = "003";//this.group_datosgenerales.value["lineanegocio"];
      request_sli.cons_tablng = "LNG";
      request_sli.cons_codrgm = this.group_datosgenerales.get('regimen')?.value
      request_sli.cons_tabrgm = "RGM";
      request_sli.cons_codvia = this.group_datosgenerales.get('via')?.value
      request_sli.cons_tabvia = "VIA";
      request_sli.isintegral = this.group_servicioslocales.get('isintegral')?.value;
      request_sli.cope_fechaSL = this.group_servicioslocales.get('fechasl')?.value ?? null;
      request_sli.cope_dam = this.group_servicioslocales.get('montodam')?.value ?? null;
      const ruta = this.group_servicioslocales.get('rutas')?.value;
      request_sli.codigo_ruta = ruta != null && ruta != '' ? Number(ruta) : null;
      request_sli.cope_cifVta = this.group_servicioslocales.get('cifEjecVta')?.value ?? null;
      request_sli.cope_cifLog = this.group_servicioslocales.get('cifLogistico')?.value ?? null;
      request_sli.cope_peso_sli = this.group_servicioslocales.get('peso')?.value ?? null;
      request_sli.cope_unmd_peso = this.group_servicioslocales.get('unmd_peso')?.value ?? null;
      request_sli.cope_tab_unmd_peso = request_sli.cope_unmd_peso != null ? 'UNM' : null;
      request_sli.cope_volumen_sli = this.group_servicioslocales.get('volumen')?.value ?? null;
      request_sli.cope_unmd_volumen = this.group_servicioslocales.get('unmd_volumen')?.value ?? null;
      request_sli.cope_tab_unmd_volumen = request_sli.cope_unmd_volumen != null ? 'UNM' : null;
      request_sli.sucursal = this.group_servicioslocales.get('sucursal')?.value ?? null;
      const listaDetSL: DetalleServiciosLocalesRequest[] = [];
      request_sli.listaAutorizacionSLI = {} as AutorizacionSliRequest;

      const resp = this.verificarCambiosPorAutorizar();
      if (resp.resultado) {
        {
          const requestAutorizacionSli: AutorizacionSliRequest = {
            cope_codigo: request_sli.cope_codigo,
            entc_codcliente: this.group_servicioslocales.get('clienteDSL').value,
            usuario: this.storage.get('nombreusr'),
            ccot_numdoc: this.group_datosgenerales.get('numero')?.value,
            nombre_cliente: this.group_datosgenerales.get('cliente')?.value,
            correo_remitente: this.storage.get('correo'),
            tbl_operaciones: resp.datos.map(item => ({
              dope_item: item.dope_item ?? null,
              serv_codigo: item.serv_codigo ?? null,
              monto_solicitado: item.precio_modificado ?? null,
              desc_moneda_solicitado: item.desc_moneda_solicitado ?? null,
              cod_moneda_solicitado: item.cod_moneda_solicitado ?? null,
              tab_moneda_solicitado: item.tab_moneda_solicitado ?? null,
              monto_original: item.precio_original ?? null,
              desc_moneda_original: item.precio_desc_mnd ?? null,
              cod_moneda_original: item.precio_cod_mnd ?? null,
              tab_moneda_original: item.precio_tab_mnd ?? null,
              servicio: item.nombre_servicio ?? null,
              tipoauth: item.tipo ?? null
            })),
            cope_numdoc: request_sli.cope_numdoc,
            hbl: this.datosRecibidos?.doov_hbl,
          };
          request_sli.listaAutorizacionSLI = requestAutorizacionSli;
        }
      }

      this.servicioslocales_datadetalle.forEach((item: any) => {
        let estado_obj = item.ESTADO_OBJ ?? "NA";
        if (estado_obj === "A") {
          const existeEnOriginal = this.listadoOriginal.some(orig => orig.dope_item === item.dope_item);
          estado_obj = existeEnOriginal ? "U" : (!item.cons_codest ? "I" : "U");
        }
        const requestItem: DetalleServiciosLocalesRequest = {
          dope_item: item.dope_item ?? null,
          cope_codigo: (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_codigo
            : 0,
          cope_version: (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] &&
            this.datosRecibidos["listadooperaciones"].length > 0)
            ? this.datosRecibidos["listadooperaciones"][0].cope_version
            : 1,
          dtar_item: item.dtar_item ?? null,
          ctar_codigo: this.idTarifa !== undefined ? this.idTarifa : item.ctar_codigo,
          ctar_tipo: item.ctar_tipo ?? null,
          pack_codigo: item.pack_codigo ?? null,
          cons_codbas: item.cons_desc_spa?.value !== undefined ? item.cons_desc_spa?.value : (item.cons_codbas ?? null),
          cons_tabbas: "BAS",
          dope_cantidad: item.dope_cantidad ?? null,
          dope_preciounitcosto: item.dope_preciounitcosto ?? null,
          dope_preciototcosto: item.dope_preciototcosto ?? item.dope_preciounitcosto * (item.dope_cantidad || 1),
          dope_preciounitvta: item.dope_preciounitvta ?? null,
          dope_preciototvta: item.dope_preciototvta ?? null,
          dope_minimo: item.dope_minimo ?? 0.00,
          dope_peso: item.dope_peso ?? null,
          dope_volumen: item.dope_volumen ?? null,
          usr_usrmod: this.nombreUsuario,
          audi_usrcrea: this.nombreUsuario,
          dope_costosada: item.dope_costosada ?? null,
          dope_costo: item.dope_costo ?? null,
          dope_ventasada: item.dope_ventasada ?? 0.00,
          dope_venta: item.dope_venta ?? 0.00,
          tipo_tabzon: 'ZON',
          tipo_codzonorigen: item.tipo_codzonorigen ?? null,
          cons_codtra: item.cons_codtra ?? null,
          cons_tabtra: item.cons_tabtra ?? null,
          tipo_codzondestino: item.tipo_codzondestino ?? null,
          tipe_codigo: item.tipoentidad?.value !== undefined ? item.tipoentidad?.value : (item.tipe_codigo ?? 2),
          // entc_codigo: item.entc_razonsocial?.value !== undefined ? item.entc_razonsocial?.value : (item.entc_codigo ?? null),
          entc_codigo:
            item.entc_razonsocial?.value !== undefined
              ? item.entc_razonsocial.value
              : (
                item.entc_razonsocial != null && !isNaN(Number(item.entc_razonsocial))
                  ? Number(item.entc_razonsocial)
                  : (item.entc_codigo != null ? Number(item.entc_codigo) : null)
              ),
          cons_codest: item.cons_codest !== '' ? item.cons_codest : '001',
          cons_tabest: "EDO",
          serv_codigo: item.serv_nombre_spa?.value !== undefined ? item.serv_nombre_spa?.value : (item.serv_codigo ?? null),
          tipo_tabmnd: "MND",
          tipo_codmnd: item.nombremnd?.value !== undefined ? item.nombremnd?.value : (item.tipo_codmnd ?? null),
          cons_tablng: "LNG",
          cons_codlng: item.cons_desclng?.value !== undefined ? item.cons_desclng?.value : (item.cons_codlng ?? '003'), // this.group_tabcotizacion.value["lineanegocio"],
          dope_changecontrol: item.dope_changecontrol ?? false,
          dope_itemchangecontrol: item.dope_itemchangecontrol ?? null,
          dope_fechaoperacion: item.dope_fechaoperacion ?? null,
          COPE_ProfitLocal: item.profit_local ?? null,
          profit_fijo: item.profit_fijo ?? null,
          agrupado: item.agrupado ?? null,
          CODE_Agrupador: item.cod_padre ?? null,
          DTAR_Codigo: item.dtar_codigo ?? null,
          RTAR_Codigo: item.rtar_codigo ?? null,
          monto_conversion: item.monto_conversion ?? null,
          TIPO_TabMNDCosto: 'MND',
          TIPO_CodMNDCosto: item.nombremnd?.value !== undefined ? item.nombremnd?.value : (item.tipo_codmnd ?? null),
          TIPO_TabMNDVenta: 'MND',
          TIPO_CodMNDVenta: item.nombremndvta?.value !== undefined ? item.nombremndvta?.value : (item.tipo_codmndventa ?? null),
          TIPO_TabMNDProfit: 'MND',
          TIPO_CodMNDProfit: item.tipo_codmndprofit ?? null,
          TIPO_TabTDS: "TDS",
          TIPO_CodTDS: this.adicional === false ? '001' : '002',
          esadicional: item.esadicional !== '' || item.esadicional !== null ? item.esadicional : false,
          dope_preciotot_prom: item.dope_preciotot_prom ?? null,
          dope_preciounit_prom: item.dope_preciounit_prom ?? null,
          ESTADO_OBJ: estado_obj,
          tipo_tabmsd: this.extraerValueSinObjeto(item.tipo_codmsd) != null ? "MSD" : null,
          tipo_codmsd: this.extraerValueSinObjeto(item.tipo_codmsd) ?? null,
          transportista: this.codTransporte,
          cliente: this.codCliente,
          mnd_tarifa: item.mnd_tarifa ?? null,
          tab_tarifa: item.tab_tarifa ?? null,
          monto_tarifa: item.monto_tarifa ?? null,
          tipo_autorizacion: item.tipo_autorizacion ?? null,
        };
        listaDetSL.push(requestItem);
      });
      request_sli.listaDetSL = listaDetSL;

      // this.servicioslocales_detalleAgrupacion = this.servicioslocales_detalleAgrupacion.map(item => ({
      //   ...item,
      //   tipotran: item.ESTADO_OBJ
      // }));

      // this.itemagrupador = this.servicioslocales_detalleAgrupacion.map(item => ({
      //   CODE_Agrupador: item.dope_item ?? null,
      //   COPE_Codigo: item.cope_codigo ?? null,
      //   SERV_Descripcion: item.serv_nombre_spa ?? null,
      //   CTAR_Codigo: item.ctar_codigo ?? null,
      //   DTAR_Codigo: item.dtar_codigo ?? null,
      //   RTAR_Codigo: item.rtar_codigo ?? null,
      //   DOPE_PrecioUnitVta: item.dope_preciounitvta ?? null,
      //   DOPE_Cantidad: item.dope_cantidad ?? null,
      //   DOPE_PrecioTotVta: item.dope_preciototvta ?? null,
      //   DOPE_PrecioUnitCosto: item.dope_preciounitcosto ?? null,
      //   DOPE_PrecioTotCosto: item.dope_preciototcosto ?? null,
      //   AUDI_Usuario: this.storage.get("usuario"),
      //   tipotran: item.ESTADO_OBJ,
      // }));

      // const RequestSL: TransaccionAgrupadorRequest = { tablaagrupador: this.itemagrupador };
      // await this.ordenventaService.TransaccionAgrupador(RequestSL).toPromise();

      request_sli.tablaagrupador = request_sli.tablaagrupador || [];
      request_sli.listaEvenSL = request_sli.listaEvenSL || [];

      this.ordenventaService.TnsServiciosLocales(request_sli).subscribe(res => {

        if (res.datos.status === 200) {
          this.itemagrupador = []
          this.listadoOriginal = []
          this.resetCosto[2].loading = false;
          this.util.MessageDialog({ titulo: "Servicios Locales", mensaje: "Actualización exitosa.", icono: "OK", tipo: "ok" });
          this.listarOPCambios();
        }
      }, (err) => {
        this.resetCosto[2].loading = false;
        const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
        this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
      });

    } catch (err) {

    } finally {
      if (botonElemento) {
        botonElemento.disabled = false;
      }
      this.resetCosto[2].loading = false;
      this.reset = [...this.resetCosto]
    }

  }

  listarOPCambios() {
    try {
      const request: listAllOVRequest = <listAllOVRequest>{}
      request.empresa = 1
      request.tipo = 2
      request.sucursal = 1
      request.regimen = ""
      request.flete = ""
      request.via = []
      request.estado = []
      request.ejecutivo = []
      request.customer = []
      request.agente = ""
      request.cliente = ""
      request.numdoc = this.datosRecibidos.ccot_numdoc
      request.mbl = ""
      request.hbl = ""
      request.booking = ""
      request.desde = "";
      request.hasta = "";
      request.condetalle = "S"
      request.numero_cotizacion = "";
      this.ordenventaService.listAllOV(request).subscribe(response => {
        if (response.datos.status == '200') {
          this.messageService.clear();
          this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Operaciones actualizadas correctamente.', life: 3000, key: "tl" });
          const data = response.datos.result[0].listadoserviciosasociados
          this.datos['listadoserviciosasociados'] = structuredClone(response.datos.result[0].listadoserviciosasociados);
          this.datos['listadooperaciones'] = structuredClone(response.datos.result[0].listadooperaciones);
          this.servicioslocales_datadetalle = data
          this.servicioslocales_datadetalle.forEach(row => {
            row['ESTADO_OBJ'] = 'NA',
              // row['colorletra'] = row.cons_codest === '002' ? '#6363d3ff' : (row.cons_codest === '005' ? '#ff0000ff' : '#3f3f46'),
              // row['color'] = row.cons_codest === '002' ? 'rgba(4, 0, 255, 0.05)' : '#ffffffff',
              // row['fontbold'] = row.cons_codest === '002' ? true : false,
              row['disabled'] = (row.fact_proveedor != null) || (row.cons_codest !== '001' && row.cons_codest !== '006') ? true : false,
              row['tipoentidad'] = row['tipoentidad']?.toUpperCase(),
              row['puedechangecontrol'] = this.datos?.['listadooperaciones']?.cons_codestado === '002' ? true : (row['cons_codest'] === '002' ? true : false),
              row['verTarifario'] = row.esadicional != true && row.cons_codest !== '005' && (row.fact_proveedor == null || row.fact_proveedor == '') ? true : false,
              row['puedemodRZ'] = row['disabled'] == true && (row.fact_proveedor == null || row.fact_proveedor == '') ? this.isLogisticaPlus : false,
              row['msd_editable'] = true,
              row['tipo_codmsd'] = row.tipo_codmsd != null ? { value: row.tipo_codmsd, label: row.tipo_descmsd } : null,
              // row['entc_razonsocial'] = row.entc_codigo != null ? row['puedemodRZ'] == true ? String(row.entc_codigo) : this.adicional == true ?
              //   { label: row.entc_razonsocial?.toUpperCase().trim(), value: String(row.entc_codigo), tipo: row.subtipoproveedor } : null : null// testt
              // row['entc_razonsocial'] = row.entc_codigo != null ? { label: row.entc_razonsocial?.toUpperCase().trim(), value: String(row.entc_codigo), tipo: row.subtipoproveedor } : null// testt
              row['entc_razonsocial'] = row.entc_codigo === null ? null : this.ListaNombreEntidadesDP.find(x => x.value === String(row.entc_codigo) && x.tipo?.toUpperCase() === row.subtipoproveedor?.toUpperCase()) ?? null,
              // row['entc_codigo'] = row.entc_codigo !== null ? String(row.entc_codigo) : null
              row['cons_codest_orig'] = row['cons_codest'],
              row['cons_descest_orig'] = row['cons_descest']
          });
          this.listadoOriginal = data
          switch (this.adicional) {
            case true:
              //   if (this.isLogisticaPlus != true) {
              //     this.servicioslocales_datadetalle.map(fila => {
              //       fila.entc_razonsocial = fila.entc_codigo !== null ? { label: fila.entc_razonsocial?.toUpperCase().trim(), value: String(fila.entc_codigo), tipo: fila.subtipoproveedor } : '';
              //     });
              //   }
              break;
            case false:
              this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.filter(item =>
                (item.agrupado === null || item.agrupado === false)
              );
              this.listadoOriginal = this.listadoOriginal.filter(item =>
                (item.agrupado === null || item.agrupado === false)
              );
              break;
            default:
              this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.filter(item =>
                (item.agrupado === null || item.agrupado === false)
              );
              this.listadoOriginal = this.listadoOriginal.filter(item =>
                (item.agrupado === null || item.agrupado === false)
              );
              break;
          }
          this.listarOPCabeceraCambios(this.datos['listadooperaciones'][0]);
        }
      })
    } catch (err) {
      console.error("Error consultando operaciones", err);
    }
  }

  validarCambios(tipo: string): boolean {
    switch (tipo) {
      case 'OS':
        if (this.tablaAgrupados.some(t => t.cons_codest === '005')) {
          this.messageService.add({ severity: 'error', summary: 'Orden de Servicio no permitida', detail: 'No se puede generar orden de servicio para un que ha sido cancelado.', key: 'tl' });
          this.PrefacturarServicios('C');
          return true;
        }
        if (this.tablaAgrupados.some(t => t.cose_nroordenservicio !== null)) {
          this.messageService.add({ severity: 'error', summary: 'Orden de Servicio no permitida', detail: 'Hay operaciones con Nro. de Orden de Servicio ya asignado.', key: 'tl' });
          this.PrefacturarServicios('C');
          return true;
        }
        break;
      case 'CAN':
        if (this.tablaAgrupados.some(t => t.cons_codest === '002' || t.cons_codest === '005')) {
          this.messageService.add({ severity: 'error', summary: 'Cancelación no permitida', detail: 'No se puede cancelar un servicio que ya ha sido prefacturado o cancelado.', key: 'tl' });
          this.PrefacturarServicios('C');
          return true;
        }
        break;
      case 'PRF':
        if (this.tablaAgrupados.some(t => t.cons_codest === '002' || t.cons_codest === '005')) {
          this.messageService.add({ severity: 'error', summary: 'Prefacturación no permitida', detail: 'No se puede prefacturar un servicio que ya ha sido prefacturado o cancelado.', key: 'tl' });
          this.PrefacturarServicios('C');
          return true;
        }
        if (this.tablaAgrupados.some(t => t.cons_codest === '006')) {
          this.messageService.add({ severity: 'error', summary: 'Prefacturación no permitida', detail: 'No se puede prefacturar un servicio Pendiente de Autorización.', key: 'tl' });
          this.PrefacturarServicios('C');
          return true;
        }


        if (!this.solosli && this.group_datosgenerales.get('via')?.value !== "003") {
          const serviciosAlmacen = [742, 1026];
          const tieneServiciosAlmacen = this.tablaAgrupados.some(row => serviciosAlmacen.includes(Number(row.serv_codigo)));

          if (tieneServiciosAlmacen) {
            let entc_codtermport: string | null = null;

            const itinerariosValidos = this.viajeitinerario_dataitinerario?.filter((item: any) => item?.ESTADO_OBJ !== 'D') || [];

            if (itinerariosValidos.length > 0) {
              const tieneDopeItem = itinerariosValidos.every(item => item.ovnv_item !== undefined && item.ovnv_item !== null);

              switch (this.group_datosgenerales?.value?.regimen) {
                case "001":
                  if (tieneDopeItem) {
                    entc_codtermport = itinerariosValidos.reduce((prev, current) =>
                      (Number(prev.ovnv_item ?? prev.key) > Number(current.ovnv_item ?? current.key)) ? prev : current
                    ).entc_codtermport;
                  } else {
                    entc_codtermport = itinerariosValidos.find((item: any) => item?.ovnv_final === true)?.entc_codtermport;
                  }
                  break;

                case "002":
                  if (tieneDopeItem) {
                    entc_codtermport = itinerariosValidos.reduce((prev, current) =>
                      (Number(prev.ovnv_item ?? prev.key) < Number(current.ovnv_item ?? current.key)) ? prev : current
                    ).entc_codtermport;
                  } else {
                    entc_codtermport = itinerariosValidos[0]?.entc_codtermport;
                  }
                  break;
              }
            }

            // 1. Validar existencia en el itinerario (solo activos)
            const tieneItinerario = itinerariosValidos.length > 0;
            ///se quito temporalemente para que deje de prefacturar.
            // if (!tieneItinerario  || this.group_datosgenerales.get('via')?.value !== "003" ) {
            //   this.messageService.add({
            //     severity: 'error', summary: 'Datos incompletos', detail: 'Para prefacturar servicios de Almacén es obligatorio ingresar una Nave/Viaje válida en el itinerario.', key: 'tl'
            //   });
            //   this.PrefacturarServicios('C');
            //   return true;
            // }

            // 2. Validar que el Terminal Portuario esté presente
            // if (!entc_codtermport) {
            //   this.messageService.add({
            //     severity: 'error',
            //     summary: 'Falta Terminal Portuario',
            //     key: 'tl',
            //     detail: 'No se ha detectado un Terminal Portuario en la Nave/Viaje ingresada. Por favor, asegúrese de que el área responsable complete este dato antes de prefacturar.'
            //   });
            //   this.PrefacturarServicios('C');
            //   return true;
            // }

            // 3. Validar conflictos en tablaAgrupados (Terminal vs Tarifa)
            const itemsConConflicto = this.tablaAgrupados.filter(row =>
              serviciosAlmacen.includes(Number(row.serv_codigo)) &&
              (row.dtar_codigo && row.ctar_codigo) &&
              entc_codtermport?.toString() !== row.cod_terminal_portuario
            );

            // if (itemsConConflicto.length > 0) {
            //   const listado = itemsConConflicto.map(i => i.dope_item).join(', ');

            //   this.messageService.add({
            //     severity: 'error', summary: 'Prefacturación no permitida',
            //     detail: `La tarifa de almacén con item: (${listado}) no coincide con el Terminal Portuario de la nave viaje. Se recomienda volver a jalar el tarifario con uno válido.`,
            //     key: 'tl'
            //   });
            //   this.PrefacturarServicios('C');
            //   return true;
            // }
          }
        }

        // if (
        //   this.tablaAgrupados && (
        //     this.tablaAgrupados.some(d =>
        //       typeof d.desctarifa === 'string' && d.desctarifa.toLowerCase().includes('promedio')
        //     )
        //   )) {
        //   this.messageService.add({
        //     severity: 'error', summary: 'Prefacturación no permitida',
        //     detail: 'No se puede prefacturar mientras existan servicios pertenecientes a tarifas promedio.', key: 'tl'
        //   });
        //   this.PrefacturarServicios('C');
        //   return true;
        // }
        break;
      default:
        break;
    }

    let hayCambios = false;
    // for (const itemActual of this.servicioslocales_datadetalle) {
    //   const itemOriginal = this.listadoOriginal.find(o => o.dope_item === itemActual.dope_item);
    //   if (!itemOriginal) { hayCambios = true; break; }
    //   if (JSON.stringify(itemActual) !== JSON.stringify(itemOriginal)) { hayCambios = true; break; }
    // }

    if (this.servicioslocales_datadetalle?.some(
      x => x.ESTADO_OBJ === 'I' || x.ESTADO_OBJ === 'U' || x.ESTADO_OBJ === 'D'
    )) {
      // if (hayCambios) {
      this.PrefacturarServicios('C')
      this.messageService.add({ severity: 'warn', summary: 'Cambios pendientes', detail: 'Faltan guardar cambios antes de continuar.', key: 'tl' });
      return true
      // }
    }

    return false;
  }

  async cancelarServicio() {
    if (this.validarCambios('CAN')) {
      return; // ⬅ Detenemos ejecución
    }
    this.confirmationService.confirm({
      message: "¿Está seguro que desea continuar con esta acción?",
      icon: 'pi pi-exclamation-triangle',
      key: 'T',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Aceptar',
      },
      header: 'Confirmation',
      closable: false,
      closeOnEscape: false,
      accept: async () => {
        this.servicioslocales_datadetalle = this.servicioslocales_datadetalle.map(item => ({
          ...item,
          cons_codest: this.tablaAgrupados.some(t => t.dope_item === item.dope_item) ? '005' : item.cons_codest
        }))
        await this.saveOperaciones(event);
        this.PrefacturarServicios('C');
      },
      reject: async () => { this.PrefacturarServicios('C'); }
    })
  }
  async onSelectChange(event: { field: string; event: any, index: any; rowdata: any }) {
    let value: string = String(event.event.value.value);
    const index = event.index;
    const valueArray = value.includes('|') ? value.split('|') : [value];

    if (event.field === 'tipoentidad') {
      const tiposMap: Record<string, string> = {
        '15': 'DepositoVacio',
        '14': 'DepositoTemp',
        '3': 'EJEC',
        '4': 'CUS',
        '5': 'TRANSPORTISTA',
        '9': 'CONTACTO',
        '6': 'AGE',
        '7': 'AGE',
        '2': 'PROVEEDOR',
        '10': 'SHIPPER',
        '17': 'TERMINALPORTUARIO',
        '1': 'CLIENTE'
      };
      const tiposSeleccionados = valueArray.map(codigo => tiposMap[codigo]);

      this.ListaFiltradaTipoEntidadDP = this.ListaNombreEntidadesDP.filter(item =>
        tiposSeleccionados.includes(item.tipo)
      );

      this.ListaFiltradaNombreEntidadesDP =
        tiposSeleccionados.includes('AGE')
          ? this.ListaNombreEntidadesDP.filter(item => item.tipo === 'AGE')
          : this.ListaNombreEntidadesDP.filter(item =>
            tiposSeleccionados.includes(item.tipo)
          );
      this.actualizarDpMtRelacionados('entc_razonsocial', this.ListaFiltradaNombreEntidadesDP);

      let nuevoValor = null;
      let valorDP = value;
      if (value == "1") {
        nuevoValor = this.group_datosgenerales.get('cliente')?.value;
      } else if (valorDP == "10") {
        value = this.group_datosembarque.get('shipper')?.value;
      } else if (valorDP == "2") {
        // PROVEEDORES
      } else if (valorDP == "5") {
        nuevoValor = this.group_serviciostarifa.get('transportista')?.value;
      } else if (valorDP == "6") {
        nuevoValor = this.group_datosgenerales.get('agente')?.value;
      } else if (valorDP == "7") {
        // BROKER
      }
      const entSeleccionada = this.ListaFiltradaNombreEntidadesDP.find(e => e.label === nuevoValor);
      this.enviarValorDtSLI(entSeleccionada, index, 'entc_razonsocial');
    }
    else if (event.field === 'cons_desclng') {
      const codigoLng = event.event.value.value;
      const codrgm = this.group_datosgenerales.get('regimen')?.value;
      const codvia = this.group_datosgenerales.get('via')?.value;

      const listaFiltrada = this.ListaTodosServiciosTable.filter(
        item => item.lng === codigoLng && item.rgm === codrgm && item.via === codvia
      );
      this.ListaFiltradaTodosServiciosTable = listaFiltrada;
      this.actualizarDpMtRelacionados('serv_nombre_spa', this.ListaFiltradaTodosServiciosTable);
    }
    else if (event.field === 'serv_nombre_spa') {

      if (event?.rowdata?.serv_nombre_spa?.label?.toLowerCase().includes("cuadrilla")) {

        const codigosAlmacen = [742, 1026, "742", "1026"]; // Códigos de servicios de almacén

        const serviciosAlmacen = this.servicioslocales_datadetalle?.filter((item: any) => {
          if (item?.ESTADO_OBJ === 'D') return false;
          const codigoServicio = item?.serv_nombre_spa?.value ?? item?.serv_codigo;
          return codigosAlmacen.includes(codigoServicio);
        });

        const hayAlmacenSinPrefacturar = serviciosAlmacen?.some((item: any) => item?.cons_codest !== '002');
        if (hayAlmacenSinPrefacturar) {
          event.rowdata['serv_nombre_spa'] = null;
          this.messageService.add({ severity: 'warn', summary: 'Validación', detail: 'No puede asignar este servicio mientras exista un servicio de almacén sin prefacturar.', life: 3000, key: "tl" });
          return;
        }
      }

      const RequestP: ConsultarProfitTCambioRequest = <ConsultarProfitTCambioRequest>{}
      RequestP.SERV_Codigo = Number(event?.event?.value?.value);
      RequestP.tipo = "PM"
      try {
        const response = await firstValueFrom(this.ordenventaService.ConsultarProfit(RequestP));
        if (response.datos.status === 200) {
          event.rowdata['profitminimo'] = response.datos.result[0].profitminimo
          event.rowdata['tipomonedam'] = response.datos.result[0].tipomonedam
          event.rowdata['tipoprofitm'] = response.datos.result[0].tipoprofitm
        }
      } catch (error) {
        event.rowdata['serv_nombre_spa'] = null;
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'No existe un profit mínimo para esta Tarifa. Por favor, verifique.', life: 3000, key: "tl" });
        // this.dtServiciosRefdt.onRowEditCancel(product, product['key'] - 1);
        // return;
      }
    }
    else if (event.field === 'cons_desc_spa') {
      const codBase = event?.rowdata.unidad?.value || event?.rowdata.cons_codbas;
      await this.calcularCantidadBase(codBase, index, 'servicios_sli') || 0;
    }
  }

  actualizarDpMtRelacionados = (field: string, lista: any[]) => {
    const fieldToUpdate = this.metadatableDataDetalle.find(m => m.field === field);
    if (fieldToUpdate) { fieldToUpdate.dropdown = lista; }
    const metadataItem = this.dtServiciosRefdt.metadata.find(m => m.field === field);
    if (metadataItem) {
      metadataItem.dropdown = [...lista];
    }
    this.renderizarDom();
  };

  enviarValorDtSLI(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onDpChangeTbl.emit(eventToEmit);
  }
  async onAddRowInit(product: any): Promise<void> {
    product['cons_codest'] = '001';
    product['ESTADO_OBJ'] = 'I';
    product['cons_tabest'] = 'EDO';
    product['tipo_codtds'] = this.adicional === false ? '001' : '002'
    product['cons_codlng'] = '003';
    product['fechaoperacion'] = new Date();
    product['disabled'] = false
    product['dope_cantidad'] = 1
    product['puedemodRZ'] = true
    product['cons_codest_orig'] = '001'
    product['esadicional'] = this.adicional === true ? true : false
    product['dope_preciounitvta'] = 0
    // product['colorletra'] = '#3f3f46'
    // product['color'] = '#ffffffff'
    // product['fontbold'] = false
    product['verTarifario'] = true
    product['msd_editable'] = true
    const selected = this.ListaEstadosDope.find(x => x.value === product['cons_codest']);
    product['cons_descest'] = selected ? selected.label : '';
    product['cons_descest_orig'] = selected ? selected.label : '';
    if (this.dtServiciosRefdt.defaultRow !== null || this.dtServiciosRefdt.defaultRow !== undefined) {
      product['cons_desclng'] = { label: 'SERVICIO INTEGRADO LOCAL', value: '003' };
    }
    let lng = { label: product.cons_desclng?.label || product.cons_desclng, value: product.cons_desclng?.value || product.cons_codlng }
    let eventlng: {
      event: { originalEvent: PointerEvent; value: any; };
      field: string; index: number | null; rowdata: any | null;
    } =
    {
      event: { originalEvent: new PointerEvent("click"), value: lng },
      field: "cons_desclng", index: null, rowdata: null
    };
    this.onSelectChange(eventlng)
    const existentes = [
      ...this.servicioslocales_datadetalle,
      ...(this.servicioslocales_detalleAgrupacion || [])
    ].filter(i => i.dope_item != null).map(i => Number(i.dope_item));
    const siguienteDope = existentes.length > 0 ? Math.max(...existentes) + 1 : 1;
    product['dope_item'] = siguienteDope;
    const key = product.key;
    this.dtServiciosRefdt.puedeValidar[key] = true;
    const Request: ConsultarProfitTCambioRequest = <ConsultarProfitTCambioRequest>{}
    Request.SERV_Codigo = product['serv_nombre_spa']?.value || product['serv_codigo']
    Request.tipo = "TC"
    try {
      const response = await firstValueFrom(this.ordenventaService.ConsultarTCambio(Request));
      if (response.datos.status === 200) {
        product['tipocambiocompra'] = response.datos.result[0].tipocambiocompra
        product['tipocambioventa'] = response.datos.result[0].tipocambioventa
        if (this.dtServiciosRefdt && this.dtServiciosRefdt.puedeValidar) {
          this.dtServiciosRefdt.puedeValidar[key] = true;
        }
      }
    } catch (error) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'El tipo de cambio de venta no está definido para el día de hoy. Por favor, verifique.', life: 3000, key: "tl" });
      this.dtServiciosRefdt.onRowEditCancel(product, product['key'] - 1);
      return;
    }
  }

  async mapearEdit(product: any): Promise<void> {
    try {
      const filaOriginal = this.dtServiciosRefdt?.getFilaOriginal?.(product);
      const filaEncontrada = this.servicioslocales_datadetalle?.find?.(
        (fila) => fila?.key === filaOriginal?.key
      );
      if (filaEncontrada) {
        product['costo_edicion_original'] = filaEncontrada.dope_preciounitcosto;
        product['venta_edicion_original'] = filaEncontrada.dope_preciounitvta;
      }
    } catch (error) {
      console.error(error);
    }
    this.actualizarDpMtRelacionados('serv_nombre_spa', this.ListaTodosServiciosTable);
    this.actualizarDpMtRelacionados('entc_razonsocial', this.ListaNombreEntidadesDP);
  }

  CrearChangeControl(row) {

    const product = { ...row.row }; // clonar fila original

    product['serv_nombre_spa'] = {
      label: product['serv_nombre_spa']?.label || product['serv_nombre_spa'],
      value: product['serv_nombre_spa']?.value || product['serv_codigo'].toString(),
      lng: product['serv_nombre_spa']?.lng || product['cons_codlng'],
      rgm: this.datos['listadooperaciones']?.cons_codrgm || null,
      via: this.datos['listadooperaciones']?.cons_codvia || null
    };
    product['nombremnd'] = {
      label: product['nombremnd']?.label || product['nombremnd'],
      value: product['nombremnd']?.value || product['tipo_codmnd'],
    };
    product['nombremndvta'] = {
      label: product['nombremndvta']?.label || product['nombremndvta'],
      value: product['nombremndvta']?.value || product['tipo_codmndventa'],
    };
    product['tipoentidad'] = {
      label: product['tipoentidad']?.label || product['tipoentidad'],
      value: product['tipoentidad']?.value || product['tipe_codigo'].toString(),
    };
    product['cons_desc_spa'] = {
      label: product['cons_desc_spa']?.label || product['cons_desc_spa'],
      value: product['cons_desc_spa']?.value || product['cons_codbas'],
    };
    product['cons_codest'] = "001";
    product['puedemodRZ'] = true;
    product['puedechangecontrol'] = false;

    this.dtServiciosRefdt.defaultRow = {
      ...product,
      key: '',
      dope_itemchangecontrol: product.dope_item,
      dcov_tipocomprobante: '',
      tipocomprobante: '',
      docv_codigo: '',
      docv_comprobante: '',
      afectoigv: product.afectoigv,
      cod_padre: null,
      agrupado: false,
      cons_codest: '001',
      verTarifario: true
    };
    this.dtServiciosRefdt.addEmptyRow();

    this.dtServiciosRefdt.defaultRow = {}
  }

  async generarOS() {
    if (this.validarCambios('OS')) {
      return; // ⬅ Detenemos ejecución
    }
    this.confirmationService.confirm({
      message: "¿Está seguro que desea continuar con esta acción?",
      icon: 'pi pi-exclamation-triangle',
      key: 'T',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Aceptar',
      },
      header: 'Confirmation',
      closable: false,
      closeOnEscape: false,
      accept: async () => {
        const adicionales = this.tablaAgrupados.map(item => ({
          dope_item: item.dope_item,
          cope_codigo: item.cope_codigo
        }));
        const Request: GenerarOrdenServicioRequest = <GenerarOrdenServicioRequest>{}
        Request.servicios = adicionales
        Request.usuario = this.storage.get('usuario')
        this.ordenventaService.GenerarOrdenServicio(Request).subscribe(response => {
          if (response.datos.status === 200) {
            this.listarOPCambios()
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'OK', detail: 'Se registró correctamente la Orden de Servicio.', life: 3000, key: "tl" });
          }
        })
        this.PrefacturarServicios('C');
      },
      reject: async () => { this.PrefacturarServicios('C'); }
    })
  }

  ModOutputEdit(row) {
    // this.rowAuth = []
    const rowKey = row?.row?.key;
    if (!rowKey) return;
    if (!this.dtServiciosRefdt.clonedProducts[rowKey]) {
      this.dtServiciosRefdt.clonedProducts[rowKey] = JSON.parse(JSON.stringify(row?.row));
      // console.log("this.dtServiciosRefdt.clonedProducts[rowKey]", this.dtServiciosRefdt.clonedProducts[rowKey])
    } else {
      // console.log("this.dtServiciosRefdt.clonedProducts[rowKey] ya tiene valores no se sobrescribe")
    }
  }

  ModOutputBlur(row) {
    // console.log('blur', row)
  }

  async onCancelEditInit(product: any): Promise<void> {
    this.actualizarDpMtRelacionados('serv_nombre_spa', this.ListaTodosServiciosTable);
    this.actualizarDpMtRelacionados('entc_razonsocial', this.ListaNombreEntidadesDP);
  }
  viewTarifarioCosto: boolean = false
  keydatadetalle: number
  dataTableTarifaServicioLogistico2: any[] = []
  metadataTableTarifaServicioLogistico2: any[] = []
  dataTableTarifaAlmacen2: any[] = []
  metadataTableTarifaAlmacen2: any[] = []
  dataTableTransporte2: any[] = []
  metadataTableTransporte2: any[] = []
  dataTableAgeAduana2: any[] = []
  metadataTableAgeAduana2: any[] = []
  dataTableExtras2: any[] = []
  metadataTableExtras2: any[] = []
  dataTableTc2: any[] = []
  metadataTableTc2: any[] = []
  async visualizarTarifarioCosto(row) {
    this.desdebtn = true
    try {
      if (this.group_servicioslocales.value.fechasl === null || this.group_servicioslocales.value.fechasl === undefined) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'Seleccione una fecha para filtrar Tarifas.', life: 3000, key: "tl" });
        return;
      }

      const product = { ...row.row };
      const serv_codigo = product['serv_nombre_spa']?.value ?? product['serv_codigo']
      this.keydatadetalle = product['key']
      const codigo_tarifa = product['tipo_codtar'];

      if (codigo_tarifa === null || codigo_tarifa === undefined || codigo_tarifa === '') {
        this.messageService.clear();
        this.messageService.add({
          severity: 'warn', summary: 'Tarifa Faltante', detail: 'Servicio no tiene tarifa asociada. No se puede actualizar a REAL.', life: 3000, key: "tl"
        });
        return;
      }

      if (row.ESTADO_OBJ === 'NA') { row.ESTADO_OBJ === 'U' }

      this.dataTableTarifaServicioLogistico = [];
      this.dataTableTarifaAlmacen = [];
      this.dataTableTransporte = [];
      this.dataTableAgeAduana = [];
      this.tarifaActualizada = []
      this.dataTableTarifaServicioLogistico2 = [];
      this.dataTableTarifaAlmacen2 = [];
      this.dataTableTransporte2 = [];
      this.dataTableAgeAduana2 = [];
      this.dataTableExtras2 = [];
      this.dataTableTc2 = [];
      this.onExpanded = false;
      switch (codigo_tarifa) {
        // switch (Number(serv_codigo)) {
        // case 1107:
        // case 1057:
        case "001":
          const valuetrans = this.group_serviciostarifa.value["transportista"]
          if (valuetrans === null) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'No se ha seleccionado transportista.', life: 3000, key: "tl" });
            return;
          }
          await this.buscarServicioLogistico();
          this.dataTableTarifaServicioLogistico2 = this.dataTableTarifaServicioLogistico.filter(
            item => Number(item.servicio?.value) === Number(serv_codigo)
          );
          // console.log('this.dataTableTarifaServicioLogistico2 después de filtrar', this.dataTableTarifaServicioLogistico2);
          if (this.dataTableTarifaServicioLogistico2.length === 0) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Sin tarifas', detail: 'No hay tarifas para la fecha seleccionada.', life: 3000, key: "tl" });
            return;
          } else {
            this.metadataTableTarifaServicioLogistico2 = [
              { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
              ...this.metadataTableTarifaServicioLogistico
            ]
            this.viewTarifarioCosto = true;
          }
          break;
        // case 1026:
        case "003":
          if (this.serviciosytarifas_dataflete.length === 0) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'No hay flete', detail: 'Debe agregar por lo menos un flete.', life: 3000, key: "tl" });
            return;
          }
          await this.buscarTarifaAlmacen();
          // console.log('this.dataTableTarifaAlmacen', this.dataTableTarifaAlmacen)
          this.dataTableTarifaAlmacen2 = [...this.dataTableTarifaAlmacen]
          this.dataTableTransporte2 = this.dataTableTransporte2.filter(
            item => Number(item.servicio?.value) === Number(serv_codigo)
          );
          if (this.dataTableTarifaAlmacen2.length === 0) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Sin tarifas', detail: 'No hay tarifas para la fecha seleccionada.', life: 3000, key: "tl" });
            return;
          } else {
            this.metadataTableTarifaAlmacen2 = [
              { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
              ...this.metadataTableTarifaAlmacen
            ]
            this.viewTarifarioCosto = true
          }
          break;
        // case 732:
        case "002":
        case "006":
          const value = this.group_Transporte.value["condicion"]
          if (value === null) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'No se ha seleccionado una Condición para esta OV.', life: 3000, key: "tl" });
            return;
          }
          const fakeEvent = { value: value };

          const valueRuta = this.group_servicioslocales.value["rutas"]
          if (valueRuta === null) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'No se ha seleccionado una ruta.', life: 3000, key: "tl" });
            return;
          }

          // console.log('this.dataTableTransporte', this.dataTableTransporte)
          await this.buscarTransporte(fakeEvent);
          this.dataTableTransporte2 = [...this.dataTableTransporte]
          this.dataTableTransporte2 = this.dataTableTransporte2.filter(
            item => Number(item.servicio?.value) === Number(serv_codigo)
          );
          if (this.dataTableTransporte2.length === 0) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Sin tarifas', detail: 'No hay tarifas para la fecha seleccionada.', life: 3000, key: "tl" });
            return;
          } else {
            this.metadataTableTransporte2 = [
              { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
              ...this.metadataTableTransporte
            ]
            this.viewTarifarioCosto = true
          }
          break;
        // case 734:
        case "004":
        case "005":
          const valuergm = this.group_datosgenerales?.value?.regimen
          if (valuergm === null) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Campo Requerido', detail: 'No se ha seleccionado Régimen.', life: 3000, key: "tl" });
            return;
          }
          await this.buscarAgenteAduana()
          this.dataTableAgeAduana2 = [...this.dataTableAgeAduana]
          this.dataTableAgeAduana2 = this.dataTableAgeAduana2.filter(
            item => Number(item.servicio?.value) === Number(serv_codigo)
          );
          if (this.dataTableAgeAduana2.length === 0) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Sin tarifas', detail: 'No hay tarifas para la fecha seleccionada.', life: 3000, key: "tl" });
            return;
          } else {
            this.metadataTableAgeAduana2 = [
              {
                field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica', disabledD: (row: any) => row?.concepto?.value === '003' && this.group_datosgenerales.get('regimen')?.value === '001'
              },
              ...this.metadataTableAgeAduana
            ]
            this.viewTarifarioCosto = true
          }
          break;
        case "007": // extras
          await this.buscarTarifasExtra();
          // console.log('this.dataTableExtras', this.dataTableExtras)

          this.dataTableExtras2 = [
            ...this.dataTableExtras.filter(item => Number(item.servicio?.value) === Number(serv_codigo))
          ];

          if (this.dataTableExtras2.length === 0) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Sin tarifas', detail: 'No hay tarifas para la fecha seleccionada.', life: 3000, key: "tl" });
            return;
          } else {
            this.metadataTableExtras2 = [
              { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
              ...this.metadataTableExtras
            ]
            this.metadataTableExtras2 = this.metadataTableExtras2.filter(
              (metadata) => metadata.field !== 'btn_duplicar'
            );
            this.viewTarifarioCosto = true
          }
          break;
        case "008": // tacna tc
          await this.buscarTarifasTacna();
          // console.log('this.dataTableTransporte', this.dataTableTc)

          this.dataTableTc2 = [
            ...this.dataTableTc.filter(item => Number(item.servicio?.value) === Number(serv_codigo))
          ];

          if (this.dataTableTc2.length === 0) {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Sin tarifas', detail: 'No hay tarifas para la fecha seleccionada.', life: 3000, key: "tl" });
            return;
          } else {
            this.metadataTableTc2 = [
              { field: 'select', title: '', filterType: 'boolean', inputType: 'checkboxEditOpcionUnica' },
              ...this.metadataTableTc
            ]
            this.viewTarifarioCosto = true
          }
          break;
        default:
          break;
      }
    } catch (err) {
      console.error("Error al visualizar tarifario", err);
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Sin tarifas', detail: 'No hay tarifas para la fecha seleccionada.', life: 3000, key: "tl" });
    }
  }
  seleccionTarifa(event) {
    if (event.isChecked === true) {
      this.tarifaActualizada = event.rowdata
    }
  }

  CambiarTarifaDatadetalle(accion) {
    if (accion === 'C') {
      this.viewTarifarioCosto = false
    } else {
      if (this.tarifaActualizada === null || this.tarifaActualizada?.length === 0) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'Debe seleccionar una tarifa antes de continuar.', life: 3000, key: "tl" });
        return;
      }
      const index = this.servicioslocales_datadetalle.findIndex(item => item.key === this.keydatadetalle);
      if (index !== -1) {
        let valorfvta = 0
        let valorfcosto = 0
        if (Number(this.tarifaActualizada['servicio']?.value) === 734) { // serv aduana
          let value_concepto = this.tarifaActualizada['concepto']?.value;
          const montocif = this.group_servicioslocales?.value?.montocif;
          if (montocif !== null && value_concepto === '001') { //&& 
            const costo = this.calcularValor(this.tarifaActualizada['tipo_codmndcosto'], this.tarifaActualizada['costo'], this.tarifaActualizada['tipocambioventa'])
            const venta = this.calcularValor(this.tarifaActualizada['tipo_codmndventa'], this.tarifaActualizada['venta'], this.tarifaActualizada['tipocambioventa'])

            const costopm = this.tarifaActualizada['tipo_codmndcosto'] === null ? 0 : this.tarifaActualizada['tipo_codmndcosto'] !== '004' ? costo : montocif * costo
            const ventapm = this.tarifaActualizada['tipo_codmndventa'] === null ? 0 : this.tarifaActualizada['tipo_codmndventa'] !== '004' ? venta : montocif * venta

            let costominc: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(this.tarifaActualizada['agente']?.value) && f.concepto?.value === '003')?.costo ?? 0;
            let gastoopec: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(this.tarifaActualizada['agente']?.value) && f.concepto?.value === '004')?.costo ?? 0;

            let costominv: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(this.tarifaActualizada['agente']?.value) && f.concepto?.value === '003')?.venta ?? 0;
            let gastoopev: any = this.dataTableAgeAduana?.find(f => Number(f.agente?.value) === Number(this.tarifaActualizada['agente']?.value) && f.concepto?.value === '004')?.venta ?? 0;

            valorfcosto = Number(costopm) > Number(costominc) ? Number(costopm) + Number(gastoopec) : Number(costominc) + Number(gastoopec)
            valorfvta = Number(ventapm) > Number(costominv) ? Number(ventapm) + Number(gastoopev) : Number(costominv) + Number(gastoopev)

            this.tarifaActualizada['tipo_codmndcosto'] = "002";
            this.tarifaActualizada['tipo_codmndventa'] = "002";
            this.tarifaActualizada['descripcion_monedacosto'] = "USD";
            this.tarifaActualizada['descripcion_monedaventa'] = "USD";

          } else if (value_concepto !== '001') {
            const costo = this.calcularValor(this.tarifaActualizada['tipo_codmndcosto'], this.tarifaActualizada['costo'], this.tarifaActualizada['tipocambioventa'])
            const venta = this.calcularValor(this.tarifaActualizada['tipo_codmndventa'], this.tarifaActualizada['venta'], this.tarifaActualizada['tipocambioventa'])
            valorfcosto = costo;
            valorfvta = venta;
          }
        } else {
          valorfcosto = this.tarifaActualizada['costo']
          valorfvta = this.tarifaActualizada['tipo_codmndventa'] === '001' ? Number(this.tarifaActualizada['montoventadolares']) : Number(this.tarifaActualizada['venta'])
        }

        const entidadLabel = this.tarifaActualizada['entidad']?.label ?? this.tarifaActualizada['almacen']?.label ?? this.tarifaActualizada['proveedor']?.label ?? this.tarifaActualizada['linea']?.label ?? this.tarifaActualizada['agente']?.label;
        const entidadValue = String(this.tarifaActualizada['entidad']?.value ?? this.tarifaActualizada['almacen']?.value ?? this.tarifaActualizada['proveedor']?.value ?? this.tarifaActualizada['linea']?.value ?? this.tarifaActualizada['agente']?.value);

        // solo si cambia de promedio -> real la venta se mantendrá igual
        // const eraPromedio = (this.servicioslocales_datadetalle[index].entc_razonsocial?.label ?? '').toLowerCase().includes('promedio');
        const row_orig = this.servicioslocales_datadetalle[index];

        this.servicioslocales_datadetalle[index] = {
          ...this.servicioslocales_datadetalle[index],
          entc_codigo: entidadValue,
          entc_razonsocial: row_orig.puedemodRZ == true ?
            this.ListaNombreEntidadesDP.find(x => x.value === String(entidadValue) && x.tipo?.toUpperCase() === row_orig.subtipoproveedor?.toUpperCase()) ?? null
            : row_orig.esadicional === true ? { label: entidadLabel, value: entidadValue, tipo: 'PROVEEDOR' } : entidadLabel, // akiii
          ctar_codigo: this.tarifaActualizada['ctaR_Codigo'],
          // dope_preciotot_prom: valorfcosto * this.servicioslocales_datadetalle[index].dope_cantidad,
          dope_preciounitcosto: Number(valorfcosto),
          // dope_preciounitvta: eraPromedio == false ? Number(valorfvta) : this.servicioslocales_datadetalle[index].dope_preciounitvta,
          dope_preciounitvta: this.servicioslocales_datadetalle[index].dope_preciounitvta,
          dope_preciototcosto: Number(valorfcosto) * this.servicioslocales_datadetalle[index].dope_cantidad,
          // dope_preciototvta: eraPromedio == false ? Number(valorfvta) * this.servicioslocales_datadetalle[index].dope_cantidad : this.servicioslocales_datadetalle[index].dope_preciototvta,
          dope_preciototvta: this.servicioslocales_datadetalle[index].dope_preciototvta,
          // dope_preciounit_prom: valorfcosto ?? 0,
          dtar_codigo: this.tarifaActualizada['dtar_Codigo'],
          profit_fijo: this.tarifaActualizada['profit'],
          profit_local: this.tarifaActualizada['profit'],
          profitminimo: this.tarifaActualizada['profitminimo'],
          rtar_codigo: this.tarifaActualizada['rtar_Codigo'],
          tipocambiocompra: this.tarifaActualizada['tipocambiocompra'],
          tipocambioventa: this.tarifaActualizada['tipocambioventa'],
          nombremnd: Number(this.tarifaActualizada['servicio']?.value) === 734 ? 'USD' : this.tarifaActualizada['descripcion_monedacosto'],
          // nombremndvta: eraPromedio == false ? this.tarifaActualizada['descripcion_monedaventa'] : this.servicioslocales_datadetalle[index].nombremndvta,
          nombremndvta: this.servicioslocales_datadetalle[index].nombremndvta,
          tipo_codmnd: this.tarifaActualizada['tipo_codmndcosto'],
          tipo_codmndDope: this.tarifaActualizada['tipo_codmndcosto'],
          tipo_codmndprofit: this.tarifaActualizada['tipo_codmndprofit'],
          // tipo_codmndventa: eraPromedio == false ? this.tarifaActualizada['tipo_codmndventa'] : this.servicioslocales_datadetalle[index].tipo_codmndventa,
          tipo_codmndventa: this.servicioslocales_datadetalle[index].tipo_codmndventa,
          tipomonedam: this.tarifaActualizada['tipomonedam'],
          tipoprofitm: this.tarifaActualizada['tipoprofitm'],
          desctarifa: this.tarifaActualizada['desctarifa'],
          vigencias: this.tarifaActualizada['vigencias'],
          puedemodRZ: this.servicioslocales_datadetalle[index].puedemodRZ,
          ESTADO_OBJ: this.dtServiciosRefdt.obtenerEstado(row_orig.ESTADO_OBJ),
        };
      }
      this.servicioslocales_datadetalle = [...this.servicioslocales_datadetalle];
      this.messageService.clear();
      this.viewTarifarioCosto = false
      this.messageService.add({ severity: 'success', summary: 'Datos Actualizados', detail: 'Se ha actualizado la operación con los datos de la tarifa.', life: 3000, key: "tl" });
    }
  }

  obtenerCodigoPorEntidad = (valueEntidad: string | number, tipo: string): string | null => {
    const tiposMap: Record<string, string> = {
      '15': 'DepositoVacio',
      '14': 'DepositoTemp',
      '3': 'EJEC',
      '4': 'CUS',
      '5': 'TRANSPORTISTA',
      '9': 'CONTACTO',
      '6': 'AGE',
      '7': 'AGE',
      '2': 'PROVEEDOR',
      '10': 'SHIPPER',
      '17': 'TERMINALPORTUARIO',
      '1': 'CLIENTE'
    };

    const entidadEncontrada = this.ListaNombreEntidadesDP.find(
      e => Number(e.value) === Number(valueEntidad)
    );

    if (tipo === 'codigo') {
      if (!entidadEncontrada?.tipo) return null;
      const codigo = Object.keys(tiposMap).find(
        key => tiposMap[key]?.toUpperCase() === entidadEncontrada.tipo?.toUpperCase()
      );
      return codigo ?? null;
    } else {
      return tiposMap[String(valueEntidad)] ?? null;
    }
  }

  listarDatosParam() {
    const request = <ObtenerParametrosRequest>{}
    request.codigos = [
      { codigo: "RUTAS" },
      { codigo: "UNM" },
      { codigo: "EDO" },
      { codigo: "SUC" },
      { codigo: "PAC" },
      { codigo: "IMO" },
      { codigo: "MOD" },
    ]
    this.servParametros.ObtenerParametros(request).subscribe(response => {
      if (response.datos.status === 200) {
        this.listRutas = response.datos.result["RUTAS"]
        this.ListaUnidadMedida = response.datos.result["UNM"]
        this.ListaEstadosDope = response.datos.result["EDO"]
        this.ListaSucursales = (response.datos.result["SUC"] || []).map((suc: any) => ({
          ...suc,
          value: +suc.value
        }));
        this.ListaBultos = response.datos.result["PAC"]
        this.ListaImo = response.datos.result["IMO"]
        this.ListaMods = response.datos.result["MOD"]

        this.actualizarMaestros();
      }
    })
  }

  openComponent() {
    // if(!this.rowAgenciamiento) return
    const proformaConf: DynamicDialogConfig = {
      data: this.rowAgenciamiento,
      width: '70%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: false,
      closable: true,
      modal: true
    }

    const proformaRef = this.util.show(ProformaAgenciamientoAduanaComponent, null, proformaConf)

    proformaRef.onClose.subscribe((res: any) => {
      if (res) {
        if (res.mensaje == "OK") {
        }
      }
    });
  }
  calcularValor(tipoMoneda: string, costo: number, tipoCambio: number): number {
    if (costo === null || costo === undefined) return 0;
    if (tipoMoneda === null || tipoMoneda === undefined) return 0;
    costo = Number(costo);
    if (isNaN(costo)) return 0;
    let valor = 0
    switch (tipoMoneda) {
      case '001': // Soles -> convertir a dólares
        valor = tipoCambio && tipoCambio > 0 ? costo / tipoCambio : 0;
        break;
      case '002': // Dólares -> retorna igual
        valor = costo
        break;
      case '004': // Porcentaje -> dividir entre 100
        valor = costo / 100;
        return Math.round(valor * 10000) / 10000;
        break;
      default: // otros códigos no definidos
        valor = 0;
    }
    return Math.round(valor * 100) / 100;
  }

  styleRow = (row: any) => {
    if (row.cons_codest === '002') {
      return { 'background-color': "rgba(4, 0, 255, 0.05)", 'color': 'rgb(4, 0, 255)' } // rojo
    } else if (row.cons_codest === '005') {
      return { 'background-color': "#ffffff", 'color': '#ff0000ff' } // verde
    } else {
      return { 'background-color': "#ffffff" }//amarillo
    }
  }

  styleRowAlm = (row: any) => {
    if (row.color !== null) {
      return { 'background-color': row.color } // rojo
    } else {
      return { 'background-color': "#ffffff" }//amarillo
    }
  }

  bloqueoBtnAddCoordinador(tipo: string) {
    let regimen = '';
    let cope_fecemi = '';
    let listaItinerario = [];
    let fechaBase = null;

    if (tipo == 'INI') {
      if (this.datosRecibidos) {
        regimen = this.datosRecibidos.cons_codrgm;
        cope_fecemi = this.datosRecibidos["listadooperaciones"].length > 0 ? this.datosRecibidos["listadooperaciones"][0].cope_fecemi : new Date();
        listaItinerario = structuredClone(this.datosRecibidos['listadoviajeitinerario']);
      }
    } else if (tipo == 'EDIT') {
      regimen = this.group_datosgenerales.get('regimen')?.value;
      listaItinerario = this.viajeitinerario_dataitinerario;
      cope_fecemi = this.group_servicioslocales.get('fechaemision')?.value ?? new Date();
    }

    // NVIA_FecETA_IMPO_ETD_EXPO_2 impo
    // NVIA_FecETA_IMPO_ETD_EXPO

    let filaElegida = null;

    if (listaItinerario && listaItinerario.length > 0) {
      filaElegida = listaItinerario.find(item => item.ovnv_final === true);

      if (!filaElegida) {
        filaElegida = [...listaItinerario].sort((a, b) => b.ovnv_item - a.ovnv_item)[0];
      }
    }

    if (filaElegida) {

      if (regimen === '001') {
        fechaBase = filaElegida.eta_operativo ?? cope_fecemi;
      } else if (regimen === '002') {
        fechaBase = filaElegida.eta_contable ?? cope_fecemi;
      }

      if (fechaBase) {
        const hoy = new Date();
        const fechaElegida = new Date(fechaBase);
        const fechaVencimiento = new Date(fechaElegida.getFullYear(), fechaElegida.getMonth() + 4, fechaElegida.getDate());

        if (hoy > fechaVencimiento) {
          this.bloqueoAddAdicionales = true;
        } else {
          this.bloqueoAddAdicionales = false;
        }
      }
    } else {
      this.bloqueoAddAdicionales = false;
    }

  }

  onChangeCif(origen: string, tipo: string) {
    if (origen == 'EVE') {
      if (tipo == 'EJEC') {
        this.group_servicioslocales.get('montocif')?.setValue(this.group_servicioslocales.get('cifEjecVta')?.value);
      }
      else if (tipo == 'LOG') {
        this.group_servicioslocales.get('montocif')?.setValue(this.group_servicioslocales.get('cifLogistico')?.value);
      } else {
        this.group_servicioslocales.get('montocif')?.setValue(this.group_servicioslocales.get('cifLogistico')?.value);
      }
    }
    else if (origen == 'INI') {
      if (this.item2) {
        const row = this.item2;
        const montocif = row.cope_cifLogistico == null ? row.cope_cifEjecVta : row.cope_cifLogistico;
        this.group_servicioslocales.get('cifEjecVta')?.setValue(row.cope_cifEjecVta);
        this.group_servicioslocales.get('cifLogistico')?.setValue(montocif);
        this.group_servicioslocales.get('montocif')?.setValue(montocif);
      }

      const roladd = this.rol;
      if (['1', '10', '11', '14', this.coordLog, this.gerentLog].includes(roladd)) { // es coordinador

        if (['1', this.gerentLog].includes(roladd)) { // es admin
          this.group_servicioslocales.get('cifEjecVta')?.enable();
          this.group_servicioslocales.get('cifLogistico')?.enable();
        }
        else { // es coord
          this.group_servicioslocales.get('cifEjecVta')?.disable();
        }

      } else { // es ejec vta
        this.group_servicioslocales.get('cifLogistico')?.disable();
      }

    }
  }

  colorLeyendasAgrupacion(row: any): string {
    return row.agrupado ? '#2563EB' : '#9CA3AF';
  }

  dtZonas: any[] = []
  visibleZonas: boolean = false;
  mtZonasHijo: readonlyMetadataTable[] = [
    { title: 'Distrito', field: 'ubig_desdistrito', type: 'text' },
    { title: 'Provincia', field: 'ubig_desprovincia', type: 'text' },
    { title: 'Departamento', field: 'ubig_desdepartamento', type: 'text' },
  ];
  mtZonas: readonlyMetadataTable[] = [
    { title: 'Zona', field: 'tipo_deszon', type: 'text' },
    { title: '', field: 'detail', type: 'array', metadata: this.mtZonasHijo, key: 'dzon_codigo' }
  ];

  verZonas() {
    this.dtZonas = [];
    const request_zona_proveedor = <getZoneByProviderRequest>{
      zona: null,
      proveedor: null
    }
    this.servLogistica.getZoneByProvider(request_zona_proveedor).subscribe(res => {
      this.dtZonas = res.datos.result
      this.visibleZonas = true;
    }, err => {
      const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
      this.util.MessageDialog({ titulo: 'Error', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
    })
  }

  async cargarTarifasDefault() {
    if (this.accion === 'NUEVO' && this.solo_aereo == false) {
      if (this.group_servicioslocales.get('fechasl')?.value == null || this.group_servicioslocales.get('fechasl')?.value == '') {
        const hoy = new Date();
        const fechaNov4 = new Date(hoy.getFullYear(), 10, 4);
        //this.group_servicioslocales.get('fechasl').setValue(fechaNov4);

        this.group_servicioslocales.get('fechasl').setValue(new Date());
      }

      if (this.serviciosytarifas_dataflete.filter(row => row.ESTADO_OBJ !== 'D')?.length > 0
        && this.group_serviciostarifa.get('transportista')?.value != null && this.group_serviciostarifa.get("condicion")?.value != null && this.group_datosgenerales?.get("regimen")?.value != null) {

        await this.buscarServicioLogistico();

        // cargar tarifa vb , gate in , gate out 
        setTimeout(() => {
          if (this.dataTableTarifaServicioLogistico.length > 0) {
            console.log("servicios logisticos automaticos", this.dataTableTarifaServicioLogistico)

            if (this.servicioslocales_datadetalle?.length > 0) {
              this.tablaAgrupados = [];
              this.servicioslocales_datadetalle = [];
              this.servicioslocales_detalleAgrupacion = [];
            }

            // item.terminal?.value == "2179" terminal dp world
            const gateIn = this.dataTableTarifaServicioLogistico.find(item => item.servicio?.value === "1057");
            const gateOut = this.dataTableTarifaServicioLogistico.find(item => item.servicio?.value === "1058");
            const vb = this.dataTableTarifaServicioLogistico.find(item => item.servicio?.value === "1107");

            if (this.servicioslocales_datadetalle?.length > 0) {
              this.tablaAgrupados = [];
              this.servicioslocales_datadetalle = [];
              this.servicioslocales_detalleAgrupacion = [];
            }
            
            if (gateIn) {
              const fakeEvent = { checked: [true] };
              this.addTarifa(fakeEvent, gateIn, 'I', 'SLI');
            }

            if (gateOut) {
              const fakeEvent = { checked: [true] };
              this.addTarifa(fakeEvent, gateOut, 'I', 'SLI');
            }

            if (vb) {
              const fakeEvent = { checked: [true] };
              this.addTarifa(fakeEvent, vb, 'I', 'SLI');
            }
          }
        }, 100);

      }

    }

  }

  renderizarDom() {
    const scrollY = window.scrollY; // guarda posición actual
    this.cdr.detectChanges();
    window.scrollTo(0, scrollY); // restaura posición
  }

  saveArchivos() {
    const request_archivos = { items: [] } as ListaDetCotizacionOVArchivoRequest;

    if (
      this.archivos_dataarchivos &&
      this.archivos_dataarchivos.some(a => ['I', 'U', 'D'].includes(a.ESTADO_OBJ))
    ) {
      this.archivos_dataarchivos.forEach(archivo => {
        const estadoObj = archivo.ESTADO_OBJ !== undefined ? archivo.ESTADO_OBJ : "NA";
        if (estadoObj === "I" || estadoObj === "U" || estadoObj === "D" || estadoObj === "NA") {
          const itemTablaArchivo = {
            CCOT_Tipo: archivo.ccot_tipo,
            CCOT_Numero: archivo.ccot_numero,
            OVAR_Codigo: archivo.ovar_codigo,
            OVAR_Descrip: archivo.ovar_descrip,
            OVAR_FecEmi: archivo.ovar_fecemi,
            OVAR_Archivo: archivo.ovar_archivo,
            OVAR_Observacion: archivo.ovar_observacion,
            AUDI_UsrMod: this.nombreUsuario,
            AUDI_UsrCrea: this.nombreUsuario,
            ESTADO_OBJ: estadoObj,
          };
          request_archivos.items.push(itemTablaArchivo);
        }
      });

      this.ordenventaService.OVArchivoActualizar(request_archivos).subscribe(res => {
        this.messageService.add({ severity: 'success', summary: 'Archivos Actualizados', detail: 'Se han actualizado los archivos.', life: 3000, key: "tl" });
        this.obtenerArchivos();
      }, err => {
        const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
        this.util.MessageDialog({ titulo: 'Error', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
      })
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Sin cambios', detail: 'No hay cambios por guardar.', life: 3000, key: "tl" });
    }
  }

  verTarifarioSli() {

    let data = {
      origen: 'orden_venta',
    }

    const ref2 = this.dialogService.open(BandejaTarifarioSliComponent, {
      header: 'Tarifario SLI',
      data: data,
      width: '90%',
      contentStyle: { "overflow": "auto" },
      baseZIndex: 10000,
      maximizable: true,
      closable: true,
    });

    ref2.onClose.subscribe((res) => {
      if (res.message == "OK") {

      }
    });

  }

  validacionBloqueoRoles(): void { // testt
    const roles = this.listadoRoles;
    const tieneLogisticaPlus = roles?.some(u => u.role_codigo === 1064) ?? false;
    const esEjecVtaOAsisCus = roles?.some(u => (u.role_codigo === 4 // eject vta
      || u.role_codigo === 5) // asist customer
      && u.principal === false
    ) ?? false;
    const esLogisticaPlus = this.rol === '1' || tieneLogisticaPlus;

    if (esLogisticaPlus) {
      this.isLogisticaPlus = true;
      this.adicional = true;
      this.bloqueoColumnas = [...this.bloqueoColumnasLogisticaPlus];
    } else {
      switch (this.adicional) {
        case true:
          if (esEjecVtaOAsisCus) {
            this.bloqueoColumnas = [...this.bloqueoColumnasCostoYVta];
          } else {
            this.bloqueoColumnas = [...this.bloqueoColumnasCosto];
          }
          break;
        case false:
          this.bloqueoColumnas = [...this.bloqueoColumnasVta];
          break;
        default:
          this.bloqueoColumnas = [...this.bloqueoColumnas];
          break;
      }
    }
  }

  verificarCambiosPorAutorizar(): { resultado: boolean, items: number[], datos: any[] } {

    const itemsTrue: number[] = [];
    const datos: any[] = [];

    const listadoOriginal = this.datos ? structuredClone(this.datos['listadoserviciosasociados'] ?? []) : [];

    const existe006 = this.servicioslocales_datadetalle?.some(x => x.cons_codest === '006');

    if (!existe006) { return { resultado: false, items: [], datos: [] }; }

    for (const item of this.servicioslocales_datadetalle ?? []) {

      if ((item.ESTADO_OBJ === 'I' || item.ESTADO_OBJ === 'U') && item.cons_codest === '006') {

        const original = listadoOriginal.find(x => x.dope_item === item.dope_item && x.cope_codigo === item.cope_codigo);
        const debeAutorizar = item.ESTADO_OBJ === 'I' || (item.ESTADO_OBJ === 'U' && original?.cons_codest !== '006');

        if (!debeAutorizar) { continue; }
        itemsTrue.push(item.dope_item);

        if (item.esadicional === true) {

          datos.push({
            nombre_servicio: item.serv_nombre_spa?.label ?? item.serv_nombre_spa,
            precio_original: item.dope_preciounitvta,
            precio_modificado: item.dope_preciounitcosto,
            tipo: 'C',
            precio_cod_mnd: item.nombremndvta?.value ?? item.tipo_codmndventa ?? null,
            precio_tab_mnd: 'MND',
            precio_desc_mnd: item.nombremndvta?.label ?? null,
            desc_moneda_solicitado: item.nombremnd?.label ?? null,
            cod_moneda_solicitado: item.nombremnd?.value ?? item.tipo_codmnd ?? null,
            tab_moneda_solicitado: 'MND',
          });

          item.tipo_autorizacion = 'C';

        } else {

          datos.push({
            nombre_servicio: item.serv_nombre_spa?.label ?? item.serv_nombre_spa,
            precio_original: item.venta_tarifa_original,
            precio_modificado: item.dope_preciounitvta,
            tipo: 'V',
            precio_cod_mnd: item.cod_mnd_venta_tariff_original,
            precio_tab_mnd: item.tab_mnd_venta_tariff_original,
            precio_desc_mnd: item.desc_mnd_venta_tariff_original,
            desc_moneda_solicitado: item.nombremndvta?.label ?? item.nombremndvta ?? null,
            cod_moneda_solicitado: item.nombremndvta?.value ?? item.tipo_codmndventa ?? null,
            tab_moneda_solicitado: item.tipo_tabmndventa ?? null,
          });

          item.mnd_tarifa = item.cod_mnd_venta_tariff_original;
          item.tab_tarifa = item.tab_mnd_venta_tariff_original;
          item.monto_tarifa = item.venta_tarifa_original;
          item.tipo_autorizacion = 'V';
        }
      }
    }

    return { resultado: itemsTrue.length > 0, items: itemsTrue, datos: datos };
  }

  listarOPCabeceraCambios(row: any) {
    this.group_servicioslocales.patchValue({
      codigooperacion: row.cope_codigo,
      numerooperacion: row.cope_numdoc,
      fechaemision: row.cope_fecemi ? new Date(row.cope_fecemi) : null,
      clienteDSL: row.entc_codcliente?.toString() ?? null,
      transportistaam: row.entc_nombretransportista,
      almacen: row.entc_nombrealmacen,
      agencia: row.entc_nombreagenciamaritima,
      terminal: row.terminal_portuario,
      condicion: row.descripcioncondicionembarque,
      transportista: null,
      sada: null,
      imo: null,
      tarifa: row.ctar_codigo,
      tipo: row.tarifftype,
      vigenciadesde: row.validfrom ? new Date(row.validfrom) : null,
      vigenciahasta: row.validto ? new Date(row.validto) : null,
      descripcion: row.remarks,
      observaciones: null,
      transportistaTerre: null,
      fechasl: row.cope_fechaSL ? new Date(row.cope_fechaSL) : null,
      isintegral: row.sintegral,
      promedio: true,
      rutas: row.codigo_ruta,
      montocif: null,
      montodam: row.cope_dam,
      cifLogistico: row.cope_cifLogistico,
      cifEjecVta: row.cope_cifEjecVta,
      peso: row.cope_peso_sli,
      volumen: row.cope_volumen_sli,
      unmd_peso: row.cope_unmd_peso,
      unmd_volumen: row.cope_unmd_volumen,
      sucursal: row.sucursal,
    });
    this.onChangeCif('INI', '');
  }

  async listarRolesUsr() {
    try {
      const Request = <ListarRolesUsuarioRequest>{}
      Request.usuario = this.nombreUsuario;
      const res = await firstValueFrom(this.usuariosService.listarRolesByUsr(Request));
      if (res.datos.status === 200) {
        this.listadoRoles = res.datos.result;
      }
    } catch (err) {
      console.warn(err);
    }
  }

  checkedServicios: any[] = [];
  todosSeleccionados = false;

  toggleSeleccionarTodos(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.todosSeleccionados = checked;
    this.checkedServicios = [];
    if (!checked) {
      this.servicioslocales_datadetalle.forEach(row => {
        if (row.ESTADO_OBJ !== 'D') {
          this.addTarifa({ checked: [], value: row.key }, row, 'A', null);
        }
      });
      return;
    }

    this.servicioslocales_datadetalle.forEach(row => {
      if ((row.cons_codest === '001' || row.cons_codest == null) && row.ESTADO_OBJ !== 'D') {
        this.checkedServicios.push(row.key);
        this.addTarifa({ checked: [row.key], value: row.key }, row, 'A', null);
      }
    });

    this.checkedServicios = [...this.checkedServicios];
  }

  private syncHeaderCheckbox(): void {
    const validRows = this.servicioslocales_datadetalle.filter(row =>
      (row.cons_codest === '001' || row.cons_codest == null) && row.ESTADO_OBJ !== 'D'
    );
    this.todosSeleccionados = validRows.length > 0 && validRows.every(row => this.checkedServicios.includes(row.key));
  }

  onCheckServicioNative(event: Event, row: any): void {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      if (!this.checkedServicios.includes(row.key)) {
        this.checkedServicios.push(row.key);
      }
      this.addTarifa({ checked: [row.key], value: row.key }, row, 'A', null);
    } else {
      this.checkedServicios = this.checkedServicios.filter(k => k !== row.key);
      this.addTarifa({ checked: [], value: row.key }, row, 'A', null);
    }

    this.syncHeaderCheckbox();
    this.checkedServicios = [...this.checkedServicios];
  }

  obtenerCodigoPorValor(lista: any[], valor: any): string | null {
    if (!valor) return null;
    const encontrado = lista.find(item =>
      item.nombre === valor || item.codigo === valor
    );
    return encontrado ? encontrado.codigo : null;
  }

  cancelarFilasEdicion() {
    this.dataFlete?.cancelarEdicionActiva();
    this.dtServiciosRefdt?.cancelarEdicionActiva();
  }

  verColumnaMetadata(row: any, columna: string): boolean {
    // se devuelve true para que se muestre la columna
    const activos = this.servicioslocales_datadetalle.filter(item => item.ESTADO_OBJ !== 'D');

    if (activos.length === 0) return false;

    const obtenerValor = (val: any) => (val && typeof val === 'object' ? val.value : val);

    switch (columna) {
      case 'tipo_cambio': {

        const valoresMnd = activos
          .map(item => obtenerValor(item.nombremnd))
          .filter(val => val !== null && val !== undefined && val !== '');

        const valoresMndVta = activos
          .map(item => obtenerValor(item.nombremndvta))
          .filter(val => val !== null && val !== undefined && val !== '');

        const hayDiferenciaMnd = new Set(valoresMnd).size > 1;
        const hayDiferenciaMndVta = new Set(valoresMndVta).size > 1;

        return hayDiferenciaMnd || hayDiferenciaMndVta;
      }

      default:
        return false;
    }
  }

  actualizarValidacionSucursal() {
    const regimen = this.group_datosgenerales.get('regimen')?.value;

    const sucursalControl = this.group_servicioslocales.get('sucursal');
    const puertoDestino = this.group_serviciostarifa.get('puertodestino')?.value;
    const puertoOrigen = this.group_serviciostarifa.get('puertoorigen')?.value;

    let esRequerido = false;

    if (this.solosli === true && (sucursalControl?.value === null || sucursalControl?.value === undefined)) {
      if (regimen === '001' && puertoDestino === null) {
        esRequerido = true;
      } else if (regimen === '002' && puertoOrigen === null) {
        esRequerido = true;
      }
    }

    if (esRequerido) {
      sucursalControl?.setValidators([Validators.required]);
    } else {
      sucursalControl?.clearValidators();
    }

    sucursalControl?.updateValueAndValidity();
  }

  deshabilitarBotones(event) {
    this.deshabilitarBtnGuardar = false;
    const boton = event?.currentTarget as HTMLButtonElement;
    if (boton) { boton.disabled = false; }
  }

  // #region Datos Emisión

  @ViewChild('tabDatosEmision') tabDatosEmision!: OvDatosDeEmisionComponent;
  initDatosEmision: I_InitDatosEmision;
  // maestrosParaEmision: any = null;

  private maestrosSubject = new BehaviorSubject<any>(null);
  maestrosParaEmision$ = this.maestrosSubject.asObservable();

  actualizarMaestrosEmision() {
    this.maestrosSubject.next({
      paquetes: this.ListaTipoPaquete,
      bultos: this.ListaBultos,
      comodities: this.ListaComodity,
      claseimo: this.ListaImo,
      listaShippers: this.ListaTodosShipper,
      listaConsignee: this.ListaTodosConsignee,
      listaNotify: this.ListaTodosNotify,
    });
  }

  inicializarDatosDeEmision() {

    let listaContenedores: I_ListadoContenedores[] = [];
    if (this.datosRecibidos?.['listadoContenedores']?.length > 0) {
      listaContenedores = structuredClone(this.datosRecibidos['listadoContenedores']);
    }

    this.initDatosEmision = {
      ccot_tipo: (this.datosRecibidos && this.datosRecibidos.ccot_tipo != null) ? this.datosRecibidos.ccot_tipo : 2,
      ccot_numero: (this.datosRecibidos && this.datosRecibidos.ccot_numero != null) ? this.datosRecibidos.ccot_numero : 0,
      ddov_descshipper: this.datosRecibidos?.ddov_descshipper ?? null,
      ddov_descconsignee: this.datosRecibidos?.ddov_descconsignee ?? null,
      ddov_descnotify: this.datosRecibidos?.ddov_descnotify ?? null,
      ddov_descapplyto: this.datosRecibidos?.ddov_descapplyto ?? null,
      doov_placereceipt: this.datosRecibidos?.doov_placereceipt ?? null,
      doov_placedelivery: this.datosRecibidos?.doov_placedelivery ?? null,
      listadoContenedores: listaContenedores ?? [],
      usuario: this.nombreUsuario,
      ddov_mblconsignee: this.datosRecibidos?.ddov_mblconsignee ?? null,
      ddov_mbldescconsignee: this.datosRecibidos?.ddov_mbldescconsignee ?? null,
      ddov_mblshipper: this.datosRecibidos?.ddov_mblshipper ?? null,
      ddov_mbldescshipper: this.datosRecibidos?.ddov_mbldescshipper ?? null,
      ddov_mblnotify: this.datosRecibidos?.ddov_mblnotify ?? null,
      ddov_mbldescnotify: this.datosRecibidos?.ddov_mbldescnotify ?? null,
      cod_shipper: this.datosRecibidos?.entc_codshipper ?? null,
      cod_consignee: this.datosRecibidos?.entc_codconsignee ?? null,
      cod_notify: this.datosRecibidos?.entc_codnotify ?? null,
      mbl: this.datosRecibidos?.doov_mbl ?? null,
      from_operaciones: this.from_operaciones,
      solo_aereo: this.solo_aereo,
    }

    this.tabDatosEmision?.cargarDatosIniciales();

  }

  fnOnChangeEntidadesDatosEmision(tipo: string) {
    const valuesDatosEmbarque = this.group_datosembarque.value;

    if (this.tabDatosEmision) {
      if (tipo == 'shipper') {
        let cod_shipper = valuesDatosEmbarque["shipper"] ? Number(this.ListaTodosShipper.find(item => item.nombre === valuesDatosEmbarque["shipper"])?.codigo) || 0 : null;
        this.tabDatosEmision.onChangeShipper(cod_shipper, false);
      } else if (tipo == 'notify') {
        let cod_notify = valuesDatosEmbarque["notify"] ? Number(this.ListaTodosNotify.find(item => item.nombre === valuesDatosEmbarque["notify"])?.codigo) || 0 : null;
        this.tabDatosEmision.onChangeNotify(cod_notify, false);
      } else if (tipo == 'consignee') {
        let cod_consignee = valuesDatosEmbarque["consignee"] ? Number(this.ListaTodosConsignee.find(item => item.nombre === valuesDatosEmbarque["consignee"])?.codigo) || 0 : null;
        this.tabDatosEmision.onChangeConsignee(cod_consignee, false);
      }
    } else { console.warn("El componente de Datos de Emisión no está cargado en el DOM."); }
  }

  fnOnChangeMblDatosEmision() {
    const valuesNovedades = this.group_novedades.value;

    if (this.tabDatosEmision) {
      let mbl = valuesNovedades["blmaster"] || null;
      this.tabDatosEmision.onChangeMbl(mbl);
    } else { console.warn("El componente de Datos de Emisión no está cargado en el DOM."); }
  }

  // #endregion

  // #region Btns Superiores

  initBtnsSuperiores: I_InitBtnsSuperioresOv;

  inicializarBtnsSuperiores() {

    this.initBtnsSuperiores = {
      ccot_tipo: (this.datosRecibidos && this.datosRecibidos.ccot_tipo != null) ? this.datosRecibidos.ccot_tipo : 2,
      ccot_numero: (this.datosRecibidos && this.datosRecibidos.ccot_numero != null) ? this.datosRecibidos.ccot_numero : 0,
      usuario: this.nombreUsuario,
      cons_codest: (this.datosRecibidos && this.datosRecibidos.cons_codest != null) ? this.datosRecibidos.cons_codest : "001",
      cons_codvia: (this.datosRecibidos && this.datosRecibidos.cons_codvia != null) ? this.datosRecibidos.cons_codvia : null,
    }

    this.tabDatosEmision?.cargarDatosIniciales();
  }

  onDocumentada(callbackRetorno: (data: any) => void) {
    try {
      const datosDelFormulario = this.obtenerDataActual('VALIDACION_OP');
      callbackRetorno(datosDelFormulario);

    } catch (error) {
      console.error("Error al recopilar datos:", error);
    }
  }

  onDocumentadaEnd() {
    const btnGuardarReal = document.getElementById('btnGuardarPrincipal') as HTMLButtonElement;

    const eventoSimulado = {
      currentTarget: btnGuardarReal,
      target: btnGuardarReal,
      type: 'click',
      preventDefault: () => { },
      stopPropagation: () => { }
    } as unknown as Event;

    this.group_datosgenerales.get('estado')?.setValue(CONST_VARIABLES.CONS_ESTOVEDOCUMENTADA);

    this.operaciones_menu('Guardar', eventoSimulado, 'OV Documentada');
  }

  private maestrosBtnsSupSubject = new BehaviorSubject<I_InitMaestrosBtnsSuperiores | null>(null);
  maestrosBtnsSupSubject$ = this.maestrosBtnsSupSubject.asObservable();

  actualizarMaestrosBtnsSuperiores() {
    this.maestrosBtnsSupSubject.next({
      ListaMods: this.ListaMods,
    });
  }

  // #endregion

  // #region GLOBAL

  inicializarDatosComponentes() {
    this.inicializarDatosDeEmision();
    this.inicializarBtnsSuperiores();
  }

  actualizarMaestros() {
    this.actualizarMaestrosEmision();
    this.actualizarMaestrosBtnsSuperiores();
  }

  // #endregion

  // #region REQUEST CRUD

  obtenerDataActual(modo: 'TODO' | 'VALIDACION_OP') {
    // --- 1. CAPTURA DE VALORES
    const valuesDatosGenerales = this.group_datosgenerales.value;
    const valuesServicioTarifa = this.group_serviciostarifa.value;
    const valuesDatosEmbarque = this.group_datosembarque.value;
    const valuesObservaciones = this.group_observaciones.value;
    const valuesNovedades = this.group_novedades.value;
    const valuesEventosTareas = this.group_eventostareas.value;
    const valuesServiciosLocales = this.group_servicioslocales.value;
    const valuesArchivos = this.group_archivos.value;

    // Obtener datos del componente hijo
    const datosEmision = this.tabDatosEmision?.getTabData();
    const tablaContenedores = datosEmision?.contenedores ?? [];

    // --- 2. MAPEO DE CABECERA (REQUEST) ---
    const request = <CrudOrdenesVentaRequest>{};
    request.pintCCOT_Numero = (this.datosRecibidos && this.datosRecibidos.ccot_numero != null) ? this.datosRecibidos.ccot_numero : 100;
    request.psinCCOT_Tipo = 2;
    request.psinEMPR_Codigo = 1;
    request.psinSUCR_Codigo = 1;
    request.pvchCCOT_NumDoc = (this.datosRecibidos && this.datosRecibidos.ccot_numdoc != null) ? this.datosRecibidos.ccot_numdoc : "2024-3342";
    request.pintCCOT_NumPadre = (this.datosRecibidos && this.datosRecibidos.ccot_numpadre != null) ? this.datosRecibidos.ccot_numpadre : null;
    request.psinCCOT_TipoPadre = (this.datosRecibidos && this.datosRecibidos.ccot_tipopadre != null) ? this.datosRecibidos.ccot_tipopadre : null;
    request.psinCCOT_Version = 1;
    request.pbitCCOT_Propia = valuesDatosGenerales["cotizacionpropia"];
    request.pintENTC_CodCliente = this.group_datosgenerales.get('cliente')?.value;
    request.pintENTC_CodTransportista = this.group_serviciostarifa.get('transportista')?.value;
    request.pintENTC_CodBroker = null;
    request.pintENTC_CodAgente = this.group_datosgenerales.get('agente')?.value;
    request.pintENTC_CodCustomer = this.group_datosgenerales.get('customer')?.value;
    request.pintENTC_CodEjecutivo = this.group_datosgenerales.get('ejecutivo')?.value;
    request.pintCCOT_NumPresupuesto = (this.datosRecibidos && this.datosRecibidos.ccot_numpresupuesto != null) ? this.datosRecibidos.ccot_numpresupuesto : null;
    request.pdtmCCOT_FecEmi = this.util.formatearfecha(valuesDatosGenerales["fechaemision"], "yyyy-MM-ddTHH:mm:ss");
    request.pdtmCCOT_FecVcto = this.util.formatearfecha(valuesDatosGenerales["fechavencimiento"], "yyyy-MM-ddTHH:mm:ss");
    request.pbitCCOT_ServicioLogistico = false;
    request.pbitCCOT_VoBoGateIn = false;
    request.pbitCCOT_CargaRefrigerada = valuesDatosEmbarque["cargarefrigerada"];
    request.pnumCCOT_Temperatura = valuesDatosEmbarque["temperatura"];
    request.pbitCCOT_CargaPeligrosa = valuesDatosEmbarque["cargapeligrosa"];
    request.pbitCCOT_Roundtrip = valuesDatosEmbarque["roundtrip"];
    request.pvchCCOT_Observaciones = valuesObservaciones["instrucciones"] ? valuesObservaciones["instrucciones"] : "";
    request.pdtmCCOT_FecCierre = null;
    request.psinCCOT_Almacenaje = valuesObservaciones["almacenaje"];
    request.psinCCOT_SobreEstadia = (valuesObservaciones["sobreestadia"] != null && valuesObservaciones["sobreestadia"] !== " ") ? valuesObservaciones["sobreestadia"] : 0;
    request.psinCCOT_TiempoViaje = valuesObservaciones["tiempoviaje"];
    request.psinCCOT_ValidezOferta = valuesObservaciones["validezoferta"];
    request.pchrTIPO_TabINC = "INC";
    request.pchrTIPO_CodINC = valuesDatosGenerales["incoterm"];
    request.pchrTIPO_TabImo = "IMO";
    request.pchrTIPO_CodImo = valuesDatosEmbarque["imoclass"];
    request.pvchCCOT_ImoUN = valuesDatosEmbarque["imoun"];
    request.pintCONT_Codigo = this.group_serviciostarifa.value["cont_codigo"];
    request.pchrCONS_TabRGM = "RGM";
    request.pchrCONS_CodRGM = valuesDatosGenerales["regimen"];
    request.pchrCONS_TabVia = "VIA";
    request.pchrCONS_CodVia = valuesDatosGenerales["via"];
    request.pchrCONS_TabFLE = "FLE";
    request.pchrCONS_CodFLE = valuesServicioTarifa["condicion"];
    request.pchrCONS_TabEST = "OVE";
    request.pchrCONS_CodEST = valuesDatosGenerales["estado"];
    request.pintPUER_CodDestino = valuesServicioTarifa["puertodestino"];
    request.pintPUER_CodTrasbordo = valuesServicioTarifa["puertotransbordo"];
    request.pintPUER_CodOrigen = valuesServicioTarifa["puertoorigen"];
    request.pvchCCOT_UsrAprueba = null;
    request.pdtmCCOT_FecAprueba = this.util.formatearfecha(valuesDatosGenerales["fechaaprobacion"], "yyyy-MM-ddTHH:mm:ss");
    request.pvchCCOT_UsrAceptaRechaza = null;
    request.pdtmCCOT_FecAceptaRechaza = null;
    request.pchrTIPO_TabMOT = (this.datosRecibidos && this.datosRecibidos.tipo_tabmot != null) ? this.datosRecibidos.tipo_tabmot : null;
    request.pchrTIPO_CodMOT = (this.datosRecibidos && this.datosRecibidos.tipo_codmot != null) ? this.datosRecibidos.tipo_codmot : null;
    request.pintENTC_CodShipper = valuesDatosEmbarque["shipper"];
    request.pintENTC_CodConsignee = valuesDatosEmbarque["consignee"];
    request.pintENTC_CodNotify = valuesDatosEmbarque["notify"];
    request.pchrCONS_TabTFT = "TFT";
    request.pchrCONS_CodTFT = valuesServicioTarifa["tipofechatarifa"];
    request.pdtmCCOT_FecTarifa = this.util.formatearfecha(valuesServicioTarifa["fechatarifa"], "yyyy-MM-ddTHH:mm:ss");
    request.pchrCCOT_PagoMBL = valuesServicioTarifa["pcmbl"];
    request.pchrCCOT_PagoHBL = valuesServicioTarifa["pchbl"];
    request.pchrTIPO_TabMND = "MND";
    request.pchrTIPO_CodMND = valuesServicioTarifa["moneda"];
    request.pvchDOOV_Cntr = valuesNovedades["contenedor"];
    request.pchrDOOV_HBL = valuesNovedades["blhijo"];
    request.pchrDOOV_MBL = valuesNovedades["blmaster"];
    request.pvchDDOV_NroBooking = valuesNovedades["numerobooking"];
    request.pdtmDDOV_FecRecBooking = (this.datosRecibidos && this.datosRecibidos.ddov_fecrecbooking != null) ? this.datosRecibidos.ddov_fecrecbooking : null;

    const tieneDatosValidos = Array.isArray(this.viajeitinerario_dataitinerario) && this.viajeitinerario_dataitinerario.length > 0;
    request.pdtmDDOV_FecEmbarque = tieneDatosValidos == true ? this.viajeitinerario_dataitinerario[0].fechaembarque : this.util.formatearfecha(valuesDatosGenerales["fechaembarque"], "yyyy-MM-ddTHH:mm:ss");

    request.pintENTC_CodDepTemporal = valuesNovedades["deposito"];
    request.pvchDOOV_CodReferencia = valuesDatosEmbarque["referencia"];
    request.pintNVIA_Codigo = Number(valuesNovedades["viaje"]);
    request.pvchDOOV_Feeder_IMPO = (this.datosRecibidos && this.datosRecibidos.doov_feeder_impo != null) ? this.datosRecibidos.doov_feeder_impo : null;
    request.pdtmDOOV_FecETDFeeder_IMPO = (this.datosRecibidos && this.datosRecibidos.doov_fecetdfeeder_impo != null) ? this.datosRecibidos.doov_fecetdfeeder_impo : null;
    request.pbitDDOV_HBLNieto = valuesNovedades["blnieto"];
    request.pbitCCOT_ServicioTransmision = false;
    request.pchrTIPO_TabTRF = "TRF";
    request.pchrTIPO_CodTRF = valuesServicioTarifa["trafico"];
    request.pbitCCOT_EnviaAvisoLlegada = valuesDatosGenerales["avisodellegada"];
    request.pchrCONS_TabLNG = "LNG";
    request.pchrCONS_CodLNG = valuesDatosGenerales["lineanegocio"];
    request.pvchAUDI_UsrCrea = this.storage.get("usuario");
    request.pvchAUDI_UsrMod = this.storage.get("usuario");
    request.pvchCCOT_OrdenCompra = null;
    request.sli = this.solosli;

    request.solo_aereo = this.solo_aereo;
    request.from_operaciones = this.from_operaciones;
    request.pvch_ddov_descshipper = datosEmision?.formulario.shipper ?? null;
    request.pvch_ddov_descconsignee = datosEmision?.formulario.consignee ?? null;
    request.pvch_ddov_descnotify = datosEmision?.formulario.notify ?? null;
    request.pvch_ddov_descapplyto = datosEmision?.formulario.applyto ?? null;
    request.pvch_doov_placereceipt = datosEmision?.formulario.place_receipt ?? null;
    request.pvch_doov_placedelivery = datosEmision?.formulario.place_delivery ?? null;
    request.ccot_emitirhbl = (this.datosRecibidos && this.datosRecibidos.ccot_emitirhbl != null) ? this.datosRecibidos.ccot_emitirhbl : false;
    request.tablaContenedores = tablaContenedores;
    request.pvch_ddov_mblconsignee = datosEmision?.form_master.consignee ?? null;
    request.pvch_ddov_mbldescconsignee = datosEmision?.form_master.desc_consignee ?? null;
    request.pvch_ddov_mblshipper = datosEmision?.form_master.shipper ?? null;
    request.pvch_ddov_mbldescshipper = datosEmision?.form_master.desc_shipper ?? null;
    request.pvch_ddov_mblnotify = datosEmision?.form_master.notify ?? null;
    request.pvch_ddov_mbldescnotify = datosEmision?.form_master.desc_notify ?? null;
    request.aerolinea = valuesServicioTarifa["aerolinea"];
    request.pdtmDDOV_FecSalida = this.util.formatearfecha(valuesDatosGenerales["fecsalida"], "yyyy-MM-ddTHH:mm:ss");
    request.pdtmDDOV_FecConexion = this.util.formatearfecha(valuesDatosGenerales["feconexion"], "yyyy-MM-ddTHH:mm:ss");
    request.pvch_ccot_descshipper = valuesDatosEmbarque["desc_shipper"];
    request.pvch_ccot_descconsignee = valuesDatosEmbarque["desc_consignee"];

    // --- 3. MAPEO DE FLETE ---
    const insertActualizarOVFlete = { items: [] };
    const datosembarqueMap = new Map<string, any>();
    this.datosembarque_dataflete.forEach((item, i) => {
      const identifier = item.dcot_item || item.key || i;
      if (identifier) { datosembarqueMap.set(identifier.toString(), item); }
    });

    request.tablaFlete = [];
    this.serviciosytarifas_dataflete.forEach((item, i) => {
      const datosembarqueItem = datosembarqueMap.get((item.dcot_item || item.key || i)?.toString());
      const packCod = this.ListaOriginalTipoPaquete.find(r => r.label === this.extraerLabelSinObjeto(item.pack_desc));
      const unmCod = this.ListaUnidadMedida.find(r => r.label === this.extraerLabelSinObjeto(datosembarqueItem?.unm_desc));
      const cdtCod = this.ListaComodity.find(r => r.label === this.extraerLabelSinObjeto(datosembarqueItem?.cdt_desc));
      const val1 = item.ESTADO_OBJ;
      const val2 = datosembarqueItem?.ESTADO_OBJ;

      const estadoObj = (val1 && val1 !== "NA") ? val1 : (val2 && val2 !== "NA") ? val2 : "NA";

      if (estadoObj === "I" || estadoObj === "U" || estadoObj === "D" || estadoObj === "NA") {
        const itemTablaFlete = {
          CCOT_Tipo: request.psinCCOT_Tipo || 2,
          CCOT_Numero: request.pintCCOT_Numero || 0,
          DCOT_Item: item.dcot_item || i,
          PACK_Codigo: packCod ? packCod.value : item.pack_desc.value,
          DCOT_Producto: datosembarqueItem ? datosembarqueItem?.dcot_producto || " " : " ",
          DCOT_Cantidad: item.dcot_cantidad || 1.0000,
          // DCOT_PrecioUniCosto: item.dcot_preciounicosto != undefined ? item.dcot_preciounicosto : 0.00,
          // DCOT_TotalUniCosto: item.dcot_totalunicosto != undefined ? item.dcot_totalunicosto : 0.00,
          // DCOT_TotalUniVenta: item.dcot_totaluniventa || 0.00,
          // DCOT_PrecioUniVenta: item.dcot_preciouniventa || 0.00,
          DCOT_PrecioUniCosto: (item.dcot_preciounicosto === "" || item.dcot_preciounicosto == undefined) ? 0.00 : item.dcot_preciounicosto,
          DCOT_TotalUniCosto: (item.dcot_totalunicosto === "" || item.dcot_totalunicosto == undefined) ? 0.00 : item.dcot_totalunicosto,
          DCOT_TotalUniVenta: item.dcot_totaluniventa === "" ? 0.00 : (item.dcot_totaluniventa || 0.00),
          DCOT_PrecioUniVenta: item.dcot_preciouniventa === "" ? 0.00 : (item.dcot_preciouniventa || 0.00),
          DCOT_Importe: item.dcot_importe || 0.00,
          DCOT_Peso: datosembarqueItem ? datosembarqueItem?.dcot_peso || 0.00 : 0.00,
          DCOT_Volumen: datosembarqueItem ? datosembarqueItem?.dcot_volumen || 0.00 : 0.00,
          DCOT_Bultos: datosembarqueItem ? datosembarqueItem?.dcot_bultos || 0.00 : 0.00,
          DCOT_Largo: datosembarqueItem ? datosembarqueItem?.dcot_largo || 0.00 : 0.00,
          DCOT_Ancho: datosembarqueItem ? datosembarqueItem?.dcot_ancho || 0.00 : 0.00,
          DCOT_Alto: datosembarqueItem ? datosembarqueItem?.dcot_alto || 0.00 : 0.00,
          TIP_TabUnm: "UNM", // item.tipo_tabunm || 
          TIP_CodUnm: unmCod ? unmCod.value : null,
          TIP_TabCDT: "CDT", // item.tipo_tabcdt ||
          TIP_CodCDT: cdtCod ? cdtCod.value : null,
          TARI_Codigo: item.tari_codigo || null,
          AUDI_UsrMod: this.storage.get("usuario") || null,
          AUDI_UsrCrea: this.storage.get("usuario") || null,
          SERV_Codigo: null,
          ESTADO_OBJ: estadoObj,
          itemAnterior: item.dcot_item
        };
        request.tablaFlete.push(itemTablaFlete);
        insertActualizarOVFlete.items.push(itemTablaFlete);
      }
    });

    // -------------------------------------------------------------------------------------------
    // PUNTO DE CORTE: Si el modo es 'VALIDACION_OP', retornamos aquí lo necesario y salimos.
    // -------------------------------------------------------------------------------------------
    if (modo === 'VALIDACION_OP') {
      // En este modo, completamos los IDs que se usan en las validaciones si es necesario, 
      // o simplemente retornamos los datos "crudos" del form si eso es lo que espera tu validador.
      // Por seguridad, asignamos los IDs principales igual que en el guardado completo.
      request.pintENTC_CodCliente = this.group_datosgenerales.get('cliente')?.value ? Number(this.ListaTodosCliente.find(cliente => cliente.nombre === this.group_datosgenerales.get('cliente')?.value)?.codigo) || 0 : null;

      return {
        request: request,
        itemsFlete: insertActualizarOVFlete.items,
        itemsServicio: [], // No necesario para documentar
        itemsCNTR: tablaContenedores
      } as any;
    }

    // --- 4. MAPEO DE SERVICIOS (Solo si modo es TODO) ---
    const insertActualizarOVServicio = { items: [] };
    const serviciosPrevios = this.serviciosytarifas_dataservicios || [];
    request.tablaServicio = [];
    this.serviciosytarifas_dataservicios.forEach((item, i) => {
      const servicioPrevio = serviciosPrevios.find(prev => prev.scot_item === item.scot_item);
      const servicio = this.ListaServiciosByViaRgmLngDP.find(r => r.label === item.serv_nombre);
      const moneda = this.ListaMoneda.find(r => r.label === item.tipo_descmnd || r.value === item.tipo_descmnd);
      const entidad = this.ListaTipoEntidad.find(r => r.label === item.tipedescripcion);
      const proveedor = this.ListaProveedorG.find(r => r.label === item.entc_nomcom);
      const base = this.ListaBase.find(r => r.label === item.cons_desc_spa || r.value === item.cons_desc_spa);
      const ingeg = this.ListaServicio.find(r => r.label === item.ccot_ingresogasto || r.value === item.ccot_ingresogasto);
      const codTDO = this.ListaTipoDocumento.find(r => r.label === this.extraerLabelSinObjeto(item.tipo_desctdo));
      const estadoObj = item.ESTADO_OBJ !== undefined ? item.ESTADO_OBJ : "NA";

      if (estadoObj === "I" || estadoObj === "U" || estadoObj === "D" || estadoObj === "NA") {
        const itemTablaServicio = {
          CCOT_Tipo: request.psinCCOT_Tipo || 2,
          CCOT_Numero: request.pintCCOT_Numero || null,
          SCOT_Item: item?.scot_item != "" && item?.scot_item != null ? item.scot_item : item.key,
          CCOT_IngresoGasto: (ingeg && ingeg.value === '001') || item.ccot_ingresogasto.value === '001' ? "I" :
            (ingeg && ingeg.value === '002') || item.ccot_ingresogasto.value === '002' ? "E" :
              ingeg ? ingeg.value : item.ccot_ingresogasto.value,
          SERV_Codigo: servicio ? Number(servicio.value) : item.serv_nombre.value,
          SCOT_Origen: "D",
          SCOT_Cantidad: item.scot_cantidad || null,
          SCOT_PrecioUni: item.scot_preciouni || null,
          SCOT_Importe_Ingreso: item.scot_importe_ingreso || 0.00,
          SCOT_Importe_Egreso: item.scot_importe_egreso || 0.00,
          TIPO_TabMnd: "MND",
          TIPO_CodMnd: item.tipo_descmnd.value ?? moneda.value ?? moneda.label,
          SCOT_PreSugerido: item.scot_presugerido != "" && item.scot_presugerido != null ? item.scot_presugerido : 0.00,
          TIPE_Codigo: entidad ? entidad.value : item.tipedescripcion.value,
          ENTC_Codigo: proveedor ? proveedor.value : item.entc_nomcom.value,
          TARI_Codigo: item.tari_codigo || null,
          CONS_TabBas: item.cons_desc_spa.nombre || "BAS",
          CONS_CodBas: item.cons_desc_spa.value ?? base.value,
          SCOT_Exonerado: item.scot_exonerado || false,
          SCOT_ChageControl: false,
          PFAC_Numero: null,
          TIPO_TabTDO: "TDO",
          TIPO_CodTDO: codTDO ? (codTDO.value || null) : null,
          SCOT_NumeroTDO: item.scot_numerotdo || " ",
          SCOT_SerieTDO: item.scot_serietdo || null,
          AUDI_UsrMod: this.storage.get("usuario") || null,
          AUDI_UsrCrea: this.storage.get("usuario") || null,
          SCOT_FechaOperacion: this.util.formatearfecha(new Date(), "yyyy-MM-ddTHH:mm:ss") || null,
          SCOT_FechaEmision: this.util.formatearfecha(item.audi_feccrea, "yyyy-MM-ddTHH:mm:ss") || null,
          EMPR_Codigo: 1,
          CCCT_Codigo: 0,
          SCOT_FechaPrefactura: this.util.formatearfecha(valuesEventosTareas["fechahora"], "yyyy-MM-ddTHH:mm:ss") || null,
          SCOT_ItemChangeControl: null,
          SCOT_CodMotivo: null,
          SCOT_Solicitante: null,
          SCOT_Autoriza: null,
          AUDI_FecCrea: this.util.formatearfecha(new Date(), "yyyy-MM-ddTHH:mm:ss") || null,
          ESTADO_OBJ: estadoObj,
        };
        request.tablaServicio.push(itemTablaServicio);
        insertActualizarOVServicio.items.push(itemTablaServicio);
      }
    });

    // --- 5. MAPEO ARCHIVOS ---
    request.request_archivos = { items: [] } as ListaDetCotizacionOVArchivoRequest;
    this.archivos_dataarchivos.forEach(archivo => {
      const estadoObj = archivo.ESTADO_OBJ !== undefined ? archivo.ESTADO_OBJ : "NA";
      if (estadoObj === "I" || estadoObj === "U" || estadoObj === "D" || estadoObj === "NA") {
        const itemTablaArchivo = {
          CCOT_Tipo: archivo.ccot_tipo,
          CCOT_Numero: archivo.ccot_numero,
          OVAR_Codigo: archivo.ovar_codigo,
          OVAR_Descrip: archivo.ovar_descrip,
          OVAR_FecEmi: archivo.ovar_fecemi,
          OVAR_Archivo: archivo.ovar_archivo,
          OVAR_Observacion: archivo.ovar_observacion,
          AUDI_UsrMod: this.storage.get("usuario"),
          AUDI_UsrCrea: this.storage.get("usuario"),
          ESTADO_OBJ: estadoObj,
        };
        request.request_archivos.items.push(itemTablaArchivo);
      }
    });

    // --- 6. MAPEO EVENTOS ---
    request.tablaEvento = [];
    this.eventostareas_dataeventos.forEach((item) => {
      const estadoObj = item.ESTADO_OBJ !== undefined ? item.ESTADO_OBJ : "NA";
      if (estadoObj === "I" || estadoObj === "U" || estadoObj === "D" || estadoObj === "NA") {
        const itemTablaEvento = {
          CCOT_Numero: request.pintCCOT_Numero || null,
          CCOT_Tipo: request.psinCCOT_Tipo || 2,
          EVEN_Item: item.even_item ?? item.key,
          EVEN_Fecha: this.util.formatearfecha(item.even_fecha, "yyyy-MM-ddTHH:mm:ss") || null,
          EVEN_Cumplida: item.even_cumplida === undefined || item.even_cumplida === null || item.even_cumplida === "" ? false : item.even_cumplida,
          EVEN_Usuario: item.even_usuario || null,
          EVEN_Observaciones: item.even_observaciones || " ",
          TIPO_TabEVE: "EVE",
          TIPO_CodEVE: item.tipo_desc1.value || "1",
          CONS_TabMOD: "MOD",
          CONS_CodMOD: "001",
          EVEN_Manual: item.even_manual === undefined || item.even_manual === null || item.even_manual === "" ? false : item.even_manual,
          AUDI_UsrMod: this.storage.get("usuario") || null,
          AUDI_UsrCrea: this.storage.get("usuario") || null,
          ESTADO_OBJ: estadoObj,
        };
        request.tablaEvento.push(itemTablaEvento);
      }
    });

    // --- 7. MAPEO ITINERARIO ---
    request.request_itinerario = { items: [], cons_codrgm: null };
    this.viajeitinerario_dataitinerario.forEach((item, i) => {
      const estadoObj = item.ESTADO_OBJ !== undefined ? item.ESTADO_OBJ : "NA";
      const codDestino = this.ListaPuertosByVia.find(r => r.label === item.nameportdischarge);
      const codOrigen = this.ListaPuertosByVia.find(r => r.label === item.nameportloading);
      let eta_anterior = null;
      const itinerario = this.datos?.['listadoviajeitinerario'];
      if (Array.isArray(itinerario)) {
        const encontrado = itinerario.find(item2 => item?.ovnv_item === item2?.ovnv_item);
        if (encontrado) { eta_anterior = encontrado.eta; }
      }
      const itemTablaItinerario = {
        CCOT_Tipo: request.psinCCOT_Tipo || 2,
        CCOT_Numero: request.pintCCOT_Numero || null,
        OVNV_Item: item.ovnv_item != "" && item.ovnv_item != null ? item.ovnv_item : item.key,
        NVIA_Codigo: item.nvia_codigo,
        PUER_CodDestino: codDestino ? codDestino?.value : item?.nameportdischarge?.value,
        PUER_CodOrigen: codOrigen ? codOrigen?.value : item?.nameportloading?.value,
        OVNV_Final: item.ovnv_final,
        FecEmbarque: item.fechaembarque || null,
        AUDI_UsrMod: this.storage.get("usuario") || null,
        AUDI_UsrCrea: this.storage.get("usuario") || null,
        ESTADO_OBJ: estadoObj,
        itemAnterior: item.ovnv_item,
        DVIA_FecETD: item.etd,
        ETA: item.eta,
        eta_anterior: eta_anterior
      };
      request.request_itinerario.items.push({ ...itemTablaItinerario });
    });
    request.request_itinerario.cons_codrgm = this.group_datosgenerales.get('regimen')?.value;

    // --- 8. MAPEO SLI (Tu lógica exacta) ---
    request.request_sli = {} as ServiciosLocalesRequest;
    request.request_sli.cope_codigo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] && this.datosRecibidos["listadooperaciones"].length > 0) ? this.datosRecibidos["listadooperaciones"][0].cope_codigo : 0;
    const cope_codigo = this.group_servicioslocales.get('codigooperacion')?.value;
    request.request_sli.ESTADO_OBJ = this.accion === 'NUEVO' ? 'I' : cope_codigo == null || cope_codigo == '' || cope_codigo == 0 ? 'I' : 'U';
    request.request_sli.cope_numdoc = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] && this.datosRecibidos["listadooperaciones"].length > 0) ? this.datosRecibidos["listadooperaciones"][0].cope_numdoc : null;
    request.request_sli.cope_fecemi = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] && this.datosRecibidos["listadooperaciones"].length > 0) ? this.datosRecibidos["listadooperaciones"][0].cope_fecemi : new Date();
    request.request_sli.cope_observacion = null;
    request.request_sli.cope_hbl = this.datosRecibidos != null ? this.datosRecibidos.doov_hbl ?? ' ' : "  ";
    request.request_sli.ccot_codigo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] && this.datosRecibidos["listadooperaciones"].length > 0) ? this.datosRecibidos["listadooperaciones"][0].ccot_codigo : null;
    request.request_sli.ccot_numero = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] && this.datosRecibidos["listadooperaciones"].length > 0) ? this.datosRecibidos["listadooperaciones"][0].ccot_numero : request.pintCCOT_Numero;
    request.request_sli.ccot_tipo = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] && this.datosRecibidos["listadooperaciones"].length > 0) ? this.datosRecibidos["listadooperaciones"][0].ccot_tipo : request.psinCCOT_Tipo;
    if (request.request_sli.ESTADO_OBJ == 'I' && request.pintCCOT_NumPadre != null) {
      request.request_sli.ccot_numero = request.pintCCOT_NumPadre;
      request.request_sli.ccot_tipo = String(request.psinCCOT_TipoPadre);
    }
    request.request_sli.entc_codcliente = this.group_servicioslocales.get('clienteDSL').value == null || this.group_servicioslocales.get('clienteDSL').value == "" ? this.codCliente : this.group_servicioslocales.get('clienteDSL').value;
    request.request_sli.entc_codtransporte = this.codTransporte;
    request.request_sli.entc_codagente = this.codAgente;
    request.request_sli.cons_codestado = (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] && this.datosRecibidos["listadooperaciones"]?.length > 0) ? this.datosRecibidos["listadooperaciones"][0].cons_codestado : '001';
    request.request_sli.cons_tabestado = "OPE";
    request.request_sli.cope_excepcion = null;
    request.request_sli.cope_fob = 0.00;
    request.request_sli.cope_seguro = 0.00;
    request.request_sli.cope_flete = 0.00;
    request.request_sli.cope_cif = 0.00;
    request.request_sli.cope_partarancelaria = 0.00;
    request.request_sli.cope_ipm = 0.00;
    request.request_sli.cope_igv = 0.00;
    request.request_sli.cope_percepcion = 0.00;
    request.request_sli.cope_tasadespacho = 0.00;
    request.request_sli.cope_advalorem = 0.00;
    request.request_sli.cope_1erembarque = null;
    request.request_sli.audi_usrmod = this.nombreUsuario;
    request.request_sli.audi_usrcrea = this.nombreUsuario;
    request.request_sli.tipo_tabmnd = "MND";
    request.request_sli.tipo_codmnd = this.group_serviciostarifa.value["moneda"];
    request.request_sli.cons_codcrg = null;
    request.request_sli.cons_tabcrg = "CRG";
    request.request_sli.ccot_codaduana = null;
    request.request_sli.ccot_codlogistico = null;
    request.request_sli.ccot_codtransporte = null;
    request.request_sli.cope_nave = null;
    request.request_sli.cope_viaje = null;
    request.request_sli.cope_mbl = this.group_novedades.value["blmaster"] ?? ' ';
    request.request_sli.cope_fechaarribo = null;
    request.request_sli.cope_cantidaddias = null;
    request.request_sli.cope_kilos = null;
    request.request_sli.cope_volumen = null;
    request.request_sli.cope_preciosada = null;
    request.request_sli.entc_codagenport = null;
    request.request_sli.entc_codtermport = null;
    request.request_sli.entc_coddeptemporal = null;
    request.request_sli.ctar_codigo = this.idTarifa !== undefined ? this.idTarifa : ((this.datosRecibidos != null && this.datosRecibidos["listadotarifaasociada"] && this.datosRecibidos["listadotarifaasociada"].length > 0) ? this.datosRecibidos["listadotarifaasociada"][0].idtariff : null);
    request.request_sli.ctar_version = 1;
    request.request_sli.entc_codtransterre = this.group_servicioslocales.get('transportistaTerre')?.value || null;
    request.request_sli.cope_version = 1;
    request.request_sli.cons_codlng = "003";
    request.request_sli.cons_tablng = "LNG";
    request.request_sli.cons_codrgm = this.group_datosgenerales.get('regimen')?.value;
    request.request_sli.cons_tabrgm = "RGM";
    request.request_sli.cons_codvia = this.group_datosgenerales.get('via')?.value;
    request.request_sli.cons_tabvia = "VIA";
    request.request_sli.isintegral = this.group_servicioslocales.get('isintegral')?.value;
    request.request_sli.cope_fechaSL = this.group_servicioslocales.get('fechasl')?.value ?? null;
    request.request_sli.cope_dam = this.group_servicioslocales.get('montodam')?.value ?? null;
    const ruta = this.group_servicioslocales.get('rutas')?.value;
    request.request_sli.codigo_ruta = ruta != null && ruta != '' ? Number(ruta) : null;
    request.request_sli.cope_cifVta = this.group_servicioslocales.get('cifEjecVta')?.value ?? null;
    request.request_sli.cope_cifLog = this.group_servicioslocales.get('cifLogistico')?.value ?? null;
    request.request_sli.cope_peso_sli = this.group_servicioslocales.get('peso')?.value ?? null;
    request.request_sli.cope_unmd_peso = this.group_servicioslocales.get('unmd_peso')?.value ?? null;
    request.request_sli.cope_tab_unmd_peso = request.request_sli.cope_unmd_peso != null ? 'UNM' : null;
    request.request_sli.cope_volumen_sli = this.group_servicioslocales.get('volumen')?.value ?? null;
    request.request_sli.cope_unmd_volumen = this.group_servicioslocales.get('unmd_volumen')?.value ?? null;
    request.request_sli.cope_tab_unmd_volumen = request.request_sli.cope_unmd_volumen != null ? 'UNM' : null;
    request.request_sli.sucursal = this.group_servicioslocales.get('sucursal')?.value ?? null;

    request.request_sli.listaAutorizacionSLI = {} as AutorizacionSliRequest;
    const resp = this.verificarCambiosPorAutorizar();
    if (resp.resultado) {
      const requestAutorizacionSli: AutorizacionSliRequest = {
        cope_codigo: request.request_sli.cope_codigo,
        entc_codcliente: this.group_servicioslocales.get('clienteDSL').value == null || this.group_servicioslocales.get('clienteDSL').value == "" ? this.codCliente : this.group_servicioslocales.get('clienteDSL').value,
        usuario: this.storage.get('nombreusr'),
        ccot_numdoc: request.pvchCCOT_NumDoc,
        nombre_cliente: this.group_datosgenerales.get('cliente')?.value,
        correo_remitente: this.storage.get('correo'),
        tbl_operaciones: resp.datos.map(item => ({
          dope_item: item.dope_item ?? null,
          serv_codigo: item.serv_codigo ?? null,
          monto_solicitado: item.precio_modificado ?? null,
          desc_moneda_solicitado: item.desc_moneda_solicitado ?? null,
          cod_moneda_solicitado: item.cod_moneda_solicitado ?? null,
          tab_moneda_solicitado: item.tab_moneda_solicitado ?? null,
          monto_original: item.precio_original ?? null,
          desc_moneda_original: item.precio_desc_mnd ?? null,
          cod_moneda_original: item.precio_cod_mnd ?? null,
          tab_moneda_original: item.precio_tab_mnd ?? null,
          servicio: item.nombre_servicio ?? null,
          tipoauth: item.tipo ?? null
        })),
        cope_numdoc: request.request_sli.cope_numdoc,
        hbl: request.pchrDOOV_HBL,
      };
      request.request_sli.listaAutorizacionSLI = requestAutorizacionSli;
    }

    request.request_sli.listaDetSL = request.request_sli.listaDetSL || [];
    let sldetrequest: DetalleServiciosLocalesRequest[] = [];
    this.servicioslocales_datadetalle.forEach((item: any) => {
      let estado_obj = item.ESTADO_OBJ ?? "NA";
      if (estado_obj === "A") {
        const existeEnOriginal = this.listadoOriginal.some(orig => orig.dope_item === item.dope_item);
        estado_obj = existeEnOriginal ? "U" : "I";
      }
      const requestItem: DetalleServiciosLocalesRequest = {
        dope_item: item.dope_item ?? null,
        cope_codigo: (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] && this.datosRecibidos["listadooperaciones"].length > 0) ? this.datosRecibidos["listadooperaciones"][0].cope_codigo : 0,
        cope_version: (this.datosRecibidos && this.datosRecibidos["listadooperaciones"] && this.datosRecibidos["listadooperaciones"].length > 0) ? this.datosRecibidos["listadooperaciones"][0].cope_version : 1,
        dtar_item: item.dtar_item ?? null,
        ctar_codigo: this.idTarifa !== undefined ? this.idTarifa : item.ctar_codigo,
        ctar_tipo: item.ctar_tipo ?? null,
        pack_codigo: item.pack_codigo ?? null,
        cons_codbas: item.cons_desc_spa?.value !== undefined ? item.cons_desc_spa?.value : (item.cons_codbas ?? null),
        cons_tabbas: "BAS",
        dope_cantidad: item.dope_cantidad ?? null,
        dope_preciounitcosto: item.dope_preciounitcosto ?? null,
        dope_preciototcosto: item.dope_preciototcosto ?? item.dope_preciounitcosto * (item.dope_cantidad || 1),
        dope_preciounitvta: item.dope_preciounitvta ?? null,
        dope_preciototvta: item.dope_preciototvta ?? null,
        dope_minimo: item.dope_minimo ?? 0.00,
        dope_peso: item.dope_peso ?? null,
        dope_volumen: item.dope_volumen ?? null,
        usr_usrmod: this.nombreUsuario,
        audi_usrcrea: this.nombreUsuario,
        dope_costosada: item.dope_costosada ?? null,
        dope_costo: item.dope_costo ?? null,
        dope_ventasada: item.dope_ventasada ?? 0.00,
        dope_venta: item.dope_venta ?? 0.00,
        tipo_tabzon: item.tipo_tabzon ?? null,
        tipo_codzonorigen: item.tipo_codzonorigen ?? null,
        cons_codtra: item.cons_codtra ?? null,
        cons_tabtra: item.cons_tabtra ?? null,
        tipo_codzondestino: item.tipo_codzondestino ?? null,
        tipe_codigo: item.tipoentidad?.value !== undefined ? item.tipoentidad?.value : (item.tipe_codigo ?? 2),
        entc_codigo: item.entc_razonsocial?.value !== undefined ? item.entc_razonsocial.value : (item.entc_razonsocial != null && !isNaN(Number(item.entc_razonsocial)) ? Number(item.entc_razonsocial) : (item.entc_codigo != null ? Number(item.entc_codigo) : null)),
        cons_codest: item.cons_codest !== '' ? item.cons_codest : '001',
        cons_tabest: "EDO",
        serv_codigo: item.serv_nombre_spa?.value !== undefined ? item.serv_nombre_spa?.value : (item.serv_codigo ?? null),
        tipo_tabmnd: "MND",
        tipo_codmnd: item.nombremnd?.value !== undefined ? item.nombremnd?.value : (item.tipo_codmnd ?? null),
        cons_tablng: "LNG",
        cons_codlng: item.cons_desclng?.value !== undefined ? item.cons_desclng?.value : (item.cons_codlng ?? '003'),
        dope_changecontrol: item.dope_changecontrol ?? false,
        dope_itemchangecontrol: item.dope_itemchangecontrol ?? null,
        dope_fechaoperacion: item.dope_fechaoperacion ?? null,
        COPE_ProfitLocal: item.profit_local ?? null,
        profit_fijo: item.profit_fijo ?? null,
        agrupado: item.agrupado ?? null,
        CODE_Agrupador: item.cod_padre ?? null,
        DTAR_Codigo: item.dtar_codigo ?? null,
        RTAR_Codigo: item.rtar_codigo ?? null,
        monto_conversion: item.monto_conversion ?? null,
        TIPO_TabMNDCosto: item.tipo_tabmnd ?? null,
        TIPO_CodMNDCosto: item.tipo_codmnd ?? null,
        TIPO_TabMNDVenta: item.tipo_tabmndventa ?? null,
        TIPO_CodMNDVenta: item.nombremndvta?.value !== undefined ? item.nombremndvta?.value : (item.tipo_codmndventa ?? null),
        TIPO_TabMNDProfit: item.tipo_tabmndprofit ?? null,
        TIPO_CodMNDProfit: item.tipo_codmndprofit ?? null,
        TIPO_TabTDS: item.tipo_tabtds ?? "TDS",
        TIPO_CodTDS: this.adicional === false ? '001' : '002',
        esadicional: item.esadicional !== '' || item.esadicional !== null ? item.esadicional : false,
        dope_preciotot_prom: item.dope_preciotot_prom ?? null,
        dope_preciounit_prom: item.dope_preciounit_prom ?? null,
        ESTADO_OBJ: estado_obj,
        tipo_tabmsd: this.extraerValueSinObjeto(item.tipo_codmsd) != null ? "MSD" : null,
        tipo_codmsd: this.extraerValueSinObjeto(item.tipo_codmsd) ?? null,
        transportista: this.codTransporte,
        cliente: this.codCliente,
        mnd_tarifa: item.mnd_tarifa ?? null,
        tab_tarifa: item.tab_tarifa ?? null,
        monto_tarifa: item.monto_tarifa ?? null,
        tipo_autorizacion: item.tipo_autorizacion ?? null,
      };
      sldetrequest.push(requestItem);
    });
    request.request_sli.listaDetSL = sldetrequest;

    this.servicioslocales_detalleAgrupacion = this.servicioslocales_detalleAgrupacion.map(item => ({ ...item, tipotran: item.ESTADO_OBJ }));
    request.request_sli.tablaagrupador = request.request_sli.tablaagrupador || [];
    this.itemagrupador = this.servicioslocales_detalleAgrupacion.map(item => ({
      CODE_Agrupador: item.dope_item ?? null,
      COPE_Codigo: item.cope_codigo ?? null,
      SERV_Descripcion: item.serv_nombre_spa ?? null,
      CTAR_Codigo: item.ctar_codigo ?? null,
      DTAR_Codigo: item.dtar_codigo ?? null,
      RTAR_Codigo: item.rtar_codigo ?? null,
      DOPE_PrecioUnitVta: item.dope_preciounitvta ?? null,
      DOPE_Cantidad: item.dope_cantidad ?? null,
      DOPE_PrecioTotVta: item.dope_preciototvta ?? null,
      DOPE_PrecioUnitCosto: item.dope_preciounitcosto ?? null,
      DOPE_PrecioTotCosto: item.dope_preciototcosto ?? null,
      AUDI_Usuario: this.storage.get("usuario"),
      tipotran: item.ESTADO_OBJ,
    }));
    request.request_sli.tablaagrupador = this.itemagrupador;

    const length = this.listarServTariff.length;
    let itemCounter = 1;
    request.request_sli.listaEvenSL = request.request_sli.listaEvenSL || [];
    let slevenrequest: EvenSiRequest[] = [];
    for (let i = 0; i < length; i++) {
      const servicio = this.listarServTariff[i];
      const item = this.servicioslocales_dataObservaciones[i] || {};
      const rItem: EvenSiRequest = {
        ccot_numero: this.datosRecibidos != null ? this.datosRecibidos.ccot_numero : null,
        ccot_tipo: 2,
        even_item: itemCounter++,
        even_fecha: item.even_fecha || null,
        even_cumplida: false,
        even_usuario: item.even_usuario || null,
        even_observaciones: item.even_observaciones || null,
        tipo_tabeve: "EVE",
        tipo_codeve: servicio.tipe_codigo.toString(),
        cons_tabmod: "MOD",
        cons_codmod: "001",
        even_manual: false,
        audi_usrcrea: this.nombreUsuario,
        audi_usrmod: this.nombreUsuario,
        even_filename: item.even_filename || null,
        even_filecontent: item.even_filename || null
      };
      slevenrequest.push(rItem);
    }
    request.request_sli.listaEvenSL = slevenrequest;

    // --- 9. ACTUALIZACIÓN FINAL DE IDs (Lo que tenías al final del Guardar) ---
    // Esta parte es crucial para que los IDs (pintENTC_CodCliente, etc) se envíen con el código numérico real
    // y no con lo que venía del form group si era un objeto o string.
    request.pintENTC_CodCliente = this.group_datosgenerales.get('cliente')?.value ? Number(this.ListaTodosCliente.find(cliente => cliente.nombre === this.group_datosgenerales.get('cliente')?.value)?.codigo) || 0 : null;
    request.pintENTC_CodTransportista = this.group_serviciostarifa.get('transportista')?.value ? Number(this.ListaTodosTransportista.find(transportista => transportista.nombre === this.group_serviciostarifa.get('transportista')?.value)?.codigo) || 0 : null;
    request.pintENTC_CodAgente = this.group_datosgenerales.get('agente')?.value ? Number(this.ListaTodosAgentes.find(agente => agente.nombre === this.group_datosgenerales.get('agente')?.value)?.codigo) || 0 : null;
    request.pintENTC_CodCustomer = this.group_datosgenerales.get('customer')?.value ? Number(this.ListaTodosCustomer.find(customer => customer.nombre === this.group_datosgenerales.get('customer')?.value)?.codigo) || 0 : null;
    request.pintENTC_CodEjecutivo = this.group_datosgenerales.get('ejecutivo')?.value ? Number(this.ListaTodosEjecutivos.find(ejecutivo => ejecutivo.nombre === this.group_datosgenerales.get('ejecutivo')?.value)?.codigo) || 0 : null;
    request.pintENTC_CodShipper = valuesDatosEmbarque["shipper"] ? Number(this.ListaTodosShipper.find(item => item.nombre === valuesDatosEmbarque["shipper"])?.codigo) || 0 : null;
    request.pintENTC_CodConsignee = valuesDatosEmbarque["consignee"] ? Number(this.ListaTodosConsignee.find(item => item.nombre === valuesDatosEmbarque["consignee"])?.codigo) || 0 : null;
    request.pintENTC_CodNotify = valuesDatosEmbarque["notify"] ? Number(this.ListaTodosNotify.find(item => item.nombre === valuesDatosEmbarque["notify"])?.codigo) || 0 : null;
    request.pintENTC_CodDepTemporal = valuesNovedades["deposito"] ? Number(this.ListaTodosDeposito.find(item => item.nombre === valuesNovedades["deposito"])?.codigo) || 0 : null;

    // Retorno final
    return {
      request: request,
      itemsFlete: insertActualizarOVFlete.items,
      itemsServicio: insertActualizarOVServicio.items,
      itemsCNTR: tablaContenedores
    } as any;
  }
  // #endregion

  async asignacionFletePorTipoPaquete(rowdata: any, index: number): Promise<{
    dcot_preciounicosto: number; dcot_preciouniventa: number; dcot_totalunicosto: number; dcot_totaluniventa: number;
  }> {

    let dcot_preciounicosto = 0.00;
    let dcot_preciouniventa = 0.00;
    let dcot_totalunicosto = 0.00;
    let dcot_totaluniventa = 0.00;
    let cantidad = 1.00;

    let rowdataModificado: any;
    try { rowdataModificado = await this.ConsultarTarifario(rowdata, true, true); } catch (error) {
      return {
        dcot_preciounicosto: 0, dcot_preciouniventa: 0, dcot_totalunicosto: 0, dcot_totaluniventa: 0
      };
    }

    dcot_preciounicosto = rowdataModificado.dcot_preciounicosto ?? 0;
    dcot_preciouniventa = rowdataModificado.dcot_preciouniventa ?? 0;
    const tarifa = rowdataModificado.tari_codigo;

    if (rowdata.dcot_cantidad == null || rowdata.dcot_cantidad == undefined || rowdata.dcot_cantidad == 0) {
      this.enviarNuevoValorToDatatableFlete(cantidad, index, 'dcot_cantidad');
    } else {
      cantidad = rowdata.dcot_cantidad;
    }

    if (rowdata.dcot_preciounicosto == null || rowdata.dcot_preciounicosto == undefined || rowdata.dcot_preciounicosto == 0) {
      this.enviarNuevoValorToDatatableFlete(dcot_preciounicosto, index, 'dcot_preciounicosto');
    }
    if (rowdata.dcot_preciouniventa == null || rowdata.dcot_preciouniventa == undefined || rowdata.dcot_preciouniventa == 0) {
      this.enviarNuevoValorToDatatableFlete(dcot_preciouniventa, index, 'dcot_preciouniventa');
    }

    dcot_preciounicosto = dcot_preciounicosto;
    dcot_totalunicosto = cantidad * dcot_preciounicosto;
    dcot_preciouniventa = dcot_preciouniventa;
    dcot_totaluniventa = cantidad * dcot_preciouniventa;
    this.enviarNuevoValorToDatatableFlete(dcot_preciounicosto, index, 'dcot_preciounicosto');
    // this.enviarNuevoValorToDatatableFlete(dcot_preciouniventa, index, 'dcot_preciouniventa');
    this.enviarNuevoValorToDatatableFlete(dcot_totalunicosto, index, 'dcot_totalunicosto');
    // this.enviarNuevoValorToDatatableFlete(dcot_totaluniventa, index, 'dcot_totaluniventa');
    this.enviarNuevoValorToDatatableFlete(tarifa, index, 'tari_codigo');
    this.group_serviciostarifa.get('fletetotal').setValue(dcot_totaluniventa);
    this.group_serviciostarifa.get('diaslibres').setValue(this.contratoSeleccionado?.row?.dias_sobrestadia);

    return {
      dcot_preciounicosto: dcot_preciounicosto, dcot_preciouniventa: dcot_preciouniventa, dcot_totalunicosto: dcot_totalunicosto, dcot_totaluniventa: dcot_totaluniventa
    };
  }

  manejoGuardadoOv(request: CrudOrdenesVentaRequest, accion: string, mensaje: string, obtenerFormato: boolean): void {
    if(accion == 'NUEVO'){
      this.guardadoNuevaOv(request, obtenerFormato)
    }else{
      this.guardadoEditarOv(request, mensaje, obtenerFormato)
    }
  }

  guardadoNuevaOv(request: CrudOrdenesVentaRequest, obtenerFormato: boolean){
    this.ordenventaService.TnsInsertarOvCot(request).subscribe(response => {
      const numeroDocumento = response.datos.numeroDocumento ?? '';
      this.enviarEventoBandejaOv({ output: 'numdoc', numdoc: numeroDocumento });

      if (response.datos.status === 200) {
        this.group_datosgenerales.get('numero')?.setValue(numeroDocumento);
        this.group_flotantes.get('ccotnumdoc_visualizacion')?.setValue(numeroDocumento);
        if(obtenerFormato == true){
          this.messageService.clear();
          this.messageService.add({ severity: 'success', summary: 'OK', detail: "Se guardó correctamente la orden de venta: " + numeroDocumento, life: 3000, key: "tl" });
          this.getFormatoOv(response.datos.codigoEntidad);
        }else{
          this.util.MessageDialog({
            titulo: "Mantenimiento Orden Venta", mensaje: "Se guardó correctamente la orden de venta: " + numeroDocumento, icono: "OK", tipo: "ok"
          });
        }
        this.actualizar_datos_ov(event);
      } else {
        this.util.MessageDialog({ titulo: 'ERROR', mensaje: response.meta.mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
        this.deshabilitarBotones(event);
      }
    }, (err) => {
      this.deshabilitarBotones(event);
      const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
      this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
    });
  }

  guardadoEditarOv(request: CrudOrdenesVentaRequest, mensajeExito: string, obtenerFormato: boolean){
    this.ordenventaService.TnsEditarOvCot(request).subscribe(response => {
      const numeroDocumento = response.datos.numeroDocumento ?? '';
      this.enviarEventoBandejaOv({ output: 'numdoc', numdoc: numeroDocumento });

      if (response.datos.status === 200) {
        this.setFiltrosBusqueda();
        const msj = mensajeExito != null ? mensajeExito : "Se actualizó correctamente";
        this.util.MessageDialog({ titulo: "Mantenimiento Orden Venta", mensaje: msj, icono: "OK", tipo: "ok" });
        this.actualizar_datos_ov(event);
      } else {
        this.util.MessageDialog({ titulo: 'ERROR', mensaje: response.meta.mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
        this.deshabilitarBotones(event);
      }
    }, (err) => {
      this.deshabilitarBotones(event);
      const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
      this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
    });
  }

  manejoCorreoPreview(request: CrudOrdenesVentaRequest, accion: string, mensaje: string): void {
    try {
      if(this.evaluarEnvioCorreoOv == true){

        this.util.MessageDialog({
          titulo: 'Confirmar envío correo',
          mensaje: `¿Desea visualizar el preview del correo de generación de OV?`,
          tipo: 'warning',
            textoBtn: {
              textoBtnOpcion1: 'Sí, ver preview',
              textoBtnOpcion2: 'No, solo generar OV'
            },
          pregunta: {
            onAccept: () => {
              this.manejoGuardadoOv(request, accion, mensaje, true);
          },
          onReject: () => {this.manejoGuardadoOv(request, accion, mensaje, false)}
            },
        });
      }else{
        this.manejoGuardadoOv(request, accion, mensaje, false);
      }
    } catch (err) {console.error(err);}
  }

  getFormatoOv(ccot_numero: number){
    const loadingScreen = this.util.showLoadingScreen({ message: "Obteniendo datos ..." });
    try{
      let dataCorreo: itemsCorreoPreview[] = [];
      const request_p = <GetPlantillaCorreoGeneracionOvRequest>{};
      request_p.codigo = ccot_numero;
      request_p.tipo = 2;
      request_p.usuario = this.nombreUsuario;
      request_p.correoUsuario = this.storage.get('correo');
      this.ordenventaService.getPlantillaCorreoGeneracionOv(request_p).subscribe(
        (res) => {
          if (res.datos.status === 200) {
            loadingScreen.close();
            dataCorreo = res.datos.result;
            const data: CorreoPreviewData = {
              config: {
                modoLectura: true,
                mostrarBotonGuardarPlantilla: false,
                mostrarArchivosAdjuntos: false,
                filtrosBusquedaHistorica: true,
                tipoEnvioCorreo: "Draft",
              },
              dataCorreo: dataCorreo,
            };

            const ref = this.dialogService.open(CorreoPreviewComponent, {
              header: 'Preview correo - Generación OV',
              data: data,
              width: '70%',
              contentStyle: { 'max-height': '70%', overflow: 'auto' },
              maximizable: true,
            });

            ref.onClose.subscribe((result: CorreoPreviewResult) => {
              if (result) {
                switch (result.accion) {
                  case 'enviar':
                    
                    break;
                  case 'guardar':
                    break;
                  case 'salir':
                    break;
                }
              }
            });
          }
        }, err => {
          loadingScreen.close();
          const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
          this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
        })
    }catch(err){
      console.error(err);
    }
  }

}
